export const systemSpecification= {
    projectName: [],
    panelName: [],
    emsDataInfo: {
      status: "False"
    },
    specification: [],
    hangerSpecifications: [
      {
        specId: "1",
        id: "24122208708764011",
        type: "cableTray",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut cable tray hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
        systemName: "Flextray BLine 304L Bolt-On Splice",
        diameter: "",
        depth: "999",
        width: "999",
        spacing: "5",
        distFromFittings: "1",
        distFromCoupling: "NA",
        distFromBeam: "",
        errHangRodLen: "2",
        errHangColor: "-65281",
        rodDia: ".375",
        noOverride: "False"
      },
      {
        specId: "25",
        id: "24122208708764011",
        type: "cableTray",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut cable tray hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
        systemName: "ladder BLine Alum Series 26 12 ft x 9 in Rung Spacing",
        diameter: "",
        depth: "999",
        width: "999",
        spacing: "5",
        distFromFittings: "1",
        distFromCoupling: "NA",
        distFromBeam: ".5",
        errHangRodLen: "2",
        errHangColor: "-65281",
        rodDia: ".375",
        noOverride: "False"
      },
      {
        specId: "126",
        id: "24122208708764011",
        type: "cableTray",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut cable tray hanger 1 5_8.rfa",        name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
        systemName: "Wireway Hoffman NEMA Type 12 Flg x Flg",
        diameter: "",
        depth: "999",
        width: "999",
        spacing: "5",
        distFromFittings: "1",
        distFromCoupling: "NA",
        distFromBeam: ".5",
        errHangRodLen: "2",
        errHangColor: "-65281",
        rodDia: "0.5",
        noOverride: "False"
      },
      {
        specId: "128",
        id: "24120904704164011",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut conduit hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
        systemName: "eMT Galv Allied Compression - Wirefill",
        diameter: "4",
        depth: "",
        width: "",
        spacing: "8",
        distFromFittings: "2",
        distFromCoupling: "NA",
        distFromBeam: ".5",
        errHangRodLen: "2",
        errHangColor: "-65281",
        rodDia: "",
        noOverride: "False"
      },
      {
        specId: "130",
        id: "24122208708764011",
        type: "cableTray",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut cable tray hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
        systemName: "ladder BLine Alum Series 25 12 ft x 9 in Rung Spacing",
        diameter: "",
        depth: "999",
        width: "999",
        spacing: "4",
        distFromFittings: "1",
        distFromCoupling: "NA",
        distFromBeam: ".5",
        errHangRodLen: "2",
        errHangColor: "-8323200",
        rodDia: "0.5",
        noOverride: "False"
      },
      {
        specId: "131",
        id: "24120904704164011",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut conduit hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
        systemName: "rMC Galv Allied Threaded with bends - Wirefill",
        diameter: "6",
        depth: "",
        width: "",
        spacing: "8",
        distFromFittings: "2",
        distFromCoupling: "NA",
        distFromBeam: ".5",
        errHangRodLen: "2",
        errHangColor: "-8323200",
        rodDia: ".375",
        noOverride: "False"
      },
      {
        specId: "133",
        id: "24150665921873911",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\minerallac\\cs conduit hanger\\carbon steel\\support\\minerallac cs emt conduit hanger bolt zinc plated.rfa",
        name: "Minerallac CS EMT Conduit Hanger Bolt Zinc Plated.rfa",
        systemName: "eMT Galv Allied Set Screw - Panel/Circuit",
        diameter: "4",
        depth: "",
        width: "",
        spacing: "8",
        distFromFittings: "1",
        distFromCoupling: "NA",
        distFromBeam: "",
        errHangRodLen: "2",
        errHangColor: "-32704",
        rodDia: ".375",
        noOverride: "False"
      },
      {
        specId: "134",
        id: "24122208708764011",
        type: "cableTray",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut cable tray hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
        systemName: "ladder BLine Alum Series 24 10 ft x 9 in Rung Spacing",
        diameter: "",
        depth: "999",
        width: "999",
        spacing: "5",
        distFromFittings: "1",
        distFromCoupling: "NA",
        distFromBeam: "",
        errHangRodLen: "2",
        errHangColor: "-65536",
        rodDia: ".375",
        noOverride: "False"
      },
      {
        specId: "135",
        id: "24120904704164011",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut conduit hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
        systemName: "eMT Wheatland Set Screw Wirefill",
        diameter: "4",
        depth: "",
        width: "",
        spacing: "8",
        distFromFittings: "NA",
        distFromCoupling: "1",
        distFromBeam: "",
        errHangRodLen: "2",
        errHangColor: "-32640",
        rodDia: "0.5",
        noOverride: "False"
      },
      {
        specId: "136",
        id: "24120904704164011",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\p1000t-gr unistrut conduit hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
        systemName: "rMC Wheatland Galv Threaded - Wirefill",
        diameter: "3",
        depth: "",
        width: "",
        spacing: "1",
        distFromFittings: "NA",
        distFromCoupling: "NA",
        distFromBeam: "",
        errHangRodLen: "1",
        errHangColor: "-1",
        rodDia: "1",
        noOverride: "False"
      },
      {
        specId: "137",
        id: "24120904704164011",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\\\p1000t-gr unistrut conduit hanger 1 5_8.rfa",
        name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
        systemName: "pVC Sch80 Allied with fittings - Panel/Circuit",
        diameter: "3",
        depth: "",
        width: "",
        spacing: "1",
        distFromFittings: "NA",
        distFromCoupling: "NA",
        distFromBeam: "",
        errHangRodLen: "1",
        errHangColor: "-1",
        rodDia: "1",
        noOverride: "False"
      },
      {
        specId: "138",
        id: "24120907704164011",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\\\p1001t-gr dbl unistrut conduit hanger 1 5_8.rfa",
        name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
        systemName: "pVC Sch80 Allied with fittings - Panel/Circuit",
        diameter: "4",
        depth: "",
        width: "",
        spacing: "1",
        distFromFittings: "NA",
        distFromCoupling: "NA",
        distFromBeam: "",
        errHangRodLen: "1",
        errHangColor: "-1",
        rodDia: "1",
        noOverride: "False"
      },
      {
        specId: "139",
        id: "24120907704164011",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\\\p1001t-gr dbl unistrut conduit hanger 1 5_8.rfa",
        name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
        systemName: "eMT Wheatland Set Screw Wirefill",
        diameter: "3",
        depth: "",
        width: "",
        spacing: "1",
        distFromFittings: "NA",
        distFromCoupling: "NA",
        distFromBeam: "",
        errHangRodLen: "1",
        errHangColor: "-1",
        rodDia: "1",
        noOverride: "False"
      },
      {
        specId: "140",
        id: "24120911704164011",
        type: "conduit",
        unit: "IMPERIAL",
        path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\p3301t-gr dbl unistrut conduit hanger 7_8.rfa",
        name: "p3301T-GR Dbl UniStrut Conduit Hanger 7_8",
        systemName: "eMT Wheatland Set Screw Wirefill",
        diameter: "6",
        depth: "",
        width: "",
        spacing: "1",
        distFromFittings: "NA",
        distFromCoupling: "NA",
        distFromBeam: "",
        errHangRodLen: "1",
        errHangColor: "-1",
        rodDia: "1",
        noOverride: "False"
      }
    ],
    systemDef: [
      {
        name: "--------------------METAL CONDUIT--------------------",
        unit: "IMPERIAL",
        id: "2",
        systemShape: "conduit",
        systemUniqueId: "2",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent"
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "--------------------NON-METAL CONDUIT--------------------",
        unit: "IMPERIAL",
        id: "13",
        systemShape: "conduit",
        systemUniqueId: "17",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent"
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "--------------------FLEXIBLE CONDUIT--------------------",
        unit: "IMPERIAL",
        id: "15",
        InVisibility: "",
        systemShape: "conduit",
        systemUniqueId: "24",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent"
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "--------------------LADDER CONTAINMENT-----------------",
        unit: "IMPERIAL",
        id: "19",
        systemShape: "conduit",
        systemUniqueId: "43",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent"
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "--------------------BUSWAY------------------------------",
        unit: "IMPERIAL",
        id: "27",
        systemShape: "conduit",
        systemUniqueId: "169",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent"
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "BusWay Cu Eaton",
        unit: "IMPERIAL",
        id: "28",
        systemShape: "BusWay",
        systemUniqueId: "170",
        hangerDisabledFor: "",
        isClearence: "true",
        fittings: [
          {
            name: "BusWay",
            channelCableTrayElbow: [
              {
                name: "eaton CU BusWay Feeder FExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU BusWay Feeder FExPE.rfa",
                description: "",
                descriptionType: "Feeder Straight",
                angle: "90",
                connector: "201*200",
                centerRadius: "0.666666666666667",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "0.395833333333333",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                bendType: "",
                id: "24128426733160111",
                isClearence: "true"
              },
              {
                name: "eaton CU Rearward Elbow FExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Rearward Elbow FExPE.rfa",
                description: "",
                descriptionType: "rearward Elbow FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "1.54166666666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.345",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "24128438733160711",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Downward Corner Joint Elbow FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Downward Corner Joint Elbow FExFE.rfa",
                description: "",
                descriptionType: "downward Corner Joint Elbow FExFE",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.23749999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "1.975",
                width: "0.365",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24128414733160211",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Forward Elbow Flange FlgdxFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "4",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Forward Elbow Flange FlgdxFE.rfa",
                description: "",
                descriptionType: "Forward Elbow Flange FlgdxFE",
                angle: "90",
                connector: "202*201",
                centerRadius: "1.33333333333337",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "0.930833333333333",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "",
                id: "24128420733160711",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Forward Traditional Elbow PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "5",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Forward Traditional Elbow PExFE.rfa",
                description: "",
                descriptionType: "Forward Traditional Elbow PExFE",
                angle: "90",
                connector: "200*201",
                centerRadius: "1.20833333333337",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "0.72",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "",
                id: "24128432733160711",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Rearward Elbow Flange FExFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "6",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Rearward Elbow Flange FExFlgd.rfa",
                description: "",
                descriptionType: "rearward Elbow Flange FExFlgd",
                angle: "90",
                connector: "201*202",
                centerRadius: "1.4791666666667",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.975",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "",
                id: "24128434733160711",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Upward Corner Joint Elbow FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "7",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Upward Corner Joint Elbow FExFE.rfa",
                description: "",
                descriptionType: "Upward Corner Joint Elbow FExFE",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.23749999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "1.975",
                width: "0.365",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "",
                id: "24128435733160711",
                isClearence: "true"
              },
              {
                name: "eaton CU Forward Corner Joint Elbow FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "8",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Forward Corner Joint Elbow FExFE.rfa",
                description: "",
                descriptionType: "Forward Corner Joint Elbow FExFE",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.23749999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.975",
                displayPosition: "1,7",
                dispPosition: "38",
                csvFileName: "",
                bendType: "",
                id: "24128427733160711",
                isClearence: "true"
              },
              {
                name: "eaton CU Rearward Corner Joint Elbow FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "9",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Rearward Corner Joint Elbow FExFE.rfa",
                description: "",
                descriptionType: "rearward Corner Joint Elbow FExFE",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.868333333333313",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.975",
                displayPosition: "2,7",
                dispPosition: "39",
                csvFileName: "",
                bendType: "",
                id: "24128433733160711",
                isClearence: "true"
              }
            ],
            channelCableTrayVerticalElbow: [
              {
                name: "eaton CU Busway Downward Traditional Elbow FlgdxFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "1",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Downward Traditional Elbow FlgdxFE.rfa",
                description: "",
                descriptionType: "downward Traditional Elbow FlgdxFE",
                angle: "90",
                connector: "202*201",
                centerRadius: "1.08333333333337",
                isConnCheck: "True",
                extraField: "",
                Height: "0.395833333333333",
                width: "0.365",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24128415733160211",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Downward Traditional Elbow PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "2",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Downward Traditional Elbow PExFE.rfa",
                description: "",
                descriptionType: "downward Traditional Elbow PExFE",
                angle: "90",
                connector: "200*201",
                centerRadius: "1.08333333333337",
                isConnCheck: "True",
                extraField: "",
                Height: "1.345",
                width: "0.365",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24128419733160711",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Switchboard Flush Flange FlgdxFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "3",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Switchboard Flush Flange FlgdxFE.rfa",
                description: "",
                descriptionType: "switchboard Flush Flange FlgdxFE",
                angle: "90",
                connector: "202*201",
                centerRadius: "1.24999999999994",
                isConnCheck: "True",
                extraField: "",
                Height: "1.975",
                width: "0.365",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24128447733163511",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Upward Traditional Elbow FExFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "4",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Upward Traditional Elbow FExFlgd.rfa",
                description: "",
                descriptionType: "Upward Traditional Elbow FExFlgd",
                angle: "90",
                connector: "201*202",
                centerRadius: "0.479166666666698",
                isConnCheck: "True",
                extraField: "",
                Height: "0.395833333333333",
                width: "0.365",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24128437733160711",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Upward Traditional Elbow FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "5",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Upward Traditional Elbow FExPE.rfa",
                description: "",
                descriptionType: "Upward Traditional Elbow FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "1.00000000000003",
                isConnCheck: "True",
                extraField: "",
                Height: "1.345",
                width: "0.365",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24128436733160711",
                isClearence: "true"
              }
            ],
            channelCableTrayCross: [
              {
                name: "eaton CU Rearward Cross FExPExFExPE",
                defaultFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "4.75x4.38x4.75x4.38x4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38x5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38x5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38x6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38x7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38x8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38x11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38x16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38x18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38x23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Rearward Cross FExPExFExPE.rfa",
                description: "",
                descriptionType: "rearward Cross FExPExFExPE",
                angle: "90",
                connector: "201*200*201*200",
                centerRadius: "1.80833333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.345",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24128440733161111",
                isClearence: "true"
              },
              {
                name: "eaton CU Figure 25 Downward Cross FExPExPExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayCross",
                position: "2",
                sizeRange: "4.75x4.38x4.75x4.38x4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38x5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38x5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38x6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38x7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38x8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38x11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38x16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38x18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38x23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Figure 25 Downward Cross FExPExPExFE.rfa",
                description: "",
                descriptionType: "Figure 25 Downward Cross",
                angle: "90",
                connector: "201*200*200*201",
                centerRadius: "2.09083333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.975",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "",
                id: "24128416733161111",
                isClearence: "true"
              },
              {
                name: "eaton CU Figure 25 Forward Cross FExPExPExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayCross",
                position: "3",
                sizeRange: "4.75x4.38x4.75x4.38x4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38x5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38x5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38x6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38x7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38x8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38x11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38x16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38x18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38x23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Figure 25 Forward Cross FExPExPExFE.rfa",
                description: "",
                descriptionType: "Figure 25 Forward Cross FExPExPExFE",
                angle: "90",
                connector: "201*200*200*201",
                centerRadius: "2.09083333333336",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.975",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "",
                id: "24128421733161111",
                isClearence: "true"
              },
              {
                name: "eaton CU Figure 25 Upward Cross FExPExFExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayCross",
                position: "5",
                sizeRange: "4.75x4.38x4.75x4.38x4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38x5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38x5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38x6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38x7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38x8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38x11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38x16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38x18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38x23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Figure 25 Upward Cross FExPExFExPE.rfa",
                description: "",
                descriptionType: "Figure 25 Upward Cross FExPExFExPE",
                angle: "90",
                connector: "201*200*201*200",
                centerRadius: "1.80833333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.345",
                displayPosition: "0,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "",
                id: "24128441733161111",
                isClearence: "true"
              }
            ],
            channelCableTrayTee: [
              {
                name: "eaton CU Forward Tee FExPExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "4.75x4.38x4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Forward Tee FExPExPE.rfa",
                description: "",
                descriptionType: "Forward Tee FExPExPE",
                angle: "90",
                connector: "201*200*200",
                centerRadius: "2.27083333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.345",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24128429733161011",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Downward Tee PExFExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "2",
                sizeRange: "4.75x4.38x4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Downward Tee PExFExFE.rfa",
                description: "",
                descriptionType: "downward Tee PExFExFE",
                angle: "90",
                connector: "200*201*201",
                centerRadius: "2.12499999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "1.975",
                width: "0.365",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "24128418733161011",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Rearward Tee PExFExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "3",
                sizeRange: "4.75x4.38x4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Rearward Tee PExFExFE.rfa",
                description: "",
                descriptionType: "rearward Tee PExFExFE",
                angle: "90",
                connector: "200*201*201",
                centerRadius: "2.51000000000003",
                isConnCheck: "True",
                extraField: "",
                Height: "0.365",
                width: "1.975",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "",
                id: "24128431733161011",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Upward Tee PExFExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "4",
                sizeRange: "4.75x4.38x4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Upward Tee PExFExFE.rfa",
                description: "",
                descriptionType: "Upward Tee PExFExFE",
                angle: "90",
                connector: "200*201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "24128430733161011",
                isClearence: "true"
              }
            ],
            channelCableTrayTransition: {
              addDefaultItem: {
                name: "eaton CU Busway Non-Fused Reducer FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "4.75x4.38x5.38x4.38,4.75x4.38x5.88x4.38,4.75x4.38x6.38x4.38,4.75x4.38x7.38x4.38,4.75x4.38x8.64x4.38,4.75x4.38x11.17x4.38,4.75x4.38x16.14x4.38,4.75x4.38x18.64x4.38,4.75x4.38x23.7x4.38,5.38x4.38x4.75x4.38,5.38x4.38x5.88x4.38,5.38x4.38x6.38x4.38,5.38x4.38x7.38x4.38,5.38x4.38x8.64x4.38,5.38x4.38x11.17x4.38,5.38x4.38x16.14x4.38,5.38x4.38x18.64x4.38,5.38x4.38x23.7x4.38,5.88x4.38x4.75x4.38,5.88x4.38x5.38x4.38,5.88x4.38x6.38x4.38,5.88x4.38x7.38x4.38,5.88x4.38x8.64x4.38,5.88x4.38x11.17x4.38,5.88x4.38x16.14x4.38,5.88x4.38x18.64x4.38,5.88x4.38x23.7x4.38,6.38x4.38x4.75x4.38,6.38x4.38x5.38x4.38,6.38x4.38x5.88x4.38,6.38x4.38x7.38x4.38,6.38x4.38x8.64x4.38,6.38x4.38x11.17x4.38,6.38x4.38x16.14x4.38,6.38x4.38x18.64x4.38,6.38x4.38x23.7x4.38,7.38x4.38x4.75x4.38,7.38x4.38x5.38x4.38,7.38x4.38x5.88x4.38,7.38x4.38x6.38x4.38,7.38x4.38x8.64x4.38,7.38x4.38x11.17x4.38,7.38x4.38x16.14x4.38,7.38x4.38x18.64x4.38,7.38x4.38x23.7x4.38,8.64x4.38x4.75x4.38,8.64x4.38x5.38x4.38,8.64x4.38x5.88x4.38,8.64x4.38x6.38x4.38,8.64x4.38x7.38x4.38,8.64x4.38x11.17x4.38,8.64x4.38x16.14x4.38,8.64x4.38x18.64x4.38,8.64x4.38x23.7x4.38,11.17x4.38x4.75x4.38,11.17x4.38x5.38x4.38,11.17x4.38x5.88x4.38,11.17x4.38x6.38x4.38,11.17x4.38x7.38x4.38,11.17x4.38x8.64x4.38,11.17x4.38x16.14x4.38,11.17x4.38x18.64x4.38,11.17x4.38x23.7x4.38,16.14x4.38x4.75x4.38,16.14x4.38x5.38x4.38,16.14x4.38x5.88x4.38,16.14x4.38x6.38x4.38,16.14x4.38x7.38x4.38,16.14x4.38x8.64x4.38,16.14x4.38x11.17x4.38,16.14x4.38x18.64x4.38,16.14x4.38x23.7x4.38,18.64x4.38x4.75x4.38,18.64x4.38x5.38x4.38,18.64x4.38x5.88x4.38,18.64x4.38x6.38x4.38,18.64x4.38x7.38x4.38,18.64x4.38x8.64x4.38,18.64x4.38x11.17x4.38,18.64x4.38x16.14x4.38,18.64x4.38x23.7x4.38,23.7x4.38x4.75x4.38,23.7x4.38x5.38x4.38,23.7x4.38x5.88x4.38,23.7x4.38x6.38x4.38,23.7x4.38x7.38x4.38,23.7x4.38x8.64x4.38,23.7x4.38x11.17x4.38,23.7x4.38x16.14x4.38,23.7x4.38x18.64x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Non-Fused Reducer FExPE.rfa",
                description: "",
                descriptionType: "Non-Fused Reducer FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "",
                id: "24128439733163211",
                isClearence: "true"
              }
            },
            channelCableTrayUnion: {
              addDefaultItem: {
                name: "eaton CU Busway Switchboard Standard Flange FlgdxFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Switchboard Standard Flange FlgdxFE.rfa",
                description: "",
                descriptionType: "switchboard Standard Flange FlgdxFE",
                angle: "90",
                connector: "202*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "",
                id: "24128448733163511",
                isClearence: "true"
              }
            },
            channelCableTrayOffset: [
              {
                name: "eaton CU Busway Downward Offset FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayOffset",
                position: "1",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Downward Offset FExPE.rfa",
                description: "",
                descriptionType: "downward Offset FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "24128417733164611",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Forward Offset FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayOffset",
                position: "2",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Forward Offset FExPE.rfa",
                description: "",
                descriptionType: "Forward Offset FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "24128428733164611",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Rearward Offset FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayOffset",
                position: "3",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Rearward Offset FExPE.rfa",
                description: "",
                descriptionType: "rearward Offset FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "",
                id: "24128442733164611",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Upward Offset FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayOffset",
                position: "4",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Upward Offset FExPE.rfa",
                description: "",
                descriptionType: "Upward Offset FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "24128443733164611",
                isClearence: "true"
              }
            ],
            channelCableTrayMultiPort: [
              {
                name: "eaton CU Busway 180 Transposition FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "1",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway 180 Transposition FExPE.rfa",
                description: "",
                descriptionType: "180 Transposition FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "24128411733163511",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway 90 Transposition FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "2",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway 90 Transposition FExPE.rfa",
                description: "",
                descriptionType: "90 Transposition FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24128412733163511",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Center Cable Tap Box FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "3",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Center Cable Tap Box FExPE.rfa",
                description: "",
                descriptionType: "center Cable Tap Box FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24128413733163511",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway DW-FW Offset FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "4",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway DW-FW Offset FExPE.rfa",
                description: "",
                descriptionType: "dW-FW Offset FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24128423733164611",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway DW-RW Offset FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "5",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway DW-RW Offset FExPE.rfa",
                description: "",
                descriptionType: "dW-RW Offset FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24128424733164611",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway End Cable Tap Box FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "6",
                sizeRange: "4.75x4.38,5.38x4.38,5.88x4.38,6.38x4.38,7.38x4.38,8.64x4.38,11.17x4.38,16.14x4.38,18.64x4.38,23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway End Cable Tap Box FE.rfa",
                description: "",
                descriptionType: "end Cable Tap Box FE",
                angle: "90",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24128422733163511",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Expansion Joint FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "7",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Expansion Joint FExPE.rfa",
                description: "",
                descriptionType: "expansion Joint FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "24128425733163511",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway UW-FW Offset FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "8",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway UW-FW Offset FExPE.rfa",
                description: "",
                descriptionType: "UW-FW Offset FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "",
                id: "24128444733164611",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway UW-RW Offset FExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "9",
                sizeRange: "4.75x4.38x4.75x4.38,5.38x4.38x5.38x4.38,5.88x4.38x5.88x4.38,6.38x4.38x6.38x4.38,7.38x4.38x7.38x4.38,8.64x4.38x8.64x4.38,11.17x4.38x11.17x4.38,16.14x4.38x16.14x4.38,18.64x4.38x18.64x4.38,23.7x4.38x23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway UW-RW Offset FExPE.rfa",
                description: "",
                descriptionType: "UW-RW Offset FExPE",
                angle: "90",
                connector: "201*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "",
                id: "24128445733164611",
                isClearence: "true"
              },
              {
                name: "eaton CU Busway Weatherhead FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "10",
                sizeRange: "4.75x4.38,5.38x4.38,5.88x4.38,6.38x4.38,7.38x4.38,8.64x4.38,11.17x4.38,16.14x4.38,18.64x4.38,23.7x4.38",
                manufacturer: "eaton",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\eaton\\cu pow-r-way iii low voltage busway\\copper\\bus\\",
                icon: "eaton CU Busway Weatherhead FE.rfa",
                description: "",
                descriptionType: "Weatherhead FE",
                angle: "90",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "",
                id: "24128446733166111",
                isClearence: "true"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "-------------------------------WIREWAY-----------------------------",
        unit: "IMPERIAL",
        id: "25",
        systemShape: "conduit",
        systemUniqueId: "171",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "conduit"
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "--------------------Wire Basket Containment--------------------",
        unit: "METRIC",
        id: "2",
        systemShape: "Wire Mesh Cable Tray",
        systemUniqueId: "2",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "Wire Mesh Cable Tray",
            channelCableTrayElbow: [],
            channelCableTrayCross: [],
            channelCableTrayTee: [],
            channelCableTrayTransition: [],
            channelCableTrayUnion: []
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Galv CabloFil CF30 3m x 30mm high",
        unit: "METRIC",
        id: "3",
        systemShape: "Wire Mesh Cable Tray",
        IsHangerNeeded: "True",
        systemUniqueId: "3",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "Wire Mesh Cable Tray",
            electricalTypeItems: {
              name: "M_Cablofil Galv Steel CF30-EZ Wire Cable Tray PExPE",
              id: "2489450542160131",
              Length: "9.85892388451444",
              JunctionType: "Tee",
              OldMat: "",
              shape: "Wire Mesh Cable Tray",
              sizeRange: "50x30,100x30,150x30,200x30,300x30,400x30,450x30,500x30,600x30",
              manufacturer: "cablofil",
              path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
              icon: "M_Cablofil Galv Steel CF30-EZ Wire Cable Tray PExPE.rfa",
              description: "",
              descriptionType: "Wire Basket Straight",
              connector: "200",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "1",
              duplicateFrom: "Wire Mesh Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              isClearence: "false"
            },
            channelCableTrayElbow: [
              {
                name: "M_Cablofil Galv Steel CF30-EZ Bend R15 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "100x30x100x30,150x30x150x30,200x30x200x30,300x30x300x30,400x30x400x30,450x30x450x30,500x30x500x30,600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Bend R15 PExPE.RFA",
                description: "",
                descriptionType: "15 Deg Bend",
                angle: "15",
                connector: "200*200",
                centerRadius: "0.805367486332252",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0984251968503937",
                width: "1.96850393700787",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "2489438542164531",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF30-EZ Bend R30 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "100x30x100x30,150x30x150x30,200x30x200x30,300x30x300x30,400x30x400x30,450x30x450x30,500x30x500x30,600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Bend R30 PExPE.RFA",
                description: "",
                descriptionType: "30 Degree Bend",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.33166495660014",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0984251968503937",
                width: "1.96850393700787",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2489439542160431",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF30-EZ Bend R45 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "100x30x100x30,150x30x150x30,200x30x200x30,300x30x300x30,400x30x400x30,450x30x450x30,500x30x500x30,600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Bend R45 PExPE.RFA",
                description: "",
                descriptionType: "45 Degree Bend",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.89397844548871",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0984251968503937",
                width: "1.96850393700787",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2489440542160531",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF30-EZ Bend R90 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "4",
                sizeRange: "100x30x100x30,150x30x150x30,200x30x200x30,300x30x300x30,400x30x400x30,450x30x450x30,500x30x500x30,600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Bend R90 PExPE.RFA",
                description: "",
                descriptionType: "90 Degree Radius Bend",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.51968503937008",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0984251968503937",
                width: "0.984251968503937",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2489441542160731",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF30-EZ Bend SR90 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "5",
                sizeRange: "100x30x100x30,150x30x150x30,200x30x200x30,300x30x300x30,400x30x400x30,450x30x450x30,500x30x500x30,600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Bend SR90 PExPE.RFA",
                description: "",
                descriptionType: "90 Degree Short Radius Bend",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.1482939632546",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0984251968503937",
                width: "1.96850393700787",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2489442542160731",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF30 Wire Cable Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "6",
                sizeRange: "50x30x50x30,100x30x100x30,150x30x150x30,200x30x200x30,300x30x300x30,400x30x400x30,450x30x450x30,500x30x500x30,600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30 Wire Cable Tray Face PExPE.RFA",
                description: "",
                descriptionType: "Face Based Straight",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24130175542160131",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF30-EZ Cross PExPExPExPE",
                defaultFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "100x30x100x30x50x30x50x30,100x30x100x30x100x30x100x30,150x30x150x30x50x30x50x30,150x30x150x30x100x30x100x30,150x30x150x30x150x30x150x30,200x30x200x30x50x30x50x30,200x30x200x30x100x30x100x30,200x30x200x30x150x30x150x30,200x30x200x30x200x30x200x30,300x30x300x30x50x30x50x30,300x30x300x30x100x30x100x30,300x30x300x30x150x30x150x30,300x30x300x30x200x30x200x30,300x30x300x30x300x30x300x30,400x30x400x30x50x30x50x30,400x30x400x30x100x30x100x30,400x30x400x30x150x30x150x30,400x30x400x30x200x30x200x30,400x30x400x30x300x30x300x30,400x30x400x30x400x30x400x30,450x30x450x30x50x30x50x30,450x30x450x30x100x30x100x30,450x30x450x30x150x30x150x30,450x30x450x30x200x30x200x30,450x30x450x30x300x30x300x30,450x30x450x30x450x30x450x30,500x30x500x30x50x30x50x30,500x30x500x30x100x30x100x30,500x30x500x30x150x30x150x30,500x30x500x30x200x30x200x30,500x30x500x30x300x30x300x30,500x30x500x30x450x30x450x30,500x30x500x30x500x30x500x30,600x30x600x30x50x30x50x30,600x30x600x30x100x30x100x30,600x30x600x30x150x30x150x30,600x30x600x30x200x30x200x30,600x30x600x30x300x30x300x30,600x30x600x30x450x30x450x30,600x30x600x30x500x30x500x30,600x30x600x30x600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Cross PExPExPExPE.RFA",
                description: "",
                descriptionType: "cross",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "0.984251968503937",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0984251968503937",
                width: "0.984251968503937",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2489443542161131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF30-EZ Tee PExPExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "100x30x100x30x50x30,100x30x100x30x100x30,150x30x150x30x50x30,150x30x150x30x100x30,150x30x150x30x150x30,200x30x200x30x50x30,200x30x200x30x100x30,200x30x200x30x150x30,200x30x200x30x200x30,300x30x300x30x50x30,300x30x300x30x100x30,300x30x300x30x150x30,300x30x300x30x200x30,300x30x300x30x300x30,400x30x400x30x50x30,400x30x400x30x100x30,400x30x400x30x150x30,400x30x400x30x200x30,400x30x400x30x300x30,400x30x400x30x400x30,450x30x450x30x50x30,450x30x450x30x100x30,450x30x450x30x150x30,450x30x450x30x200x30,450x30x450x30x300x30,450x30x450x30x450x30,500x30x500x30x50x30,500x30x500x30x100x30,500x30x500x30x150x30,500x30x500x30x200x30,500x30x500x30x300x30,500x30x500x30x450x30,500x30x500x30x500x30,600x30x600x30x50x30,600x30x600x30x100x30,600x30x600x30x150x30,600x30x600x30x200x30,600x30x600x30x300x30,600x30x600x30x450x30,600x30x600x30x500x30,600x30x600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Tee PExPExPE.RFA",
                description: "",
                descriptionType: "Tee",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "0.5249343832021",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0984251968503937",
                width: "0.164041994750656",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "2489449542161031",
                isClearence: "false"
              }
            },
            channelCableTrayTransition: [
              {
                name: "M_Cablofil Galv Steel CF30-EZ Left Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "50x30x100x30,50x30x150x30,50x30x200x30,50x30x300x30,50x30x400x30,50x30x450x30,50x30x500x30,50x30x600x30,100x30x50x30,100x30x150x30,100x30x200x30,100x30x300x30,100x30x400x30,100x30x450x30,100x30x500x30,100x30x600x30,150x30x50x30,150x30x100x30,150x30x200x30,150x30x300x30,150x30x400x30,150x30x450x30,150x30x500x30,150x30x600x30,200x30x50x30,200x30x100x30,200x30x150x30,200x30x300x30,200x30x400x30,200x30x450x30,200x30x500x30,200x30x600x30,300x30x50x30,300x30x100x30,300x30x150x30,300x30x200x30,300x30x400x30,300x30x450x30,300x30x500x30,300x30x600x30,400x30x50x30,400x30x100x30,400x30x150x30,400x30x200x30,400x30x300x30,450x30x50x30,450x30x100x30,450x30x150x30,450x30x200x30,450x30x300x30,450x30x500x30,450x30x600x30,500x30x50x30,500x30x100x30,500x30x150x30,500x30x200x30,500x30x300x30,500x30x450x30,500x30x600x30,600x30x50x30,600x30x100x30,600x30x150x30,600x30x200x30,600x30x300x30,600x30x450x30,600x30x500x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Left Reducer PExPE.RFA",
                description: "",
                descriptionType: "Left Reducer",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "2489444542160831",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF30-EZ Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "2",
                sizeRange: "50x30x100x30,50x30x150x30,50x30x200x30,50x30x300x30,50x30x400x30,50x30x450x30,50x30x500x30,50x30x600x30,100x30x50x30,100x30x150x30,100x30x200x30,100x30x300x30,100x30x400x30,100x30x450x30,100x30x500x30,100x30x600x30,150x30x50x30,150x30x100x30,150x30x200x30,150x30x300x30,150x30x400x30,150x30x450x30,150x30x500x30,150x30x600x30,200x30x50x30,200x30x100x30,200x30x150x30,200x30x300x30,200x30x400x30,200x30x450x30,200x30x500x30,200x30x600x30,300x30x50x30,300x30x100x30,300x30x150x30,300x30x200x30,300x30x400x30,300x30x450x30,300x30x500x30,300x30x600x30,400x30x50x30,400x30x100x30,400x30x150x30,400x30x200x30,400x30x300x30,450x30x50x30,450x30x100x30,450x30x150x30,450x30x200x30,450x30x300x30,450x30x500x30,450x30x600x30,500x30x50x30,500x30x100x30,500x30x150x30,500x30x200x30,500x30x300x30,500x30x450x30,500x30x600x30,600x30x50x30,600x30x100x30,600x30x150x30,600x30x200x30,600x30x300x30,600x30x450x30,600x30x500x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Reducer PExPE.RFA",
                description: "",
                descriptionType: "reducer",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "2489445542163231",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF30-EZ Right Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "3",
                sizeRange: "50x30x100x30,50x30x150x30,50x30x200x30,50x30x300x30,50x30x400x30,50x30x450x30,50x30x500x30,50x30x600x30,100x30x50x30,100x30x150x30,100x30x200x30,100x30x300x30,100x30x400x30,100x30x450x30,100x30x500x30,100x30x600x30,150x30x50x30,150x30x100x30,150x30x200x30,150x30x300x30,150x30x400x30,150x30x450x30,150x30x500x30,150x30x600x30,200x30x50x30,200x30x100x30,200x30x150x30,200x30x300x30,200x30x400x30,200x30x450x30,200x30x500x30,200x30x600x30,300x30x50x30,300x30x100x30,300x30x150x30,300x30x200x30,300x30x400x30,300x30x450x30,300x30x500x30,300x30x600x30,400x30x50x30,400x30x100x30,400x30x150x30,400x30x200x30,400x30x300x30,450x30x50x30,450x30x100x30,450x30x150x30,450x30x200x30,450x30x300x30,450x30x500x30,450x30x600x30,500x30x50x30,500x30x100x30,500x30x150x30,500x30x200x30,500x30x300x30,500x30x450x30,500x30x600x30,600x30x50x30,600x30x100x30,600x30x150x30,600x30x200x30,600x30x300x30,600x30x450x30,600x30x500x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Right Reducer PExPE.RFA",
                description: "",
                descriptionType: "right Reducer",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "2489446542160931",
                isClearence: "false"
              }
            ],
            channelCableTrayUnion: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF30-EZ Splice Plate FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayUnion",
                position: "4",
                sizeRange: "50x30x50x30,100x30x100x30,150x30x150x30,200x30x200x30,300x30x300x30,400x30x400x30,450x30x450x30,500x30x500x30,600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30-ez+ cable tray\\carbon steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30-EZ Splice Plate FExFE.RFA",
                description: "",
                descriptionType: "splice Plate",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.00249999999999764",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0984251968503937",
                width: "1.96850393700787",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "2499757590361231",
                isClearence: "false"
              }
            },
            channelCableTrayOffset: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF30 Offset PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayOffset",
                position: "1",
                sizeRange: "100x30x100x30,150x30x150x30,200x30x200x30,300x30x300x30,400x30x400x30,450x30x450x30,500x30x500x30,600x30x600x30",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf30 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF30 Offset PExPE.RFA",
                description: "",
                descriptionType: "Horizontal and Vertical Offset",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "2489447542164631",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: {
              addDefaultItem: {
                name: "M_P1000T-GR UniStrut Cable Tray Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "500x60x500x60",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\metric\\hangers\\unistrut\\m_cs cable tray trapeze hangers\\carbon steel\\support\\",
                icon: "M_P1000T-GR UniStrut Cable Tray Hanger 1 5_8.RFA",
                description: "",
                descriptionType: "Trapeze hanger",
                angle: "90",
                connector: "",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                bendType: "",
                id: "24123138714764131",
                IsHanger: "True",
                supportDiscipline: "Wire Basket Hanger",
                isClearence: "false"
              }
            }
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Galv CabloFil CF54 3m x 54mm high",
        unit: "METRIC",
        id: "10",
        systemShape: "Wire Mesh Cable Tray",
        systemUniqueId: "10",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "Wire Mesh Cable Tray",
            electricalTypeItems: {
              name: "M_Cablofil Galv Steel CF54-EZ Wire Cable Tray PExPE",
              id: "2489463542260131",
              Length: "9.85892388451444",
              JunctionType: "Tee",
              OldMat: "",
              shape: "Wire Mesh Cable Tray",
              sizeRange: "50x50,100x50,150x50,200x50,300x50,400x50,450x50,500x50,600x50",
              manufacturer: "cablofil",
              path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
              icon: "M_Cablofil Galv Steel CF54-EZ Wire Cable Tray PExPE.rfa",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "1",
              duplicateFrom: "Wire Mesh Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "5",
              LinePattern: "<No Override>",
              isClearence: "false"
            },
            channelCableTrayElbow: [
              {
                name: "M_Cablofil Galv Steel CF54-EZ Bend R15 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "5",
                sizeRange: "100x50x100x50,150x50x150x50,200x50x200x50,300x50x300x50,400x50x400x50,450x50x450x50,500x50x500x50,600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Bend R15 PExPE.RFA",
                description: "",
                angle: "15",
                connector: "200*200",
                centerRadius: "0.805367486332256",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "1.96850393700787",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "2489451542264531",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF54-EZ Bend R30 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "100x50x100x50,150x50x150x50,200x50x200x50,300x50x300x50,400x50x400x50,450x50x450x50,500x50x500x50,600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Bend R30 PExPE.RFA",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.33166495660013",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "1.96850393700787",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2489452542260431",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF54-EZ Bend R45 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "100x50x100x50,150x50x150x50,200x50x200x50,300x50x300x50,400x50x400x50,450x50x450x50,500x50x500x50,600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Bend R45 PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.89397844548871",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "1.96850393700787",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2489453542260531",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF54-EZ Bend R90 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "4",
                sizeRange: "100x50x100x50,150x50x150x50,200x50x200x50,300x50x300x50,400x50x400x50,450x50x450x50,500x50x500x50,600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Bend R90 PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.51115485564304",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "1.96850393700787",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2489454542260731",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF54-EZ Bend SR90 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "100x50x100x50,150x50x150x50,200x50x200x50,300x50x300x50,400x50x400x50,450x50x450x50,500x50x500x50,600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Bend SR90 PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.1482939632546",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "1.96850393700787",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2489455542260731",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF54 Wire Cable Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "7",
                sizeRange: "50x50x50x50,100x50x100x50,150x50x150x50,200x50x200x50,300x50x300x50,400x50x400x50,450x50x450x50,500x50x500x50,600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54 Wire Cable Tray Face PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24130182542260131",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF54-EZ Cross PExPExPExPE",
                defaultFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "100x50x100x50x50x50x50x50,100x50x100x50x100x50x100x50,150x50x150x50x50x50x50x50,150x50x150x50x100x50x100x50,150x50x150x50x150x50x150x50,200x50x200x50x50x50x50x50,200x50x200x50x100x50x100x50,200x50x200x50x150x50x150x50,200x50x200x50x200x50x200x50,300x50x300x50x50x50x50x50,300x50x300x50x100x50x100x50,300x50x300x50x150x50x150x50,300x50x300x50x200x50x200x50,300x50x300x50x300x50x300x50,400x50x400x50x50x50x50x50,400x50x400x50x100x50x100x50,400x50x400x50x150x50x150x50,400x50x400x50x200x50x200x50,400x50x400x50x300x50x300x50,400x50x400x50x400x50x400x50,450x50x450x50x50x50x50x50,450x50x450x50x100x50x100x50,450x50x450x50x150x50x150x50,450x50x450x50x200x50x200x50,450x50x450x50x300x50x300x50,450x50x450x50x450x50x450x50,500x50x500x50x50x50x50x50,500x50x500x50x100x50x100x50,500x50x500x50x150x50x150x50,500x50x500x50x200x50x200x50,500x50x500x50x300x50x300x50,500x50x500x50x450x50x450x50,500x50x500x50x500x50x500x50,600x50x600x50x50x50x50x50,600x50x600x50x100x50x100x50,600x50x600x50x150x50x150x50,600x50x600x50x200x50x200x50,600x50x600x50x300x50x300x50,600x50x600x50x450x50x450x50,600x50x600x50x500x50x500x50,600x50x600x50x600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Cross PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "0.984251968503937",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "0.984251968503937",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2489456542261131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF54-EZ Tee PExPExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "100x50x100x50x50x50,100x50x100x50x100x50,150x50x150x50x50x50,150x50x150x50x100x50,150x50x150x50x150x50,200x50x200x50x50x50,200x50x200x50x100x50,200x50x200x50x150x50,200x50x200x50x200x50,300x50x300x50x50x50,300x50x300x50x100x50,300x50x300x50x150x50,300x50x300x50x200x50,300x50x300x50x300x50,400x50x400x50x50x50,400x50x400x50x100x50,400x50x400x50x150x50,400x50x400x50x200x50,400x50x400x50x300x50,400x50x400x50x400x50,450x50x450x50x50x50,450x50x450x50x100x50,450x50x450x50x150x50,450x50x450x50x200x50,450x50x450x50x300x50,450x50x450x50x450x50,500x50x500x50x50x50,500x50x500x50x100x50,500x50x500x50x150x50,500x50x500x50x200x50,500x50x500x50x300x50,500x50x500x50x450x50,500x50x500x50x500x50,600x50x600x50x50x50,600x50x600x50x100x50,600x50x600x50x150x50,600x50x600x50x200x50,600x50x600x50x300x50,600x50x600x50x450x50,600x50x600x50x500x50,600x50x600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Tee PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.34514435695538",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "1.47637795275591",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "2489462542261031",
                isClearence: "false"
              }
            },
            channelCableTrayTransition: [
              {
                name: "M_Cablofil Galv Steel CF54-EZ Left Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "50x50x100x50,50x50x150x50,50x50x200x50,50x50x300x50,50x50x400x50,50x50x450x50,50x50x500x50,50x50x600x50,100x50x50x50,100x50x150x50,100x50x200x50,100x50x300x50,100x50x400x50,100x50x450x50,100x50x500x50,100x50x600x50,150x50x50x50,150x50x100x50,150x50x200x50,150x50x300x50,150x50x400x50,150x50x450x50,150x50x500x50,150x50x600x50,200x50x50x50,200x50x100x50,200x50x150x50,200x50x300x50,200x50x400x50,200x50x450x50,200x50x500x50,200x50x600x50,300x50x50x50,300x50x100x50,300x50x150x50,300x50x200x50,300x50x400x50,300x50x450x50,300x50x500x50,300x50x600x50,400x50x50x50,400x50x100x50,400x50x150x50,400x50x200x50,400x50x300x50,450x50x50x50,450x50x100x50,450x50x150x50,450x50x200x50,450x50x300x50,450x50x500x50,450x50x600x50,500x50x50x50,500x50x100x50,500x50x150x50,500x50x200x50,500x50x300x50,500x50x450x50,500x50x600x50,600x50x50x50,600x50x100x50,600x50x150x50,600x50x200x50,600x50x300x50,600x50x450x50,600x50x500x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Left Reducer PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "2489457542260831",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF54-EZ Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "2",
                sizeRange: "50x50x100x50,50x50x150x50,50x50x200x50,50x50x300x50,50x50x400x50,50x50x450x50,50x50x500x50,50x50x600x50,100x50x50x50,100x50x150x50,100x50x200x50,100x50x300x50,100x50x400x50,100x50x450x50,100x50x500x50,100x50x600x50,150x50x50x50,150x50x100x50,150x50x200x50,150x50x300x50,150x50x400x50,150x50x450x50,150x50x500x50,150x50x600x50,200x50x50x50,200x50x100x50,200x50x150x50,200x50x300x50,200x50x400x50,200x50x450x50,200x50x500x50,200x50x600x50,300x50x50x50,300x50x100x50,300x50x150x50,300x50x200x50,300x50x400x50,300x50x450x50,300x50x500x50,300x50x600x50,400x50x50x50,400x50x100x50,400x50x150x50,400x50x200x50,400x50x300x50,450x50x50x50,450x50x100x50,450x50x150x50,450x50x200x50,450x50x300x50,450x50x500x50,450x50x600x50,500x50x50x50,500x50x100x50,500x50x150x50,500x50x200x50,500x50x300x50,500x50x450x50,500x50x600x50,600x50x50x50,600x50x100x50,600x50x150x50,600x50x200x50,600x50x300x50,600x50x450x50,600x50x500x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Reducer PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "2489458542263231",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF54-EZ Right Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "3",
                sizeRange: "50x50x100x50,50x50x150x50,50x50x200x50,50x50x300x50,50x50x400x50,50x50x450x50,50x50x500x50,50x50x600x50,100x50x50x50,100x50x150x50,100x50x200x50,100x50x300x50,100x50x400x50,100x50x450x50,100x50x500x50,100x50x600x50,150x50x50x50,150x50x100x50,150x50x200x50,150x50x300x50,150x50x400x50,150x50x450x50,150x50x500x50,150x50x600x50,200x50x50x50,200x50x100x50,200x50x150x50,200x50x300x50,200x50x400x50,200x50x450x50,200x50x500x50,200x50x600x50,300x50x50x50,300x50x100x50,300x50x150x50,300x50x200x50,300x50x400x50,300x50x450x50,300x50x500x50,300x50x600x50,400x50x50x50,400x50x100x50,400x50x150x50,400x50x200x50,400x50x300x50,450x50x50x50,450x50x100x50,450x50x150x50,450x50x200x50,450x50x300x50,450x50x500x50,450x50x600x50,500x50x50x50,500x50x100x50,500x50x150x50,500x50x200x50,500x50x300x50,500x50x450x50,500x50x600x50,600x50x50x50,600x50x100x50,600x50x150x50,600x50x200x50,600x50x300x50,600x50x450x50,600x50x500x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Right Reducer PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "2489459542260931",
                isClearence: "false"
              }
            ],
            channelCableTrayUnion: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF54-EZ Splice Plate PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "50x50x50x50,100x50x100x50,150x50x150x50,200x50x200x50,300x50x300x50,400x50x400x50,450x50x450x50,500x50x500x50,600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Splice Plate PExPE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "2489461542261231",
                isClearence: "false"
              }
            },
            channelCableTrayOffset: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF54-EZ Offset PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayOffset",
                position: "1",
                sizeRange: "100x50x100x50,150x50x150x50,200x50x200x50,300x50x300x50,400x50x400x50,450x50x450x50,500x50x500x50,600x50x600x50",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf54-ez+ cable tray\\carbon steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF54-EZ Offset PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24100177590964631",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Galv CabloFil CF105 3m x 105mm",
        unit: "METRIC",
        id: "17",
        systemShape: "Wire Mesh Cable Tray",
        systemUniqueId: "17",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "Wire Mesh Cable Tray",
            channelCableTrayElbow: [
              {
                name: "M_Cablofil Galv Steel CF105-EZ Bend R15 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Bend R15 PExPE.RFA",
                description: "",
                angle: "15",
                connector: "200*200",
                centerRadius: "0.805367486332252",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "2489425542364531",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105-EZ Bend R30 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Bend R30 PExPE.RFA",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.33166495660013",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2489426542360431",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105-EZ Bend R45 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Bend R45 PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.89397844548871",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2489427542360531",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105-EZ Bend R90 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "4",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Bend R90 PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.51115485564304",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2489428542360731",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105-EZ Bend SR90 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "5",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Bend SR90 PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.47834645669291",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2489429542360731",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105-EZ Wire Cable Tray PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "6",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Wire Cable Tray PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "2489437542360131",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105 Wire Cable Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "7",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105 Wire Cable Tray Face PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24130168542360131",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF105-EZ Cross PExPExPExPE",
                defaultFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "100x100x100x100x50x100x50x100,100x100x100x100x100x100x100x100,150x100x150x100x50x100x50x100,150x100x150x100x100x100x100x100,150x100x150x100x150x100x150x100,200x100x200x100x50x100x50x100,200x100x200x100x100x100x100x100,200x100x200x100x150x100x150x100,200x100x200x100x200x100x200x100,300x100x300x100x50x100x50x100,300x100x300x100x100x100x100x100,300x100x300x100x150x100x150x100,300x100x300x100x200x100x200x100,300x100x300x100x300x100x300x100,400x100x400x100x50x100x50x100,400x100x400x100x100x100x100x100,400x100x400x100x150x100x150x100,400x100x400x100x200x100x200x100,400x100x400x100x300x100x300x100,400x100x400x100x400x100x400x100,450x100x450x100x50x100x50x100,450x100x450x100x100x100x100x100,450x100x450x100x150x100x150x100,450x100x450x100x200x100x200x100,450x100x450x100x300x100x300x100,450x100x450x100x450x100x450x100,500x100x500x100x50x100x50x100,500x100x500x100x100x100x100x100,500x100x500x100x150x100x150x100,500x100x500x100x200x100x200x100,500x100x500x100x300x100x300x100,500x100x500x100x450x100x450x100,500x100x500x100x500x100x500x100,600x100x600x100x50x100x50x100,600x100x600x100x100x100x100x100,600x100x600x100x150x100x150x100,600x100x600x100x200x100x200x100,600x100x600x100x300x100x300x100,600x100x600x100x450x100x450x100,600x100x600x100x500x100x500x100,600x100x600x100x600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Cross PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "0.984251968503937",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.984251968503937",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2489430542361131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: {
              addDefaultItem: {
                name: "M_Cablofil Galv Steel CF105-EZ Tee PExPExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "100x100x100x100x50x100,100x100x100x100x100x100,150x100x150x100x50x100,150x100x150x100x100x100,150x100x150x100x150x100,200x100x200x100x50x100,200x100x200x100x100x100,200x100x200x100x150x100,200x100x200x100x200x100,300x100x300x100x50x100,300x100x300x100x100x100,300x100x300x100x150x100,300x100x300x100x200x100,300x100x300x100x300x100,400x100x400x100x50x100,400x100x400x100x100x100,400x100x400x100x150x100,400x100x400x100x200x100,400x100x400x100x300x100,400x100x400x100x400x100,450x100x450x100x50x100,450x100x450x100x100x100,450x100x450x100x150x100,450x100x450x100x200x100,450x100x450x100x300x100,450x100x450x100x450x100,500x100x500x100x50x100,500x100x500x100x100x100,500x100x500x100x150x100,500x100x500x100x200x100,500x100x500x100x300x100,500x100x500x100x450x100,500x100x500x100x500x100,600x100x600x100x50x100,600x100x600x100x100x100,600x100x600x100x150x100,600x100x600x100x200x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x500x100,600x100x600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Tee PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "0.688976377952756",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.656167979002625",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "2489436542361031",
                isClearence: "false"
              }
            },
            channelCableTrayTransition: [
              {
                name: "M_Cablofil Galv Steel CF105-EZ Left Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "50x100x100x100,50x100x150x100,50x100x200x100,50x100x300x100,50x100x400x100,50x100x450x100,50x100x500x100,50x100x600x100,100x100x50x100,100x100x150x100,100x100x200x100,100x100x300x100,100x100x400x100,100x100x450x100,100x100x500x100,100x100x600x100,150x100x50x100,150x100x100x100,150x100x200x100,150x100x300x100,150x100x400x100,150x100x450x100,150x100x500x100,150x100x600x100,200x100x50x100,200x100x100x100,200x100x150x100,200x100x300x100,200x100x400x100,200x100x450x100,200x100x500x100,200x100x600x100,300x100x50x100,300x100x100x100,300x100x150x100,300x100x200x100,300x100x400x100,300x100x450x100,300x100x500x100,300x100x600x100,400x100x50x100,400x100x100x100,400x100x150x100,400x100x200x100,400x100x300x100,450x100x50x100,450x100x100x100,450x100x150x100,450x100x200x100,450x100x300x100,450x100x500x100,450x100x600x100,500x100x50x100,500x100x100x100,500x100x150x100,500x100x200x100,500x100x300x100,500x100x450x100,500x100x600x100,600x100x50x100,600x100x100x100,600x100x150x100,600x100x200x100,600x100x300x100,600x100x450x100,600x100x500x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Left Reducer PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "2489431542360831",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105-EZ Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "2",
                sizeRange: "50x100x100x100,50x100x150x100,50x100x200x100,50x100x300x100,50x100x400x100,50x100x450x100,50x100x500x100,50x100x600x100,100x100x50x100,100x100x150x100,100x100x200x100,100x100x300x100,100x100x400x100,100x100x450x100,100x100x500x100,100x100x600x100,150x100x50x100,150x100x100x100,150x100x200x100,150x100x300x100,150x100x400x100,150x100x450x100,150x100x500x100,150x100x600x100,200x100x50x100,200x100x100x100,200x100x150x100,200x100x300x100,200x100x400x100,200x100x450x100,200x100x500x100,200x100x600x100,300x100x50x100,300x100x100x100,300x100x150x100,300x100x200x100,300x100x400x100,300x100x450x100,300x100x500x100,300x100x600x100,400x100x50x100,400x100x100x100,400x100x150x100,400x100x200x100,400x100x300x100,450x100x50x100,450x100x100x100,450x100x150x100,450x100x200x100,450x100x300x100,450x100x500x100,450x100x600x100,500x100x50x100,500x100x100x100,500x100x150x100,500x100x200x100,500x100x300x100,500x100x450x100,500x100x600x100,600x100x50x100,600x100x100x100,600x100x150x100,600x100x200x100,600x100x300x100,600x100x450x100,600x100x500x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Reducer PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "2489432542363231",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105-EZ Right Reducer PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "3",
                sizeRange: "50x100x100x100,50x100x150x100,50x100x200x100,50x100x300x100,50x100x400x100,50x100x450x100,50x100x500x100,50x100x600x100,100x100x50x100,100x100x150x100,100x100x200x100,100x100x300x100,100x100x400x100,100x100x450x100,100x100x500x100,100x100x600x100,150x100x50x100,150x100x100x100,150x100x200x100,150x100x300x100,150x100x400x100,150x100x450x100,150x100x500x100,150x100x600x100,200x100x50x100,200x100x100x100,200x100x150x100,200x100x300x100,200x100x400x100,200x100x450x100,200x100x500x100,200x100x600x100,300x100x50x100,300x100x100x100,300x100x150x100,300x100x200x100,300x100x400x100,300x100x450x100,300x100x500x100,300x100x600x100,400x100x50x100,400x100x100x100,400x100x150x100,400x100x200x100,400x100x300x100,450x100x50x100,450x100x100x100,450x100x150x100,450x100x200x100,450x100x300x100,450x100x500x100,450x100x600x100,500x100x50x100,500x100x100x100,500x100x150x100,500x100x200x100,500x100x300x100,500x100x450x100,500x100x600x100,600x100x50x100,600x100x100x100,600x100x150x100,600x100x200x100,600x100x300x100,600x100x450x100,600x100x500x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Right Reducer PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "2489433542360931",
                isClearence: "false"
              }
            ],
            channelCableTrayUnion: [
              {
                name: "M_Cablofil Galv Steel CF105-EZ Splice Plate PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "50x100x50x100,100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105 cable tray\\galvanized steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Splice Plate PExPE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "2489435542363631",
                isClearence: "false"
              },
              {
                name: "M_Cablofil Galv Steel CF105-EZ Splice Plate FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayUnion",
                position: "2",
                sizeRange: "50x100x50x100,100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100",
                manufacturer: "cablofil",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\cablofil cf105-ez+ cable tray\\carbon steel\\tray\\",
                icon: "M_Cablofil Galv Steel CF105-EZ Splice Plate FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.00249999999999764",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "2499503591561231",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "--------------------Ladder Containment--------------------",
        unit: "METRIC",
        id: "28",
        systemShape: "ladder Cable Tray",
        systemUniqueId: "28",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "ladder Cable Tray",
            ladderCableTrayElbow: [
              {
                name: "M_Legrand SS Emerald D Finish Flat 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "1",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Trays",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-d\\galvanized steel\\tray\\",
                icon: "M_Legrand SS Emerald D Finish Flat 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.45472440944881",
                isConnCheck: "True",
                extraField: "",
                Height: "",
                width: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2487573532260731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald D Finish Flat 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "2",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-d\\galvanized steel\\tray\\",
                icon: "M_Legrand SS Emerald D Finish Flat 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.24737532808399",
                isConnCheck: "True",
                extraField: "",
                Height: "",
                width: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2487568532260631",
                isClearence: "false"
              }
            ],
            ladderCableTrayVerticalElbow: [],
            ladderCableTrayCross: [],
            ladderCableTrayTee: [],
            ladderCableTrayUnion: []
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Swifts Galv Medium Duty Topaz G 3m length",
        unit: "METRIC",
        id: "29",
        systemShape: "ladder Cable Tray",
        systemUniqueId: "29",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: {
              name: "M_Legrand SS Topaz G Finish Straight Ladder Tray PExPE",
              id: "24100064592560131",
              Length: "9.84251968503937",
              JunctionType: "Tee",
              OldMat: "",
              shape: "ladder Cable Tray",
              sizeRange: "150x100,300x100,450x100,600x100,750x100,900x100",
              manufacturer: "Legrand",
              path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
              icon: "M_Legrand SS Topaz G Finish Straight Ladder Tray PExPE.rfa",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "4,17",
              dispPosition: "90",
              duplicateFrom: "ladder Cable Tray",
              defaultFor: "",
              isClearence: "false"
            },
            ladderCableTrayElbow: [
              {
                name: "M_Legrand SS Topaz G Finish Flat 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.853018372703409",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "",
                id: "24100073592560431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.05314960629921",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "24100074592560431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.11876640419947",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "",
                id: "24100075592560431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.31561679790026",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "",
                id: "24100076592560431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.38123359580052",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "",
                id: "24100077592560431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.974409448818895",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.47637795275591",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "",
                id: "24100078592560531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.38123359580052",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "",
                id: "24100079592560531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.68635170603675",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "",
                id: "24100080592560531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.78805774278215",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "",
                id: "24100081592560531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "12",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "2.09317585301837",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "",
                id: "24100082592560531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "13",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.67979002624671",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "24100083592560631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "14",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.96194225721784",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "24100084592560631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "15",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.24737532808399",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "",
                id: "24100085592560631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "16",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.53280839895013",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "",
                id: "24100086592560631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "17",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.67388451443569",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "",
                id: "24100087592560631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "18",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.71653543307086",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "",
                id: "24100088592560731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "19",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.20866141732283",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "",
                id: "24100089592560731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "20",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Trays",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.70078740157479",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "",
                id: "24100090592560731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "21",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.94685039370078",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "",
                id: "24100091592560731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flat 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "22",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flat 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "4.68503937007873",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "",
                id: "24100092592560731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Straight Ladder Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "23",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Straight Ladder Tray Face PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,17",
                dispPosition: "89",
                csvFileName: "",
                bendType: "",
                id: "24130196592560131",
                isClearence: "false"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "M_Legrand SS Topaz G Finish ZIR 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.308398950131233",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "3,9",
                dispPosition: "49",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100093592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.439632545931758",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "4,9",
                dispPosition: "50",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100094592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.570866141732283",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "0,10",
                dispPosition: "51",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100095592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.702099737532806",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "1,10",
                dispPosition: "52",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100096592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.836614173228349",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "2,10",
                dispPosition: "53",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100097592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.475721784776903",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "3,10",
                dispPosition: "54",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100103592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.679133858267717",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "4,10",
                dispPosition: "55",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100104592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.882545931758529",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "0,11",
                dispPosition: "56",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100105592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.08595800524934",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "1,11",
                dispPosition: "57",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100106592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.29265091863517",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "2,11",
                dispPosition: "58",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100107592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.662729658792651",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "3,11",
                dispPosition: "59",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100113592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.948162729658791",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "4,11",
                dispPosition: "60",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100114592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.23031496062992",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "0,12",
                dispPosition: "61",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100115592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.51574803149606",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "1,12",
                dispPosition: "62",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100116592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.79790026246719",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "2,12",
                dispPosition: "63",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100117592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.14829396325459",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "3,12",
                dispPosition: "64",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100123592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.64041994750654",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "4,12",
                dispPosition: "65",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100124592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.13254593175853",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "0,13",
                dispPosition: "66",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100125592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.62467191601049",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "1,13",
                dispPosition: "67",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100126592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZIR 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZIR 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.11679790026246",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "2,13",
                dispPosition: "68",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24100127592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "21",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.308398950131232",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.328083989501312",
                displayPosition: "3,13",
                dispPosition: "69",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100098592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "22",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.439632545931756",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.328083989501312",
                displayPosition: "4,13",
                dispPosition: "70",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100099592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "23",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.570866141732282",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.328083989501312",
                displayPosition: "0,14",
                dispPosition: "71",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100100592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "24",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.702099737532806",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.328083989501312",
                displayPosition: "1,14",
                dispPosition: "72",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100101592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "25",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.836614173228347",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.328083989501312",
                displayPosition: "2,14",
                dispPosition: "73",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100102592563031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "26",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.475721784776901",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.328083989501312",
                displayPosition: "3,14",
                dispPosition: "74",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100108592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "27",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.679133858267715",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.328083989501312",
                displayPosition: "4,14",
                dispPosition: "75",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100109592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "28",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.882545931758529",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "0,15",
                dispPosition: "76",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100110592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "29",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.08595800524934",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.328083989501312",
                displayPosition: "1,15",
                dispPosition: "77",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100111592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "30",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.29265091863516",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.328083989501312",
                displayPosition: "2,15",
                dispPosition: "78",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100112592560331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "31",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.66272965879265",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.328083989501312",
                displayPosition: "3,15",
                dispPosition: "79",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100118592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "32",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.948162729658792",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "4,15",
                dispPosition: "80",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100119592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "33",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.23031496062992",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.328083989501312",
                displayPosition: "0,16",
                dispPosition: "81",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100120592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "34",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.51574803149606",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.328083989501312",
                displayPosition: "1,16",
                dispPosition: "82",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100121592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "35",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.79790026246719",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.328083989501312",
                displayPosition: "2,16",
                dispPosition: "83",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100122592563131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "36",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.14829396325459",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "3,16",
                dispPosition: "84",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100128592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "37",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.64041994750655",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.328083989501312",
                displayPosition: "4,16",
                dispPosition: "85",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100129592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "38",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.13254593175852",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "0,17",
                dispPosition: "86",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100130592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "39",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.6246719160105",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.328083989501312",
                displayPosition: "1,17",
                dispPosition: "87",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100131592560231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish ZOR 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "40",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish ZOR 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.11679790026247",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.328083989501312",
                displayPosition: "2,17",
                dispPosition: "88",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24100132592560231",
                isClearence: "false"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "M_Legrand SS Topaz G Finish Cross 300 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "150x100x150x100x150x100x150x100,300x100x300x100x300x100x300x100,450x100x450x100x450x100x450x100,600x100x600x100x600x100x600x100,750x100x750x100x750x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Cross 300 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.22769028871389",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24100143592561131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Cross 300 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "900x100x900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Cross 300 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.71981627296589",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "24100144592561131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Cross 450 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "150x100x150x100x150x100x150x100,300x100x300x100x300x100x300x100,450x100x450x100x450x100x450x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Cross 450 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.47375328083989",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.47637795275591",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "24100145592561131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Cross 450 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "600x100x600x100x600x100x600x100,750x100x750x100x750x100x750x100,900x100x900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Cross 450 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.21194225721784",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24100146592561131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Cross 600 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "5",
                sizeRange: "150x100x150x100x150x100x150x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Cross 600 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.47375328083989",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.492125984251969",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24100147592561131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Cross 600 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "6",
                sizeRange: "150x100x150x100x150x100x150x100,300x100x300x100x300x100x300x100,450x100x450x100x450x100x450x100,600x100x600x100x600x100x600x100,750x100x750x100x750x100x750x100,900x100x900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Cross 600 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.95013123359581",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24100148592561131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Cross 750 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "7",
                sizeRange: "150x100x150x100x150x100x150x100,300x100x300x100x300x100x300x100,450x100x450x100x450x100x450x100,600x100x600x100x600x100x600x100,750x100x750x100x750x100x750x100,900x100x900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Cross 750 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "4.44225721784776",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "24100149592561131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Cross 900 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "8",
                sizeRange: "300x100x300x100x300x100x300x100,450x100x450x100x450x100x450x100,600x100x600x100x600x100x600x100,750x100x750x100x750x100x750x100,900x100x900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Cross 900 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.45800524934384",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "24100150592561131",
                isClearence: "false"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "M_Legrand SS Topaz G Finish Equal Tee 300 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "150x100x150x100x150x100,300x100x300x100x300x100,450x100x450x100x450x100,600x100x600x100x600x100,750x100x750x100x750x100,900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Equal Tee 300 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.71981627296588",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24100133592561031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Equal Tee 450 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "150x100x150x100x150x100,300x100x300x100x300x100,450x100x450x100x450x100,600x100x600x100x600x100,750x100x750x100x750x100,900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Equal Tee 450 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.21194225721785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24100134592561031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Equal Tee 600 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "150x100x150x100x150x100,300x100x300x100x300x100,450x100x450x100x450x100,600x100x600x100x600x100,750x100x750x100x750x100,900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Equal Tee 600 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.45800524934384",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24100135592561031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Equal Tee 750 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "150x100x150x100x150x100,300x100x300x100x300x100,450x100x450x100x450x100,600x100x600x100x600x100,750x100x750x100x750x100,900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Equal Tee 750 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.70406824146982",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24100136592561031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Equal Tee 900 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "150x100x150x100x150x100,300x100x300x100x300x100,450x100x450x100x450x100,600x100x600x100x600x100,750x100x750x100x750x100,900x100x900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Equal Tee 900 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.68832020997375",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24100137592561031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Unequal Tee 300 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "6",
                sizeRange: "150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x600x100,150x100x150x100x750x100,150x100x150x100x900x100,300x100x300x100x150x100,300x100x300x100x450x100,300x100x300x100x600x100,300x100x300x100x750x100,300x100x300x100x900x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x600x100,450x100x450x100x750x100,450x100x450x100x900x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x750x100,600x100x600x100x900x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x600x100,750x100x750x100x900x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x600x100,900x100x900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Unequal Tee 300 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.2244094488189",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "3,8",
                dispPosition: "44",
                csvFileName: "",
                bendType: "",
                id: "24100138592563331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Unequal Tee 450 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "7",
                sizeRange: "150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x600x100,150x100x150x100x750x100,150x100x150x100x900x100,300x100x300x100x150x100,300x100x300x100x450x100,300x100x300x100x600x100,300x100x300x100x750x100,300x100x300x100x900x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x600x100,450x100x450x100x750x100,450x100x450x100x900x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x750x100,600x100x600x100x900x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x600x100,750x100x750x100x900x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x600x100,900x100x900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Unequal Tee 450 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.71653543307087",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.47637795275591",
                displayPosition: "4,8",
                dispPosition: "45",
                csvFileName: "",
                bendType: "",
                id: "24100139592563331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Unequal Tee 600 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "8",
                sizeRange: "150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x600x100,150x100x150x100x750x100,150x100x150x100x900x100,300x100x300x100x150x100,300x100x300x100x450x100,300x100x300x100x600x100,300x100x300x100x750x100,300x100x300x100x900x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x600x100,450x100x450x100x750x100,450x100x450x100x900x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x750x100,600x100x600x100x900x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x600x100,750x100x750x100x900x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x600x100,900x100x900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Unequal Tee 600 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.71653543307087",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "0,9",
                dispPosition: "46",
                csvFileName: "",
                bendType: "",
                id: "24100140592563331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Unequal Tee 750 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "9",
                sizeRange: "150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x600x100,150x100x150x100x750x100,150x100x150x100x900x100,300x100x300x100x150x100,300x100x300x100x450x100,300x100x300x100x600x100,300x100x300x100x750x100,300x100x300x100x900x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x600x100,450x100x450x100x750x100,450x100x450x100x900x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x750x100,600x100x600x100x900x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x600x100,750x100x750x100x900x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x600x100,900x100x900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Unequal Tee 750 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.19291338582677",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.46062992125984",
                displayPosition: "1,9",
                dispPosition: "47",
                csvFileName: "",
                bendType: "",
                id: "24100141592563331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Unequal Tee 900 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "10",
                sizeRange: "150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x600x100,150x100x150x100x750x100,150x100x150x100x900x100,300x100x300x100x150x100,300x100x300x100x450x100,300x100x300x100x600x100,300x100x300x100x750x100,300x100x300x100x900x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x600x100,450x100x450x100x750x100,450x100x450x100x900x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x750x100,600x100x600x100x900x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x600x100,750x100x750x100x900x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x600x100,900x100x900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Unequal Tee 900 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.19291338582677",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.984251968503937",
                displayPosition: "2,9",
                dispPosition: "48",
                csvFileName: "",
                bendType: "",
                id: "24100142592563331",
                isClearence: "false"
              }
            ],
            ladderCableTrayTransition: [
              {
                name: "M_Legrand SS Topaz G Finish Left Hand Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "1",
                sizeRange: "150x100x300x100,150x100x450x100,150x100x600x100,150x100x750x100,150x100x900x100,300x100x150x100,300x100x450x100,300x100x600x100,300x100x750x100,300x100x900x100,450x100x150x100,450x100x300x100,450x100x600x100,450x100x750x100,450x100x900x100,600x100x150x100,600x100x300x100,600x100x450x100,600x100x750x100,600x100x900x100,750x100x150x100,750x100x300x100,750x100x450x100,750x100x600x100,750x100x900x100,900x100x150x100,900x100x300x100,900x100x450x100,900x100x600x100,900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Left Hand Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "M_Legrand SS Topaz G Finish Left Hand Reducer FExFE",
                bendType: "",
                id: "24100068592560831",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Offset Reducer Bracket FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "2",
                sizeRange: "150x100x300x100,150x100x450x100,150x100x600x100,150x100x750x100,150x100x900x100,300x100x150x100,300x100x450x100,300x100x600x100,300x100x750x100,300x100x900x100,450x100x150x100,450x100x300x100,450x100x600x100,450x100x750x100,450x100x900x100,600x100x150x100,600x100x300x100,600x100x450x100,600x100x750x100,600x100x900x100,750x100x150x100,750x100x300x100,750x100x450x100,750x100x600x100,750x100x900x100,900x100x150x100,900x100x300x100,900x100x450x100,900x100x600x100,900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Offset Reducer Bracket FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "M_Legrand SS Topaz G Finish Offset Reducer Bracket FExFE",
                bendType: "",
                id: "24100069592563231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Right Hand Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "3",
                sizeRange: "150x100x300x100,150x100x450x100,150x100x600x100,150x100x750x100,150x100x900x100,300x100x150x100,300x100x450x100,300x100x600x100,300x100x750x100,300x100x900x100,450x100x150x100,450x100x300x100,450x100x600x100,450x100x750x100,450x100x900x100,600x100x150x100,600x100x300x100,600x100x450x100,600x100x750x100,600x100x900x100,750x100x150x100,750x100x300x100,750x100x450x100,750x100x600x100,750x100x900x100,900x100x150x100,900x100x300x100,900x100x450x100,900x100x600x100,900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Right Hand Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "M_Legrand SS Topaz G Finish Right Hand Reducer FExFE",
                bendType: "",
                id: "24100072592560931",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Straight Reducer Bracket FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "4",
                sizeRange: "150x100x300x100,150x100x450x100,150x100x600x100,150x100x750x100,150x100x900x100,300x100x150x100,300x100x450x100,300x100x600x100,300x100x750x100,300x100x900x100,450x100x150x100,450x100x300x100,450x100x600x100,450x100x750x100,450x100x900x100,600x100x150x100,600x100x300x100,600x100x450x100,600x100x750x100,600x100x900x100,750x100x150x100,750x100x300x100,750x100x450x100,750x100x600x100,750x100x900x100,900x100x150x100,900x100x300x100,900x100x450x100,900x100x600x100,900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Straight Reducer Bracket FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,8",
                dispPosition: "42",
                csvFileName: "M_Legrand SS Topaz G Finish Straight Reducer Bracket FExFE",
                bendType: "",
                id: "24100070592563231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Straight Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "5",
                sizeRange: "150x100x300x100,150x100x450x100,150x100x600x100,150x100x750x100,150x100x900x100,300x100x150x100,300x100x450x100,300x100x600x100,300x100x750x100,300x100x900x100,450x100x150x100,450x100x300x100,450x100x600x100,450x100x750x100,450x100x900x100,600x100x150x100,600x100x300x100,600x100x450x100,600x100x750x100,600x100x900x100,750x100x150x100,750x100x300x100,750x100x450x100,750x100x600x100,750x100x900x100,900x100x150x100,900x100x300x100,900x100x450x100,900x100x600x100,900x100x750x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Straight Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,8",
                dispPosition: "43",
                csvFileName: "M_Legrand SS Topaz G Finish Straight Reducer FExFE",
                bendType: "",
                id: "24100071592563231",
                isClearence: "false"
              }
            ],
            ladderCableTrayUnion: [
              {
                name: "M_Legrand SS Topaz G Finish Coupler Straight Length FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Coupler Straight Length FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24100065592561231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Fitting to Fitting Coupler PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "2",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Fitting to Fitting Coupler PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "24100067592561231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Topaz G Finish Flexible Expansion Coupler FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "3",
                sizeRange: "150x100x150x100,300x100x300x100,450x100x450x100,600x100x600x100,750x100x750x100,900x100x900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Flexible Expansion Coupler FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "",
                id: "24100066592561231",
                isClearence: "false"
              }
            ],
            ladderCableTrayMultiPort: {
              addDefaultItem: {
                name: "M_Legrand SS Topaz G Finish Stop End Type D FE",
                defaultFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "150x100,300x100,450x100,600x100,750x100,900x100",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder topaz-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Topaz G Finish Stop End Type D FE.RFA",
                description: "",
                angle: "",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "",
                id: "24100063592566131",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Swifts Galv Heavy Duty Sapphire G 3m length",
        unit: "METRIC",
        id: "32",
        systemShape: "ladder Cable Tray",
        systemUniqueId: "32",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: {
              name: "M_Legrand SS Sapphire G Finish Straight Ladder Tray PExPE",
              id: "2499890592360131",
              Length: "9.84251968503937",
              JunctionType: "Tee",
              OldMat: "",
              shape: "ladder Cable Tray",
              sizeRange: "150x125,300x125,450x125,600x125,750x125,900x125",
              manufacturer: "Legrand",
              path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
              icon: "M_Legrand SS Sapphire G Finish Straight Ladder Tray PExPE.rfa",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "4,17",
              dispPosition: "90",
              duplicateFrom: "ladder Cable Tray",
              defaultFor: "",
              isClearence: "false"
            },
            ladderCableTrayElbow: [
              {
                name: "M_Legrand SS Sapphire G Finish Flat 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.853018372703409",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "",
                id: "2499897592360431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.921916010498684",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "2499898592360431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.11876640419948",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "",
                id: "2499899592360431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.31561679790026",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "",
                id: "2499900592360431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.38123359580053",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "",
                id: "2499901592360431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.974409448818897",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.47637795275591",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "",
                id: "2499902592360531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.38123359580052",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "",
                id: "2499903592360531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.68635170603675",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "",
                id: "2499904592360531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.78805774278215",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "",
                id: "2499905592360531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "12",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "2.09317585301837",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "",
                id: "2499906592360531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "13",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.67979002624672",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "2499907592360631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "14",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.96194225721785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "2499908592360631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "15",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.24737532808399",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "",
                id: "2499909592360631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "16",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.53280839895013",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "",
                id: "2499910592360631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "17",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.67388451443569",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "",
                id: "2499911592360631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "18",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.71653543307086",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "",
                id: "2499912592360731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "19",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.20866141732283",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "",
                id: "2499913592360731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "20",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Trays",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.70078740157479",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "",
                id: "2499914592360731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "21",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.94685039370078",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "",
                id: "2499915592360731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flat 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "22",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flat 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "4.68503937007873",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "",
                id: "2499916592360731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Straight Ladder Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "23",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Straight Ladder Tray Face PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,17",
                dispPosition: "89",
                csvFileName: "",
                bendType: "",
                id: "24130193592360131",
                isClearence: "false"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "M_Legrand SS Sapphire G Finish PIR 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.318241469816273",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.41010498687664",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499917592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.449475065616796",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499918592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.583989501312333",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "1,8",
                dispPosition: "42",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499919592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.715223097112858",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "2,8",
                dispPosition: "43",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499920592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.846456692913384",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "3,8",
                dispPosition: "44",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499921592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.492125984251968",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "4,8",
                dispPosition: "45",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499927592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.695538057742781",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "0,9",
                dispPosition: "46",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499928592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.898950131233594",
                isConnCheck: "True",
                extraField: "",
                Height: "2.46062992125984",
                width: "0.41010498687664",
                displayPosition: "1,9",
                dispPosition: "47",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499929592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.10564304461942",
                isConnCheck: "True",
                extraField: "",
                Height: "2.46062992125984",
                width: "0.41010498687664",
                displayPosition: "2,9",
                dispPosition: "48",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499930592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.30905511811023",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.41010498687664",
                displayPosition: "3,9",
                dispPosition: "49",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499931592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.685695538057742",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "4,9",
                dispPosition: "50",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499937592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.971128608923884",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "0,10",
                dispPosition: "51",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499938592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.25328083989501",
                isConnCheck: "True",
                extraField: "",
                Height: "2.46062992125984",
                width: "0.41010498687664",
                displayPosition: "1,10",
                dispPosition: "52",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499939592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.53871391076115",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.41010498687664",
                displayPosition: "2,10",
                dispPosition: "53",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499940592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.8241469816273",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "3,10",
                dispPosition: "54",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499941592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.19094488188976",
                isConnCheck: "True",
                extraField: "",
                Height: "2.46062992125984",
                width: "0.41010498687664",
                displayPosition: "4,10",
                dispPosition: "55",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499947592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.68307086614173",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "0,11",
                dispPosition: "56",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499948592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.1751968503937",
                isConnCheck: "True",
                extraField: "",
                Height: "2.46062992125984",
                width: "0.41010498687664",
                displayPosition: "1,11",
                dispPosition: "57",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499949592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.66732283464567",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "2,11",
                dispPosition: "58",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499950592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish PIR 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish PIR 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.15944881889764",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "3,11",
                dispPosition: "59",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499951592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "21",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.318241469816272",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "4,11",
                dispPosition: "60",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499922592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "22",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.449475065616798",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "0,12",
                dispPosition: "61",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499923592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "23",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.583989501312338",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "1,12",
                dispPosition: "62",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499924592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "24",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.715223097112859",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.41010498687664",
                displayPosition: "2,12",
                dispPosition: "63",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499925592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "25",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.846456692913381",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "3,12",
                dispPosition: "64",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499926592363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "26",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.492125984251968",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.41010498687664",
                displayPosition: "4,12",
                dispPosition: "65",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499932592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "27",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.695538057742783",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.41010498687664",
                displayPosition: "0,13",
                dispPosition: "66",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499933592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "28",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.898950131233594",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.41010498687664",
                displayPosition: "1,13",
                dispPosition: "67",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499934592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "29",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.10564304461942",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.41010498687664",
                displayPosition: "2,13",
                dispPosition: "68",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499935592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "30",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.30905511811023",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "3,13",
                dispPosition: "69",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499936592360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "31",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.685695538057741",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.41010498687664",
                displayPosition: "4,13",
                dispPosition: "70",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499942592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "32",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.971128608923883",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.41010498687664",
                displayPosition: "0,14",
                dispPosition: "71",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499943592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "33",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.25328083989501",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.41010498687664",
                displayPosition: "1,14",
                dispPosition: "72",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499944592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "34",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.53871391076115",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.41010498687664",
                displayPosition: "2,14",
                dispPosition: "73",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499945592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "35",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.82414698162729",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.41010498687664",
                displayPosition: "3,14",
                dispPosition: "74",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499946592363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "36",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.19094488188976",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "4,14",
                dispPosition: "75",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499952592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "37",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.68307086614173",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "0,15",
                dispPosition: "76",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499953592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "38",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.1751968503937",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "1,15",
                dispPosition: "77",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499954592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "39",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.66732283464566",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "2,15",
                dispPosition: "78",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499955592360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish POR 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "40",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish POR 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.15944881889764",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "3,15",
                dispPosition: "79",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499956592360231",
                isClearence: "false"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "M_Legrand SS Sapphire G Finish Cross 300 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "150x125x150x125x150x125x150x125,300x125x300x125x300x125x300x125,450x125x450x125x450x125x450x125,600x125x600x125x600x125x600x125,750x125x750x125x750x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Cross 300 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "1.73556430446194",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "0.984251968503937",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2499967592361131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Cross 300 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "900x125x900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Cross 300 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.71981627296587",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2499968592361131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Cross 450 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "150x125x150x125x150x125x150x125,300x125x300x125x300x125x300x125,450x125x450x125x450x125x450x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Cross 450 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.47375328083989",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.47637795275591",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2499969592361131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Cross 450 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "600x125x600x125x600x125x600x125,750x125x750x125x750x125x750x125,900x125x900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Cross 450 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.21194225721784",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2499970592361131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Cross 600 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "5",
                sizeRange: "150x125x150x125x150x125x150x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Cross 600 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.47375328083989",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "0.492125984251969",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2499971592361131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Cross 600 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "6",
                sizeRange: "300x125x300x125x300x125x300x125,450x125x450x125x450x125x450x125,600x125x600x125x600x125x600x125,750x125x750x125x750x125x750x125,900x125x900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Cross 600 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.45800524934382",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "2499972592361131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Cross 750 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "7",
                sizeRange: "150x125x150x125x150x125x150x125,300x125x300x125x300x125x300x125,450x125x450x125x450x125x450x125,600x125x600x125x600x125x600x125,750x125x750x125x750x125x750x125,900x125x900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Cross 750 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.9501312335958",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "2499973592361131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Cross 900 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "8",
                sizeRange: "150x125x150x125x150x125x150x125,300x125x300x125x300x125x300x125,450x125x450x125x450x125x450x125,600x125x600x125x600x125x600x125,750x125x750x125x750x125x750x125,900x125x900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Cross 900 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "4.44225721784776",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "2499974592361131",
                isClearence: "false"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "M_Legrand SS Sapphire G Finish Equal Tee 300 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "150x125x150x125x150x125,300x125x300x125x300x125,450x125x450x125x450x125,600x125x600x125x600x125,750x125x750x125x750x125,900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Equal Tee 300 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.22769028871391",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "2499957592361031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Equal Tee 450 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "150x125x150x125x150x125,300x125x300x125x300x125,450x125x450x125x450x125,600x125x600x125x600x125,750x125x750x125x750x125,900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Equal Tee 450 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.21194225721785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "2499958592361031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Equal Tee 600 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "150x125x150x125x150x125,300x125x300x125x300x125,450x125x450x125x450x125,600x125x600x125x600x125,750x125x750x125x750x125,900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Equal Tee 600 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.45800524934384",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "2499959592361031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Equal Tee 750 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "150x125x150x125x150x125,300x125x300x125x300x125,450x125x450x125x450x125,600x125x600x125x600x125,750x125x750x125x750x125,900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Equal Tee 750 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.70406824146982",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "2499960592361031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Equal Tee 900 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "150x125x150x125x150x125,300x125x300x125x300x125,450x125x450x125x450x125,600x125x600x125x600x125,750x125x750x125x750x125,900x125x900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Equal Tee 900 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.68832020997375",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "2499961592361031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Unequal Tee 300 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "6",
                sizeRange: "150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x600x125,150x125x150x125x750x125,150x125x150x125x900x125,300x125x300x125x150x125,300x125x300x125x450x125,300x125x300x125x600x125,300x125x300x125x750x125,300x125x300x125x900x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x600x125,450x125x450x125x750x125,450x125x450x125x900x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x750x125,600x125x600x125x900x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x600x125,750x125x750x125x900x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x600x125,900x125x900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Unequal Tee 300 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.2244094488189",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.95275590551181",
                displayPosition: "3,16",
                dispPosition: "84",
                csvFileName: "",
                bendType: "",
                id: "2499962592363331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Unequal Tee 450 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "7",
                sizeRange: "150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x600x125,150x125x150x125x750x125,150x125x150x125x900x125,300x125x300x125x150x125,300x125x300x125x450x125,300x125x300x125x600x125,300x125x300x125x750x125,300x125x300x125x900x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x600x125,450x125x450x125x750x125,450x125x450x125x900x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x750x125,600x125x600x125x900x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x600x125,750x125x750x125x900x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x600x125,900x125x900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Unequal Tee 450 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.71653543307087",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.47637795275591",
                displayPosition: "4,16",
                dispPosition: "85",
                csvFileName: "",
                bendType: "",
                id: "2499963592363331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Unequal Tee 600 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "8",
                sizeRange: "150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x600x125,150x125x150x125x750x125,150x125x150x125x900x125,300x125x300x125x150x125,300x125x300x125x450x125,300x125x300x125x600x125,300x125x300x125x750x125,300x125x300x125x900x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x600x125,450x125x450x125x750x125,450x125x450x125x900x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x750x125,600x125x600x125x900x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x600x125,750x125x750x125x900x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x600x125,900x125x900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Unequal Tee 600 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.71653543307087",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "0,17",
                dispPosition: "86",
                csvFileName: "",
                bendType: "",
                id: "2499964592363331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Unequal Tee 750 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "9",
                sizeRange: "150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x600x125,150x125x150x125x750x125,150x125x150x125x900x125,300x125x300x125x150x125,300x125x300x125x450x125,300x125x300x125x600x125,300x125x300x125x750x125,300x125x300x125x900x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x600x125,450x125x450x125x750x125,450x125x450x125x900x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x750x125,600x125x600x125x900x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x600x125,750x125x750x125x900x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x600x125,900x125x900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Unequal Tee 750 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.19291338582677",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.46062992125984",
                displayPosition: "1,17",
                dispPosition: "87",
                csvFileName: "",
                bendType: "",
                id: "2499965592363331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Unequal Tee 900 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "10",
                sizeRange: "150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x600x125,150x125x150x125x750x125,150x125x150x125x900x125,300x125x300x125x150x125,300x125x300x125x450x125,300x125x300x125x600x125,300x125x300x125x750x125,300x125x300x125x900x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x600x125,450x125x450x125x750x125,450x125x450x125x900x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x750x125,600x125x600x125x900x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x600x125,750x125x750x125x900x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x600x125,900x125x900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Unequal Tee 900 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.19291338582677",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "0.984251968503937",
                displayPosition: "2,17",
                dispPosition: "88",
                csvFileName: "",
                bendType: "",
                id: "2499966592363331",
                isClearence: "false"
              }
            ],
            ladderCableTrayTransition: [
              {
                name: "M_Legrand SS Sapphire G Finish Left Hand Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "1",
                sizeRange: "150x125x300x125,150x125x450x125,150x125x600x125,150x125x750x125,150x125x900x125,300x125x150x125,300x125x450x125,300x125x600x125,300x125x750x125,300x125x900x125,450x125x150x125,450x125x300x125,450x125x600x125,450x125x750x125,450x125x900x125,600x125x150x125,600x125x300x125,600x125x450x125,600x125x750x125,600x125x900x125,750x125x150x125,750x125x300x125,750x125x450x125,750x125x600x125,750x125x900x125,900x125x150x125,900x125x300x125,900x125x450x125,900x125x600x125,900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Left Hand Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "M_Legrand SS Sapphire G Finish Left Hand Reducer FExFE",
                bendType: "",
                id: "2499891592360831",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Offset Reducer Bracket FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "2",
                sizeRange: "150x125x300x125,150x125x450x125,150x125x600x125,150x125x750x125,150x125x900x125,300x125x150x125,300x125x450x125,300x125x600x125,300x125x750x125,300x125x900x125,450x125x150x125,450x125x300x125,450x125x600x125,450x125x750x125,450x125x900x125,600x125x150x125,600x125x300x125,600x125x450x125,600x125x750x125,600x125x900x125,750x125x150x125,750x125x300x125,750x125x450x125,750x125x600x125,750x125x900x125,900x125x150x125,900x125x300x125,900x125x450x125,900x125x600x125,900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Offset Reducer Bracket FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "M_Legrand SS Sapphire G Finish Offset Reducer Bracket FExFE",
                bendType: "",
                id: "2499892592363231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Right Hand Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "3",
                sizeRange: "150x125x300x125,150x125x450x125,150x125x600x125,150x125x750x125,150x125x900x125,300x125x150x125,300x125x450x125,300x125x600x125,300x125x750x125,300x125x900x125,450x125x150x125,450x125x300x125,450x125x600x125,450x125x750x125,450x125x900x125,600x125x150x125,600x125x300x125,600x125x450x125,600x125x750x125,600x125x900x125,750x125x150x125,750x125x300x125,750x125x450x125,750x125x600x125,750x125x900x125,900x125x150x125,900x125x300x125,900x125x450x125,900x125x600x125,900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Right Hand Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,15",
                dispPosition: "80",
                csvFileName: "M_Legrand SS Sapphire G Finish Right Hand Reducer FExFE",
                bendType: "",
                id: "2499895592360931",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Straight Reducer Bracket FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "4",
                sizeRange: "150x125x300x125,150x125x450x125,150x125x600x125,150x125x750x125,150x125x900x125,300x125x150x125,300x125x450x125,300x125x600x125,300x125x750x125,300x125x900x125,450x125x150x125,450x125x300x125,450x125x600x125,450x125x750x125,450x125x900x125,600x125x150x125,600x125x300x125,600x125x450x125,600x125x750x125,600x125x900x125,750x125x150x125,750x125x300x125,750x125x450x125,750x125x600x125,750x125x900x125,900x125x150x125,900x125x300x125,900x125x450x125,900x125x600x125,900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Straight Reducer Bracket FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,16",
                dispPosition: "82",
                csvFileName: "M_Legrand SS Sapphire G Finish Straight Reducer Bracket FExFE",
                bendType: "",
                id: "2499893592363231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Straight Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "5",
                sizeRange: "150x125x300x125,150x125x450x125,150x125x600x125,150x125x750x125,150x125x900x125,300x125x150x125,300x125x450x125,300x125x600x125,300x125x750x125,300x125x900x125,450x125x150x125,450x125x300x125,450x125x600x125,450x125x750x125,450x125x900x125,600x125x150x125,600x125x300x125,600x125x450x125,600x125x750x125,600x125x900x125,750x125x150x125,750x125x300x125,750x125x450x125,750x125x600x125,750x125x900x125,900x125x150x125,900x125x300x125,900x125x450x125,900x125x600x125,900x125x750x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Straight Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,16",
                dispPosition: "83",
                csvFileName: "M_Legrand SS Sapphire G Finish Straight Reducer FExFE",
                bendType: "",
                id: "2499894592363231",
                isClearence: "false"
              }
            ],
            ladderCableTrayUnion: [
              {
                name: "M_Legrand SS Sapphire G Finish Coupler Straight Length FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Coupler Straight Length FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "2499887592361231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Fitting to Fitting Coupler PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "2",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Fitting to Fitting Coupler PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "2499889592361231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Sapphire G Finish Flexible Expansion Coupler FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "3",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Flexible Expansion Coupler FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "",
                id: "2499888592361231",
                isClearence: "false"
              }
            ],
            ladderCableTrayMultiPort: {
              addDefaultItem: {
                name: "M_Legrand SS Sapphire G Finish Stop End Type D FE",
                defaultFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "150x125,300x125,450x125,600x125,750x125,900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder sapphire-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Sapphire G Finish Stop End Type D FE.RFA",
                description: "",
                angle: "",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,16",
                dispPosition: "81",
                csvFileName: "",
                bendType: "",
                id: "2499896592366131",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Swifts Galv Extra Heavy Duty Emerald G 3m length",
        unit: "METRIC",
        id: "36",
        systemShape: "ladder Cable Tray",
        systemUniqueId: "36",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: {
              name: "M_Legrand SS Emerald G Finish Straight Ladder Tray PExPE",
              id: "2499575592060131",
              Length: "9.84251968503937",
              JunctionType: "Tee",
              OldMat: "",
              shape: "ladder Cable Tray",
              sizeRange: "150x150,300x150,450x150,600x150,750x150,900x150",
              manufacturer: "Legrand",
              path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
              icon: "M_Legrand SS Emerald G Finish Straight Ladder Tray PExPE.rfa",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "4,17",
              dispPosition: "90",
              duplicateFrom: "ladder Cable Tray",
              defaultFor: "",
              isClearence: "false"
            },
            ladderCableTrayElbow: [
              {
                name: "M_Legrand SS Emerald G Finish Flat 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.853018372703409",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "1,11",
                dispPosition: "57",
                csvFileName: "",
                bendType: "",
                id: "2499534592060431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.987532808398928",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "2,11",
                dispPosition: "58",
                csvFileName: "",
                bendType: "",
                id: "2499535592060431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.18438320209974",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "3,11",
                dispPosition: "59",
                csvFileName: "",
                bendType: "",
                id: "2499536592060431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.31561679790026",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "4,11",
                dispPosition: "60",
                csvFileName: "",
                bendType: "",
                id: "2499537592060431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "1.38123359580052",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "0,12",
                dispPosition: "61",
                csvFileName: "",
                bendType: "",
                id: "2499538592060431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.27952755905512",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "1,12",
                dispPosition: "62",
                csvFileName: "",
                bendType: "",
                id: "2499539592060531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.38123359580052",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "2,12",
                dispPosition: "63",
                csvFileName: "",
                bendType: "",
                id: "2499540592060531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.68635170603674",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "3,12",
                dispPosition: "64",
                csvFileName: "",
                bendType: "",
                id: "2499541592060531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.78805774278215",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "4,12",
                dispPosition: "65",
                csvFileName: "",
                bendType: "",
                id: "2499542592060531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "12",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "2.09317585301837",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "0,13",
                dispPosition: "66",
                csvFileName: "",
                bendType: "",
                id: "2499543592060531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "13",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.67979002624672",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "1,13",
                dispPosition: "67",
                csvFileName: "",
                bendType: "",
                id: "2499544592060631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "14",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.96194225721785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "2,13",
                dispPosition: "68",
                csvFileName: "",
                bendType: "",
                id: "2499545592060631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "15",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.24737532808398",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "3,13",
                dispPosition: "69",
                csvFileName: "",
                bendType: "",
                id: "2499546592060631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "16",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Tray Type",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.53280839895013",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "4,13",
                dispPosition: "70",
                csvFileName: "",
                bendType: "",
                id: "2499547592060631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "17",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "2.67388451443569",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "0,14",
                dispPosition: "71",
                csvFileName: "",
                bendType: "",
                id: "2499548592060631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "18",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.71653543307086",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "1,14",
                dispPosition: "72",
                csvFileName: "",
                bendType: "",
                id: "2499549592060731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "19",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.20866141732283",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "2,14",
                dispPosition: "73",
                csvFileName: "",
                bendType: "",
                id: "2499550592060731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "20",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Trays",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.45472440944881",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "3,14",
                dispPosition: "74",
                csvFileName: "",
                bendType: "",
                id: "2499551592060731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "21",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.94685039370078",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "4,14",
                dispPosition: "75",
                csvFileName: "",
                bendType: "",
                id: "2499552592060731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flat 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "22",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flat 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "4.68503937007873",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "0,15",
                dispPosition: "76",
                csvFileName: "",
                bendType: "",
                id: "2499553592060731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Straight Ladder Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "23",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Straight Ladder Tray Face PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,17",
                dispPosition: "89",
                csvFileName: "",
                bendType: "",
                id: "24130189592060131",
                isClearence: "false"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "M_Legrand SS Emerald G Finish EIR 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.328083989501312",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499555592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.46259842519685",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499556592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.593832020997376",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499557592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.725065616797898",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499558592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.856299212598421",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.492125984251969",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499559592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.508530183727034",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.492125984251969",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499560592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "150x125x150x125,300x125x300x125,450x125x450x125,600x125x600x125,750x125x750x125,900x125x900x125",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.711942257217846",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.492125984251969",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499561592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.918635170603673",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499562592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.12204724409449",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499563592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.3254593175853",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.492125984251969",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499564592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.711942257217847",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.492125984251969",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499565592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.994094488188975",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.492125984251969",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499566592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.27952755905512",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.492125984251969",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499567592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.56167979002624",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.492125984251969",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499568592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.84711286089239",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499569592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.23031496062992",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.492125984251969",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499570592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.72244094488188",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499571592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.21456692913383",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499572592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.7066929133858",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499573592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EIR 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EIR 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.19881889763779",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2499574592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 30 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "21",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 30 Bend 300 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.328083989501311",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499577592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 30 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "22",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 30 Bend 450 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.462598425196848",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499578592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 30 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "23",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 30 Bend 600 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.593832020997374",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499579592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 30 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "24",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 30 Bend 750 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.725065616797896",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499580592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 30 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "25",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 30 Bend 900 R FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.856299212598423",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499581592063031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 45 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "26",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 45 Bend 300 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.508530183727035",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499582592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 45 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "27",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 45 Bend 450 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.711942257217849",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499583592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 45 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "28",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 45 Bend 600 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.91863517060367",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499584592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 45 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "29",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 45 Bend 750 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.12204724409449",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499585592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 45 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "30",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 45 Bend 900 R FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "1.3254593175853",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499586592060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 60 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "31",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 60 Bend 300 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.711942257217847",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499587592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 60 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "32",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 60 Bend 450 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.994094488188976",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "1,8",
                dispPosition: "42",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499588592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 60 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "33",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 60 Bend 600 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.27952755905512",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "2,8",
                dispPosition: "43",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499589592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 60 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "34",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 60 Bend 750 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.56167979002624",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "3,8",
                dispPosition: "44",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499590592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 60 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "35",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 60 Bend 900 R FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "1.84711286089239",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "4,8",
                dispPosition: "45",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499591592063131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 90 Bend 300 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "36",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 90 Bend 300 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.2303149606299",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "0,9",
                dispPosition: "46",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499592592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 90 Bend 450 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "37",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 90 Bend 450 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.72244094488189",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "1,9",
                dispPosition: "47",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499593592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 90 Bend 600 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "38",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 90 Bend 600 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.21456692913386",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "2,9",
                dispPosition: "48",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499594592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 90 Bend 750 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "39",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 90 Bend 750 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "2.70669291338581",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.492125984251969",
                displayPosition: "3,9",
                dispPosition: "49",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499595592060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish EOR 90 Bend 900 R FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "40",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish EOR 90 Bend 900 R FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "3.19881889763779",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.492125984251969",
                displayPosition: "4,9",
                dispPosition: "50",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2499596592060231",
                isClearence: "false"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "M_Legrand SS Emerald G Finish Cross 300 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "150x150x150x150x150x150x150x150,300x150x300x150x300x150x300x150,450x150x450x150x450x150x450x150,600x150x600x150x600x150x600x150,750x150x750x150x750x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Cross 300 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.47375328083989",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2499612592061131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Cross 300 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "900x150x900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Cross 300 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.71981627296589",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2499613592061131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Cross 450 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "150x150x150x150x150x150x150x150,300x150x300x150x300x150x300x150,450x150x450x150x450x150x450x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Cross 450 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.47375328083989",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "1.47637795275591",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2499614592061131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Cross 450 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "600x150x600x150x600x150x600x150,750x150x750x150x750x150x750x150,900x150x900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Cross 450 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.21194225721785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2499615592061131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Cross 600 R FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "5",
                sizeRange: "150x150x150x150x150x150x150x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Cross 600 R FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "2.47375328083989",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.492125984251969",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2499616592061131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Cross 600 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "6",
                sizeRange: "300x150x300x150x300x150x300x150,450x150x450x150x450x150x300x150,600x150x600x150x600x150x600x150,750x150x750x150x750x150x750x150,900x150x900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Cross 600 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.21194225721785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "1.96850393700787",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "2499617592061131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Cross 750 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "7",
                sizeRange: "150x150x150x150x150x150x150x150,300x150x300x150x300x150x300x150,450x150x450x150x450x150x450x150,600x150x600x150x600x150x600x150,750x150x750x150x750x150x750x150,900x150x900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Cross 750 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "3.9501312335958",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "2499618592061131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Cross 900 R W 2 Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "8",
                sizeRange: "150x150x150x150x150x150x150x150,300x150x300x150x300x150x300x150,450x150x450x150x450x150x450x150,600x150x600x150x600x150x600x150,750x150x750x150x750x150x750x150,900x150x900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Cross 900 R W 2 Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "4.44225721784778",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "2499619592061131",
                isClearence: "false"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "M_Legrand SS Emerald G Finish Equal Tee 300 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "150x150x150x150x150x150,300x150x300x150x300x150,450x150x450x150x450x150,600x150x600x150x600x150,750x150x750x150x750x150,900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Equal Tee 300 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.71981627296588",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "0,10",
                dispPosition: "51",
                csvFileName: "",
                bendType: "",
                id: "2499602592061031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Equal Tee 450 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "150x150x150x150x150x150,300x150x300x150x300x150,450x150x450x150x450x150,600x150x600x150x600x150,750x150x750x150x750x150,900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Equal Tee 450 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.21194225721785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "1,10",
                dispPosition: "52",
                csvFileName: "",
                bendType: "",
                id: "2499603592061031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Equal Tee 600 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "150x150x150x150x150x150,300x150x300x150x300x150,450x150x450x150x450x150,600x150x600x150x600x150,750x150x750x150x750x150,900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Equal Tee 600 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.45800524934384",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "2,10",
                dispPosition: "53",
                csvFileName: "",
                bendType: "",
                id: "2499604592061031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Equal Tee 750 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "150x150x150x150x150x150,300x150x300x150x300x150,450x150x450x150x450x150,600x150x600x150x600x150,750x150x750x150x750x150,900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Equal Tee 750 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.70406824146982",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "1.96850393700787",
                displayPosition: "3,10",
                dispPosition: "54",
                csvFileName: "",
                bendType: "",
                id: "2499605592061031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Equal Tee 900 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "150x150x150x150x150x150,300x150x300x150x300x150,450x150x450x150x450x150,600x150x600x150x600x150,750x150x750x150x750x150,900x150x900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Equal Tee 900 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.68832020997375",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "4,10",
                dispPosition: "55",
                csvFileName: "",
                bendType: "",
                id: "2499606592061031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Unequal Tee 300 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "6",
                sizeRange: "150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x600x150,150x150x150x150x750x150,150x150x150x150x900x150,300x150x300x150x150x150,300x150x300x150x450x150,300x150x300x150x600x150,300x150x300x150x750x150,300x150x300x150x900x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x600x150,450x150x450x150x750x150,450x150x450x150x900x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x750x150,600x150x600x150x900x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x600x150,750x150x750x150x900x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x600x150,900x150x900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Unequal Tee 300 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "2.2244094488189",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "3,16",
                dispPosition: "84",
                csvFileName: "",
                bendType: "",
                id: "2499607592063331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Unequal Tee 450 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "7",
                sizeRange: "150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x600x150,150x150x150x150x750x150,150x150x150x150x900x150,300x150x300x150x150x150,300x150x300x150x450x150,300x150x300x150x600x150,300x150x300x150x750x150,300x150x300x150x900x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x600x150,450x150x450x150x750x150,450x150x450x150x900x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x750x150,600x150x600x150x900x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x600x150,750x150x750x150x900x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x600x150,900x150x900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Unequal Tee 450 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.20866141732284",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "4,16",
                dispPosition: "85",
                csvFileName: "",
                bendType: "",
                id: "2499608592063331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Unequal Tee 600 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "8",
                sizeRange: "150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x600x150,150x150x150x150x750x150,150x150x150x150x900x150,300x150x300x150x150x150,300x150x300x150x450x150,300x150x300x150x600x150,300x150x300x150x750x150,300x150x300x150x900x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x600x150,450x150x450x150x750x150,450x150x450x150x900x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x750x150,600x150x600x150x900x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x600x150,750x150x750x150x900x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x600x150,900x150x900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Unequal Tee 600 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "3.70078740157481",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "0,17",
                dispPosition: "86",
                csvFileName: "",
                bendType: "",
                id: "2499609592063331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Unequal Tee 750 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "9",
                sizeRange: "150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x600x150,150x150x150x150x750x150,150x150x150x150x900x150,300x150x300x150x150x150,300x150x300x150x450x150,300x150x300x150x600x150,300x150x300x150x750x150,300x150x300x150x900x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x600x150,450x150x450x150x750x150,450x150x450x150x900x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x750x150,600x150x600x150x900x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x600x150,750x150x750x150x900x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x600x150,900x150x900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Unequal Tee 750 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.19291338582677",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "1,17",
                dispPosition: "87",
                csvFileName: "",
                bendType: "",
                id: "2499610592063331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Unequal Tee 900 R FExFExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "10",
                sizeRange: "150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x600x150,150x150x150x150x750x150,150x150x150x150x900x150,300x150x300x150x150x150,300x150x300x150x450x150,300x150x300x150x600x150,300x150x300x150x750x150,300x150x300x150x900x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x600x150,450x150x450x150x750x150,450x150x450x150x900x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x750x150,600x150x600x150x900x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x600x150,750x150x750x150x900x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x600x150,900x150x900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Unequal Tee 900 R FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "4.68503937007874",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.46062992125984",
                displayPosition: "2,17",
                dispPosition: "88",
                csvFileName: "",
                bendType: "",
                id: "2499611592063331",
                isClearence: "false"
              }
            ],
            ladderCableTrayTransition: [
              {
                name: "M_Legrand SS Emerald G Finish Left Hand Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "1",
                sizeRange: "150x150x300x150,150x150x450x150,150x150x600x150,150x150x750x150,150x150x900x150,300x150x150x150,300x150x450x150,300x150x600x150,300x150x750x150,300x150x900x150,450x150x150x150,450x150x300x150,450x150x600x150,450x150x750x150,450x150x900x150,600x150x150x150,600x150x300x150,600x150x450x150,600x150x750x150,600x150x900x150,750x150x150x150,750x150x300x150,750x150x450x150,750x150x600x150,750x150x900x150,900x150x150x150,900x150x300x150,900x150x450x150,900x150x600x150,900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Left Hand Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,15",
                dispPosition: "78",
                csvFileName: "M_Legrand SS Emerald G Finish Left Hand Reducer FExFE",
                bendType: "",
                id: "2499576592060831",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Offset Reducer Bracket FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "2",
                sizeRange: "150x150x300x150,150x150x450x150,150x150x600x150,150x150x750x150,150x150x900x150,300x150x150x150,300x150x450x150,300x150x600x150,300x150x750x150,300x150x900x150,450x150x150x150,450x150x300x150,450x150x600x150,450x150x750x150,450x150x900x150,600x150x150x150,600x150x300x150,600x150x450x150,600x150x750x150,600x150x900x150,750x150x150x150,750x150x300x150,750x150x450x150,750x150x600x150,750x150x900x150,900x150x150x150,900x150x300x150,900x150x450x150,900x150x600x150,900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Offset Reducer Bracket FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,15",
                dispPosition: "79",
                csvFileName: "M_Legrand SS Emerald G Finish Offset Reducer Bracket FExFE",
                bendType: "",
                id: "2499597592063231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Right Hand Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "3",
                sizeRange: "150x150x300x150,150x150x450x150,150x150x600x150,150x150x750x150,150x150x900x150,300x150x150x150,300x150x450x150,300x150x600x150,300x150x750x150,300x150x900x150,450x150x150x150,450x150x300x150,450x150x600x150,450x150x750x150,450x150x900x150,600x150x150x150,600x150x300x150,600x150x450x150,600x150x750x150,600x150x900x150,750x150x150x150,750x150x300x150,750x150x450x150,750x150x600x150,750x150x900x150,900x150x150x150,900x150x300x150,900x150x450x150,900x150x600x150,900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Right Hand Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,15",
                dispPosition: "80",
                csvFileName: "M_Legrand SS Emerald G Finish Right Hand Reducer FExFE",
                bendType: "",
                id: "2499599592060931",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Straight Reducer Bracket FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "4",
                sizeRange: "150x150x300x150,150x150x450x150,150x150x600x150,150x150x750x150,150x150x900x150,300x150x150x150,300x150x450x150,300x150x600x150,300x150x750x150,300x150x900x150,450x150x150x150,450x150x300x150,450x150x600x150,450x150x750x150,450x150x900x150,600x150x150x150,600x150x300x150,600x150x450x150,600x150x750x150,600x150x900x150,750x150x150x150,750x150x300x150,750x150x450x150,750x150x600x150,750x150x900x150,900x150x150x150,900x150x300x150,900x150x450x150,900x150x600x150,900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Straight Reducer Bracket FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,16",
                dispPosition: "82",
                csvFileName: "M_Legrand SS Emerald G Finish Straight Reducer Bracket FExFE",
                bendType: "",
                id: "2499598592063231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Straight Reducer FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "5",
                sizeRange: "150x150x300x150,150x150x450x150,150x150x600x150,150x150x750x150,150x150x900x150,300x150x150x150,300x150x450x150,300x150x600x150,300x150x750x150,300x150x900x150,450x150x150x150,450x150x300x150,450x150x600x150,450x150x750x150,450x150x900x150,600x150x150x150,600x150x300x150,600x150x450x150,600x150x750x150,600x150x900x150,750x150x150x150,750x150x300x150,750x150x450x150,750x150x600x150,750x150x900x150,900x150x150x150,900x150x300x150,900x150x450x150,900x150x600x150,900x150x750x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Straight Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,16",
                dispPosition: "83",
                csvFileName: "M_Legrand SS Emerald G Finish Straight Reducer FExFE",
                bendType: "",
                id: "2499601592063231",
                isClearence: "false"
              }
            ],
            ladderCableTrayUnion: [
              {
                name: "M_Legrand SS Emerald G Finish Coupler Straight Length FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Coupler Straight Length FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "2499532592061231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Fitting to Fitting Coupler PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "2",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Fitting to Fitting Coupler PExPE.RFA",
                description: "",
                angle: "",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,11",
                dispPosition: "56",
                csvFileName: "",
                bendType: "",
                id: "2499554592061231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS Emerald G Finish Flexible Expansion Coupler FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "3",
                sizeRange: "150x150x150x150,300x150x300x150,450x150x450x150,600x150x600x150,750x150x750x150,900x150x900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Flexible Expansion Coupler FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,15",
                dispPosition: "77",
                csvFileName: "",
                bendType: "",
                id: "2499533592061231",
                isClearence: "false"
              }
            ],
            ladderCableTrayMultiPort: {
              addDefaultItem: {
                name: "M_Legrand SS Emerald G Finish Stop End Type D FE",
                defaultFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "150x150,300x150,450x150,600x150,750x150,900x150",
                manufacturer: "Legrand",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable ladder emerald-g\\carbon steel\\tray\\",
                icon: "M_Legrand SS Emerald G Finish Stop End Type D FE.RFA",
                description: "",
                angle: "",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,16",
                dispPosition: "81",
                csvFileName: "",
                bendType: "",
                id: "2499600592066131",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "unistrut Galv U10 HG 3m x 300mm Rung Spacing",
        unit: "METRIC",
        id: "39",
        systemShape: "ladder Cable Tray",
        systemUniqueId: "39",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: {
              name: "M_Unistrut HG Finish U10 Cable Ladder 3M PExPE",
              id: "24119667697760131",
              Length: "10",
              JunctionType: "Tee",
              OldMat: "",
              shape: "ladder Cable Tray",
              sizeRange: "100x100,150x100,200x100,300x100,400x100,450x100,500x100,600x100,700x100,750x100,800x100,900x100,1000x100",
              manufacturer: "unistrut",
              path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
              icon: "M_Unistrut HG Finish U10 Cable Ladder 3M PExPE.RFA",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "2,8",
              dispPosition: "43",
              duplicateFrom: "ladder Cable Tray",
              defaultFor: "",
              isClearence: "false"
            },
            ladderCableTrayElbow: [
              {
                name: "M_Unistrut HG Finish U10 FB 45 Flat Bend 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 45 Flat Bend 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.28100227579123",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.6246719160105",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24119674697760531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 45 Flat Bend 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 45 Flat Bend 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.4848475328646",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.6246719160105",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24119675697760531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 45 Flat Bend 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 45 Flat Bend 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.68869278993797",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.6246719160105",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24119676697760531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 45 Flat Bend 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 45 Flat Bend 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.89253804701134",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.6246719160105",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "24119677697760531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 45 Flat Bend 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 45 Flat Bend 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.23228014213361",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "3.28083989501312",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "24119678697760531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 90 Flat Bend 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 90 Flat Bend 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.79035433070866",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24119679697760731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 90 Flat Bend 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 90 Flat Bend 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.28248031496062",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24119680697760731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 90 Flat Bend 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 90 Flat Bend 600 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.77460629921258",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24119681697760731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 90 Flat Bend 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 90 Flat Bend 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.26673228346454",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24119682697760731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 FB 90 Flat Bend 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "12",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 FB 90 Flat Bend 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.75885826771653",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "2.95275590551181",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24119683697760731",
                isClearence: "false"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "M_Unistrut HG Finish U10 IR 45 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 45 Riser 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.967764917423152",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119684697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 45 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 45 Riser 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.17161017449654",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119685697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 45 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 45 Riser 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.37545543156992",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119686697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 45 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 45 Riser 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.57930068864326",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119687697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 45 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 45 Riser 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.78314594571666",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119688697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 90 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 90 Riser 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.64041994750656",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119694697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 90 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 90 Riser 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.1325459317585",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119695697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 90 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 90 Riser 600 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.62467191601049",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119696697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 90 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 90 Riser 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.11679790026243",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119697697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 IR 90 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 IR 90 Riser 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.6089238845144",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.328083989501312",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119698697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 45 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 45 Riser 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.96776491742317",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.328083989501312",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119689697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 45 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 45 Riser 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.17161017449654",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.328083989501312",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119690697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 45 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 45 Riser 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.37545543156992",
                isConnCheck: "True",
                extraField: "",
                Height: "2.29658792650919",
                width: "0.328083989501312",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119691697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 45 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 45 Riser 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.57930068864329",
                isConnCheck: "True",
                extraField: "",
                Height: "2.29658792650919",
                width: "0.328083989501312",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119692697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 45 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 45 Riser 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.78314594571666",
                isConnCheck: "True",
                extraField: "",
                Height: "2.29658792650919",
                width: "0.328083989501312",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119693697760331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 90 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 90 Riser 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.64041994750655",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.328083989501312",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119699697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 90 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 90 Riser 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.13254593175853",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.328083989501312",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119700697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 90 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 90 Riser 600 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.62467191601049",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.328083989501312",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119701697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 90 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 90 Riser 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.11679790026246",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.328083989501312",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119702697760231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 OR 90 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 OR 90 Riser 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.60892388451443",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.328083989501312",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119703697760231",
                isClearence: "false"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "M_Unistrut HG Finish U10 EC Cross 300 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "100x100x100x100x100x100x100x100,150x100x150x100x150x100x150x100,200x100x200x100x200x100x200x100,300x100x300x100x300x100x300x100,400x100x400x100x400x100x400x100,450x100x450x100x450x100x450x100,500x100x500x100x500x100x500x100,600x100x600x100x600x100x600x100,700x100x700x100x700x100x700x100,750x100x750x100x750x100x750x100,800x100x800x100x800x100x800x100,900x100x900x100x900x100x900x100,1000x100x1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 EC Cross 300 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.23097112860892",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                bendType: "",
                id: "24119669697761131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 EC Cross 450 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "100x100x100x100x100x100x100x100,150x100x150x100x150x100x150x100,200x100x200x100x200x100x200x100,300x100x300x100x300x100x300x100,400x100x400x100x400x100x400x100,450x100x450x100x450x100x450x100,500x100x500x100x500x100x500x100,600x100x600x100x600x100x600x100,700x100x700x100x700x100x700x100,750x100x750x100x750x100x750x100,800x100x800x100x800x100x800x100,900x100x900x100x900x100x900x100,1000x100x1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 EC Cross 450 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.72309711286089",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24119670697761131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 EC Cross 600 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "100x100x100x100x100x100x100x100,150x100x150x100x150x100x150x100,200x100x200x100x200x100x200x100,300x100x300x100x300x100x300x100,400x100x400x100x400x100x400x100,450x100x450x100x450x100x450x100,500x100x500x100x500x100x500x100,600x100x600x100x600x100x600x100,700x100x700x100x700x100x700x100,750x100x750x100x750x100x750x100,800x100x800x100x800x100x800x100,900x100x900x100x900x100x900x100,1000x100x1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 EC Cross 600 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.21522309711286",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24119671697761131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 EC Cross 750 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "100x100x100x100x100x100x100x100,150x100x150x100x150x100x150x100,200x100x200x100x200x100x200x100,300x100x300x100x300x100x300x100,400x100x400x100x400x100x400x100,450x100x450x100x450x100x450x100,500x100x500x100x500x100x500x100,600x100x600x100x600x100x600x100,700x100x700x100x700x100x700x100,750x100x750x100x750x100x750x100,800x100x800x100x800x100x800x100,900x100x900x100x900x100x900x100,1000x100x1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 EC Cross 750 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.70734908136481",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "24119672697761131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 EC Cross 900 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "5",
                sizeRange: "100x100x100x100x100x100x100x100,150x100x150x100x150x100x150x100,200x100x200x100x200x100x200x100,300x100x300x100x300x100x300x100,400x100x400x100x400x100x400x100,450x100x450x100x450x100x450x100,500x100x500x100x500x100x500x100,600x100x600x100x600x100x600x100,700x100x700x100x700x100x700x100,750x100x750x100x750x100x750x100,800x100x800x100x800x100x800x100,900x100x900x100x900x100x900x100,1000x100x1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 EC Cross 900 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "4.19947506561678",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "1.96850393700787",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "24119673697761131",
                isClearence: "false"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "M_Unistrut HG Finish U10 LT Tee 300 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "100x100x100x100x100x100,100x100x100x100x150x100,100x100x100x100x300x100,100x100x100x100x450x100,100x100x100x100x500x100,100x100x100x100x600x100,100x100x100x100x700x100,100x100x100x100x750x100,100x100x100x100x800x100,100x100x100x100x900x100,100x100x100x100x1000x100,150x100x150x100x100x100,150x100x150x100x150x100,150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x500x100,150x100x150x100x600x100,150x100x150x100x700x100,150x100x150x100x750x100,150x100x150x100x800x100,150x100x150x100x900x100,150x100x150x100x1000x100,200x100x200x100x200x100,200x100x200x100x400x100,300x100x300x100x100x100,300x100x300x100x150x100,300x100x300x100x300x100,300x100x300x100x400x100,300x100x300x100x450x100,300x100x300x100x500x100,300x100x300x100x600x100,300x100x300x100x700x100,300x100x300x100x750x100,300x100x300x100x800x100,300x100x300x100x900x100,300x100x300x100x1000x100,400x100x400x100x100x100,400x100x400x100x150x100,400x100x400x100x200x100,400x100x400x100x300x100,400x100x400x100x400x100,400x100x400x100x450x100,400x100x400x100x500x100,400x100x400x100x600x100,400x100x400x100x700x100,400x100x400x100x750x100,400x100x400x100x800x100,400x100x400x100x900x100,400x100x400x100x1000x100,450x100x450x100x100x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x450x100,450x100x450x100x500x100,450x100x450x100x600x100,450x100x450x100x700x100,450x100x450x100x750x100,450x100x450x100x800x100,450x100x450x100x900x100,450x100x450x100x1000x100,500x100x500x100x100x100,500x100x500x100x150x100,500x100x500x100x300x100,500x100x500x100x450x100,500x100x500x100x500x100,500x100x500x100x600x100,500x100x500x100x700x100,500x100x500x100x750x100,500x100x500x100x800x100,500x100x500x100x900x100,500x100x500x100x1000x100,600x100x600x100x100x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x500x100,600x100x600x100x600x100,600x100x600x100x700x100,600x100x600x100x750x100,600x100x600x100x800x100,600x100x600x100x900x100,600x100x600x100x1000x100,700x100x700x100x100x100,700x100x700x100x150x100,700x100x700x100x300x100,700x100x700x100x450x100,700x100x700x100x500x100,700x100x700x100x600x100,700x100x700x100x700x100,700x100x700x100x750x100,700x100x700x100x800x100,700x100x700x100x900x100,700x100x700x100x1000x100,750x100x750x100x100x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x500x100,750x100x750x100x600x100,750x100x750x100x700x100,750x100x750x100x750x100,750x100x750x100x800x100,750x100x750x100x900x100,750x100x750x100x1000x100,800x100x800x100x100x100,800x100x800x100x150x100,800x100x800x100x300x100,800x100x800x100x450x100,800x100x800x100x500x100,800x100x800x100x600x100,800x100x800x100x700x100,800x100x800x100x750x100,800x100x800x100x800x100,800x100x800x100x900x100,800x100x800x100x1000x100,900x100x900x100x100x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x500x100,900x100x900x100x600x100,900x100x900x100x700x100,900x100x900x100x750x100,900x100x900x100x800x100,900x100x900x100x900x100,900x100x900x100x1000x100,1000x100x1000x100x100x100,1000x100x1000x100x150x100,1000x100x1000x100x300x100,1000x100x1000x100x450x100,1000x100x1000x100x500x100,1000x100x1000x100x600x100,1000x100x1000x100x700x100,1000x100x1000x100x750x100,1000x100x1000x100x800x100,1000x100x1000x100x900x100,1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 LT Tee 300 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.47703412073491",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.328083989501312",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "",
                id: "24119704697761031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 LT Tee 450 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "100x100x100x100x100x100,100x100x100x100x150x100,100x100x100x100x300x100,100x100x100x100x450x100,100x100x100x100x500x100,100x100x100x100x600x100,100x100x100x100x700x100,100x100x100x100x750x100,100x100x100x100x800x100,100x100x100x100x900x100,100x100x100x100x1000x100,150x100x150x100x100x100,150x100x150x100x150x100,150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x500x100,150x100x150x100x600x100,150x100x150x100x700x100,150x100x150x100x750x100,150x100x150x100x800x100,150x100x150x100x900x100,150x100x150x100x1000x100,200x100x200x100x200x100,200x100x200x100x400x100,300x100x300x100x100x100,300x100x300x100x150x100,300x100x300x100x300x100,300x100x300x100x400x100,300x100x300x100x450x100,300x100x300x100x500x100,300x100x300x100x600x100,300x100x300x100x700x100,300x100x300x100x750x100,300x100x300x100x800x100,300x100x300x100x900x100,300x100x300x100x1000x100,400x100x400x100x100x100,400x100x400x100x150x100,400x100x400x100x200x100,400x100x400x100x300x100,400x100x400x100x400x100,400x100x400x100x450x100,400x100x400x100x500x100,400x100x400x100x600x100,400x100x400x100x700x100,400x100x400x100x750x100,400x100x400x100x800x100,400x100x400x100x900x100,400x100x400x100x1000x100,450x100x450x100x100x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x450x100,450x100x450x100x500x100,450x100x450x100x600x100,450x100x450x100x700x100,450x100x450x100x750x100,450x100x450x100x800x100,450x100x450x100x900x100,450x100x450x100x1000x100,500x100x500x100x100x100,500x100x500x100x150x100,500x100x500x100x300x100,500x100x500x100x450x100,500x100x500x100x500x100,500x100x500x100x600x100,500x100x500x100x700x100,500x100x500x100x750x100,500x100x500x100x800x100,500x100x500x100x900x100,500x100x500x100x1000x100,600x100x600x100x100x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x500x100,600x100x600x100x600x100,600x100x600x100x700x100,600x100x600x100x750x100,600x100x600x100x800x100,600x100x600x100x900x100,600x100x600x100x1000x100,700x100x700x100x100x100,700x100x700x100x150x100,700x100x700x100x300x100,700x100x700x100x450x100,700x100x700x100x500x100,700x100x700x100x600x100,700x100x700x100x700x100,700x100x700x100x750x100,700x100x700x100x800x100,700x100x700x100x900x100,700x100x700x100x1000x100,750x100x750x100x100x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x500x100,750x100x750x100x600x100,750x100x750x100x700x100,750x100x750x100x750x100,750x100x750x100x800x100,750x100x750x100x900x100,750x100x750x100x1000x100,800x100x800x100x100x100,800x100x800x100x150x100,800x100x800x100x300x100,800x100x800x100x450x100,800x100x800x100x500x100,800x100x800x100x600x100,800x100x800x100x700x100,800x100x800x100x750x100,800x100x800x100x800x100,800x100x800x100x900x100,800x100x800x100x1000x100,900x100x900x100x100x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x500x100,900x100x900x100x600x100,900x100x900x100x700x100,900x100x900x100x750x100,900x100x900x100x800x100,900x100x900x100x900x100,900x100x900x100x1000x100,1000x100x1000x100x100x100,1000x100x1000x100x150x100,1000x100x1000x100x300x100,1000x100x1000x100x450x100,1000x100x1000x100x500x100,1000x100x1000x100x600x100,1000x100x1000x100x700x100,1000x100x1000x100x750x100,1000x100x1000x100x800x100,1000x100x1000x100x900x100,1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 LT Tee 450 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.47703412073491",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.328083989501312",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "24119705697761031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 LT Tee 600 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "100x100x100x100x100x100,100x100x100x100x150x100,100x100x100x100x300x100,100x100x100x100x450x100,100x100x100x100x500x100,100x100x100x100x600x100,100x100x100x100x700x100,100x100x100x100x750x100,100x100x100x100x800x100,100x100x100x100x900x100,100x100x100x100x1000x100,150x100x150x100x100x100,150x100x150x100x150x100,150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x500x100,150x100x150x100x600x100,150x100x150x100x700x100,150x100x150x100x750x100,150x100x150x100x800x100,150x100x150x100x900x100,150x100x150x100x1000x100,200x100x200x100x200x100,200x100x200x100x400x100,300x100x300x100x100x100,300x100x300x100x150x100,300x100x300x100x300x100,300x100x300x100x400x100,300x100x300x100x450x100,300x100x300x100x500x100,300x100x300x100x600x100,300x100x300x100x700x100,300x100x300x100x750x100,300x100x300x100x800x100,300x100x300x100x900x100,300x100x300x100x1000x100,400x100x400x100x100x100,400x100x400x100x150x100,400x100x400x100x200x100,400x100x400x100x300x100,400x100x400x100x400x100,400x100x400x100x450x100,400x100x400x100x500x100,400x100x400x100x600x100,400x100x400x100x700x100,400x100x400x100x750x100,400x100x400x100x800x100,400x100x400x100x900x100,400x100x400x100x1000x100,450x100x450x100x100x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x450x100,450x100x450x100x500x100,450x100x450x100x600x100,450x100x450x100x700x100,450x100x450x100x750x100,450x100x450x100x800x100,450x100x450x100x900x100,450x100x450x100x1000x100,500x100x500x100x100x100,500x100x500x100x150x100,500x100x500x100x300x100,500x100x500x100x450x100,500x100x500x100x500x100,500x100x500x100x600x100,500x100x500x100x700x100,500x100x500x100x750x100,500x100x500x100x800x100,500x100x500x100x900x100,500x100x500x100x1000x100,600x100x600x100x100x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x500x100,600x100x600x100x600x100,600x100x600x100x700x100,600x100x600x100x750x100,600x100x600x100x800x100,600x100x600x100x900x100,600x100x600x100x1000x100,700x100x700x100x100x100,700x100x700x100x150x100,700x100x700x100x300x100,700x100x700x100x450x100,700x100x700x100x500x100,700x100x700x100x600x100,700x100x700x100x700x100,700x100x700x100x750x100,700x100x700x100x800x100,700x100x700x100x900x100,700x100x700x100x1000x100,750x100x750x100x100x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x500x100,750x100x750x100x600x100,750x100x750x100x700x100,750x100x750x100x750x100,750x100x750x100x800x100,750x100x750x100x900x100,750x100x750x100x1000x100,800x100x800x100x100x100,800x100x800x100x150x100,800x100x800x100x300x100,800x100x800x100x450x100,800x100x800x100x500x100,800x100x800x100x600x100,800x100x800x100x700x100,800x100x800x100x750x100,800x100x800x100x800x100,800x100x800x100x900x100,800x100x800x100x1000x100,900x100x900x100x100x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x500x100,900x100x900x100x600x100,900x100x900x100x700x100,900x100x900x100x750x100,900x100x900x100x800x100,900x100x900x100x900x100,900x100x900x100x1000x100,1000x100x1000x100x100x100,1000x100x1000x100x150x100,1000x100x1000x100x300x100,1000x100x1000x100x450x100,1000x100x1000x100x500x100,1000x100x1000x100x600x100,1000x100x1000x100x700x100,1000x100x1000x100x750x100,1000x100x1000x100x800x100,1000x100x1000x100x900x100,1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 LT Tee 600 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.96916010498688",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.492125984251969",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "24119706697761031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 LT Tee 750 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "100x100x100x100x100x100,100x100x100x100x150x100,100x100x100x100x300x100,100x100x100x100x450x100,100x100x100x100x500x100,100x100x100x100x600x100,100x100x100x100x700x100,100x100x100x100x750x100,100x100x100x100x800x100,100x100x100x100x900x100,100x100x100x100x1000x100,150x100x150x100x100x100,150x100x150x100x150x100,150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x500x100,150x100x150x100x600x100,150x100x150x100x700x100,150x100x150x100x750x100,150x100x150x100x800x100,150x100x150x100x900x100,150x100x150x100x1000x100,200x100x200x100x200x100,200x100x200x100x400x100,300x100x300x100x100x100,300x100x300x100x150x100,300x100x300x100x300x100,300x100x300x100x400x100,300x100x300x100x450x100,300x100x300x100x500x100,300x100x300x100x600x100,300x100x300x100x700x100,300x100x300x100x750x100,300x100x300x100x800x100,300x100x300x100x900x100,300x100x300x100x1000x100,400x100x400x100x100x100,400x100x400x100x150x100,400x100x400x100x200x100,400x100x400x100x300x100,400x100x400x100x400x100,400x100x400x100x450x100,400x100x400x100x500x100,400x100x400x100x600x100,400x100x400x100x700x100,400x100x400x100x750x100,400x100x400x100x800x100,400x100x400x100x900x100,400x100x400x100x1000x100,450x100x450x100x100x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x450x100,450x100x450x100x500x100,450x100x450x100x600x100,450x100x450x100x700x100,450x100x450x100x750x100,450x100x450x100x800x100,450x100x450x100x900x100,450x100x450x100x1000x100,500x100x500x100x100x100,500x100x500x100x150x100,500x100x500x100x300x100,500x100x500x100x450x100,500x100x500x100x500x100,500x100x500x100x600x100,500x100x500x100x700x100,500x100x500x100x750x100,500x100x500x100x800x100,500x100x500x100x900x100,500x100x500x100x1000x100,600x100x600x100x100x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x500x100,600x100x600x100x600x100,600x100x600x100x700x100,600x100x600x100x750x100,600x100x600x100x800x100,600x100x600x100x900x100,600x100x600x100x1000x100,700x100x700x100x100x100,700x100x700x100x150x100,700x100x700x100x300x100,700x100x700x100x450x100,700x100x700x100x500x100,700x100x700x100x600x100,700x100x700x100x700x100,700x100x700x100x750x100,700x100x700x100x800x100,700x100x700x100x900x100,700x100x700x100x1000x100,750x100x750x100x100x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x500x100,750x100x750x100x600x100,750x100x750x100x700x100,750x100x750x100x750x100,750x100x750x100x800x100,750x100x750x100x900x100,750x100x750x100x1000x100,800x100x800x100x100x100,800x100x800x100x150x100,800x100x800x100x300x100,800x100x800x100x450x100,800x100x800x100x500x100,800x100x800x100x600x100,800x100x800x100x700x100,800x100x800x100x750x100,800x100x800x100x800x100,800x100x800x100x900x100,800x100x800x100x1000x100,900x100x900x100x100x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x500x100,900x100x900x100x600x100,900x100x900x100x700x100,900x100x900x100x750x100,900x100x900x100x800x100,900x100x900x100x900x100,900x100x900x100x1000x100,1000x100x1000x100x100x100,1000x100x1000x100x150x100,1000x100x1000x100x300x100,1000x100x1000x100x450x100,1000x100x1000x100x500x100,1000x100x1000x100x600x100,1000x100x1000x100x700x100,1000x100x1000x100x750x100,1000x100x1000x100x800x100,1000x100x1000x100x900x100,1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 LT Tee 750 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.46128608923885",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.492125984251969",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "",
                id: "24119707697761031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U10 LT Tee 900 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "100x100x100x100x100x100,100x100x100x100x150x100,100x100x100x100x300x100,100x100x100x100x450x100,100x100x100x100x500x100,100x100x100x100x600x100,100x100x100x100x700x100,100x100x100x100x750x100,100x100x100x100x800x100,100x100x100x100x900x100,100x100x100x100x1000x100,150x100x150x100x100x100,150x100x150x100x150x100,150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x500x100,150x100x150x100x600x100,150x100x150x100x700x100,150x100x150x100x750x100,150x100x150x100x800x100,150x100x150x100x900x100,150x100x150x100x1000x100,200x100x200x100x200x100,200x100x200x100x400x100,300x100x300x100x100x100,300x100x300x100x150x100,300x100x300x100x300x100,300x100x300x100x400x100,300x100x300x100x450x100,300x100x300x100x500x100,300x100x300x100x600x100,300x100x300x100x700x100,300x100x300x100x750x100,300x100x300x100x800x100,300x100x300x100x900x100,300x100x300x100x1000x100,400x100x400x100x100x100,400x100x400x100x150x100,400x100x400x100x200x100,400x100x400x100x300x100,400x100x400x100x400x100,400x100x400x100x450x100,400x100x400x100x500x100,400x100x400x100x600x100,400x100x400x100x700x100,400x100x400x100x750x100,400x100x400x100x800x100,400x100x400x100x900x100,400x100x400x100x1000x100,450x100x450x100x100x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x450x100,450x100x450x100x500x100,450x100x450x100x600x100,450x100x450x100x700x100,450x100x450x100x750x100,450x100x450x100x800x100,450x100x450x100x900x100,450x100x450x100x1000x100,500x100x500x100x100x100,500x100x500x100x150x100,500x100x500x100x300x100,500x100x500x100x450x100,500x100x500x100x500x100,500x100x500x100x600x100,500x100x500x100x700x100,500x100x500x100x750x100,500x100x500x100x800x100,500x100x500x100x900x100,500x100x500x100x1000x100,600x100x600x100x100x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x500x100,600x100x600x100x600x100,600x100x600x100x700x100,600x100x600x100x750x100,600x100x600x100x800x100,600x100x600x100x900x100,600x100x600x100x1000x100,700x100x700x100x100x100,700x100x700x100x150x100,700x100x700x100x300x100,700x100x700x100x450x100,700x100x700x100x500x100,700x100x700x100x600x100,700x100x700x100x700x100,700x100x700x100x750x100,700x100x700x100x800x100,700x100x700x100x900x100,700x100x700x100x1000x100,750x100x750x100x100x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x500x100,750x100x750x100x600x100,750x100x750x100x700x100,750x100x750x100x750x100,750x100x750x100x800x100,750x100x750x100x900x100,750x100x750x100x1000x100,800x100x800x100x100x100,800x100x800x100x150x100,800x100x800x100x300x100,800x100x800x100x450x100,800x100x800x100x500x100,800x100x800x100x600x100,800x100x800x100x700x100,800x100x800x100x750x100,800x100x800x100x800x100,800x100x800x100x900x100,800x100x800x100x1000x100,900x100x900x100x100x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x500x100,900x100x900x100x600x100,900x100x900x100x700x100,900x100x900x100x750x100,900x100x900x100x800x100,900x100x900x100x900x100,900x100x900x100x1000x100,1000x100x1000x100x100x100,1000x100x1000x100x150x100,1000x100x1000x100x300x100,1000x100x1000x100x450x100,1000x100x1000x100x500x100,1000x100x1000x100x600x100,1000x100x1000x100x700x100,1000x100x1000x100x750x100,1000x100x1000x100x800x100,1000x100x1000x100x900x100,1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 LT Tee 900 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.36351706036745",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.492125984251969",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "",
                id: "24119708697761031",
                isClearence: "false"
              }
            ],
            ladderCableTrayUnion: {
              addDefaultItem: {
                name: "M_Unistrut HG Finish U10 SP Coupler FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "100x100x100x100,150x100x150x100,200x100x200x100,300x100x300x100,400x100x400x100,450x100x450x100,500x100x500x100,600x100x600x100,700x100x700x100,750x100x750x100,800x100x800x100,900x100x900x100,1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 SP Coupler FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,8",
                dispPosition: "42",
                csvFileName: "",
                bendType: "",
                id: "24119710697763531",
                isClearence: "false"
              }
            },
            ladderCableTrayMultiPort: {
              addDefaultItem: {
                name: "M_Unistrut HG Finish U10 SE Cap FE",
                defaultFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "100x100,150x100,200x100,300x100,400x100,450x100,500x100,600x100,700x100,750x100,800x100,900x100,1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u10-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U10 SE Cap FE.RFA",
                description: "",
                angle: "",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "",
                id: "24119709697766131",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "unistrut Galv U12 HG 3m x 300mm Rung Spacing",
        unit: "METRIC",
        id: "43",
        systemShape: "ladder Cable Tray",
        systemUniqueId: "43",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: {
              name: "M_Unistrut HG Finish U12 Cable Ladder 3M PExPE",
              id: "24119799697960131",
              Length: "10",
              JunctionType: "Tee",
              OldMat: "",
              shape: "ladder Cable Tray",
              sizeRange: "100x125,150x125,200x125,300x125,400x125,450x125,500x125,600x125,700x125,750x125,800x125,900x125,1000x125",
              manufacturer: "unistrut",
              path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
              icon: "M_Unistrut HG Finish U12 Cable Ladder 3M PExPE.RFA",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "1,8",
              dispPosition: "42",
              duplicateFrom: "ladder Cable Tray",
              defaultFor: "",
              isClearence: "false"
            },
            ladderCableTrayElbow: [
              {
                name: "M_Unistrut HG Finish U12 FB 45 Flat Bend 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 45 Flat Bend 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.41689911384014",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "3.28083989501312",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24119806697960531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 FB 45 Flat Bend 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 45 Flat Bend 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.4848475328646",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.6246719160105",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24119807697960531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 FB 45 Flat Bend 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 45 Flat Bend 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.68869278993797",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.6246719160105",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24119808697960531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 FB 45 Flat Bend 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 45 Flat Bend 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.89253804701134",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.6246719160105",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "24119809697960531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 FB 45 Flat Bend 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 45 Flat Bend 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.23228014213363",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "3.28083989501312",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "24119810697960531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 FB 90 Flat Bend 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 90 Flat Bend 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.626312335958",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.6246719160105",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24119811697960731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 FB 90 Flat Bend 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 90 Flat Bend 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.11843832020997",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.6246719160105",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24119812697960731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 FB 90 Flat Bend 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 90 Flat Bend 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.1026902887139",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.6246719160105",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24119814697960731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 FB 90 Flat Bend 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 FB 90 Flat Bend 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.59481627296585",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "2.6246719160105",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24119815697960731",
                isClearence: "false"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "M_Unistrut HG Finish U12 IR 45 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 45 Riser 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.984752022179284",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.41010498687664",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119816697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 45 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 45 Riser 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.18859727925263",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.41010498687664",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119817697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 45 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 45 Riser 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.39244253632603",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.41010498687664",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119818697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 45 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 45 Riser 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.5962877933994",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.41010498687664",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119819697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 45 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 45 Riser 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.80013305047278",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.41010498687664",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119820697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 90 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 90 Riser 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.68143044619422",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.41010498687664",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119826697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 90 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 90 Riser 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.17355643044616",
                isConnCheck: "True",
                extraField: "",
                Height: "1.64041994750656",
                width: "0.41010498687664",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119827697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 90 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 90 Riser 600 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.66568241469816",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.41010498687664",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119828697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 90 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 90 Riser 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.15780839895008",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.41010498687664",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119829697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 IR 90 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 IR 90 Riser 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.64993438320205",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.41010498687664",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119830697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 45 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 45 Riser 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.984752022179275",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.41010498687664",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119821697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 45 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 45 Riser 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.18859727925265",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.41010498687664",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119822697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 45 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 45 Riser 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.39244253632603",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.41010498687664",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119823697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 45 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 45 Riser 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.5962877933994",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.41010498687664",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119824697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 45 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 45 Riser 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.80013305047276",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.41010498687664",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119825697960331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 90 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 90 Riser 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.68143044619421",
                isConnCheck: "True",
                extraField: "",
                Height: "1.64041994750656",
                width: "0.41010498687664",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119831697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 90 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 90 Riser 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.17355643044617",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119832697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 90 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 90 Riser 600 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.66568241469814",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119833697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 90 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 90 Riser 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.15780839895012",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119834697960231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 OR 90 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 OR 90 Riser 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.64993438320209",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.41010498687664",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119835697960231",
                isClearence: "false"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "M_Unistrut HG Finish U12 EC Cross 300 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "100x125x100x125x100x125x100x125,150x125x150x125x150x125x150x125,200x125x200x125x200x125x200x125,300x125x300x125x300x125x300x125,400x125x400x125x400x125x400x125,450x125x450x125x450x125x450x125,500x125x500x125x500x125x500x125,600x125x600x125x600x125x600x125,700x125x700x125x700x125x700x125,750x125x750x125x750x125x750x125,800x125x800x125x800x125x800x125,900x125x900x125x900x125x900x125,1000x125x1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 EC Cross 300 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.23097112860891",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                bendType: "",
                id: "24119801697961131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 EC Cross 450 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "100x125x100x125x100x125x100x125,150x125x150x125x150x125x150x125,200x125x200x125x200x125x200x125,300x125x300x125x300x125x300x125,400x125x400x125x400x125x400x125,450x125x450x125x450x125x450x125,500x125x500x125x500x125x500x125,600x125x600x125x600x125x600x125,700x125x700x125x700x125x700x125,750x125x750x125x750x125x750x125,800x125x800x125x800x125x800x125,900x125x900x125x900x125x900x125,1000x125x1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 EC Cross 450 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.72309711286089",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24119802697961131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 EC Cross 600 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "100x125x100x125x100x125x100x125,150x125x150x125x150x125x150x125,200x125x200x125x200x125x200x125,300x125x300x125x300x125x300x125,400x125x400x125x400x125x400x125,450x125x450x125x450x125x450x125,500x125x500x125x500x125x500x125,600x125x600x125x600x125x600x125,700x125x700x125x700x125x700x125,750x125x750x125x750x125x750x125,800x125x800x125x800x125x800x125,900x125x900x125x900x125x900x125,1000x125x1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 EC Cross 600 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.21522309711286",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24119803697961131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 EC Cross 750 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "100x125x100x125x100x125x100x125,150x125x150x125x150x125x150x125,200x125x200x125x200x125x200x125,300x125x300x125x300x125x300x125,400x125x400x125x400x125x400x125,450x125x450x125x450x125x450x125,500x125x500x125x500x125x500x125,600x125x600x125x600x125x600x125,700x125x700x125x700x125x700x125,750x125x750x125x750x125x750x125,800x125x800x125x800x125x800x125,900x125x900x125x900x125x900x125,1000x125x1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 EC Cross 750 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.70734908136481",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "24119804697961131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 EC Cross 900 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "5",
                sizeRange: "100x125x100x125x100x125x100x125,150x125x150x125x150x125x150x125,200x125x200x125x200x125x200x125,300x125x300x125x300x125x300x125,400x125x400x125x400x125x400x125,450x125x450x125x450x125x450x125,500x125x500x125x500x125x500x125,600x125x600x125x600x125x600x125,700x125x700x125x700x125x700x125,750x125x750x125x750x125x750x125,800x125x800x125x800x125x800x125,900x125x900x125x900x125x900x125,1000x125x1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 EC Cross 900 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "4.19947506561678",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "1.96850393700787",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "24119805697961131",
                isClearence: "false"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "M_Unistrut HG Finish U12 LT Tee 300 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "100x125x100x125x100x125,100x125x100x125x150x125,100x125x100x125x300x125,100x125x100x125x450x125,100x125x100x125x500x125,100x125x100x125x600x125,100x125x100x125x700x125,100x125x100x125x750x125,100x125x100x125x800x125,100x125x100x125x900x125,100x125x100x125x1000x125,150x125x150x125x100x125,150x125x150x125x150x125,150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x500x125,150x125x150x125x600x125,150x125x150x125x700x125,150x125x150x125x750x125,150x125x150x125x800x125,150x125x150x125x900x125,150x125x150x125x1000x125,200x125x200x125x200x125,200x125x200x125x400x125,300x125x300x125x100x125,300x125x300x125x150x125,300x125x300x125x300x125,300x125x300x125x400x125,300x125x300x125x450x125,300x125x300x125x500x125,300x125x300x125x600x125,300x125x300x125x700x125,300x125x300x125x750x125,300x125x300x125x800x125,300x125x300x125x900x125,300x125x300x125x1000x125,400x125x400x125x100x125,400x125x400x125x150x125,400x125x400x125x200x125,400x125x400x125x300x125,400x125x400x125x400x125,400x125x400x125x450x125,400x125x400x125x500x125,400x125x400x125x600x125,400x125x400x125x700x125,400x125x400x125x750x125,400x125x400x125x800x125,400x125x400x125x900x125,400x125x400x125x1000x125,450x125x450x125x100x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x450x125,450x125x450x125x500x125,450x125x450x125x600x125,450x125x450x125x700x125,450x125x450x125x750x125,450x125x450x125x800x125,450x125x450x125x900x125,450x125x450x125x1000x125,500x125x500x125x100x125,500x125x500x125x150x125,500x125x500x125x300x125,500x125x500x125x450x125,500x125x500x125x500x125,500x125x500x125x600x125,500x125x500x125x700x125,500x125x500x125x750x125,500x125x500x125x800x125,500x125x500x125x900x125,500x125x500x125x1000x125,600x125x600x125x100x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x500x125,600x125x600x125x600x125,600x125x600x125x700x125,600x125x600x125x750x125,600x125x600x125x800x125,600x125x600x125x900x125,600x125x600x125x1000x125,700x125x700x125x100x125,700x125x700x125x150x125,700x125x700x125x300x125,700x125x700x125x450x125,700x125x700x125x500x125,700x125x700x125x600x125,700x125x700x125x700x125,700x125x700x125x750x125,700x125x700x125x800x125,700x125x700x125x900x125,700x125x700x125x1000x125,750x125x750x125x100x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x500x125,750x125x750x125x600x125,750x125x750x125x700x125,750x125x750x125x750x125,750x125x750x125x800x125,750x125x750x125x900x125,750x125x750x125x1000x125,800x125x800x125x100x125,800x125x800x125x150x125,800x125x800x125x300x125,800x125x800x125x450x125,800x125x800x125x500x125,800x125x800x125x600x125,800x125x800x125x700x125,800x125x800x125x750x125,800x125x800x125x800x125,800x125x800x125x900x125,800x125x800x125x1000x125,900x125x900x125x100x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x500x125,900x125x900x125x600x125,900x125x900x125x700x125,900x125x900x125x750x125,900x125x900x125x800x125,900x125x900x125x900x125,900x125x900x125x1000x125,1000x125x1000x125x100x125,1000x125x1000x125x150x125,1000x125x1000x125x300x125,1000x125x1000x125x450x125,1000x125x1000x125x500x125,1000x125x1000x125x600x125,1000x125x1000x125x700x125,1000x125x1000x125x750x125,1000x125x1000x125x800x125,1000x125x1000x125x900x125,1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 LT Tee 300 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.39501312335958",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "0.492125984251969",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "",
                id: "24119836697961031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 LT Tee 450 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "100x100x100x100x100x100,100x100x100x100x150x100,100x100x100x100x300x100,100x100x100x100x450x100,100x100x100x100x500x100,100x100x100x100x600x100,100x100x100x100x700x100,100x100x100x100x750x100,100x100x100x100x800x100,100x100x100x100x900x100,100x100x100x100x1000x100,150x100x150x100x100x100,150x100x150x100x150x100,150x100x150x100x300x100,150x100x150x100x450x100,150x100x150x100x500x100,150x100x150x100x600x100,150x100x150x100x700x100,150x100x150x100x750x100,150x100x150x100x800x100,150x100x150x100x900x100,150x100x150x100x1000x100,200x100x200x100x200x100,200x100x200x100x400x100,300x100x300x100x100x100,300x100x300x100x150x100,300x100x300x100x300x100,300x100x300x100x400x100,300x100x300x100x450x100,300x100x300x100x500x100,300x100x300x100x600x100,300x100x300x100x700x100,300x100x300x100x750x100,300x100x300x100x800x100,300x100x300x100x900x100,300x100x300x100x1000x100,400x100x400x100x100x100,400x100x400x100x150x100,400x100x400x100x200x100,400x100x400x100x300x100,400x100x400x100x400x100,400x100x400x100x450x100,400x100x400x100x500x100,400x100x400x100x600x100,400x100x400x100x700x100,400x100x400x100x750x100,400x100x400x100x800x100,400x100x400x100x900x100,400x100x400x100x1000x100,450x100x450x100x100x100,450x100x450x100x150x100,450x100x450x100x300x100,450x100x450x100x450x100,450x100x450x100x500x100,450x100x450x100x600x100,450x100x450x100x700x100,450x100x450x100x750x100,450x100x450x100x800x100,450x100x450x100x900x100,450x100x450x100x1000x100,500x100x500x100x100x100,500x100x500x100x150x100,500x100x500x100x300x100,500x100x500x100x450x100,500x100x500x100x500x100,500x100x500x100x600x100,500x100x500x100x700x100,500x100x500x100x750x100,500x100x500x100x800x100,500x100x500x100x900x100,500x100x500x100x1000x100,600x100x600x100x100x100,600x100x600x100x150x100,600x100x600x100x300x100,600x100x600x100x450x100,600x100x600x100x500x100,600x100x600x100x600x100,600x100x600x100x700x100,600x100x600x100x750x100,600x100x600x100x800x100,600x100x600x100x900x100,600x100x600x100x1000x100,700x100x700x100x100x100,700x100x700x100x150x100,700x100x700x100x300x100,700x100x700x100x450x100,700x100x700x100x500x100,700x100x700x100x600x100,700x100x700x100x700x100,700x100x700x100x750x100,700x100x700x100x800x100,700x100x700x100x900x100,700x100x700x100x1000x100,750x100x750x100x100x100,750x100x750x100x150x100,750x100x750x100x300x100,750x100x750x100x450x100,750x100x750x100x500x100,750x100x750x100x600x100,750x100x750x100x700x100,750x100x750x100x750x100,750x100x750x100x800x100,750x100x750x100x900x100,750x100x750x100x1000x100,800x100x800x100x100x100,800x100x800x100x150x100,800x100x800x100x300x100,800x100x800x100x450x100,800x100x800x100x500x100,800x100x800x100x600x100,800x100x800x100x700x100,800x100x800x100x750x100,800x100x800x100x800x100,800x100x800x100x900x100,800x100x800x100x1000x100,900x100x900x100x100x100,900x100x900x100x150x100,900x100x900x100x300x100,900x100x900x100x450x100,900x100x900x100x500x100,900x100x900x100x600x100,900x100x900x100x700x100,900x100x900x100x750x100,900x100x900x100x800x100,900x100x900x100x900x100,900x100x900x100x1000x100,1000x100x1000x100x100x100,1000x100x1000x100x150x100,1000x100x1000x100x300x100,1000x100x1000x100x450x100,1000x100x1000x100x500x100,1000x100x1000x100x600x100,1000x100x1000x100x700x100,1000x100x1000x100x750x100,1000x100x1000x100x800x100,1000x100x1000x100x900x100,1000x100x1000x100x1000x100",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 LT Tee 450 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.88713910761155",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "0.984251968503937",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "",
                id: "24119837697961031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 LT Tee 600 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "100x125x100x125x100x125,100x125x100x125x150x125,100x125x100x125x300x125,100x125x100x125x450x125,100x125x100x125x500x125,100x125x100x125x600x125,100x125x100x125x700x125,100x125x100x125x750x125,100x125x100x125x800x125,100x125x100x125x900x125,100x125x100x125x1000x125,150x125x150x125x100x125,150x125x150x125x150x125,150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x500x125,150x125x150x125x600x125,150x125x150x125x700x125,150x125x150x125x750x125,150x125x150x125x800x125,150x125x150x125x900x125,150x125x150x125x1000x125,200x125x200x125x200x125,200x125x200x125x400x125,300x125x300x125x100x125,300x125x300x125x150x125,300x125x300x125x300x125,300x125x300x125x400x125,300x125x300x125x450x125,300x125x300x125x500x125,300x125x300x125x600x125,300x125x300x125x700x125,300x125x300x125x750x125,300x125x300x125x800x125,300x125x300x125x900x125,300x125x300x125x1000x125,400x125x400x125x100x125,400x125x400x125x150x125,400x125x400x125x200x125,400x125x400x125x300x125,400x125x400x125x400x125,400x125x400x125x450x125,400x125x400x125x500x125,400x125x400x125x600x125,400x125x400x125x700x125,400x125x400x125x750x125,400x125x400x125x800x125,400x125x400x125x900x125,400x125x400x125x1000x125,450x125x450x125x100x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x450x125,450x125x450x125x500x125,450x125x450x125x600x125,450x125x450x125x700x125,450x125x450x125x750x125,450x125x450x125x800x125,450x125x450x125x900x125,450x125x450x125x1000x125,500x125x500x125x100x125,500x125x500x125x150x125,500x125x500x125x300x125,500x125x500x125x450x125,500x125x500x125x500x125,500x125x500x125x600x125,500x125x500x125x700x125,500x125x500x125x750x125,500x125x500x125x800x125,500x125x500x125x900x125,500x125x500x125x1000x125,600x125x600x125x100x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x500x125,600x125x600x125x600x125,600x125x600x125x700x125,600x125x600x125x750x125,600x125x600x125x800x125,600x125x600x125x900x125,600x125x600x125x1000x125,700x125x700x125x100x125,700x125x700x125x150x125,700x125x700x125x300x125,700x125x700x125x450x125,700x125x700x125x500x125,700x125x700x125x600x125,700x125x700x125x700x125,700x125x700x125x750x125,700x125x700x125x800x125,700x125x700x125x900x125,700x125x700x125x1000x125,750x125x750x125x100x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x500x125,750x125x750x125x600x125,750x125x750x125x700x125,750x125x750x125x750x125,750x125x750x125x800x125,750x125x750x125x900x125,750x125x750x125x1000x125,800x125x800x125x100x125,800x125x800x125x150x125,800x125x800x125x300x125,800x125x800x125x450x125,800x125x800x125x500x125,800x125x800x125x600x125,800x125x800x125x700x125,800x125x800x125x750x125,800x125x800x125x800x125,800x125x800x125x900x125,800x125x800x125x1000x125,900x125x900x125x100x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x500x125,900x125x900x125x600x125,900x125x900x125x700x125,900x125x900x125x750x125,900x125x900x125x800x125,900x125x900x125x900x125,900x125x900x125x1000x125,1000x125x1000x125x100x125,1000x125x1000x125x150x125,1000x125x1000x125x300x125,1000x125x1000x125x450x125,1000x125x1000x125x500x125,1000x125x1000x125x600x125,1000x125x1000x125x700x125,1000x125x1000x125x750x125,1000x125x1000x125x800x125,1000x125x1000x125x900x125,1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 LT Tee 600 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.37926509186352",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "0.984251968503937",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "24119838697961031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 LT Tee 750 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "100x125x100x125x100x125,100x125x100x125x150x125,100x125x100x125x300x125,100x125x100x125x450x125,100x125x100x125x500x125,100x125x100x125x600x125,100x125x100x125x700x125,100x125x100x125x750x125,100x125x100x125x800x125,100x125x100x125x900x125,100x125x100x125x1000x125,150x125x150x125x100x125,150x125x150x125x150x125,150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x500x125,150x125x150x125x600x125,150x125x150x125x700x125,150x125x150x125x750x125,150x125x150x125x800x125,150x125x150x125x900x125,150x125x150x125x1000x125,200x125x200x125x200x125,200x125x200x125x400x125,300x125x300x125x100x125,300x125x300x125x150x125,300x125x300x125x300x125,300x125x300x125x400x125,300x125x300x125x450x125,300x125x300x125x500x125,300x125x300x125x600x125,300x125x300x125x700x125,300x125x300x125x750x125,300x125x300x125x800x125,300x125x300x125x900x125,300x125x300x125x1000x125,400x125x400x125x100x125,400x125x400x125x150x125,400x125x400x125x200x125,400x125x400x125x300x125,400x125x400x125x400x125,400x125x400x125x450x125,400x125x400x125x500x125,400x125x400x125x600x125,400x125x400x125x700x125,400x125x400x125x750x125,400x125x400x125x800x125,400x125x400x125x900x125,400x125x400x125x1000x125,450x125x450x125x100x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x450x125,450x125x450x125x500x125,450x125x450x125x600x125,450x125x450x125x700x125,450x125x450x125x750x125,450x125x450x125x800x125,450x125x450x125x900x125,450x125x450x125x1000x125,500x125x500x125x100x125,500x125x500x125x150x125,500x125x500x125x300x125,500x125x500x125x450x125,500x125x500x125x500x125,500x125x500x125x600x125,500x125x500x125x700x125,500x125x500x125x750x125,500x125x500x125x800x125,500x125x500x125x900x125,500x125x500x125x1000x125,600x125x600x125x100x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x500x125,600x125x600x125x600x125,600x125x600x125x700x125,600x125x600x125x750x125,600x125x600x125x800x125,600x125x600x125x900x125,600x125x600x125x1000x125,700x125x700x125x100x125,700x125x700x125x150x125,700x125x700x125x300x125,700x125x700x125x450x125,700x125x700x125x500x125,700x125x700x125x600x125,700x125x700x125x700x125,700x125x700x125x750x125,700x125x700x125x800x125,700x125x700x125x900x125,700x125x700x125x1000x125,750x125x750x125x100x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x500x125,750x125x750x125x600x125,750x125x750x125x700x125,750x125x750x125x750x125,750x125x750x125x800x125,750x125x750x125x900x125,750x125x750x125x1000x125,800x125x800x125x100x125,800x125x800x125x150x125,800x125x800x125x300x125,800x125x800x125x450x125,800x125x800x125x500x125,800x125x800x125x600x125,800x125x800x125x700x125,800x125x800x125x750x125,800x125x800x125x800x125,800x125x800x125x900x125,800x125x800x125x1000x125,900x125x900x125x100x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x500x125,900x125x900x125x600x125,900x125x900x125x700x125,900x125x900x125x750x125,900x125x900x125x800x125,900x125x900x125x900x125,900x125x900x125x1000x125,1000x125x1000x125x100x125,1000x125x1000x125x150x125,1000x125x1000x125x300x125,1000x125x1000x125x450x125,1000x125x1000x125x500x125,1000x125x1000x125x600x125,1000x125x1000x125x700x125,1000x125x1000x125x750x125,1000x125x1000x125x800x125,1000x125x1000x125x900x125,1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 LT Tee 750 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.87139107611549",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "0.984251968503937",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "24119839697961031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U12 LT Tee 900 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "100x125x100x125x100x125,100x125x100x125x150x125,100x125x100x125x300x125,100x125x100x125x450x125,100x125x100x125x500x125,100x125x100x125x600x125,100x125x100x125x700x125,100x125x100x125x750x125,100x125x100x125x800x125,100x125x100x125x900x125,100x125x100x125x1000x125,150x125x150x125x100x125,150x125x150x125x150x125,150x125x150x125x300x125,150x125x150x125x450x125,150x125x150x125x500x125,150x125x150x125x600x125,150x125x150x125x700x125,150x125x150x125x750x125,150x125x150x125x800x125,150x125x150x125x900x125,150x125x150x125x1000x125,200x125x200x125x200x125,200x125x200x125x400x125,300x125x300x125x100x125,300x125x300x125x150x125,300x125x300x125x300x125,300x125x300x125x400x125,300x125x300x125x450x125,300x125x300x125x500x125,300x125x300x125x600x125,300x125x300x125x700x125,300x125x300x125x750x125,300x125x300x125x800x125,300x125x300x125x900x125,300x125x300x125x1000x125,400x125x400x125x100x125,400x125x400x125x150x125,400x125x400x125x200x125,400x125x400x125x300x125,400x125x400x125x400x125,400x125x400x125x450x125,400x125x400x125x500x125,400x125x400x125x600x125,400x125x400x125x700x125,400x125x400x125x750x125,400x125x400x125x800x125,400x125x400x125x900x125,400x125x400x125x1000x125,450x125x450x125x100x125,450x125x450x125x150x125,450x125x450x125x300x125,450x125x450x125x450x125,450x125x450x125x500x125,450x125x450x125x600x125,450x125x450x125x700x125,450x125x450x125x750x125,450x125x450x125x800x125,450x125x450x125x900x125,450x125x450x125x1000x125,500x125x500x125x100x125,500x125x500x125x150x125,500x125x500x125x300x125,500x125x500x125x450x125,500x125x500x125x500x125,500x125x500x125x600x125,500x125x500x125x700x125,500x125x500x125x750x125,500x125x500x125x800x125,500x125x500x125x900x125,500x125x500x125x1000x125,600x125x600x125x100x125,600x125x600x125x150x125,600x125x600x125x300x125,600x125x600x125x450x125,600x125x600x125x500x125,600x125x600x125x600x125,600x125x600x125x700x125,600x125x600x125x750x125,600x125x600x125x800x125,600x125x600x125x900x125,600x125x600x125x1000x125,700x125x700x125x100x125,700x125x700x125x150x125,700x125x700x125x300x125,700x125x700x125x450x125,700x125x700x125x500x125,700x125x700x125x600x125,700x125x700x125x700x125,700x125x700x125x750x125,700x125x700x125x800x125,700x125x700x125x900x125,700x125x700x125x1000x125,750x125x750x125x100x125,750x125x750x125x150x125,750x125x750x125x300x125,750x125x750x125x450x125,750x125x750x125x500x125,750x125x750x125x600x125,750x125x750x125x700x125,750x125x750x125x750x125,750x125x750x125x800x125,750x125x750x125x900x125,750x125x750x125x1000x125,800x125x800x125x100x125,800x125x800x125x150x125,800x125x800x125x300x125,800x125x800x125x450x125,800x125x800x125x500x125,800x125x800x125x600x125,800x125x800x125x700x125,800x125x800x125x750x125,800x125x800x125x800x125,800x125x800x125x900x125,800x125x800x125x1000x125,900x125x900x125x100x125,900x125x900x125x150x125,900x125x900x125x300x125,900x125x900x125x450x125,900x125x900x125x500x125,900x125x900x125x600x125,900x125x900x125x700x125,900x125x900x125x750x125,900x125x900x125x800x125,900x125x900x125x900x125,900x125x900x125x1000x125,1000x125x1000x125x100x125,1000x125x1000x125x150x125,1000x125x1000x125x300x125,1000x125x1000x125x450x125,1000x125x1000x125x500x125,1000x125x1000x125x600x125,1000x125x1000x125x700x125,1000x125x1000x125x750x125,1000x125x1000x125x800x125,1000x125x1000x125x900x125,1000x125x1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 LT Tee 900 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.37926509186352",
                isConnCheck: "True",
                extraField: "",
                Height: "0.41010498687664",
                width: "0.328083989501312",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "",
                id: "24119840697961031",
                isClearence: "false"
              }
            ],
            ladderCableTrayUnion: {
              addDefaultItem: {
                name: "M_Unistrut HG Finish U12 SP Coupler FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "100x125x100x125,150x125x150x125,200x125x200x125,300x125x300x125,400x125x400x125,450x125x450x125,500x125x500x125,600x125x600x125,700x125x700x125,750x125x750x125,800x125x800x125,900x125x900x125,1000x125x1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 SP Coupler FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "",
                id: "24119842697963531",
                isClearence: "false"
              }
            },
            ladderCableTrayMultiPort: {
              addDefaultItem: {
                name: "M_Unistrut HG Finish U12 SE Cap FE",
                defaultFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "100x125,150x125,200x125,300x125,400x125,450x125,500x125,600x125,700x125,750x125,800x125,900x125,1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u12-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U12 SE Cap FE.RFA",
                description: "",
                angle: "",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "",
                bendType: "",
                id: "24119841697966131",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "unistrut Galv U15 HG 3m x 300mm Rung Spacing",
        unit: "METRIC",
        id: "47",
        systemShape: "ladder Cable Tray",
        systemUniqueId: "47",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: {
              name: "M_Unistrut HG Finish U15 Cable Ladder 3M PExPE",
              id: "24119886698160131",
              Length: "10",
              JunctionType: "Tee",
              OldMat: "",
              shape: "ladder Cable Tray",
              sizeRange: "100x150,150x150,200x150,300x150,400x150,450x150,500x150,600x150,700x150,750x150,800x150,900x150,1000x150",
              manufacturer: "unistrut",
              path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
              icon: "M_Unistrut HG Finish U15 Cable Ladder 3M PExPE.RFA",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "2,8",
              dispPosition: "43",
              duplicateFrom: "ladder Cable Tray",
              defaultFor: "",
              isClearence: "false"
            },
            ladderCableTrayElbow: [
              {
                name: "M_Unistrut HG Finish U15 FB 45 Flat Bend 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 45 Flat Bend 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.04318280920563",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "1.47637795275591",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24119893698160531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 45 Flat Bend 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 45 Flat Bend 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.4848475328646",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.6246719160105",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24119894698160531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 45 Flat Bend 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 45 Flat Bend 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.68869278993797",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.6246719160105",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24119895698160531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 45 Flat Bend 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 45 Flat Bend 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.89253804701134",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.6246719160105",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "24119896698160531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 45 Flat Bend 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 45 Flat Bend 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.23228014213361",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "3.28083989501312",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "24119897698160531",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 90 Flat Bend 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 90 Flat Bend 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.626312335958",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.6246719160105",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24119898698160731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 90 Flat Bend 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 90 Flat Bend 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.11843832020997",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.6246719160105",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24119899698160731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 90 Flat Bend 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 90 Flat Bend 600 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.61056430446193",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.6246719160105",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24119900698160731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 90 Flat Bend 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 90 Flat Bend 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.1026902887139",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.6246719160105",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24119901698160731",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 FB 90 Flat Bend 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "12",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 FB 90 Flat Bend 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.59481627296585",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.6246719160105",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24119902698160731",
                isClearence: "false"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "M_Unistrut HG Finish U15 IR 45 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 45 Riser 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.0017391269354",
                isConnCheck: "True",
                extraField: "",
                Height: "1.64041994750656",
                width: "0.492125984251969",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119903698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 45 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 45 Riser 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.20558438400877",
                isConnCheck: "True",
                extraField: "",
                Height: "1.64041994750656",
                width: "0.492125984251969",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119904698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 45 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 45 Riser 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.40942964108215",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.492125984251969",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119905698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 45 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 45 Riser 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.61327489815552",
                isConnCheck: "True",
                extraField: "",
                Height: "1.64041994750656",
                width: "0.492125984251969",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119906698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 45 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 45 Riser 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.81712015522889",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.492125984251969",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119907698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 90 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 90 Riser 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.72244094488189",
                isConnCheck: "True",
                extraField: "",
                Height: "1.64041994750656",
                width: "0.492125984251969",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119912698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 90 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 90 Riser 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.21456692913385",
                isConnCheck: "True",
                extraField: "",
                Height: "1.64041994750656",
                width: "0.492125984251969",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119913698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 90 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 90 Riser 600 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.70669291338582",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.492125984251969",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119914698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 90 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 90 Riser 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.19881889763779",
                isConnCheck: "True",
                extraField: "",
                Height: "1.64041994750656",
                width: "0.492125984251969",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119915698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 IR 90 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 IR 90 Riser 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.69094488188971",
                isConnCheck: "True",
                extraField: "",
                Height: "1.31233595800525",
                width: "0.492125984251969",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119916698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 45 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 45 Riser 300 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.0017391269354",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119908698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 45 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 45 Riser 450 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.20558438400876",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119909698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 45 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 45 Riser 600 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.40942964108213",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119910698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 45 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 45 Riser 750 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.6132748981555",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119911698160331",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 45 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 45 Riser 900 R PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.81712015522887",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119917698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 90 Riser 300 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 90 Riser 300 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.72244094488188",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119918698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 90 Riser 450 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 90 Riser 450 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.21456692913385",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119919698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 90 Riser 600 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 90 Riser 600 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.70669291338582",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119920698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 90 Riser 750 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 90 Riser 750 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.19881889763777",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119921698160231",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 OR 90 Riser 900 R PExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 OR 90 Riser 900 R PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.69094488188973",
                isConnCheck: "True",
                extraField: "",
                Height: "3.28083989501312",
                width: "0.492125984251969",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119922698160231",
                isClearence: "false"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "M_Unistrut HG Finish U15 EC Cross 300 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "100x150x100x150x100x150x100x150,150x150x150x150x150x150x150x150,200x150x200x150x200x150x200x150,300x150x300x150x300x150x300x150,400x150x400x150x400x150x400x150,450x150x450x150x450x150x450x150,500x150x500x150x500x150x500x150,600x150x600x150x600x150x600x150,700x150x700x150x700x150x700x150,750x150x750x150x750x150x750x150,800x150x800x150x800x150x800x150,900x150x900x150x900x150x900x150,1000x150x1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 EC Cross 300 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.23097112860891",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "1.96850393700787",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                bendType: "",
                id: "24119888698161131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 EC Cross 450 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "100x150x100x150x100x150x100x150,150x150x150x150x150x150x150x150,200x150x200x150x200x150x200x150,300x150x300x150x300x150x300x150,400x150x400x150x400x150x400x150,450x150x450x150x450x150x450x150,500x150x500x150x500x150x500x150,600x150x600x150x600x150x600x150,700x150x700x150x700x150x700x150,750x150x750x150x750x150x750x150,800x150x800x150x800x150x800x150,900x150x900x150x900x150x900x150,1000x150x1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 EC Cross 450 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.21522309711284",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24119889698161131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 EC Cross 600 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "100x150x100x150x100x150x100x150,150x150x150x150x150x150x150x150,200x150x200x150x200x150x200x150,300x150x300x150x300x150x300x150,400x150x400x150x400x150x400x150,450x150x450x150x450x150x450x150,500x150x500x150x500x150x500x150,600x150x600x150x600x150x600x150,700x150x700x150x700x150x700x150,750x150x750x150x750x150x750x150,800x150x800x150x800x150x800x150,900x150x900x150x900x150x900x150,1000x150x1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 EC Cross 600 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.96916010498688",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "1.47637795275591",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24119890698161131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 EC Cross 750 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "100x150x100x150x100x150x100x150,150x150x150x150x150x150x150x150,200x150x200x150x200x150x200x150,300x150x300x150x300x150x300x150,400x150x400x150x400x150x400x150,450x150x450x150x450x150x450x150,500x150x500x150x500x150x500x150,600x150x600x150x600x150x600x150,700x150x700x150x700x150x700x150,750x150x750x150x750x150x750x150,800x150x800x150x800x150x800x150,900x150x900x150x900x150x900x150,1000x150x1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 EC Cross 750 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "4.19947506561678",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "2.95275590551181",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "24119891698161131",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 EC Cross 900 R PExPExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayCross",
                position: "5",
                sizeRange: "100x150x100x150x100x150x100x150,150x150x150x150x150x150x150x150,200x150x200x150x200x150x200x150,300x150x300x150x300x150x300x150,400x150x400x150x400x150x400x150,450x150x450x150x450x150x450x150,500x150x500x150x500x150x500x150,600x150x600x150x600x150x600x150,700x150x700x150x700x150x700x150,750x150x750x150x750x150x750x150,800x150x800x150x800x150x800x150,900x150x900x150x900x150x900x150,1000x150x1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 EC Cross 900 R PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.87139107611549",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "1.31233595800525",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "24119892698161131",
                isClearence: "false"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "M_Unistrut HG Finish U15 LT Tee 300 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "100x150x100x150x100x150,100x150x100x150x150x150,100x150x100x150x300x150,100x150x100x150x450x150,100x150x100x150x500x150,100x150x100x150x600x150,100x150x100x150x700x150,100x150x100x150x750x150,100x150x100x150x800x150,100x150x100x150x900x150,100x150x100x150x1000x150,150x150x150x150x100x150,150x150x150x150x150x150,150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x500x150,150x150x150x150x600x150,150x150x150x150x700x150,150x150x150x150x750x150,150x150x150x150x800x150,150x150x150x150x900x150,150x150x150x150x1000x150,200x150x200x150x200x150,200x150x200x150x400x150,300x150x300x150x100x150,300x150x300x150x150x150,300x150x300x150x300x150,300x150x300x150x400x150,300x150x300x150x450x150,300x150x300x150x500x150,300x150x300x150x600x150,300x150x300x150x700x150,300x150x300x150x750x150,300x150x300x150x800x150,300x150x300x150x900x150,300x150x300x150x1000x150,400x150x400x150x100x150,400x150x400x150x150x150,400x150x400x150x200x150,400x150x400x150x300x150,400x150x400x150x400x150,400x150x400x150x450x150,400x150x400x150x500x150,400x150x400x150x600x150,400x150x400x150x700x150,400x150x400x150x750x150,400x150x400x150x800x150,400x150x400x150x900x150,400x150x400x150x1000x150,450x150x450x150x100x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x450x150,450x150x450x150x500x150,450x150x450x150x600x150,450x150x450x150x700x150,450x150x450x150x750x150,450x150x450x150x800x150,450x150x450x150x900x150,450x150x450x150x1000x150,500x150x500x150x100x150,500x150x500x150x150x150,500x150x500x150x300x150,500x150x500x150x450x150,500x150x500x150x500x150,500x150x500x150x600x150,500x150x500x150x700x150,500x150x500x150x750x150,500x150x500x150x800x150,500x150x500x150x900x150,500x150x500x150x1000x150,600x150x600x150x100x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x500x150,600x150x600x150x600x150,600x150x600x150x700x150,600x150x600x150x750x150,600x150x600x150x800x150,600x150x600x150x900x150,600x150x600x150x1000x150,700x150x700x150x100x150,700x150x700x150x150x150,700x150x700x150x300x150,700x150x700x150x450x150,700x150x700x150x500x150,700x150x700x150x600x150,700x150x700x150x700x150,700x150x700x150x750x150,700x150x700x150x800x150,700x150x700x150x900x150,700x150x700x150x1000x150,750x150x750x150x100x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x500x150,750x150x750x150x600x150,750x150x750x150x700x150,750x150x750x150x750x150,750x150x750x150x800x150,750x150x750x150x900x150,750x150x750x150x1000x150,800x150x800x150x100x150,800x150x800x150x150x150,800x150x800x150x300x150,800x150x800x150x450x150,800x150x800x150x500x150,800x150x800x150x600x150,800x150x800x150x700x150,800x150x800x150x750x150,800x150x800x150x800x150,800x150x800x150x900x150,800x150x800x150x1000x150,900x150x900x150x100x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x500x150,900x150x900x150x600x150,900x150x900x150x700x150,900x150x900x150x750x150,900x150x900x150x800x150,900x150x900x150x900x150,900x150x900x150x1000x150,1000x150x1000x150x100x150,1000x150x1000x150x150x150,1000x150x1000x150x300x150,1000x150x1000x150x450x150,1000x150x1000x150x500x150,1000x150x1000x150x600x150,1000x150x1000x150x700x150,1000x150x1000x150x750x150,1000x150x1000x150x800x150,1000x150x1000x150x900x150,1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 LT Tee 300 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.90288713910761",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.328083989501312",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "",
                id: "24119923698161031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 LT Tee 450 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "100x150x100x150x100x150,100x150x100x150x150x150,100x150x100x150x300x150,100x150x100x150x450x150,100x150x100x150x500x150,100x150x100x150x600x150,100x150x100x150x700x150,100x150x100x150x750x150,100x150x100x150x800x150,100x150x100x150x900x150,100x150x100x150x1000x150,150x150x150x150x100x150,150x150x150x150x150x150,150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x500x150,150x150x150x150x600x150,150x150x150x150x700x150,150x150x150x150x750x150,150x150x150x150x800x150,150x150x150x150x900x150,150x150x150x150x1000x150,200x150x200x150x200x150,200x150x200x150x400x150,300x150x300x150x100x150,300x150x300x150x150x150,300x150x300x150x300x150,300x150x300x150x400x150,300x150x300x150x450x150,300x150x300x150x500x150,300x150x300x150x600x150,300x150x300x150x700x150,300x150x300x150x750x150,300x150x300x150x800x150,300x150x300x150x900x150,300x150x300x150x1000x150,400x150x400x150x100x150,400x150x400x150x150x150,400x150x400x150x200x150,400x150x400x150x300x150,400x150x400x150x400x150,400x150x400x150x450x150,400x150x400x150x500x150,400x150x400x150x600x150,400x150x400x150x700x150,400x150x400x150x750x150,400x150x400x150x800x150,400x150x400x150x900x150,400x150x400x150x1000x150,450x150x450x150x100x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x450x150,450x150x450x150x500x150,450x150x450x150x600x150,450x150x450x150x700x150,450x150x450x150x750x150,450x150x450x150x800x150,450x150x450x150x900x150,450x150x450x150x1000x150,500x150x500x150x100x150,500x150x500x150x150x150,500x150x500x150x300x150,500x150x500x150x450x150,500x150x500x150x500x150,500x150x500x150x600x150,500x150x500x150x700x150,500x150x500x150x750x150,500x150x500x150x800x150,500x150x500x150x900x150,500x150x500x150x1000x150,600x150x600x150x100x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x500x150,600x150x600x150x600x150,600x150x600x150x700x150,600x150x600x150x750x150,600x150x600x150x800x150,600x150x600x150x900x150,600x150x600x150x1000x150,700x150x700x150x100x150,700x150x700x150x150x150,700x150x700x150x300x150,700x150x700x150x450x150,700x150x700x150x500x150,700x150x700x150x600x150,700x150x700x150x700x150,700x150x700x150x750x150,700x150x700x150x800x150,700x150x700x150x900x150,700x150x700x150x1000x150,750x150x750x150x100x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x500x150,750x150x750x150x600x150,750x150x750x150x700x150,750x150x750x150x750x150,750x150x750x150x800x150,750x150x750x150x900x150,750x150x750x150x1000x150,800x150x800x150x100x150,800x150x800x150x150x150,800x150x800x150x300x150,800x150x800x150x450x150,800x150x800x150x500x150,800x150x800x150x600x150,800x150x800x150x700x150,800x150x800x150x750x150,800x150x800x150x800x150,800x150x800x150x900x150,800x150x800x150x1000x150,900x150x900x150x100x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x500x150,900x150x900x150x600x150,900x150x900x150x700x150,900x150x900x150x750x150,900x150x900x150x800x150,900x150x900x150x900x150,900x150x900x150x1000x150,1000x150x1000x150x100x150,1000x150x1000x150x150x150,1000x150x1000x150x300x150,1000x150x1000x150x450x150,1000x150x1000x150x500x150,1000x150x1000x150x600x150,1000x150x1000x150x700x150,1000x150x1000x150x750x150,1000x150x1000x150x800x150,1000x150x1000x150x900x150,1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 LT Tee 450 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.39501312335958",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.328083989501312",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "24119924698161031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 LT Tee 600 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "100x150x100x150x100x150,100x150x100x150x150x150,100x150x100x150x300x150,100x150x100x150x450x150,100x150x100x150x500x150,100x150x100x150x600x150,100x150x100x150x700x150,100x150x100x150x750x150,100x150x100x150x800x150,100x150x100x150x900x150,100x150x100x150x1000x150,150x150x150x150x100x150,150x150x150x150x150x150,150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x500x150,150x150x150x150x600x150,150x150x150x150x700x150,150x150x150x150x750x150,150x150x150x150x800x150,150x150x150x150x900x150,150x150x150x150x1000x150,200x150x200x150x200x150,200x150x200x150x400x150,300x150x300x150x100x150,300x150x300x150x150x150,300x150x300x150x300x150,300x150x300x150x400x150,300x150x300x150x450x150,300x150x300x150x500x150,300x150x300x150x600x150,300x150x300x150x700x150,300x150x300x150x750x150,300x150x300x150x800x150,300x150x300x150x900x150,300x150x300x150x1000x150,400x150x400x150x100x150,400x150x400x150x150x150,400x150x400x150x200x150,400x150x400x150x300x150,400x150x400x150x400x150,400x150x400x150x450x150,400x150x400x150x500x150,400x150x400x150x600x150,400x150x400x150x700x150,400x150x400x150x750x150,400x150x400x150x800x150,400x150x400x150x900x150,400x150x400x150x1000x150,450x150x450x150x100x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x450x150,450x150x450x150x500x150,450x150x450x150x600x150,450x150x450x150x700x150,450x150x450x150x750x150,450x150x450x150x800x150,450x150x450x150x900x150,450x150x450x150x1000x150,500x150x500x150x100x150,500x150x500x150x150x150,500x150x500x150x300x150,500x150x500x150x450x150,500x150x500x150x500x150,500x150x500x150x600x150,500x150x500x150x700x150,500x150x500x150x750x150,500x150x500x150x800x150,500x150x500x150x900x150,500x150x500x150x1000x150,600x150x600x150x100x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x500x150,600x150x600x150x600x150,600x150x600x150x700x150,600x150x600x150x750x150,600x150x600x150x800x150,600x150x600x150x900x150,600x150x600x150x1000x150,700x150x700x150x100x150,700x150x700x150x150x150,700x150x700x150x300x150,700x150x700x150x450x150,700x150x700x150x500x150,700x150x700x150x600x150,700x150x700x150x700x150,700x150x700x150x750x150,700x150x700x150x800x150,700x150x700x150x900x150,700x150x700x150x1000x150,750x150x750x150x100x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x500x150,750x150x750x150x600x150,750x150x750x150x700x150,750x150x750x150x750x150,750x150x750x150x800x150,750x150x750x150x900x150,750x150x750x150x1000x150,800x150x800x150x100x150,800x150x800x150x150x150,800x150x800x150x300x150,800x150x800x150x450x150,800x150x800x150x500x150,800x150x800x150x600x150,800x150x800x150x700x150,800x150x800x150x750x150,800x150x800x150x800x150,800x150x800x150x900x150,800x150x800x150x1000x150,900x150x900x150x100x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x500x150,900x150x900x150x600x150,900x150x900x150x700x150,900x150x900x150x750x150,900x150x900x150x800x150,900x150x900x150x900x150,900x150x900x150x1000x150,1000x150x1000x150x100x150,1000x150x1000x150x150x150,1000x150x1000x150x300x150,1000x150x1000x150x450x150,1000x150x1000x150x500x150,1000x150x1000x150x600x150,1000x150x1000x150x700x150,1000x150x1000x150x750x150,1000x150x1000x150x800x150,1000x150x1000x150x900x150,1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 LT Tee 600 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.88713910761155",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.328083989501312",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "24119925698161031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 LT Tee 750 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "100x150x100x150x100x150,100x150x100x150x150x150,100x150x100x150x300x150,100x150x100x150x450x150,100x150x100x150x500x150,100x150x100x150x600x150,100x150x100x150x700x150,100x150x100x150x750x150,100x150x100x150x800x150,100x150x100x150x900x150,100x150x100x150x1000x150,150x150x150x150x100x150,150x150x150x150x150x150,150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x500x150,150x150x150x150x600x150,150x150x150x150x700x150,150x150x150x150x750x150,150x150x150x150x800x150,150x150x150x150x900x150,150x150x150x150x1000x150,200x150x200x150x200x150,200x150x200x150x400x150,300x150x300x150x100x150,300x150x300x150x150x150,300x150x300x150x300x150,300x150x300x150x400x150,300x150x300x150x450x150,300x150x300x150x500x150,300x150x300x150x600x150,300x150x300x150x700x150,300x150x300x150x750x150,300x150x300x150x800x150,300x150x300x150x900x150,300x150x300x150x1000x150,400x150x400x150x100x150,400x150x400x150x150x150,400x150x400x150x200x150,400x150x400x150x300x150,400x150x400x150x400x150,400x150x400x150x450x150,400x150x400x150x500x150,400x150x400x150x600x150,400x150x400x150x700x150,400x150x400x150x750x150,400x150x400x150x800x150,400x150x400x150x900x150,400x150x400x150x1000x150,450x150x450x150x100x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x450x150,450x150x450x150x500x150,450x150x450x150x600x150,450x150x450x150x700x150,450x150x450x150x750x150,450x150x450x150x800x150,450x150x450x150x900x150,450x150x450x150x1000x150,500x150x500x150x100x150,500x150x500x150x150x150,500x150x500x150x300x150,500x150x500x150x450x150,500x150x500x150x500x150,500x150x500x150x600x150,500x150x500x150x700x150,500x150x500x150x750x150,500x150x500x150x800x150,500x150x500x150x900x150,500x150x500x150x1000x150,600x150x600x150x100x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x500x150,600x150x600x150x600x150,600x150x600x150x700x150,600x150x600x150x750x150,600x150x600x150x800x150,600x150x600x150x900x150,600x150x600x150x1000x150,700x150x700x150x100x150,700x150x700x150x150x150,700x150x700x150x300x150,700x150x700x150x450x150,700x150x700x150x500x150,700x150x700x150x600x150,700x150x700x150x700x150,700x150x700x150x750x150,700x150x700x150x800x150,700x150x700x150x900x150,700x150x700x150x1000x150,750x150x750x150x100x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x500x150,750x150x750x150x600x150,750x150x750x150x700x150,750x150x750x150x750x150,750x150x750x150x800x150,750x150x750x150x900x150,750x150x750x150x1000x150,800x150x800x150x100x150,800x150x800x150x150x150,800x150x800x150x300x150,800x150x800x150x450x150,800x150x800x150x500x150,800x150x800x150x600x150,800x150x800x150x700x150,800x150x800x150x750x150,800x150x800x150x800x150,800x150x800x150x900x150,800x150x800x150x1000x150,900x150x900x150x100x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x500x150,900x150x900x150x600x150,900x150x900x150x700x150,900x150x900x150x750x150,900x150x900x150x800x150,900x150x900x150x900x150,900x150x900x150x1000x150,1000x150x1000x150x100x150,1000x150x1000x150x150x150,1000x150x1000x150x300x150,1000x150x1000x150x450x150,1000x150x1000x150x500x150,1000x150x1000x150x600x150,1000x150x1000x150x700x150,1000x150x1000x150x750x150,1000x150x1000x150x800x150,1000x150x1000x150x900x150,1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 LT Tee 750 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.37926509186352",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.328083989501312",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "",
                id: "24119926698161031",
                isClearence: "false"
              },
              {
                name: "M_Unistrut HG Finish U15 LT Tee 900 R PExPExPE",
                defaultFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "100x150x100x150x100x150,100x150x100x150x150x150,100x150x100x150x300x150,100x150x100x150x450x150,100x150x100x150x500x150,100x150x100x150x600x150,100x150x100x150x700x150,100x150x100x150x750x150,100x150x100x150x800x150,100x150x100x150x900x150,100x150x100x150x1000x150,150x150x150x150x100x150,150x150x150x150x150x150,150x150x150x150x300x150,150x150x150x150x450x150,150x150x150x150x500x150,150x150x150x150x600x150,150x150x150x150x700x150,150x150x150x150x750x150,150x150x150x150x800x150,150x150x150x150x900x150,150x150x150x150x1000x150,200x150x200x150x200x150,200x150x200x150x400x150,300x150x300x150x100x150,300x150x300x150x150x150,300x150x300x150x300x150,300x150x300x150x400x150,300x150x300x150x450x150,300x150x300x150x500x150,300x150x300x150x600x150,300x150x300x150x700x150,300x150x300x150x750x150,300x150x300x150x800x150,300x150x300x150x900x150,300x150x300x150x1000x150,400x150x400x150x100x150,400x150x400x150x150x150,400x150x400x150x200x150,400x150x400x150x300x150,400x150x400x150x400x150,400x150x400x150x450x150,400x150x400x150x500x150,400x150x400x150x600x150,400x150x400x150x700x150,400x150x400x150x750x150,400x150x400x150x800x150,400x150x400x150x900x150,400x150x400x150x1000x150,450x150x450x150x100x150,450x150x450x150x150x150,450x150x450x150x300x150,450x150x450x150x450x150,450x150x450x150x500x150,450x150x450x150x600x150,450x150x450x150x700x150,450x150x450x150x750x150,450x150x450x150x800x150,450x150x450x150x900x150,450x150x450x150x1000x150,500x150x500x150x100x150,500x150x500x150x150x150,500x150x500x150x300x150,500x150x500x150x450x150,500x150x500x150x500x150,500x150x500x150x600x150,500x150x500x150x700x150,500x150x500x150x750x150,500x150x500x150x800x150,500x150x500x150x900x150,500x150x500x150x1000x150,600x150x600x150x100x150,600x150x600x150x150x150,600x150x600x150x300x150,600x150x600x150x450x150,600x150x600x150x500x150,600x150x600x150x600x150,600x150x600x150x700x150,600x150x600x150x750x150,600x150x600x150x800x150,600x150x600x150x900x150,600x150x600x150x1000x150,700x150x700x150x100x150,700x150x700x150x150x150,700x150x700x150x300x150,700x150x700x150x450x150,700x150x700x150x500x150,700x150x700x150x600x150,700x150x700x150x700x150,700x150x700x150x750x150,700x150x700x150x800x150,700x150x700x150x900x150,700x150x700x150x1000x150,750x150x750x150x100x150,750x150x750x150x150x150,750x150x750x150x300x150,750x150x750x150x450x150,750x150x750x150x500x150,750x150x750x150x600x150,750x150x750x150x700x150,750x150x750x150x750x150,750x150x750x150x800x150,750x150x750x150x900x150,750x150x750x150x1000x150,800x150x800x150x100x150,800x150x800x150x150x150,800x150x800x150x300x150,800x150x800x150x450x150,800x150x800x150x500x150,800x150x800x150x600x150,800x150x800x150x700x150,800x150x800x150x750x150,800x150x800x150x800x150,800x150x800x150x900x150,800x150x800x150x1000x150,900x150x900x150x100x150,900x150x900x150x150x150,900x150x900x150x300x150,900x150x900x150x450x150,900x150x900x150x500x150,900x150x900x150x600x150,900x150x900x150x700x150,900x150x900x150x750x150,900x150x900x150x800x150,900x150x900x150x900x150,900x150x900x150x1000x150,1000x150x1000x150x100x150,1000x150x1000x150x150x150,1000x150x1000x150x300x150,1000x150x1000x150x450x150,1000x150x1000x150x500x150,1000x150x1000x150x600x150,1000x150x1000x150x700x150,1000x150x1000x150x750x150,1000x150x1000x150x800x150,1000x150x1000x150x900x150,1000x150x1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 LT Tee 900 R PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.87139107611549",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.492125984251969",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "",
                id: "24119927698161031",
                isClearence: "false"
              }
            ],
            ladderCableTrayUnion: {
              addDefaultItem: {
                name: "M_Unistrut HG Finish U15 SP Coupler FExFE",
                defaultFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "100x150x100x150,150x150x150x150,200x150x200x150,300x150x300x150,400x150x400x150,450x150x450x150,500x150x500x150,600x150x600x150,700x150x700x150,750x150x750x150,800x150x800x150,900x150x900x150,1000x150x1000x150",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 SP Coupler FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,8",
                dispPosition: "42",
                csvFileName: "",
                bendType: "",
                id: "24119929698163531",
                isClearence: "false"
              }
            },
            ladderCableTrayMultiPort: {
              addDefaultItem: {
                name: "M_Unistrut HG Finish U15 SE Cap FE",
                defaultFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "100x125,150x125,200x125,300x125,400x125,450x125,500x125,600x125,700x125,750x125,800x125,900x125,1000x125",
                manufacturer: "unistrut",
                shape: "ladder Cable Tray",
                path: "\\metric\\cabletrays\\unistrut\\m_ladder cable tray u15-hg\\formed steel\\tray\\",
                icon: "M_Unistrut HG Finish U15 SE Cap FE.RFA",
                description: "",
                angle: "",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "",
                id: "24119928698166131",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "--------------------Channel Containment--------------------",
        unit: "METRIC",
        id: "51",
        systemShape: "channel Cable Tray",
        systemUniqueId: "51",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "channel Cable Tray",
            channelCableTrayElbow: [],
            channelCableTrayVerticalElbow: [],
            channelCableTrayTee: [],
            channelCableTrayTransition: [],
            channelCableTrayUnion: []
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Swifts Galv Medium Duty MRF-G 3m length",
        unit: "METRIC",
        id: "52",
        systemShape: "channel Cable Tray",
        systemUniqueId: "52",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "channel Cable Tray",
            electricalTypeItems: {
              name: "M_Legrand SS MRF G Finish Cable Tray PExPE",
              id: "2493121562160131",
              Length: "9.84251968503937",
              JunctionType: "Tee",
              OldMat: "",
              shape: "channel Cable Tray",
              sizeRange: "50x25,75x25,100x25,150x25,225x25,300x25,450x25,600x25,750x25,900x25",
              manufacturer: "Legrand",
              path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
              icon: "M_Legrand SS MRF G Finish Cable Tray PExPE.RFA",
              description: "",
              descriptionType: "",
              connector: "200",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "1",
              duplicateFrom: "channel Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              isClearence: "false"
            },
            channelCableTrayElbow: [
              {
                name: "M_Legrand SS MRF G Finish 30 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "6",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish 30 Flat Bend FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.107279297279465",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0820209973753281",
                width: "0.164041994750656",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "2493107562160431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish 45 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish 45 Flat Bend FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.560804187238327",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0820209973753281",
                width: "1.96850393700787",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2493108562160531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish 60 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish 60 Flat Bend FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.503855549883338",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0820209973753281",
                width: "0.984251968503937",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2493109562160631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish 90 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "4",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish 90 Flat Bend FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.482283464566932",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0820209973753281",
                width: "0.164041994750656",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2493110562160731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Cable Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "5",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Cable Tray Face PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "",
                id: "24130739562160131",
                isClearence: "false"
              },
              {
                name: "M_Legrand MRFAB-G Cable Tray Adjustable Flat Bend FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray",
                icon: "M_Legrand MRFAB-G Cable Tray Adjustable Flat Bend FExFE.rfa",
                description: "",
                descriptionType: "Adjustable Flat Bend",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.05693192137838",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0820209973753281",
                width: "0.984251968503937",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "",
                id: "24167478562160731",
                isClearence: "false"
              }
            ],
            channelCableTrayVerticalElbow: [
              {
                name: "M_Legrand SS MRF G Finish Inside Riser MRFIR 30 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "1",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Inside Riser MRFIR 30 FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.264601821176544",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.0820209973753281",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2493113562163031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Inside Riser MRFIR 45 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "2",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Inside Riser MRFIR 45 FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.405235448314604",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.0820209973753281",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2493115562160331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Inside Riser MRFIR 60 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "3",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Inside Riser MRFIR 60 FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.563522654474792",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.0820209973753281",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2493117562163131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Inside Riser MRFIR 90 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "4",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Inside Riser MRFIR 90 FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.812007874015756",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.0820209973753281",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2493119562160231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Outside Riser MRFOR 30 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "5",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Outside Riser MRFOR 30 FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.286579281185658",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.0820209973753281",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2493114562163031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Outside Riser MRFOR 45 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "6",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Outside Riser MRFOR 45 FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.439209657826821",
                isConnCheck: "True",
                extraField: "",
                Height: "2.95275590551181",
                width: "0.0820209973753281",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2493116562160331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Outside Riser MRFOR 60 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "7",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Outside Riser MRFOR 60 FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.61087749938864",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.0820209973753281",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2493118562163131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Outside Riser MRFOR 90 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "8",
                sizeRange: "50x25x50x25,75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Outside Riser MRFOR 90 FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.894028871391074",
                isConnCheck: "True",
                extraField: "",
                Height: "0.738188976377953",
                width: "0.0820209973753281",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2493120562160231",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Legrand SS MRF G Finish 4 Way Cross Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "50x25x50x25x50x25x50x25,75x25x75x25x75x25x75x25,100x25x100x25x100x25x100x25,150x25x150x25x150x25x150x25,225x25x225x25x225x25x225x25,300x25x300x25x300x25x300x25,450x25x450x25x450x25x450x25,600x25x600x25x600x25x600x25,750x25x750x25x750x25x750x25,900x25x900x25x900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish 4 Way Cross Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "0.524934383202115",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0820209973753281",
                width: "0.246062992125984",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2493125562161131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: [
              {
                name: "M_Legrand SS MRF G Finish Equal Tee FExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "50x25x50x25x50x25,75x25x75x25x75x25,100x25x100x25x100x25,150x25x150x25x150x25,225x25x225x25x225x25,300x25x300x25x300x25,450x25x450x25x450x25,600x25x600x25x600x25,750x25x750x25x750x25,900x25x900x25x900x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Equal Tee FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "1.87007874015746",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0820209973753281",
                width: "2.95275590551181",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2493123562161031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Unequal Tee FExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "2",
                sizeRange: "50x25x50x25x75x25,50x25x50x25x100x25,50x25x50x25x150x25,50x25x50x25x225x25,50x25x50x25x300x25,50x25x50x25x450x25,50x25x50x25x600x25,50x25x50x25x750x25,50x25x50x25x900x25,75x25x75x25x50x25,75x25x75x25x100x25,75x25x75x25x150x25,75x25x75x25x225x25,75x25x75x25x300x25,75x25x75x25x450x25,75x25x75x25x600x25,75x25x75x25x750x25,75x25x75x25x900x25,100x25x100x25x50x25,100x25x100x25x75x25,100x25x100x25x150x25,100x25x100x25x225x25,100x25x100x25x300x25,100x25x100x25x450x25,100x25x100x25x600x25,100x25x100x25x750x25,100x25x100x25x900x25,150x25x150x25x50x25,150x25x150x25x75x25,150x25x150x25x100x25,150x25x150x25x225x25,150x25x150x25x300x25,150x25x150x25x450x25,150x25x150x25x600x25,150x25x150x25x750x25,150x25x150x25x900x25,225x25x225x25x50x25,225x25x225x25x75x25,225x25x225x25x100x25,225x25x225x25x150x25,225x25x225x25x300x25,225x25x225x25x450x25,225x25x225x25x600x25,225x25x225x25x750x25,225x25x225x25x900x25,300x25x300x25x50x25,300x25x300x25x75x25,300x25x300x25x100x25,300x25x300x25x150x25,300x25x300x25x225x25,300x25x300x25x450x25,300x25x300x25x600x25,300x25x300x25x750x25,300x25x300x25x900x25,450x25x450x25x50x25,450x25x450x25x75x25,450x25x450x25x100x25,450x25x450x25x150x25,450x25x450x25x225x25,450x25x450x25x300x25,450x25x450x25x600x25,450x25x450x25x750x25,450x25x450x25x900x25,600x25x600x25x50x25,600x25x600x25x75x25,600x25x600x25x100x25,600x25x600x25x150x25,600x25x600x25x225x25,600x25x600x25x300x25,600x25x600x25x450x25,600x25x600x25x750x25,600x25x600x25x900x25,750x25x750x25x50x25,750x25x750x25x75x25,750x25x750x25x100x25,750x25x750x25x150x25,750x25x750x25x225x25,750x25x750x25x300x25,750x25x750x25x450x25,750x25x750x25x600x25,750x25x750x25x900x25,900x25x900x25x50x25,900x25x900x25x75x25,900x25x900x25x100x25,900x25x900x25x150x25,900x25x900x25x225x25,900x25x900x25x300x25,900x25x900x25x450x25,900x25x900x25x600x25,900x25x900x25x750x25",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Unequal Tee FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "1.13188976377951",
                isConnCheck: "True",
                extraField: "",
                Height: "0.0820209973753281",
                width: "2.95275590551181",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "2493124562163331",
                isClearence: "false"
              }
            ],
            channelCableTrayTransition: {
              addDefaultItem: {
                name: "M_Legrand SS MRF G Finish Straight Reducer FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "50x25x75x25,50x25x100x25,50x25x150x25,50x25x225x25,50x25x300x25,50x25x450x25,50x25x600x25,50x25x750x25,50x25x900x25,75x25x50x25,75x25x100x25,75x25x150x25,75x25x225x25,75x25x300x25,75x25x450x25,75x25x600x25,75x25x750x25,75x25x900x25,100x25x50x25,100x25x75x25,100x25x150x25,100x25x225x25,100x25x300x25,100x25x450x25,100x25x600x25,100x25x750x25,100x25x900x25,150x25x50x25,150x25x75x25,150x25x100x25,150x25x225x25,150x25x300x25,150x25x450x25,150x25x600x25,150x25x750x25,150x25x900x25,225x25x50x25,225x25x75x25,225x25x100x25,225x25x150x25,225x25x300x25,225x25x450x25,225x25x600x25,225x25x750x25,225x25x900x25,300x25x50x25,300x25x75x25,300x25x100x25,300x25x150x25,300x25x225x25,300x25x450x25,300x25x600x25,300x25x750x25,300x25x900x25,450x25x50x25,450x25x75x25,450x25x100x25,450x25x150x25,450x25x225x25,450x25x300x25,450x25x600x25,450x25x750x25,450x25x900x25,600x25x50x25,600x25x75x25,600x25x100x25,600x25x150x25,600x25x225x25,600x25x300x25,600x25x450x25,600x25x750x25,600x25x900x25,750x25x50x25,750x25x75x25,750x25x100x25,750x25x150x25,750x25x225x25,750x25x300x25,750x25x450x25,750x25x600x25,750x25x900x25,900x25x50x25,900x25x75x25,900x25x100x25,900x25x150x25,900x25x225x25,900x25x300x25,900x25x450x25,900x25x600x25,900x25x750x25",
                manufacturer: "Legrand",
                shape: "cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Straight Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "M_Legrand SS MRF G Finish Straight Reducer FExFE",
                bendType: "",
                id: "2493122562163231",
                isClearence: "false"
              }
            },
            channelCableTrayUnion: [
              {
                name: "M_Legrand SS MRF G Finish Coupler Set FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "75x25x75x25,100x25x100x25,150x25x150x25,225x25x225x25,300x25x300x25,450x25x450x25,600x25x600x25,750x25x750x25,900x25x900x25",
                manufacturer: "Legrand",
                shape: "cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Coupler Set FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "2493112562163531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MRF G Finish Coupler Set MRFC50 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayUnion",
                position: "2",
                sizeRange: "50x25x50x25",
                manufacturer: "Legrand",
                shape: "cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray mrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS MRF G Finish Coupler Set MRFC50 FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "2493111562163531",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Swifts Galv Heavy Duty SRF-G 3m length",
        unit: "METRIC",
        id: "57",
        systemShape: "channel Cable Tray",
        systemUniqueId: "57",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "channel Cable Tray",
            electricalTypeItems: {
              name: "M_Legrand SS SRF G Finish Cable Tray PExPE",
              id: "2487643532360131",
              Length: "9.84251968503937",
              JunctionType: "Tee",
              OldMat: "",
              shape: "channel Cable Tray",
              sizeRange: "75x50,100x50,150x50,225x50,300x50,450x50,600x50,750x50,900x50",
              manufacturer: "Legrand",
              path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
              icon: "M_Legrand SS SRF G Finish Cable Tray PExPE.RFA",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "4,3",
              dispPosition: "20",
              duplicateFrom: "channel Cable Tray",
              defaultFor: "",
              isClearence: "false"
            },
            channelCableTrayElbow: [
              {
                name: "M_Legrand SS SRF G Finish 30 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish 30 Flat Bend FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.151234217297692",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "0.492125984251969",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "2487645532360431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish 45 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish 45 Flat Bend FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.556164378962825",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "1.96850393700787",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2487646532360531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish 60 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish 60 Flat Bend FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.503855549883338",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "0.984251968503937",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2487647532360631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish 90 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "4",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish 90 Flat Bend FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.86351706036746",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "2.95275590551181",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2487648532360731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Cable Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "5",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Cable Tray Face PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "",
                id: "24130745532360131",
                isClearence: "false"
              }
            ],
            channelCableTrayVerticalElbow: [
              {
                name: "M_Legrand SS SRF G Finish Inside Riser SRFIR 30 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "1",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Inside Riser SRFIR 30 PExPE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.253613091171987",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.164041994750656",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2487650532363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Inside Riser SRFIR 45 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "2",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Inside Riser SRFIR 45 PExPE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.388248343558489",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.164041994750656",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2487651532360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Inside Riser SRFIR 60 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "3",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Inside Riser SRFIR 60 PExPE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.539845232017868",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.164041994750656",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2487652532363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Inside Riser SRFIR 90 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "4",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Inside Riser SRFIR 90 PExPE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.770997375328092",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.164041994750656",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2487653532360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Outside Riser SRFOR 30 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "5",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Outside Riser SRFOR 30 PExPE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.297568011190215",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.164041994750656",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2487654532363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Outside Riser SRFOR 45 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "6",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Outside Riser SRFOR 45 PExPE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.456196762582935",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.164041994750656",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2487655532360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Outside Riser SRFOR 60 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "7",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Outside Riser SRFOR 60 PExPE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.634554921845564",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.164041994750656",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2487656532363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Outside Riser SRFOR 90 PExPE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "8",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Outside Riser SRFOR 90 PExPE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.935039370078738",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.164041994750656",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2487657532360231",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Legrand SS SRF G Finish 4 Way Cross Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "75x50x75x50x75x50x75x50,100x50x100x50x100x50x100x50,150x50x150x50x150x50x150x50,225x50x225x50x225x50x225x50,300x50x300x50x300x50x300x50,450x50x450x50x450x50x450x50,600x50x600x50x600x50x600x50,750x50x750x50x750x50x750x50,900x50x900x50x900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish 4 Way Cross Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "1.8700787401575",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "2.95275590551181",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2487661532361131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: [
              {
                name: "M_Legrand SS SRF G Finish Equal Tee FExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "75x50x75x50x75x50,100x50x100x50x100x50,150x50x150x50x150x50,225x50x225x50x225x50,300x50x300x50x300x50,450x50x450x50x450x50,600x50x600x50x600x50,750x50x750x50x750x50,900x50x900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Equal Tee FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "0.646325459317564",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "0.492125984251969",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "2487659532361031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF G Finish Unequal Tee FExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "2",
                sizeRange: "75x50x75x50x100x50,75x50x75x50x150x50,75x50x75x50x225x50,75x50x75x50x300x50,75x50x75x50x450x50,75x50x75x50x600x50,75x50x75x50x750x50,75x50x75x50x900x50,100x50x100x50x75x50,100x50x100x50x150x50,100x50x100x50x225x50,100x50x100x50x300x50,100x50x100x50x450x50,100x50x100x50x600x50,100x50x100x50x750x50,100x50x100x50x900x50,150x50x150x50x75x50,150x50x150x50x100x50,150x50x150x50x225x50,150x50x150x50x300x50,150x50x150x50x450x50,150x50x150x50x600x50,150x50x150x50x750x50,150x50x150x50x900x50,225x50x225x50x75x50,225x50x225x50x100x50,225x50x225x50x150x50,225x50x225x50x300x50,225x50x225x50x450x50,225x50x225x50x600x50,225x50x225x50x750x50,225x50x225x50x900x50,300x50x300x50x75x50,300x50x300x50x100x50,300x50x300x50x150x50,300x50x300x50x225x50,300x50x300x50x450x50,300x50x300x50x600x50,300x50x300x50x750x50,300x50x300x50x900x50,450x50x450x50x75x50,450x50x450x50x100x50,450x50x450x50x150x50,450x50x450x50x225x50,450x50x450x50x300x50,450x50x450x50x600x50,450x50x450x50x750x50,450x50x450x50x900x50,600x50x600x50x75x50,600x50x600x50x100x50,600x50x600x50x150x50,600x50x600x50x225x50,600x50x600x50x300x50,600x50x600x50x450x50,600x50x600x50x750x50,600x50x600x50x900x50,750x50x750x50x75x50,750x50x750x50x100x50,750x50x750x50x150x50,750x50x750x50x225x50,750x50x750x50x300x50,750x50x750x50x450x50,750x50x750x50x600x50,750x50x750x50x900x50,900x50x900x50x75x50,900x50x900x50x100x50,900x50x900x50x150x50,900x50x900x50x225x50,900x50x900x50x300x50,900x50x900x50x450x50,900x50x900x50x600x50,900x50x900x50x750x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Unequal Tee FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "0.554461942257197",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "2.95275590551181",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "2487660532363331",
                isClearence: "false"
              }
            ],
            channelCableTrayTransition: [
              {
                name: "M_Legrand SS SRF G Finish Straight Reducer FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "75x50x100x50,75x50x150x50,75x50x225x50,75x50x300x50,75x50x450x50,75x50x600x50,75x50x750x50,75x50x900x50,100x50x75x50,100x50x150x50,100x50x225x50,100x50x300x50,100x50x450x50,100x50x600x50,100x50x750x50,100x50x900x50,150x50x75x50,150x50x100x50,150x50x225x50,150x50x300x50,150x50x450x50,150x50x600x50,150x50x750x50,150x50x900x50,225x50x75x50,225x50x100x50,225x50x150x50,225x50x300x50,225x50x450x50,225x50x600x50,225x50x750x50,225x50x900x50,300x50x75x50,300x50x100x50,300x50x150x50,300x50x225x50,300x50x450x50,300x50x600x50,300x50x750x50,300x50x900x50,450x50x75x50,450x50x100x50,450x50x150x50,450x50x225x50,450x50x300x50,450x50x600x50,450x50x750x50,450x50x900x50,600x50x75x50,600x50x100x50,600x50x150x50,600x50x225x50,600x50x300x50,600x50x450x50,600x50x750x50,600x50x900x50,750x50x75x50,750x50x100x50,750x50x150x50,750x50x225x50,750x50x300x50,750x50x450x50,750x50x600x50,750x50x900x50,900x50x75x50,900x50x100x50,900x50x150x50,900x50x225x50,900x50x300x50,900x50x450x50,900x50x600x50,900x50x750x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Straight Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "M_Legrand SS SRF G Finish Straight Reducer FExFE",
                bendType: "",
                id: "2487658532363231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS SRF To MRF G Finish Straight Reducer FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "2",
                sizeRange: "75x50x75x25,75x25x75x50,100x50x100x25,100x25x100x50,150x50x150x25,150x25x150x50,225x50x225x25,225x25x225x50,300x50x300x25,300x25x300x50,450x50x450x25,450x25x450x50,600x50x600x25,600x25x600x50,750x50x750x25,750x25x750x50,900x50x900x25,900x25x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF To MRF G Finish Straight Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "M_Legrand SS SRF To MRF G Finish Straight Reducer FExFE",
                bendType: "",
                id: "2487644532363231",
                isClearence: "false"
              }
            ],
            channelCableTrayUnion: {
              addDefaultItem: {
                name: "M_Legrand SS SRF G Finish Coupler Set FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "75x50x75x50,100x50x100x50,150x50x150x50,225x50x225x50,300x50x300x50,450x50x450x50,600x50x600x50,750x50x750x50,900x50x900x50",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray srf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS SRF G Finish Coupler Set FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2487649532363531",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Swifts Galv Extra Heavy Duty XRF-G 3m length",
        unit: "METRIC",
        id: "62",
        systemShape: "channel Cable Tray",
        systemUniqueId: "62",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "channel Cable Tray",
            electricalTypeItems: {
              name: "M_Legrand SS XRF G Finish Cable Tray PExPE",
              id: "2493140562360131",
              Length: "9.84251968503937",
              JunctionType: "Tee",
              OldMat: "",
              shape: "channel Cable Tray",
              sizeRange: "100x80,150x80,225x80,300x80,450x80,600x80",
              manufacturer: "Legrand",
              path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
              icon: "M_Legrand SS XRF G Finish Cable Tray PExPE.RFA",
              description: "",
              connector: "200",
              extraField: "",
              displayPosition: "1,3",
              dispPosition: "17",
              duplicateFrom: "channel Cable Tray",
              defaultFor: "",
              isClearence: "false"
            },
            channelCableTrayElbow: [
              {
                name: "M_Legrand SS XRF G Finish 30 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish 30 Flat Bend FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.473703273390215",
                isConnCheck: "True",
                extraField: "",
                Height: "0.26246719160105",
                width: "1.96850393700787",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "2493127562360431",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish 45 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish 45 Flat Bend FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.449755095675002",
                isConnCheck: "True",
                extraField: "",
                Height: "0.26246719160105",
                width: "0.984251968503937",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2493128562360531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish 60 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish 60 Flat Bend FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.625083952862786",
                isConnCheck: "True",
                extraField: "",
                Height: "0.26246719160105",
                width: "0.984251968503937",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2493129562360631",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish 90 Flat Bend FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayElbow",
                position: "4",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish 90 Flat Bend FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "1.77165354330709",
                isConnCheck: "True",
                extraField: "",
                Height: "0.26246719160105",
                width: "1.96850393700787",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2493130562360731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Cable Tray Face PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "5",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Cable Tray Face PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "24130752562360131",
                isClearence: "false"
              }
            ],
            channelCableTrayVerticalElbow: [
              {
                name: "M_Legrand SS XRF G Finish Inside Riser XRFIR 30 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "1",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Inside Riser XRFIR 30 FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.164967297581217",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.26246719160105",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2493132562363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Inside Riser XRFIR 45 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "2",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Inside Riser XRFIR 45 FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.275573980859964",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.26246719160105",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2493134562360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Inside Riser XRFIR 60 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "3",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Inside Riser XRFIR 60 FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.118836425629793",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.26246719160105",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2493136562363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Inside Riser XRFIR 90 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "4",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Inside Riser XRFIR 90 FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.479002624671915",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.26246719160105",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "2493138562360231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Outside Riser XRFOR 30 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "5",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Outside Riser XRFOR 30 FExFE.RFA",
                description: "",
                angle: "30",
                connector: "201*201",
                centerRadius: "0.235295169610381",
                isConnCheck: "True",
                extraField: "",
                Height: "1.47637795275591",
                width: "0.26246719160105",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2493133562363031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Outside Riser XRFOR 45 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "6",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Outside Riser XRFOR 45 FExFE.RFA",
                description: "",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.319334135442063",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.26246719160105",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2493135562360331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Outside Riser XRFOR 60 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "7",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Outside Riser XRFOR 60 FExFE.RFA",
                description: "",
                angle: "60",
                connector: "201*201",
                centerRadius: "0.505251960126786",
                isConnCheck: "True",
                extraField: "",
                Height: "1.96850393700787",
                width: "0.26246719160105",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2493137562363131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Outside Riser XRFOR 90 FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "8",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Outside Riser XRFOR 90 FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.738188976377952",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.26246719160105",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "2493139562360231",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Legrand SS XRF G Finish 4 Way Cross Piece FExFExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "100x80x100x80x100x80x100x80,150x80x150x80x150x80x150x80,225x80x225x80x225x80x225x80,300x80x300x80x300x80x300x80,450x80x450x80x450x80x450x80,600x80x600x80x600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish 4 Way Cross Piece FExFExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "1.7716535433071",
                isConnCheck: "True",
                extraField: "",
                Height: "0.26246719160105",
                width: "1.96850393700787",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2493144562361131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: [
              {
                name: "M_Legrand SS XRF G Finish Equal Tee FExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "100x80x100x80x100x80,150x80x150x80x150x80,225x80x225x80x225x80,300x80x300x80x300x80,450x80x450x80x450x80,600x80x600x80x600x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Equal Tee FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "1.52559055118111",
                isConnCheck: "True",
                extraField: "",
                Height: "0.26246719160105",
                width: "1.47637795275591",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2493142562361031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS XRF G Finish Unequal Tee FExFExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTee",
                position: "2",
                sizeRange: "100x80x100x80x150x80,100x80x100x80x225x80,100x80x100x80x300x80,100x80x100x80x450x80,100x80x100x80x600x80,150x80x150x80x100x80,150x80x150x80x225x80,150x80x150x80x300x80,150x80x150x80x450x80,150x80x150x80x600x80,225x80x225x80x100x80,225x80x225x80x150x80,225x80x225x80x300x80,225x80x225x80x450x80,225x80x225x80x600x80,300x80x300x80x100x80,300x80x300x80x150x80,300x80x300x80x225x80,300x80x300x80x450x80,300x80x300x80x600x80,450x80x450x80x100x80,450x80x450x80x150x80,450x80x450x80x225x80,450x80x450x80x300x80,450x80x450x80x600x80,600x80x600x80x100x80,600x80x600x80x150x80,600x80x600x80x225x80,600x80x600x80x300x80,600x80x600x80x450x80",
                manufacturer: "Legrand",
                shape: "channel Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Unequal Tee FExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "1.77165354330707",
                isConnCheck: "True",
                extraField: "",
                Height: "0.26246719160105",
                width: "0.984251968503937",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "2493143562363331",
                isClearence: "false"
              }
            ],
            channelCableTrayTransition: {
              addDefaultItem: {
                name: "M_Legrand SS XRF G Finish Straight Reducer FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "100x80x150x80,100x80x225x80,100x80x300x80,100x80x450x80,100x80x600x80,150x80x100x80,150x80x225x80,150x80x300x80,150x80x450x80,150x80x600x80,225x80x100x80,225x80x150x80,225x80x300x80,225x80x450x80,225x80x600x80,300x80x100x80,300x80x150x80,300x80x225x80,300x80x450x80,300x80x600x80,450x80x100x80,450x80x150x80,450x80x225x80,450x80x300x80,450x80x600x80,600x80x100x80,600x80x150x80,600x80x225x80,600x80x300x80,600x80x450x80",
                manufacturer: "Legrand",
                shape: "cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Straight Reducer FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,3",
                dispPosition: "18",
                csvFileName: "M_Legrand SS XRF G Finish Straight Reducer FExFE",
                bendType: "",
                id: "2493141562363231",
                isClearence: "false"
              }
            },
            channelCableTrayUnion: {
              addDefaultItem: {
                name: "M_Legrand SS XRF G Finish Coupler Set FExFE",
                defaultFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "100x80x100x80,150x80x150x80,225x80x225x80,300x80x300x80,450x80x450x80,600x80x600x80",
                manufacturer: "Legrand",
                shape: "cable Tray",
                path: "\\metric\\cabletrays\\legrand\\swifts cable tray xrf-g\\galvanized steel\\tray\\",
                icon: "M_Legrand SS XRF G Finish Coupler Set FExFE.RFA",
                description: "",
                angle: "",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,1",
                dispPosition: "19",
                csvFileName: "",
                bendType: "",
                id: "2493131562363531",
                isClearence: "false"
              }
            }
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "--------------------Busway--------------------",
        unit: "METRIC",
        id: "71",
        systemShape: "BusWay",
        systemUniqueId: "71",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "BusWay"
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Galv Zucchini MS Busbar",
        unit: "METRIC",
        id: "72",
        systemShape: "BusWay",
        systemUniqueId: "72",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "BusWay",
            channelCableTrayElbow: [
              {
                name: "M_Legrand GS 160 A Fire Barrier PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Fire Barrier PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24119594696963531",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Std Horizontal Elbow Left Hand PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Std Horizontal Elbow Left Hand PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "1.19750656167977",
                isConnCheck: "True",
                extraField: "",
                Height: "0.318241469816273",
                width: "0.127952755905512",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24119595696960731",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Std Horizontal Elbow Right Hand PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Std Horizontal Elbow Right Hand PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0.442913385826732",
                isConnCheck: "True",
                extraField: "",
                Height: "0.318241469816273",
                width: "0.127952755905512",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24119596696960731",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Std Trunking Length 1M PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "4",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Std Trunking Length 1M PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24119602696960131",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Std Trunking Length 1_5M PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "5",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Std Trunking Length 1_5M PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24119601696960131",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Std Trunking Length 2M PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "6",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Std Trunking Length 2M PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24119603696960131",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Std Trunking Length 3M PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "7",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Std Trunking Length 3M PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "24119604696960131",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Thrust Unit PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "8",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Thrust Unit PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "",
                id: "24119605696960131",
                isClearence: "false"
              }
            ],
            channelCableTrayVerticalElbow: [
              {
                name: "M_Legrand GS 160 A Vertical Elbow Left Hand PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "1",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Vertical Elbow Left Hand PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0.442913385826732",
                isConnCheck: "True",
                extraField: "",
                Height: "0.127952755905512",
                width: "0.318241469816273",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119606696960231",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Vertical Elbow Right Hand PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "2",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Vertical Elbow Right Hand PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0.442913385826732",
                isConnCheck: "True",
                extraField: "",
                Height: "0.127952755905512",
                width: "0.318241469816273",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119607696960231",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Legrand GS 160 A Crossover PExFExFExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "39x97x39x97x39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Crossover PExFExFExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*201*201*200",
                centerRadius: "1.19750656167976",
                isConnCheck: "True",
                extraField: "",
                Height: "0.318241469816273",
                width: "0.127952755905512",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24119593696961131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: [
              {
                name: "M_Legrand GS 160 A Left Hand Tee Female PExFExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "39x97x39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Left Hand Tee Female PExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201*201",
                centerRadius: "0.442913385826785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.318241469816273",
                width: "0.127952755905512",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24119597696961031",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Left Hand Tee Male PExFExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "2",
                sizeRange: "39x97x39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Left Hand Tee Male PExFExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*201*200",
                centerRadius: "1.19750656167982",
                isConnCheck: "True",
                extraField: "",
                Height: "0.318241469816273",
                width: "0.127952755905512",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24119598696961031",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Right Hand Tee Female PExFExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "3",
                sizeRange: "39x97x39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Right Hand Tee Female PExFExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201*201",
                centerRadius: "0.442913385826785",
                isConnCheck: "True",
                extraField: "",
                Height: "0.318241469816273",
                width: "0.127952755905512",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "24119599696961031",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A Right Hand Tee Male PExFExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "4",
                sizeRange: "39x97x39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Right Hand Tee Male PExFExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*201*200",
                centerRadius: "1.19750656167982",
                isConnCheck: "True",
                extraField: "",
                Height: "0.318241469816273",
                width: "0.127952755905512",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "24119600696961031",
                isClearence: "false"
              }
            ],
            channelCableTrayUnion: {
              addDefaultItem: {
                name: "M_Legrand GS 160 A Centre Feed Units PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A Centre Feed Units PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24119590696963531",
                isClearence: "false"
              }
            },
            channelCableTrayMultiPort: [
              {
                name: "M_Legrand GS 160 A End Feed Units Left",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "1",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A End Feed Units Left.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "24119591696966131",
                isClearence: "false"
              },
              {
                name: "M_Legrand GS 160 A End Feed Units Right",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "2",
                sizeRange: "39x97x39x97",
                manufacturer: "Legrand",
                shape: "BusWay",
                path: "\\metric\\cabletrays\\legrand\\zucchini - galvstl ms busbar\\galvanized steel\\tray\\",
                icon: "M_Legrand GS 160 A End Feed Units Right.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "24119592696966131",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "--------------------Distribution Trunking--------------------",
        unit: "METRIC",
        id: "73",
        systemShape: "channel Cable Tray",
        systemUniqueId: "73",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "WireWay",
            channelCableTrayElbow: [],
            channelCableTrayVerticalElbow: [],
            channelCableTrayTee: [],
            channelCableTrayTransition: [],
            channelCableTrayUnion: []
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "BuildingLayout",
            normal: []
          },
          {
            name: "Accessories"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Legrand Galv Salamandre IP4X",
        unit: "METRIC",
        id: "83",
        InVisibility: "",
        systemShape: "WireWay",
        systemUniqueId: "83",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "WireWay",
            electricalTypeItems: {
              name: "M_Legrand SS MGIP Salamandre Trunking PExPE",
              id: "24119150696060131",
              Length: "9.84251968503937",
              JunctionType: "Tee",
              OldMat: "",
              shape: "Wire Mesh Cable Tray",
              sizeRange: "50x50,75x50,75x75,100x50,100x75,100x100,150x50,150x75,150x100,150x150,225x75,225x100,225x150,225x225,300x75,300x100,300x150,300x300",
              manufacturer: "Legrand",
              path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
              icon: "M_Legrand SS MGIP Salamandre Trunking PExPE.RFA",
              description: "",
              descriptionType: "",
              connector: "200",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "1",
              duplicateFrom: "Wire Mesh Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "4",
              LinePattern: "solid",
              isClearence: "false"
            },
            channelCableTrayElbow: [
              {
                name: "M_Legrand SS MGIP-AGL Top Lid 90 Bend Gussett PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-AGL Top Lid 90 Bend Gussett PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0.672572178477671",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.984251968503937",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24119153696060731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-AL Top Lid 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-AL Top Lid 45 Bend PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.326768457240721",
                isConnCheck: "True",
                extraField: "",
                Height: "0.246062992125984",
                width: "0.738188976377953",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "24119162696060531",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-ASL Top Lid 90 Bend Square PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-ASL Top Lid 90 Bend Square PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0.672573303764797",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.984251968503937",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24119165696060731",
                isClearence: "false"
              }
            ],
            channelCableTrayVerticalElbow: [
              {
                name: "M_Legrand SS MGIP-BGL Inside Lid 90 Bend Gussett PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "1",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-BGL Inside Lid 90 Bend Gussett PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.00065616797898",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.328083989501312",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119171696060731",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-BL Inside Lid 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "2",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-BL Inside Lid 45 Bend PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.24183606302792",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.328083989501312",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119177696060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-BSL Inside Lid 90 Bend Square PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "3",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-BSL Inside Lid 90 Bend Square PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0.442913385826744",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.164041994750656",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24119183696060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-CGL Outside Lid 90 Bend Gussett PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "4",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-CGL Outside Lid 90 Bend Gussett PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0.754593175853",
                isConnCheck: "True",
                extraField: "",
                Height: "0.738188976377953",
                width: "0.328083989501312",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119186696060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-CL Outside Lid 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "5",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-CL Outside Lid 45 Bend PExPE.RFA",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.377729771509066",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.984251968503937",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119180696060331",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-CSL Outside Lid 90 Bend Square PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "6",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-CSL Outside Lid 90 Bend Square PExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0.42650918635168",
                isConnCheck: "True",
                extraField: "",
                Height: "0.738188976377953",
                width: "0.492125984251969",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24119189696060231",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-AGT Top Lid Tee Gussett PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "7",
                sizeRange: "50x50x50x50x50x50,75x50x75x50x75x50,75x75x75x75x75x75,100x50x100x50x100x50,100x75x100x75x100x75,100x100x100x100x100x100,150x50x150x50x150x50,150x75x150x75x150x75,150x100x150x100x150x100,150x150x150x150x150x150,225x75x225x75x225x75,225x100x225x100x225x100,225x150x225x150x225x150,225x225x225x225x225x225,300x75x300x75x300x75,300x100x300x100x300x100,300x150x300x150x300x150,300x300x300x300x300x300",
                manufacturer: "Legrand",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-AGT Top Lid Tee Gussett PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "0.667134071555478",
                isConnCheck: "True",
                extraField: "",
                Height: "0.984251968503937",
                width: "0.328083989501312",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "",
                id: "24119156696061031",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Legrand SS MGIP-AGX Crossover PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "50x50x50x50x50x50x50x50,75x50x75x50x75x50x75x50,75x75x75x75x75x75x75x75,100x50x100x50x100x50x100x50,100x75x100x75x100x75x100x75,100x100x100x100x100x100x100x100,150x50x150x50x150x50x150x50,150x75x150x75x150x75x150x75,150x100x150x100x150x100x150x100,150x150x150x150x150x150x150x150,225x75x225x75x225x75x225x75,225x100x225x100x225x100x225x100,225x150x225x150x225x150x225x150,225x225x225x225x225x225x225x225,300x75x300x75x300x75x300x75,300x100x300x100x300x100x300x100,300x150x300x150x300x150x300x150,300x300x300x300x300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-AGX Crossover PExPExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "0.667650918635168",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.984251968503937",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "24119159696061131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: [
              {
                name: "M_Legrand SS MGIP-AGT Top Lid Tee Gussett PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "50x50x50x50x50x50,75x50x75x50x75x50,75x75x75x75x75x75,100x50x100x50x100x50,100x75x100x75x100x75,100x100x100x100x100x100,150x50x150x50x150x50,150x75x150x75x150x75,150x100x150x100x150x100,150x150x150x150x150x150,225x75x225x75x225x75,225x100x225x100x225x100,225x150x225x150x225x150,225x225x225x225x225x225,300x75x300x75x300x75,300x100x300x100x300x100,300x150x300x150x300x150,300x300x300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-AGT Top Lid Tee Gussett PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "0.25590551181102",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "0.164041994750656",
                displayPosition: "2,3",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24119156696061031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-AST Top Lid Tee Square PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "2",
                sizeRange: "50x50x50x50x50x50,75x50x75x50x75x50,75x75x75x75x75x75,100x50x100x50x100x50,100x75x100x75x100x75,100x100x100x100x100x100,150x50x150x50x150x50,150x75x150x75x150x75,150x100x150x100x150x100,150x150x150x150x150x150,225x75x225x75x225x75,225x100x225x100x225x100,225x150x225x150x225x150,225x225x225x225x225x225,300x75x300x75x300x75,300x100x300x100x300x100,300x150x300x150x300x150,300x300x300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-AST Top Lid Tee Square PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "0.295275590551178",
                isConnCheck: "True",
                extraField: "",
                Height: "0.328083989501312",
                width: "0.328083989501312",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24119168696061031",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-AGT Top Lid Tee Gussett PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "3",
                sizeRange: "50x50x50x50x50x50,75x50x75x50x75x50,75x75x75x75x75x75,100x50x100x50x100x50,100x75x100x75x100x75,100x100x100x100x100x100,150x50x150x50x150x50,150x75x150x75x150x75,150x100x150x100x150x100,150x150x150x150x150x150,225x75x225x75x225x75,225x100x225x100x225x100,225x150x225x150x225x150,225x225x225x225x225x225,300x75x300x75x300x75,300x100x300x100x300x100,300x150x300x150x300x150,300x300x300x300x300x300",
                manufacturer: "Legrand",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-AGT Top Lid Tee Gussett PExPExPE.RFA",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "0.666010498687664",
                isConnCheck: "True",
                extraField: "",
                Height: "0.492125984251969",
                width: "0.984251968503937",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "24119156696061031",
                isClearence: "false"
              }
            ],
            channelCableTrayTransition: {
              addDefaultItem: {
                name: "M_Legrand SS MGIP-R Reducers IP4X PExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "50x50x75x50,50x50x75x75,50x50x100x50,50x50x100x75,50x50x100x100,50x50x150x50,50x50x150x75,50x50x150x100,50x50x150x150,50x50x225x75,50x50x225x100,50x50x225x150,50x50x225x225,50x50x300x75,50x50x300x100,50x50x300x150,50x50x300x300,75x50x50x50,75x75x50x50,75x75x75x50,75x50x75x75,75x50x100x50,75x75x100x50,75x50x100x75,75x75x100x75,75x50x100x100,75x75x100x100,75x50x150x50,75x75x150x50,75x50x150x75,75x75x150x75,75x50x150x100,75x75x150x100,75x50x150x150,75x75x150x150,75x50x225x75,75x75x225x75,75x50x225x100,75x75x225x100,75x50x225x150,75x75x225x150,75x50x225x225,75x75x225x225,75x50x300x75,75x75x300x75,75x50x300x100,75x75x300x100,75x50x300x150,75x75x300x150,75x50x300x300,75x75x300x300,100x50x50x50,100x50x75x50,100x50x75x75,100x75x50x50,100x75x75x50,100x75x75x75,100x75x100x50,100x100x50x50,100x100x75x50,100x100x75x75,100x100x100x50,100x100x100x75,100x50x100x75,100x50x100x100,100x75x100x100,100x50x150x50,100x75x150x50,100x100x150x50,100x50x150x75,100x75x150x75,100x100x150x75,100x50x150x100,100x75x150x100,100x100x150x100,100x50x150x150,100x75x150x150,100x100x150x150,100x50x225x75,100x75x225x75,100x100x225x75,100x50x225x100,100x75x225x100,100x100x225x100,100x50x225x150,100x75x225x150,100x100x225x150,100x50x225x225,100x75x225x225,100x100x225x225,100x50x300x75,100x75x300x75,100x100x300x75,100x50x300x100,100x75x300x100,100x100x300x100,100x50x300x150,100x75x300x150,100x100x300x150,100x50x300x300,100x75x300x300,100x100x300x300,150x50x50x50,150x50x75x50,150x50x75x75,150x50x100x50,150x50x100x75,150x50x100x100,150x75x50x50,150x75x75x50,150x75x75x75,150x75x100x50,150x75x100x75,150x75x100x100,150x75x150x50,150x100x50x50,150x100x75x50,150x100x75x75,150x100x100x50,150x100x100x75,150x100x100x100,150x100x150x50,150x100x150x75,150x150x50x50,150x150x75x50,150x150x75x75,150x150x100x50,150x150x100x75,150x150x100x100,150x150x150x50,150x150x150x75,150x150x150x100,150x50x150x75,150x50x150x100,150x75x150x100,150x50x150x150,150x75x150x150,150x100x150x150,150x50x225x75,150x75x225x75,150x100x225x75,150x150x225x75,150x50x225x100,150x75x225x100,150x100x225x100,150x150x225x100,150x50x225x150,150x75x225x150,150x100x225x150,150x150x225x150,150x50x225x225,150x75x225x225,150x100x225x225,150x150x225x225,150x50x300x75,150x75x300x75,150x100x300x75,150x150x300x75,150x50x300x100,150x75x300x100,150x100x300x100,150x150x300x100,150x50x300x150,150x75x300x150,150x100x300x150,150x150x300x150,150x50x300x300,150x75x300x300,150x100x300x300,150x150x300x300,225x75x50x50,225x75x75x50,225x75x75x75,225x75x100x50,225x75x100x75,225x75x100x100,225x75x150x50,225x75x150x75,225x75x150x100,225x75x150x150,225x100x50x50,225x100x75x50,225x100x75x75,225x100x100x50,225x100x100x75,225x100x100x100,225x100x150x50,225x100x150x75,225x100x150x100,225x100x150x150,225x100x225x75,225x150x50x50,225x150x75x50,225x150x75x75,225x150x100x50,225x150x100x75,225x150x100x100,225x150x150x50,225x150x150x75,225x150x150x100,225x150x150x150,225x150x225x75,225x150x225x100,225x225x50x50,225x225x75x50,225x225x75x75,225x225x100x50,225x225x100x75,225x225x100x100,225x225x150x50,225x225x150x75,225x225x150x100,225x225x150x150,225x225x225x75,225x225x225x100,225x225x225x150,225x75x225x100,225x75x225x150,225x100x225x150,225x75x225x225,225x100x225x225,225x150x225x225,225x75x300x75,225x100x300x75,225x150x300x75,225x225x300x75,225x75x300x100,225x100x300x100,225x150x300x100,225x225x300x100,225x75x300x150,225x100x300x150,225x150x300x150,225x225x300x150,225x75x300x300,225x100x300x300,225x150x300x300,225x225x300x300,300x75x50x50,300x75x75x50,300x75x75x75,300x75x100x50,300x75x100x75,300x75x100x100,300x75x150x50,300x75x150x75,300x75x150x100,300x75x150x150,300x75x225x75,300x75x225x100,300x75x225x150,300x75x225x225,300x100x50x50,300x100x75x50,300x100x75x75,300x100x100x50,300x100x100x75,300x100x100x100,300x100x150x50,300x100x150x75,300x100x150x100,300x100x150x150,300x100x225x75,300x100x225x100,300x100x225x150,300x100x225x225,300x100x300x75,300x150x50x50,300x150x75x50,300x150x75x75,300x150x100x50,300x150x100x75,300x150x100x100,300x150x150x50,300x150x150x75,300x150x150x100,300x150x150x150,300x150x225x75,300x150x225x100,300x150x225x150,300x150x225x225,300x150x300x75,300x150x300x100,300x300x50x50,300x300x75x50,300x300x75x75,300x300x100x50,300x300x100x75,300x300x100x100,300x300x150x50,300x300x150x75,300x300x150x100,300x300x150x150,300x300x225x75,300x300x225x100,300x300x225x150,300x300x225x225,300x300x300x75,300x300x300x100,300x300x300x150,300x75x300x100,300x75x300x150,300x100x300x150,300x75x300x300,300x100x300x300,300x150x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-R Reducers IP4X PExFE.RFA",
                description: "",
                angle: "90",
                connector: "200*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "M_Legrand SS MGIP-R Reducers IP4X PExFE",
                bendType: "",
                id: "24119199696063231",
                isClearence: "false"
              }
            },
            channelCableTrayUnion: {
              addDefaultItem: {
                name: "M_Legrand SS MGIP-C Trunking Coupler FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-C Trunking Coupler FExFE.RFA",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24119195696063531",
                isClearence: "false"
              }
            },
            channelCableTrayMultiPort: [
              {
                name: "M_Legrand SS MGIP-E End Cap PE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "1",
                sizeRange: "50x50,75x50,75x75,100x50,100x75,100x100,150x50,150x75,150x100,150x150,225x75,225x100,225x150,225x225,300x75,300x100,300x150,300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-E End Cap PE.RFA",
                description: "",
                angle: "90",
                connector: "200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24119196696066131",
                isClearence: "false"
              },
              {
                name: "M_Legrand SS MGIP-F Flange PExFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "2",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x50x100x50,100x75x100x75,100x100x100x100,150x50x150x50,150x75x150x75,150x100x150x100,150x150x150x150,225x75x225x75,225x100x225x100,225x150x225x150,225x225x225x225,300x75x300x75,300x100x300x100,300x150x300x150,300x300x300x300",
                manufacturer: "Legrand",
                shape: "WireWay",
                path: "\\metric\\cabletrays\\legrand\\salamandre  - ip4x trunking\\formed steel\\tray\\",
                icon: "M_Legrand SS MGIP-F Flange PExFlgd.RFA",
                description: "",
                angle: "90",
                connector: "200*202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "24119200696063731",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "-------------WIRE BASKET CONTAINMENT------------",
        unit: "IMPERIAL",
        id: "23",
        systemShape: "conduit",
        systemUniqueId: "167",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "conduit"
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Flextray BLine 304L Bolt-On Splice",
        unit: "IMPERIAL",
        id: "24",
        InVisibility: "",
        systemShape: "Wire Mesh Cable Tray",
        IsHangerNeeded: "True",
        systemUniqueId: "168",
        hangerDisabledFor: "",
        isClearence: "true",
        fittings: [
          {
            name: "Wire Mesh Cable Tray",
            electricalTypeItems: {
              name: "cooper B-Line SS304L Flextray Straight PExPE",
              id: "2480727505960111",
              Length: "10",
              JunctionType: "Tee",
              OldMat: "",
              shape: "Wire Mesh Cable Tray",
              sizeRange: "2x2,4x1.5,4x2,4x4,6x1.5,6x2,6x4,8x1.5,8x2,8x4,8x6,12x1.5,12x2,12x4,12x6,16x2,16x4,16x6,18x2,18x4,18x6,20x2,20x4,20x6,24x2,24x4,24x6,30x2,30x4,32x2",
              manufacturer: "cooper B-Line",
              path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
              icon: "cooper B-Line SS304L Flextray Straight PExPE.rfa",
              description: "",
              descriptionType: "",
              connector: "200",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "2",
              duplicateFrom: "Wire Mesh Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              isClearence: "true"
            },
            channelCableTrayElbow: [
              {
                name: "cooper B-Line SS 90 LR Horizontal Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "2x2x2x2,4x1.5x4x1.5,4x2x4x2,4x4x4x4,6x1.5x6x1.5,6x2x6x2,6x4x6x4,8x1.5x8x1.5,8x2x8x2,8x4x8x4,8x6x8x6,12x1.5x12x1.5,12x2x12x2,12x4x12x4,12x6x12x6,16x2x16x2,16x4x16x4,16x6x16x6,18x2x18x2,18x4x18x4,18x6x18x6,20x2x20x2,20x4x20x4,20x6x20x6,24x2x24x2,24x4x24x4,24x6x24x6,30x2x30x2,30x4x30x4,32x2x32x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS 90 LR Horizontal Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0.924647972915316",
                isConnCheck: "True",
                extraField: "",
                Height: "0.125",
                width: "0.666666666666667",
                displayPosition: "1,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "2480728505960711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line SS 90 Bend From 2 Section PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "4x1.5x4x1.5,4x2x4x2,4x4x4x4,6x1.5x6x1.5,6x2x6x2,6x4x6x4,8x1.5x8x1.5,8x2x8x2,8x4x8x4,8x6x8x6,12x1.5x12x1.5,12x2x12x2,12x4x12x4,12x6x12x6,16x2x16x2,16x4x16x4,16x6x16x6,18x2x18x2,18x4x18x4,18x6x18x6,20x2x20x2,20x4x20x4,20x6x20x6,24x2x24x2,24x4x24x4,24x6x24x6,30x2x30x2,30x4x30x4,32x2x32x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS 90 Bend From 2 Section PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.38",
                isConnCheck: "True",
                extraField: "",
                Height: "0.125",
                width: "0.333333333333333",
                displayPosition: "2,1",
                dispPosition: "9",
                csvFileName: "",
                bendType: "",
                id: "2480730505960711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line SS 90 Bend Short Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "2x2x2x2,4x1.5x4x1.5,4x2x4x2,4x4x4x4,6x1.5x6x1.5,6x2x6x2,6x4x6x4,8x1.5x8x1.5,8x2x8x2,8x4x8x4,8x6x8x6,12x1.5x12x1.5,12x2x12x2,12x4x12x4,12x6x12x6,16x2x16x2,16x4x16x4,16x6x16x6,18x2x18x2,18x4x18x4,18x6x18x6,20x2x20x2,20x4x20x4,20x6x20x6,24x2x24x2,24x4x24x4,24x6x24x6",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS 90 Bend Short Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.92966666666667",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "3,1",
                dispPosition: "10",
                csvFileName: "",
                bendType: "",
                id: "2480729505960711",
                isClearence: "true"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "cooper B-Line SS304L Flextray Cross PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "2x2x2x2x2x2x2x2,4x1.5x4x1.5x4x1.5x4x1.5,4x2x4x2x4x2x4x2,4x4x4x4x4x4x4x4,6x1.5x6x1.5x6x1.5x6x1.5,6x2x6x2x6x2x6x2,6x4x6x4x6x4x6x4,8x1.5x8x1.5x8x1.5x8x1.5,8x2x8x2x8x2x8x2,8x4x8x4x8x4x8x4,8x6x8x6x8x6x8x6,12x1.5x12x1.5x12x1.5x12x1.5,12x2x12x2x12x2x12x2,12x4x12x4x12x4x12x4,12x6x12x6x12x6x12x6,16x2x16x2x16x2x16x2,16x4x16x4x16x4x16x4,16x6x16x6x16x6x16x6,18x2x18x2x18x2x18x2,18x4x18x4x18x4x18x4,18x6x18x6x18x6x18x6,20x2x20x2x20x2x20x2,20x4x20x4x20x4x20x4,20x6x20x6x20x6x20x6,24x2x24x2x24x2x24x2,24x4x24x4x24x4x24x4,24x6x24x6x24x6x24x6,30x2x30x2x30x2x30x2,30x4x30x4x30x4x30x4,32x2x32x2x32x2x32x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS304L Flextray Cross PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "4.92966666666667",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "2,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "2480731505961111",
                isClearence: "true"
              }
            },
            channelCableTrayTee: {
              addDefaultItem: {
                name: "cooper B-Line SS304L Flextray Tee PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "2x2x2x2x2x2,4x1.5x4x1.5x4x1.5,4x2x4x2x4x2,4x4x4x4x4x4,6x1.5x6x1.5x6x1.5,6x2x6x2x6x2,6x4x6x4x6x4,8x1.5x8x1.5x8x1.5,8x2x8x2x8x2,8x4x8x4x8x4,8x6x8x6x8x6,12x1.5x12x1.5x12x1.5,12x2x12x2x12x2,12x4x12x4x12x4,12x6x12x6x12x6,16x2x16x2x16x2,16x4x16x4x16x4,16x6x16x6x16x6,18x2x18x2x18x2,18x4x18x4x18x4,18x6x18x6x18x6,20x2x20x2x20x2,20x4x20x4x20x4,20x6x20x6x20x6,24x2x24x2x24x2,24x4x24x4x24x4,24x6x24x6x24x6,30x2x30x2x30x2,30x4x30x4x30x4,32x2x32x2x32x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS304L Flextray Tee PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.92966666666667",
                isConnCheck: "True",
                extraField: "",
                Height: "0.125",
                width: "0.333333333333333",
                displayPosition: "3,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "2480735505961011",
                isClearence: "true"
              }
            },
            channelCableTrayTransition: [
              {
                name: "cooper B-Line SS304L Flextray Left Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "4x1.5x6x1.5,4x1.5x8x1.5,4x1.5x12x1.5,4x2x6x2,4x2x8x2,4x2x12x2,4x2x16x2,4x2x18x2,4x2x20x2,4x2x24x2,4x2x30x2,4x2x32x2,4x4x6x4,4x4x8x4,4x4x12x4,4x4x16x4,4x4x18x4,4x4x20x4,4x4x24x4,4x4x30x4,6x1.5x4x1.5,6x2x4x2,6x4x4x4,6x1.5x8x1.5,6x1.5x12x1.5,6x2x8x2,6x2x12x2,6x2x16x2,6x2x18x2,6x2x20x2,6x2x24x2,6x2x30x2,6x2x32x2,6x4x8x4,6x4x12x4,6x4x16x4,6x4x18x4,6x4x20x4,6x4x24x4,6x4x30x4,8x1.5x4x1.5,8x1.5x6x1.5,8x2x4x2,8x2x6x2,8x4x4x4,8x4x6x4,8x1.5x12x1.5,8x2x12x2,8x2x16x2,8x2x18x2,8x2x20x2,8x2x24x2,8x2x30x2,8x2x32x2,8x4x12x4,8x4x16x4,8x4x18x4,8x4x20x4,8x4x24x4,8x4x30x4,8x6x12x6,8x6x16x6,8x6x18x6,8x6x20x6,8x6x24x6,12x1.5x4x1.5,12x1.5x6x1.5,12x1.5x8x1.5,12x2x4x2,12x2x6x2,12x2x8x2,12x4x4x4,12x4x6x4,12x4x8x4,12x6x8x6,12x2x16x2,12x2x18x2,12x2x20x2,12x2x24x2,12x2x30x2,12x2x32x2,12x4x16x4,12x4x18x4,12x4x20x4,12x4x24x4,12x4x30x4,12x6x16x6,12x6x18x6,12x6x20x6,12x6x24x6,16x2x4x2,16x2x6x2,16x2x8x2,16x2x12x2,16x4x4x4,16x4x6x4,16x4x8x4,16x4x12x4,16x6x8x6,16x6x12x6,16x2x18x2,16x2x20x2,16x2x24x2,16x2x30x2,16x2x32x2,16x4x18x4,16x4x20x4,16x4x24x4,16x4x30x4,16x6x18x6,16x6x20x6,16x6x24x6,18x2x4x2,18x2x6x2,18x2x8x2,18x2x12x2,18x2x16x2,18x4x4x4,18x4x6x4,18x4x8x4,18x4x12x4,18x4x16x4,18x6x8x6,18x6x12x6,18x6x16x6,18x2x20x2,18x2x24x2,18x2x30x2,18x2x32x2,18x4x20x4,18x4x24x4,18x4x30x4,18x6x20x6,18x6x24x6,20x2x4x2,20x2x6x2,20x2x8x2,20x2x12x2,20x2x16x2,20x2x18x2,20x4x4x4,20x4x6x4,20x4x8x4,20x4x12x4,20x4x16x4,20x4x18x4,20x6x8x6,20x6x12x6,20x6x16x6,20x6x18x6,20x2x24x2,20x2x30x2,20x2x32x2,20x4x24x4,20x4x30x4,20x6x24x6,24x2x4x2,24x2x6x2,24x2x8x2,24x2x12x2,24x2x16x2,24x2x18x2,24x2x20x2,24x4x4x4,24x4x6x4,24x4x8x4,24x4x12x4,24x4x16x4,24x4x18x4,24x4x20x4,24x6x8x6,24x6x12x6,24x6x16x6,24x6x18x6,24x6x20x6,24x2x30x2,24x2x32x2,24x4x30x4,30x2x4x2,30x2x6x2,30x2x8x2,30x2x12x2,30x2x16x2,30x2x18x2,30x2x20x2,30x2x24x2,30x4x4x4,30x4x6x4,30x4x8x4,30x4x12x4,30x4x16x4,30x4x18x4,30x4x20x4,30x4x24x4,30x2x32x2,32x2x4x2,32x2x6x2,32x2x8x2,32x2x12x2,32x2x16x2,32x2x18x2,32x2x20x2,32x2x24x2,32x2x30x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS304L Flextray Left Reducer PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,0",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "2480732505960811",
                isClearence: "true"
              },
              {
                name: "cooper B-Line SS304L Flextray Right Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "2",
                sizeRange: "4x1.5x6x1.5,4x1.5x8x1.5,4x1.5x12x1.5,4x2x6x2,4x2x8x2,4x2x12x2,4x2x16x2,4x2x18x2,4x2x20x2,4x2x24x2,4x2x30x2,4x2x32x2,4x4x6x4,4x4x8x4,4x4x12x4,4x4x16x4,4x4x18x4,4x4x20x4,4x4x24x4,4x4x30x4,6x1.5x4x1.5,6x2x4x2,6x4x4x4,6x1.5x8x1.5,6x1.5x12x1.5,6x2x8x2,6x2x12x2,6x2x16x2,6x2x18x2,6x2x20x2,6x2x24x2,6x2x30x2,6x2x32x2,6x4x8x4,6x4x12x4,6x4x16x4,6x4x18x4,6x4x20x4,6x4x24x4,6x4x30x4,8x1.5x4x1.5,8x1.5x6x1.5,8x2x4x2,8x2x6x2,8x4x4x4,8x4x6x4,8x1.5x12x1.5,8x2x12x2,8x2x16x2,8x2x18x2,8x2x20x2,8x2x24x2,8x2x30x2,8x2x32x2,8x4x12x4,8x4x16x4,8x4x18x4,8x4x20x4,8x4x24x4,8x4x30x4,8x6x12x6,8x6x16x6,8x6x18x6,8x6x20x6,8x6x24x6,12x1.5x4x1.5,12x1.5x6x1.5,12x1.5x8x1.5,12x2x4x2,12x2x6x2,12x2x8x2,12x4x4x4,12x4x6x4,12x4x8x4,12x6x8x6,12x2x16x2,12x2x18x2,12x2x20x2,12x2x24x2,12x2x30x2,12x2x32x2,12x4x16x4,12x4x18x4,12x4x20x4,12x4x24x4,12x4x30x4,12x6x16x6,12x6x18x6,12x6x20x6,12x6x24x6,16x2x4x2,16x2x6x2,16x2x8x2,16x2x12x2,16x4x4x4,16x4x6x4,16x4x8x4,16x4x12x4,16x6x8x6,16x6x12x6,16x2x18x2,16x2x20x2,16x2x24x2,16x2x30x2,16x2x32x2,16x4x18x4,16x4x20x4,16x4x24x4,16x4x30x4,16x6x18x6,16x6x20x6,16x6x24x6,18x2x4x2,18x2x6x2,18x2x8x2,18x2x12x2,18x2x16x2,18x4x4x4,18x4x6x4,18x4x8x4,18x4x12x4,18x4x16x4,18x6x8x6,18x6x12x6,18x6x16x6,18x2x20x2,18x2x24x2,18x2x30x2,18x2x32x2,18x4x20x4,18x4x24x4,18x4x30x4,18x6x20x6,18x6x24x6,20x2x4x2,20x2x6x2,20x2x8x2,20x2x12x2,20x2x16x2,20x2x18x2,20x4x4x4,20x4x6x4,20x4x8x4,20x4x12x4,20x4x16x4,20x4x18x4,20x6x8x6,20x6x12x6,20x6x16x6,20x6x18x6,20x2x24x2,20x2x30x2,20x2x32x2,20x4x24x4,20x4x30x4,20x6x24x6,24x2x4x2,24x2x6x2,24x2x8x2,24x2x12x2,24x2x16x2,24x2x18x2,24x2x20x2,24x4x4x4,24x4x6x4,24x4x8x4,24x4x12x4,24x4x16x4,24x4x18x4,24x4x20x4,24x6x8x6,24x6x12x6,24x6x16x6,24x6x18x6,24x6x20x6,24x2x30x2,24x2x32x2,24x4x30x4,30x2x4x2,30x2x6x2,30x2x8x2,30x2x12x2,30x2x16x2,30x2x18x2,30x2x20x2,30x2x24x2,30x4x4x4,30x4x6x4,30x4x8x4,30x4x12x4,30x4x16x4,30x4x18x4,30x4x20x4,30x4x24x4,30x2x32x2,32x2x4x2,32x2x6x2,32x2x8x2,32x2x12x2,32x2x16x2,32x2x18x2,32x2x20x2,32x2x24x2,32x2x30x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS304L Flextray Right Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "2480733505960911",
                isClearence: "true"
              },
              {
                name: "cooper B-Line SS304L Flextray Straight Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "3",
                sizeRange: "4x1.5x6x1.5,4x1.5x8x1.5,4x1.5x12x1.5,4x2x6x2,4x2x8x2,4x2x12x2,4x2x16x2,4x2x18x2,4x2x20x2,4x2x24x2,4x2x30x2,4x2x32x2,4x4x6x4,4x4x8x4,4x4x12x4,4x4x16x4,4x4x18x4,4x4x20x4,4x4x24x4,4x4x30x4,6x1.5x4x1.5,6x2x4x2,6x4x4x4,6x1.5x8x1.5,6x1.5x12x1.5,6x2x8x2,6x2x12x2,6x2x16x2,6x2x18x2,6x2x20x2,6x2x24x2,6x2x30x2,6x2x32x2,6x4x8x4,6x4x12x4,6x4x16x4,6x4x18x4,6x4x20x4,6x4x24x4,6x4x30x4,8x1.5x4x1.5,8x1.5x6x1.5,8x2x4x2,8x2x6x2,8x4x4x4,8x4x6x4,8x1.5x12x1.5,8x2x12x2,8x2x16x2,8x2x18x2,8x2x20x2,8x2x24x2,8x2x30x2,8x2x32x2,8x4x12x4,8x4x16x4,8x4x18x4,8x4x20x4,8x4x24x4,8x4x30x4,8x6x12x6,8x6x16x6,8x6x18x6,8x6x20x6,8x6x24x6,12x1.5x4x1.5,12x1.5x6x1.5,12x1.5x8x1.5,12x2x4x2,12x2x6x2,12x2x8x2,12x4x4x4,12x4x6x4,12x4x8x4,12x6x8x6,12x2x16x2,12x2x18x2,12x2x20x2,12x2x24x2,12x2x30x2,12x2x32x2,12x4x16x4,12x4x18x4,12x4x20x4,12x4x24x4,12x4x30x4,12x6x16x6,12x6x18x6,12x6x20x6,12x6x24x6,16x2x4x2,16x2x6x2,16x2x8x2,16x2x12x2,16x4x4x4,16x4x6x4,16x4x8x4,16x4x12x4,16x6x8x6,16x6x12x6,16x2x18x2,16x2x20x2,16x2x24x2,16x2x30x2,16x2x32x2,16x4x18x4,16x4x20x4,16x4x24x4,16x4x30x4,16x6x18x6,16x6x20x6,16x6x24x6,18x2x4x2,18x2x6x2,18x2x8x2,18x2x12x2,18x2x16x2,18x4x4x4,18x4x6x4,18x4x8x4,18x4x12x4,18x4x16x4,18x6x8x6,18x6x12x6,18x6x16x6,18x2x20x2,18x2x24x2,18x2x30x2,18x2x32x2,18x4x20x4,18x4x24x4,18x4x30x4,18x6x20x6,18x6x24x6,20x2x4x2,20x2x6x2,20x2x8x2,20x2x12x2,20x2x16x2,20x2x18x2,20x4x4x4,20x4x6x4,20x4x8x4,20x4x12x4,20x4x16x4,20x4x18x4,20x6x8x6,20x6x12x6,20x6x16x6,20x6x18x6,20x2x24x2,20x2x30x2,20x2x32x2,20x4x24x4,20x4x30x4,20x6x24x6,24x2x4x2,24x2x6x2,24x2x8x2,24x2x12x2,24x2x16x2,24x2x18x2,24x2x20x2,24x4x4x4,24x4x6x4,24x4x8x4,24x4x12x4,24x4x16x4,24x4x18x4,24x4x20x4,24x6x8x6,24x6x12x6,24x6x16x6,24x6x18x6,24x6x20x6,24x2x30x2,24x2x32x2,24x4x30x4,30x2x4x2,30x2x6x2,30x2x8x2,30x2x12x2,30x2x16x2,30x2x18x2,30x2x20x2,30x2x24x2,30x4x4x4,30x4x6x4,30x4x8x4,30x4x12x4,30x4x16x4,30x4x18x4,30x4x20x4,30x4x24x4,30x2x32x2,32x2x4x2,32x2x6x2,32x2x8x2,32x2x12x2,32x2x16x2,32x2x18x2,32x2x20x2,32x2x24x2,32x2x30x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS304L Flextray Straight Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "2480734505960011",
                isClearence: "true"
              }
            ],
            channelCableTrayUnion: [
              {
                name: "cooper B-Line Glv Steel Wing Splice FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "2x2x2x2,4x1.5x4x1.5,4x2x4x2,4x4x4x4,6x1.5x6x1.5,6x2x6x2,6x4x6x4,8x1.5x8x1.5,8x2x8x2,8x4x8x4,8x6x8x6,12x1.5x12x1.5,12x2x12x2,12x4x12x4,12x6x12x6,16x2x16x2,16x4x16x4,16x6x16x6,18x2x18x2,18x4x18x4,18x6x18x6,20x2x20x2,20x4x20x4,20x6x20x6,24x2x24x2,24x4x24x4,24x6x24x6,30x2x30x2,30x4x30x4,32x2x32x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line Glv Steel Wing Splice FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,1",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "2482263505961211",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 Junction Box FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "2",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray",
                icon: "Hoffman GS NEMA Type12 Junction Box FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24128475733063511",
                isClearence: "true"
              }
            ],
            channelCableTrayOffset: {
              addDefaultItem: {
                name: "cooper B-Line SS304L Flextray Offset PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayOffset",
                position: "1",
                sizeRange: "2x2x2x2,4x1.5x4x1.5,4x2x4x2,4x4x4x4,6x1.5x6x1.5,6x2x6x2,6x4x6x4,8x1.5x8x1.5,8x2x8x2,8x4x8x4,8x6x8x6,12x1.5x12x1.5,12x2x12x2,12x4x12x4,12x6x12x6,16x2x16x2,16x4x16x4,16x6x16x6,18x2x18x2,18x4x18x4,18x6x18x6,20x2x20x2,20x4x20x4,20x6x20x6,24x2x24x2,24x4x24x4,24x6x24x6,30x2x30x2,30x4x30x4,32x2x32x2",
                manufacturer: "cooper B-Line",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\304l bolt-on spliced flextray\\stainless steel\\tray\\",
                icon: "cooper B-Line SS304L Flextray Offset PExPE.rfa",
                description: "",
                descriptionType: "Offset",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24159977505964611",
                isClearence: "true"
              }
            }
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                isConnCheck: "",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                id: "24122208708764011",
                IsHanger: "True",
                supportDiscipline: "cable Tray",
                specId: "1",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "ladder BLine Alum Series 24 10 ft x 9 in Rung Spacing",
        unit: "IMPERIAL",
        id: "20",
        InVisibility: "",
        systemShape: "ladder Cable Tray",
        IsHangerNeeded: "True",
        systemUniqueId: "670adea6-8771-40bd-a9d1-c33f26954623",
        hangerDisabledFor: "",
        isClearence: "true",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: [
              {
                name: "cooper B-Line AL VE1 Sr24 Type09 Lt10Ft Straight Ladder PExPE",
                id: "24108689631860111",
                Length: "10",
                JunctionType: "Tee",
                OldMat: "",
                shape: "ladder Cable Tray",
                sizeRange: "6x4,9x4,12x4,18x4,24x4,30x4,36x4",
                manufacturer: "cooper B-Line",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder straights\\aluminum\\tray\\",
                icon: "cooper B-Line AL VE1 Sr24 Type09 Lt10Ft Straight Ladder PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "200",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                duplicateFrom: "ladder Cable Tray",
                defaultFor: "",
                serviceType: "",
                serviceTypeColor: "",
                LineWeight: "",
                LinePattern: "",
                isClearence: "true"
              },
              {
                name: "Legrand SC-A12C-S240 PW Ladder Cable Tray PExPE",
                id: "24126730726860111",
                Length: "20",
                JunctionType: "Tee",
                OldMat: "",
                shape: "ladder Cable Tray",
                sizeRange: "6x4,6x5,6x6,6x7,9x4,9x5,9x6,9x7,12x4,12x5,12x6,12x7,18x4,18x5,18x6,18x7,24x4,24x5,24x6,24x7,30x4,30x5,30x6,30x7,36x4,36x5,36x6,36x7",
                manufacturer: "Legrand",
                path: "\\imperial\\cabletrays\\clearance\\legrand\\imp_cablofil al-nema pw ladder tray\\aluminum\\tray",
                icon: "Legrand SC-A12C-S240 PW Ladder Cable Tray PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "200",
                extraField: "",
                displayPosition: "2,16",
                dispPosition: "83",
                duplicateFrom: "ladder Cable Tray",
                defaultFor: "",
                serviceType: "",
                serviceTypeColor: "",
                LineWeight: "",
                LinePattern: "",
                isClearence: "true"
              }
            ],
            ladderCableTrayElbow: [
              {
                name: "cooper B-Line AL Radius 12 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.786458333333314",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24108804631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.07812499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24108808631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.40624999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24108812631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24108816631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.05208333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "24108805631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.49479166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "24108809631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.98437499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "",
                id: "24108813631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "",
                id: "24108817631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.52083333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3.5",
                displayPosition: "2,8",
                dispPosition: "43",
                csvFileName: "",
                bendType: "",
                id: "24108806631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.11458333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "3,8",
                dispPosition: "44",
                csvFileName: "",
                bendType: "",
                id: "24108810631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.84895833333331",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "4,8",
                dispPosition: "45",
                csvFileName: "",
                bendType: "",
                id: "24108814631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "12",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.74999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "0,9",
                dispPosition: "46",
                csvFileName: "",
                bendType: "",
                id: "24108818631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "13",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.58854166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "3,11",
                dispPosition: "59",
                csvFileName: "",
                bendType: "",
                id: "24108807631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "14",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.32291666666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "4,11",
                dispPosition: "60",
                csvFileName: "",
                bendType: "",
                id: "24108811631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "15",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "3.13541666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "0,12",
                dispPosition: "61",
                csvFileName: "",
                bendType: "",
                id: "24108815631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "16",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "5.24999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "1,12",
                dispPosition: "62",
                csvFileName: "",
                bendType: "",
                id: "24108819631760711",
                isClearence: "true"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "cooper B-Line AL Cable Support Fitting 12 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 12 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.49999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.5",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108861631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 24 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 24 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108862631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 36 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 36 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108863631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 48 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 48 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108864631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.67187499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108820631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.906249999999994",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.583333333333333",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108828631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.11458333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.5",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108836631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.49999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.5",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108844631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.515624999999981",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.583333333333333",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108824631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.66666666666666",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108832631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "0.828124999999985",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108840631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.41666666666659",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108848631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.942708333333312",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.583333333333333",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108821631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.21874999999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108829631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.73958333333332",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108837631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.54166666666657",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108845631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.786458333333334",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.5",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108825631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.07812499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.583333333333333",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108833631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.40624999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.583333333333333",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108841631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.41666666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "1,8",
                dispPosition: "42",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108849631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "21",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.14062499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "0,10",
                dispPosition: "51",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108822631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "22",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.63020833333333",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "1,10",
                dispPosition: "52",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108830631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "23",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.17708333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "2,10",
                dispPosition: "53",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108838631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "24",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.54166666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "3,10",
                dispPosition: "54",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108846631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "25",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.05208333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "4,10",
                dispPosition: "55",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108826631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "26",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.49479166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "0,11",
                dispPosition: "56",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108834631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "27",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.98437499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "1,11",
                dispPosition: "57",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108842631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "28",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.54166666666649",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "2,11",
                dispPosition: "58",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108850631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "29",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.41145833333333",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "1,13",
                dispPosition: "67",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108823631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "30",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.04687499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "2,13",
                dispPosition: "68",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108831631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "31",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.74999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "3,13",
                dispPosition: "69",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108839631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "32",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.41666666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "4,13",
                dispPosition: "70",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108847631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "33",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.32291666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "0,14",
                dispPosition: "71",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108827631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "34",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.90624999999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "1,14",
                dispPosition: "72",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108835631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "35",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.55729166666665",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "2,14",
                dispPosition: "73",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108843631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "36",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.54166666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "3,14",
                dispPosition: "74",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108851631760211",
                isClearence: "true"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "cooper B-Line AL Radius 12 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "",
                id: "24108877631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "",
                id: "24108878631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "4.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "3,9",
                dispPosition: "49",
                csvFileName: "",
                bendType: "",
                id: "24108879631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "5.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "4,12",
                dispPosition: "65",
                csvFileName: "",
                bendType: "",
                id: "24108880631761111",
                isClearence: "true"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "cooper B-Line AL Radius 12 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.75",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24108869631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "0.5",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "24108865631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "0.5",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "24108870631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.75",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "",
                id: "24108871631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "",
                id: "24108866631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "6",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "",
                id: "24108872631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "7",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.75",
                displayPosition: "1,9",
                dispPosition: "47",
                csvFileName: "",
                bendType: "",
                id: "24108873631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "8",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "2,9",
                dispPosition: "48",
                csvFileName: "",
                bendType: "",
                id: "24108867631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "9",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.58333333333334",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "4,9",
                dispPosition: "50",
                csvFileName: "",
                bendType: "",
                id: "24108874631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "10",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.75",
                displayPosition: "2,12",
                dispPosition: "63",
                csvFileName: "",
                bendType: "",
                id: "24108875631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "11",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "5.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "3,12",
                dispPosition: "64",
                csvFileName: "",
                bendType: "",
                id: "24108868631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "12",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "0,13",
                dispPosition: "66",
                csvFileName: "",
                bendType: "",
                id: "24108876631763311",
                isClearence: "true"
              }
            ],
            ladderCableTrayTransition: [
              {
                name: "cooper B-Line AL Left Hand Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "1",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Left Hand Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "cooper B-Line AL Left Hand Reducer PExPE",
                bendType: "",
                id: "24108881631760811",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL LR Offset Red Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "2",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL LR Offset Red Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "cooper B-Line AL LR Offset Red Splice Plate FExFE",
                bendType: "",
                id: "24108882631760811",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Right Hand Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "3",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Right Hand Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,14",
                dispPosition: "75",
                csvFileName: "cooper B-Line AL Right Hand Reducer PExPE",
                bendType: "",
                id: "24108884631760911",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL RR Offset Red Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "4",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL RR Offset Red Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,15",
                dispPosition: "76",
                csvFileName: "cooper B-Line AL RR Offset Red Splice Plate FExFE",
                bendType: "",
                id: "24108883631760911",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL SR Reducing Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "5",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL SR Reducing Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,15",
                dispPosition: "77",
                csvFileName: "cooper B-Line AL SR Reducing Splice Plate FExFE",
                bendType: "",
                id: "24108885631763211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Step Down Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "6",
                sizeRange: "6x5x6x4,6x6x6x4,6x6x6x5,6x7x6x4,6x7x6x5,6x7x6x6,9x5x9x4,9x6x9x4,9x6x9x5,9x7x9x4,9x7x9x5,9x7x9x6,12x5x12x4,12x6x12x4,12x6x12x5,12x7x12x4,12x7x12x5,12x7x12x6,18x5x18x4,18x6x18x4,18x6x18x5,18x7x18x4,18x7x18x5,18x7x18x6,24x5x24x4,24x6x24x4,24x6x24x5,24x7x24x4,24x7x24x5,24x7x24x6,30x5x30x4,30x6x30x4,30x6x30x5,30x7x30x4,30x7x30x5,30x7x30x6,36x5x36x4,36x6x36x4,36x6x36x5,36x7x36x4,36x7x36x5,36x7x36x6",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Step Down Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,15",
                dispPosition: "78",
                csvFileName: "cooper B-Line AL Step Down Splice Plate FExFE",
                bendType: "",
                id: "24108854631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Straight Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "7",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Straight Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,15",
                dispPosition: "79",
                csvFileName: "cooper B-Line AL Straight Reducer PExPE",
                bendType: "",
                id: "24108886631763211",
                isClearence: "true"
              }
            ],
            ladderCableTrayUnion: [
              {
                name: "cooper B-Line AL Expansion Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Expansion Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24108853631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Universal Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Universal Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,16",
                dispPosition: "81",
                csvFileName: "",
                bendType: "",
                id: "24108857631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Wedge Lock Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Wedge Lock Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,16",
                dispPosition: "82",
                csvFileName: "",
                bendType: "",
                id: "24108858631763611",
                isClearence: "true"
              }
            ],
            ladderCableTrayMultiPort: [
              {
                name: "cooper B-Line AL Blind End FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "6x4,6x5,6x6,6x7,9x4,9x5,9x6,9x7,12x4,12x5,12x6,12x7,18x4,18x5,18x6,18x7,24x4,24x5,24x6,24x7,30x4,30x5,30x6,30x7,36x4,36x5,36x6,36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Blind End FE.rfa",
                description: "",
                angle: "90",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24108852631766111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Frame Type Box Connector FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Frame Type Box Connector FE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24108855631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Tray To Box Splice Plate FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Tray To Box Splice Plate FE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,15",
                dispPosition: "80",
                csvFileName: "",
                bendType: "",
                id: "24108856631763611",
                isClearence: "true"
              }
            ]
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "6",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "7",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "Trapese Hanger",
                angle: "90",
                connector: "",
                isConnCheck: "",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "8",
                id: "24122208708764011",
                IsHanger: "True",
                supportDiscipline: "cable Tray",
                specId: "134",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "9",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          },
          {
            name: "test",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "ladder BLine Alum Series 25 12 ft x 9 in Rung Spacing",
        unit: "IMPERIAL",
        id: "21",
        InVisibility: "",
        systemShape: "ladder Cable Tray",
        IsHangerNeeded: "True",
        systemUniqueId: "6d2f605f-b479-4f52-a471-3129a8e18526",
        hangerDisabledFor: "",
        isClearence: "true",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: {
              name: "cooper B-Line AL VE1 Sr25 Type09 Lt12Ft Straight Ladder PExPE",
              id: "24108699631860111",
              Length: "12",
              JunctionType: "Tee",
              OldMat: "",
              shape: "ladder Cable Tray",
              sizeRange: "6x5,9x5,12x5,18x5,24x5,30x5,36x5",
              manufacturer: "cooper B-Line",
              path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder straights\\aluminum\\tray\\",
              icon: "cooper B-Line AL VE1 Sr25 Type09 Lt12Ft Straight Ladder PExPE.rfa",
              description: "",
              descriptionType: "",
              connector: "200",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "1",
              duplicateFrom: "ladder Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              isClearence: "true"
            },
            ladderCableTrayElbow: [
              {
                name: "cooper B-Line AL Radius 12 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.786458333333314",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24108804631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.07812499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24108808631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.40624999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24108812631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24108816631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.05208333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "24108805631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.49479166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "24108809631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.98437499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "",
                id: "24108813631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "",
                id: "24108817631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.52083333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3.5",
                displayPosition: "2,8",
                dispPosition: "43",
                csvFileName: "",
                bendType: "",
                id: "24108806631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.11458333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "3,8",
                dispPosition: "44",
                csvFileName: "",
                bendType: "",
                id: "24108810631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.84895833333331",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "4,8",
                dispPosition: "45",
                csvFileName: "",
                bendType: "",
                id: "24108814631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "12",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.74999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "0,9",
                dispPosition: "46",
                csvFileName: "",
                bendType: "",
                id: "24108818631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "13",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.58854166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "3,11",
                dispPosition: "59",
                csvFileName: "",
                bendType: "",
                id: "24108807631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "14",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.32291666666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "4,11",
                dispPosition: "60",
                csvFileName: "",
                bendType: "",
                id: "24108811631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "15",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "3.13541666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "0,12",
                dispPosition: "61",
                csvFileName: "",
                bendType: "",
                id: "24108815631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "16",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "5.24999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "1,12",
                dispPosition: "62",
                csvFileName: "",
                bendType: "",
                id: "24108819631760711",
                isClearence: "true"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "cooper B-Line AL Cable Support Fitting 12 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 12 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.49999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.5",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108861631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 24 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 24 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108862631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 36 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 36 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108863631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 48 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 48 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108864631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.67187499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108820631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.906249999999994",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.583333333333333",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108828631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.11458333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.5",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108836631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.49999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.5",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108844631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.515624999999981",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.583333333333333",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108824631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.66666666666666",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108832631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "0.828124999999985",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108840631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.41666666666659",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108848631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.942708333333312",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.583333333333333",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108821631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.21874999999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108829631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.73958333333332",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108837631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.54166666666657",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108845631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.786458333333334",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.5",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108825631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.07812499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.583333333333333",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108833631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.40624999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.583333333333333",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108841631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.41666666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "1,8",
                dispPosition: "42",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108849631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "21",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.14062499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "0,10",
                dispPosition: "51",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108822631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "22",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.63020833333333",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "1,10",
                dispPosition: "52",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108830631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "23",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.17708333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "2,10",
                dispPosition: "53",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108838631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "24",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.54166666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "3,10",
                dispPosition: "54",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108846631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "25",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.05208333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "4,10",
                dispPosition: "55",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108826631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "26",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.49479166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "0,11",
                dispPosition: "56",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108834631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "27",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.98437499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "1,11",
                dispPosition: "57",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108842631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "28",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.54166666666649",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "2,11",
                dispPosition: "58",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108850631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "29",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.41145833333333",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "1,13",
                dispPosition: "67",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108823631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "30",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.04687499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "2,13",
                dispPosition: "68",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108831631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "31",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.74999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "3,13",
                dispPosition: "69",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108839631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "32",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.41666666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "4,13",
                dispPosition: "70",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108847631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "33",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.32291666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "0,14",
                dispPosition: "71",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108827631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "34",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.90624999999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "1,14",
                dispPosition: "72",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108835631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "35",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.55729166666665",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "2,14",
                dispPosition: "73",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108843631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "36",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.54166666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "3,14",
                dispPosition: "74",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108851631760211",
                isClearence: "true"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "cooper B-Line AL Radius 12 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "",
                id: "24108877631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "",
                id: "24108878631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "4.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "3,9",
                dispPosition: "49",
                csvFileName: "",
                bendType: "",
                id: "24108879631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "5.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "4,12",
                dispPosition: "65",
                csvFileName: "",
                bendType: "",
                id: "24108880631761111",
                isClearence: "true"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "cooper B-Line AL Radius 12 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.75",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24108869631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "0.5",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "24108865631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "0.5",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "24108870631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.75",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "",
                id: "24108871631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "",
                id: "24108866631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "6",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "",
                id: "24108872631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "7",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.75",
                displayPosition: "1,9",
                dispPosition: "47",
                csvFileName: "",
                bendType: "",
                id: "24108873631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "8",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "2,9",
                dispPosition: "48",
                csvFileName: "",
                bendType: "",
                id: "24108867631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "9",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.58333333333334",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "4,9",
                dispPosition: "50",
                csvFileName: "",
                bendType: "",
                id: "24108874631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "10",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.75",
                displayPosition: "2,12",
                dispPosition: "63",
                csvFileName: "",
                bendType: "",
                id: "24108875631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "11",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "5.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "3,12",
                dispPosition: "64",
                csvFileName: "",
                bendType: "",
                id: "24108868631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "12",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "0,13",
                dispPosition: "66",
                csvFileName: "",
                bendType: "",
                id: "24108876631763311",
                isClearence: "true"
              }
            ],
            ladderCableTrayTransition: [
              {
                name: "cooper B-Line AL Left Hand Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "1",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Left Hand Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "cooper B-Line AL Left Hand Reducer PExPE",
                bendType: "",
                id: "24108881631760811",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL LR Offset Red Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "2",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL LR Offset Red Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "cooper B-Line AL LR Offset Red Splice Plate FExFE",
                bendType: "",
                id: "24108882631760811",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Right Hand Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "3",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Right Hand Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,14",
                dispPosition: "75",
                csvFileName: "cooper B-Line AL Right Hand Reducer PExPE",
                bendType: "",
                id: "24108884631760911",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL RR Offset Red Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "4",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL RR Offset Red Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,15",
                dispPosition: "76",
                csvFileName: "cooper B-Line AL RR Offset Red Splice Plate FExFE",
                bendType: "",
                id: "24108883631760911",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL SR Reducing Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "5",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL SR Reducing Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,15",
                dispPosition: "77",
                csvFileName: "cooper B-Line AL SR Reducing Splice Plate FExFE",
                bendType: "",
                id: "24108885631763211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Step Down Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "6",
                sizeRange: "6x5x6x4,6x6x6x4,6x6x6x5,6x7x6x4,6x7x6x5,6x7x6x6,9x5x9x4,9x6x9x4,9x6x9x5,9x7x9x4,9x7x9x5,9x7x9x6,12x5x12x4,12x6x12x4,12x6x12x5,12x7x12x4,12x7x12x5,12x7x12x6,18x5x18x4,18x6x18x4,18x6x18x5,18x7x18x4,18x7x18x5,18x7x18x6,24x5x24x4,24x6x24x4,24x6x24x5,24x7x24x4,24x7x24x5,24x7x24x6,30x5x30x4,30x6x30x4,30x6x30x5,30x7x30x4,30x7x30x5,30x7x30x6,36x5x36x4,36x6x36x4,36x6x36x5,36x7x36x4,36x7x36x5,36x7x36x6",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Step Down Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,15",
                dispPosition: "78",
                csvFileName: "cooper B-Line AL Step Down Splice Plate FExFE",
                bendType: "",
                id: "24108854631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Straight Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "7",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Straight Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,15",
                dispPosition: "79",
                csvFileName: "cooper B-Line AL Straight Reducer PExPE",
                bendType: "",
                id: "24108886631763211",
                isClearence: "true"
              }
            ],
            ladderCableTrayUnion: [
              {
                name: "cooper B-Line AL Expansion Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Expansion Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24108853631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Universal Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Universal Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,16",
                dispPosition: "81",
                csvFileName: "",
                bendType: "",
                id: "24108857631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Wedge Lock Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Wedge Lock Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,16",
                dispPosition: "82",
                csvFileName: "",
                bendType: "",
                id: "24108858631763611",
                isClearence: "true"
              }
            ],
            ladderCableTrayMultiPort: [
              {
                name: "cooper B-Line AL Blind End FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "6x4,6x5,6x6,6x7,9x4,9x5,9x6,9x7,12x4,12x5,12x6,12x7,18x4,18x5,18x6,18x7,24x4,24x5,24x6,24x7,30x4,30x5,30x6,30x7,36x4,36x5,36x6,36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Blind End FE.rfa",
                description: "",
                angle: "90",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24108852631766111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Frame Type Box Connector FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Frame Type Box Connector FE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24108855631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Tray To Box Splice Plate FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Tray To Box Splice Plate FE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,15",
                dispPosition: "80",
                csvFileName: "",
                bendType: "",
                id: "24108856631763611",
                isClearence: "true"
              }
            ]
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "6",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "7",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                isConnCheck: "",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "8",
                id: "24122208708764011",
                IsHanger: "True",
                supportDiscipline: "cable Tray",
                specId: "130",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "ladder BLine Alum Series 26 12 ft x 9 in Rung Spacing",
        unit: "IMPERIAL",
        id: "22",
        InVisibility: "",
        systemShape: "ladder Cable Tray",
        IsHangerNeeded: "True",
        systemUniqueId: "47532a70-1a6f-4c37-b817-c44746f24de0",
        hangerDisabledFor: "",
        isClearence: "true",
        fittings: [
          {
            name: "ladder Cable Tray",
            electricalTypeItems: {
              name: "cooper B-Line AL VE1 Sr26 Type09 Lt12Ft Straight Ladder PExPE",
              id: "24108709631860111",
              Length: "12",
              JunctionType: "Tee",
              OldMat: "",
              shape: "ladder Cable Tray",
              sizeRange: "6x6,9x6,12x6,18x6,24x6,30x6,36x6",
              manufacturer: "cooper B-Line",
              path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder straights\\aluminum\\tray\\",
              icon: "cooper B-Line AL VE1 Sr26 Type09 Lt12Ft Straight Ladder PExPE.rfa",
              description: "",
              descriptionType: "",
              connector: "200",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "1",
              duplicateFrom: "ladder Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              isClearence: "true"
            },
            ladderCableTrayElbow: [
              {
                name: "cooper B-Line AL Radius 12 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.786458333333314",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24108804631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.07812499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "",
                bendType: "",
                id: "24108808631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.40624999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "",
                bendType: "",
                id: "24108812631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "4",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "",
                id: "24108816631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "5",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.05208333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                bendType: "",
                id: "24108805631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "6",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.49479166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                bendType: "",
                id: "24108809631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "7",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.98437499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                bendType: "",
                id: "24108813631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "8",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                bendType: "",
                id: "24108817631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "9",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.52083333333333",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3.5",
                displayPosition: "2,8",
                dispPosition: "43",
                csvFileName: "",
                bendType: "",
                id: "24108806631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "10",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.11458333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "3,8",
                dispPosition: "44",
                csvFileName: "",
                bendType: "",
                id: "24108810631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "11",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.84895833333331",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "4,8",
                dispPosition: "45",
                csvFileName: "",
                bendType: "",
                id: "24108814631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "12",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.74999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "3",
                displayPosition: "0,9",
                dispPosition: "46",
                csvFileName: "",
                bendType: "",
                id: "24108818631760711",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 30 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "13",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 30 HB PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.58854166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "3,11",
                dispPosition: "59",
                csvFileName: "",
                bendType: "",
                id: "24108807631760411",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 45 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "14",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 45 HB PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.32291666666666",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "4,11",
                dispPosition: "60",
                csvFileName: "",
                bendType: "",
                id: "24108811631760511",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 60 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "15",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 60 HB PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "3.13541666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "0,12",
                dispPosition: "61",
                csvFileName: "",
                bendType: "",
                id: "24108815631760611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 90 HB PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayElbow",
                position: "16",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 90 HB PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "5.24999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "2",
                displayPosition: "1,12",
                dispPosition: "62",
                csvFileName: "",
                bendType: "",
                id: "24108819631760711",
                isClearence: "true"
              }
            ],
            ladderCableTrayVerticalElbow: [
              {
                name: "cooper B-Line AL Cable Support Fitting 12 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "12",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 12 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.49999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.5",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108861631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 24 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 24 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108862631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 36 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "4",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 36 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108863631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Cable Support Fitting 48 Radius PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "5",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Cable Support Fitting 48 Radius PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.41666666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.333333333333333",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108864631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "11",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.67187499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108820631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "7",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.906249999999994",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.583333333333333",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108828631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "8",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.11458333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.5",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108836631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.49999999999997",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.5",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108844631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "9",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.515624999999981",
                isConnCheck: "True",
                extraField: "",
                Height: "1.5",
                width: "0.583333333333333",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108824631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "6",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "0.66666666666666",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108832631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "10",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "0.828124999999985",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108840631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "1.41666666666659",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108848631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "13",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.942708333333312",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.583333333333333",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108821631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "14",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.21874999999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108829631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "15",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.73958333333332",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108837631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "16",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.54166666666657",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "2,7",
                dispPosition: "38",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108845631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "17",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "0.786458333333334",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.5",
                displayPosition: "3,7",
                dispPosition: "39",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108825631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "18",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.07812499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.583333333333333",
                displayPosition: "4,7",
                dispPosition: "40",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108833631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "19",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.40624999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.583333333333333",
                displayPosition: "0,8",
                dispPosition: "41",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108841631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "20",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "2.41666666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "1,8",
                dispPosition: "42",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108849631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "21",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.14062499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "0,10",
                dispPosition: "51",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108822631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "22",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.63020833333333",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "1,10",
                dispPosition: "52",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108830631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "23",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.17708333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "2,10",
                dispPosition: "53",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108838631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "24",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.54166666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "3,10",
                dispPosition: "54",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108846631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "25",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.05208333333331",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "4,10",
                dispPosition: "55",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108826631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "26",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.49479166666666",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "0,11",
                dispPosition: "56",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108834631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "27",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "1.98437499999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "1,11",
                dispPosition: "57",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108842631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "28",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "3.54166666666649",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.583333333333333",
                displayPosition: "2,11",
                dispPosition: "58",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108850631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "29",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.41145833333333",
                isConnCheck: "True",
                extraField: "",
                Height: "3.5",
                width: "0.333333333333333",
                displayPosition: "1,13",
                dispPosition: "67",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108823631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "30",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "2.04687499999999",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "2,13",
                dispPosition: "68",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108831631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "31",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.74999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "3,13",
                dispPosition: "69",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108839631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VI 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "32",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VI 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.41666666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "2",
                width: "0.333333333333333",
                displayPosition: "4,13",
                dispPosition: "70",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24108847631760211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 30 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "33",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 30 Bend PExPE.rfa",
                description: "",
                angle: "30",
                connector: "200*200",
                centerRadius: "1.32291666666665",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "0,14",
                dispPosition: "71",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108827631763011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 45 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "34",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 45 Bend PExPE.rfa",
                description: "",
                angle: "45",
                connector: "200*200",
                centerRadius: "1.90624999999999",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "1,14",
                dispPosition: "72",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108835631760311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 60 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "35",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 60 Bend PExPE.rfa",
                description: "",
                angle: "60",
                connector: "200*200",
                centerRadius: "2.55729166666665",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.333333333333333",
                displayPosition: "2,14",
                dispPosition: "73",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108843631763111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 VO 90 Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayVerticalElbow",
                position: "36",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7,42x4x42x4,42x5x42x5,42x6x42x6,42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 VO 90 Bend PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "4.54166666666664",
                isConnCheck: "True",
                extraField: "",
                Height: "3",
                width: "0.583333333333333",
                displayPosition: "3,14",
                dispPosition: "74",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24108851631760211",
                isClearence: "true"
              }
            ],
            ladderCableTrayCross: [
              {
                name: "cooper B-Line AL Radius 12 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "1",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "2.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "",
                bendType: "",
                id: "24108877631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "2",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "3.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                bendType: "",
                id: "24108878631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "3",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "4.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "3,9",
                dispPosition: "49",
                csvFileName: "",
                bendType: "",
                id: "24108879631761111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 HX PExPExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayCross",
                position: "4",
                sizeRange: "6x4x6x4x6x4x6x4,6x5x6x5x6x5x6x5,6x6x6x6x6x6x6x6,6x7x6x7x6x7x6x7,9x4x9x4x9x4x9x4,9x5x9x5x9x5x9x5,9x6x9x6x9x6x9x6,9x7x9x7x9x7x9x7,12x4x12x4x12x4x12x4,12x5x12x5x12x5x12x5,12x6x12x6x12x6x12x6,12x7x12x7x12x7x12x7,18x4x18x4x18x4x18x4,18x5x18x5x18x5x18x5,18x6x18x6x18x6x18x6,18x7x18x7x18x7x18x7,24x4x24x4x24x4x24x4,24x5x24x5x24x5x24x5,24x6x24x6x24x6x24x6,24x7x24x7x24x7x24x7,30x4x30x4x30x4x30x4,30x5x30x5x30x5x30x5,30x6x30x6x30x6x30x6,30x7x30x7x30x7x30x7,36x4x36x4x36x4x36x4,36x5x36x5x36x5x36x5,36x6x36x6x36x6x36x6,36x7x36x7x36x7x36x7,42x4x42x4x42x4x42x4,42x5x42x5x42x5x42x5,42x6x42x6x42x6x42x6,42x7x42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 HX PExPExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200*200",
                centerRadius: "5.24999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.583333333333333",
                width: "2",
                displayPosition: "4,12",
                dispPosition: "65",
                csvFileName: "",
                bendType: "",
                id: "24108880631761111",
                isClearence: "true"
              }
            ],
            ladderCableTrayTee: [
              {
                name: "cooper B-Line AL Radius 12 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "1",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.75",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "",
                id: "24108869631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "2",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "0.5",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "24108865631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 12 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "3",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 12 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "1.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "0.5",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "24108870631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "4",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.75",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                bendType: "",
                id: "24108871631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "5",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                bendType: "",
                id: "24108866631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 24 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "6",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 24 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "2.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                bendType: "",
                id: "24108872631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "7",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.75",
                displayPosition: "1,9",
                dispPosition: "47",
                csvFileName: "",
                bendType: "",
                id: "24108873631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "8",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "2,9",
                dispPosition: "48",
                csvFileName: "",
                bendType: "",
                id: "24108867631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 36 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "9",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 36 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "3.58333333333334",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "4,9",
                dispPosition: "50",
                csvFileName: "",
                bendType: "",
                id: "24108874631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 Exp HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "10",
                sizeRange: "6x4x6x4x9x12,6x4x6x4x12x12,6x4x6x4x18x12,6x4x6x4x24x12,6x4x6x4x30x12,6x4x6x4x36x12,6x4x6x4x42x12,6x5x6x5x9x5,6x5x6x5x12x5,6x5x6x5x18x5,6x5x6x5x24x5,6x5x6x5x30x5,6x5x6x5x36x5,6x5x6x5x42x5,6x6x6x6x9x6,6x6x6x6x12x6,6x6x6x6x18x6,6x6x6x6x24x6,6x6x6x6x30x6,6x6x6x6x36x6,6x6x6x6x42x6,6x7x6x7x9x7,6x7x6x7x12x7,6x7x6x7x18x7,6x7x6x7x24x7,6x7x6x7x30x7,6x7x6x7x36x7,6x7x6x7x42x7,9x4x9x4x12x12,9x4x9x4x18x12,9x4x9x4x24x12,9x4x9x4x30x12,9x4x9x4x36x12,9x4x9x4x42x12,9x5x9x5x12x5,9x5x9x5x18x5,9x5x9x5x24x5,9x5x9x5x30x5,9x5x9x5x36x5,9x5x9x5x42x5,9x6x9x6x12x6,9x6x9x6x18x6,9x6x9x6x24x6,9x6x9x6x30x6,9x6x9x6x36x6,9x6x9x6x42x6,9x7x9x7x12x7,9x7x9x7x18x7,9x7x9x7x24x7,9x7x9x7x30x7,9x7x9x7x36x7,9x7x9x7x42x7,12x4x12x4x18x12,12x4x12x4x24x12,12x4x12x4x30x12,12x4x12x4x36x12,12x4x12x4x42x12,12x5x12x5x18x5,12x5x12x5x24x5,12x5x12x5x30x5,12x5x12x5x36x5,12x5x12x5x42x5,12x6x12x6x18x6,12x6x12x6x24x6,12x6x12x6x30x6,12x6x12x6x36x6,12x6x12x6x42x6,12x7x12x7x18x7,12x7x12x7x24x7,12x7x12x7x30x7,12x7x12x7x36x7,12x7x12x7x42x7,18x4x18x4x24x12,18x4x18x4x30x12,18x4x18x4x36x12,18x4x18x4x42x12,18x5x18x5x24x5,18x5x18x5x30x5,18x5x18x5x36x5,18x5x18x5x42x5,18x6x18x6x24x6,18x6x18x6x30x6,18x6x18x6x36x6,18x6x18x6x42x6,18x7x18x7x24x7,18x7x18x7x30x7,18x7x18x7x36x7,18x7x18x7x42x7,24x4x24x4x30x12,24x4x24x4x36x12,24x4x24x4x42x12,24x5x24x5x30x5,24x5x24x5x36x5,24x5x24x5x42x5,24x6x24x6x30x6,24x6x24x6x36x6,24x6x24x6x42x6,24x7x24x7x30x7,24x7x24x7x36x7,24x7x24x7x42x7,30x4x30x4x36x12,30x4x30x4x42x12,30x5x30x5x36x5,30x5x30x5x42x5,30x6x30x6x36x6,30x6x30x6x42x6,30x7x30x7x36x7,30x7x30x7x42x7,36x4x36x4x42x12,36x5x36x5x42x5,36x6x36x6x42x6,36x7x36x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 Exp HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.5",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.75",
                displayPosition: "2,12",
                dispPosition: "63",
                csvFileName: "",
                bendType: "",
                id: "24108875631763311",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "11",
                sizeRange: "6x4x6x4x6x4,6x5x6x5x6x5,6x6x6x6x6x6,6x7x6x7x6x7,9x4x9x4x9x4,9x5x9x5x9x5,9x6x9x6x9x6,9x7x9x7x9x7,12x4x12x4x12x4,12x5x12x5x12x5,12x6x12x6x12x6,12x7x12x7x12x7,18x4x18x4x18x4,18x5x18x5x18x5,18x6x18x6x18x6,18x7x18x7x18x7,24x4x24x4x24x4,24x5x24x5x24x5,24x6x24x6x24x6,24x7x24x7x24x7,30x4x30x4x30x4,30x5x30x5x30x5,30x6x30x6x30x6,30x7x30x7x30x7,36x4x36x4x36x4,36x5x36x5x36x5,36x6x36x6x36x6,36x7x36x7x36x7,42x4x42x4x42x4,42x5x42x5x42x5,42x6x42x6x42x6,42x7x42x7x42x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "5.25",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "2",
                displayPosition: "3,12",
                dispPosition: "64",
                csvFileName: "",
                bendType: "",
                id: "24108868631761011",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Radius 48 Red HT PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTee",
                position: "12",
                sizeRange: "9x4x9x4x6x4,9x5x9x5x6x5,9x6x9x6x6x6,9x7x9x7x6x7,12x4x12x4x6x4,12x4x12x4x9x4,12x5x12x5x6x5,12x5x12x5x9x5,12x6x12x6x6x6,12x6x12x6x9x6,12x7x12x7x6x7,12x7x12x7x9x7,18x4x18x4x6x4,18x4x18x4x9x4,18x4x18x4x12x4,18x5x18x5x6x5,18x5x18x5x9x5,18x5x18x5x12x5,18x6x18x6x6x6,18x6x18x6x9x6,18x6x18x6x12x6,18x7x18x7x6x7,18x7x18x7x9x7,18x7x18x7x12x7,24x4x24x4x6x4,24x4x24x4x9x4,24x4x24x4x12x4,24x4x24x4x18x4,24x5x24x5x6x5,24x5x24x5x9x5,24x5x24x5x12x5,24x5x24x5x18x5,24x6x24x6x6x6,24x6x24x6x9x6,24x6x24x6x12x6,24x6x24x6x18x6,24x7x24x7x6x7,24x7x24x7x9x7,24x7x24x7x12x7,24x7x24x7x18x7,30x4x30x4x6x4,30x4x30x4x9x4,30x4x30x4x12x4,30x4x30x4x18x4,30x4x30x4x24x4,30x5x30x5x6x5,30x5x30x5x9x5,30x5x30x5x12x5,30x5x30x5x18x5,30x5x30x5x24x5,30x6x30x6x6x6,30x6x30x6x9x6,30x6x30x6x12x6,30x6x30x6x18x6,30x6x30x6x24x6,30x7x30x7x6x7,30x7x30x7x9x7,30x7x30x7x12x7,30x7x30x7x18x7,30x7x30x7x24x7,36x4x36x4x6x4,36x4x36x4x9x4,36x4x36x4x12x4,36x4x36x4x18x4,36x4x36x4x24x4,36x4x36x4x30x4,36x5x36x5x6x5,36x5x36x5x9x5,36x5x36x5x12x5,36x5x36x5x18x5,36x5x36x5x24x5,36x5x36x5x30x5,36x6x36x6x6x6,36x6x36x6x9x6,36x6x36x6x12x6,36x6x36x6x18x6,36x6x36x6x24x6,36x6x36x6x30x6,36x7x36x7x6x7,36x7x36x7x9x7,36x7x36x7x12x7,36x7x36x7x18x7,36x7x36x7x24x7,36x7x36x7x30x7,42x4x42x4x6x4,42x4x42x4x9x4,42x4x42x4x12x4,42x4x42x4x18x4,42x4x42x4x24x4,42x4x42x4x30x4,42x4x42x4x36x4,42x5x42x5x6x5,42x5x42x5x9x5,42x5x42x5x12x5,42x5x42x5x18x5,42x5x42x5x24x5,42x5x42x5x30x5,42x5x42x5x36x5,42x6x42x6x6x6,42x6x42x6x9x6,42x6x42x6x12x6,42x6x42x6x18x6,42x6x42x6x24x6,42x6x42x6x30x6,42x6x42x6x36x6,42x7x42x7x6x7,42x7x42x7x9x7,42x7x42x7x12x7,42x7x42x7x18x7,42x7x42x7x24x7,42x7x42x7x30x7,42x7x42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Radius 48 Red HT PExPExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200*200",
                centerRadius: "4.625",
                isConnCheck: "True",
                extraField: "",
                Height: "0.416666666666667",
                width: "0.5",
                displayPosition: "0,13",
                dispPosition: "66",
                csvFileName: "",
                bendType: "",
                id: "24108876631763311",
                isClearence: "true"
              }
            ],
            ladderCableTrayTransition: [
              {
                name: "cooper B-Line AL Left Hand Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "1",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Left Hand Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "cooper B-Line AL Left Hand Reducer PExPE",
                bendType: "",
                id: "24108881631760811",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL LR Offset Red Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "2",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL LR Offset Red Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "cooper B-Line AL LR Offset Red Splice Plate FExFE",
                bendType: "",
                id: "24108882631760811",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Right Hand Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "3",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Right Hand Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,14",
                dispPosition: "75",
                csvFileName: "cooper B-Line AL Right Hand Reducer PExPE",
                bendType: "",
                id: "24108884631760911",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL RR Offset Red Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "4",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL RR Offset Red Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,15",
                dispPosition: "76",
                csvFileName: "cooper B-Line AL RR Offset Red Splice Plate FExFE",
                bendType: "",
                id: "24108883631760911",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL SR Reducing Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "5",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x6x5,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x6x6,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x6x7,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x6x5,12x5x9x5,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x6x6,12x6x9x6,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x6x7,12x7x9x7,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x6x5,18x5x9x5,18x5x12x5,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x6x6,18x6x9x6,18x6x12x6,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x6x7,18x7x9x7,18x7x12x7,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x4x30x4,24x4x36x4,24x4x42x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x5x30x5,24x5x36x5,24x5x42x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x6x30x6,24x6x36x6,24x6x42x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x4x36x4,30x4x42x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x5x36x5,30x5x42x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x6x36x6,30x6x42x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x4x42x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x5x42x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x6x42x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL SR Reducing Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,15",
                dispPosition: "77",
                csvFileName: "cooper B-Line AL SR Reducing Splice Plate FExFE",
                bendType: "",
                id: "24108885631763211",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Step Down Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "6",
                sizeRange: "6x5x6x4,6x6x6x4,6x6x6x5,6x7x6x4,6x7x6x5,6x7x6x6,9x5x9x4,9x6x9x4,9x6x9x5,9x7x9x4,9x7x9x5,9x7x9x6,12x5x12x4,12x6x12x4,12x6x12x5,12x7x12x4,12x7x12x5,12x7x12x6,18x5x18x4,18x6x18x4,18x6x18x5,18x7x18x4,18x7x18x5,18x7x18x6,24x5x24x4,24x6x24x4,24x6x24x5,24x7x24x4,24x7x24x5,24x7x24x6,30x5x30x4,30x6x30x4,30x6x30x5,30x7x30x4,30x7x30x5,30x7x30x6,36x5x36x4,36x6x36x4,36x6x36x5,36x7x36x4,36x7x36x5,36x7x36x6",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Step Down Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,15",
                dispPosition: "78",
                csvFileName: "cooper B-Line AL Step Down Splice Plate FExFE",
                bendType: "",
                id: "24108854631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Straight Reducer PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayTransition",
                position: "7",
                sizeRange: "6x4x9x4,6x4x12x4,6x4x18x4,6x4x24x4,6x4x30x4,6x4x36x4,6x4x42x4,6x5x9x5,6x5x12x5,6x5x18x5,6x5x24x5,6x5x30x5,6x5x36x5,6x5x42x5,6x6x9x6,6x6x12x6,6x6x18x6,6x6x24x6,6x6x30x6,6x6x36x6,6x6x42x6,6x7x9x7,6x7x12x7,6x7x18x7,6x7x24x7,6x7x30x7,6x7x36x7,6x7x42x7,9x4x6x4,9x5x6x5,9x6x6x6,9x7x6x7,9x4x12x4,9x4x18x4,9x4x24x4,9x4x30x4,9x4x36x4,9x4x42x4,9x5x12x5,9x5x18x5,9x5x24x5,9x5x30x5,9x5x36x5,9x5x42x5,9x6x12x6,9x6x18x6,9x6x24x6,9x6x30x6,9x6x36x6,9x6x42x6,9x7x12x7,9x7x18x7,9x7x24x7,9x7x30x7,9x7x36x7,9x7x42x7,12x4x6x4,12x4x9x4,12x5x6x5,12x5x9x5,12x6x6x6,12x6x9x6,12x7x6x7,12x7x9x7,12x4x18x4,12x4x24x4,12x4x30x4,12x4x36x4,12x4x42x4,12x5x18x5,12x5x24x5,12x5x30x5,12x5x36x5,12x5x42x5,12x6x18x6,12x6x24x6,12x6x30x6,12x6x36x6,12x6x42x6,12x7x18x7,12x7x24x7,12x7x30x7,12x7x36x7,12x7x42x7,18x4x6x4,18x4x9x4,18x4x12x4,18x5x6x5,18x5x9x5,18x5x12x5,18x6x6x6,18x6x9x6,18x6x12x6,18x7x6x7,18x7x9x7,18x7x12x7,18x4x24x4,18x4x30x4,18x4x36x4,18x4x42x4,18x5x24x5,18x5x30x5,18x5x36x5,18x5x42x5,18x6x24x6,18x6x30x6,18x6x36x6,18x6x42x6,18x7x24x7,18x7x30x7,18x7x36x7,18x7x42x7,24x4x6x4,24x4x9x4,24x4x12x4,24x4x18x4,24x5x6x5,24x5x9x5,24x5x12x5,24x5x18x5,24x6x6x6,24x6x9x6,24x6x12x6,24x6x18x6,24x7x6x7,24x7x9x7,24x7x12x7,24x7x18x7,24x4x30x4,24x4x36x4,24x4x42x4,24x5x30x5,24x5x36x5,24x5x42x5,24x6x30x6,24x6x36x6,24x6x42x6,24x7x30x7,24x7x36x7,24x7x42x7,30x4x6x4,30x4x9x4,30x4x12x4,30x4x18x4,30x4x24x4,30x5x6x5,30x5x9x5,30x5x12x5,30x5x18x5,30x5x24x5,30x6x6x6,30x6x9x6,30x6x12x6,30x6x18x6,30x6x24x6,30x7x6x7,30x7x9x7,30x7x12x7,30x7x18x7,30x7x24x7,30x4x36x4,30x4x42x4,30x5x36x5,30x5x42x5,30x6x36x6,30x6x42x6,30x7x36x7,30x7x42x7,36x4x6x4,36x4x9x4,36x4x12x4,36x4x18x4,36x4x24x4,36x4x30x4,36x5x6x5,36x5x9x5,36x5x12x5,36x5x18x5,36x5x24x5,36x5x30x5,36x6x6x6,36x6x9x6,36x6x12x6,36x6x18x6,36x6x24x6,36x6x30x6,36x7x6x7,36x7x9x7,36x7x12x7,36x7x18x7,36x7x24x7,36x7x30x7,36x4x42x4,36x5x42x5,36x6x42x6,36x7x42x7,42x4x6x4,42x4x9x4,42x4x12x4,42x4x18x4,42x4x24x4,42x4x30x4,42x4x36x4,42x5x6x5,42x5x9x5,42x5x12x5,42x5x18x5,42x5x24x5,42x5x30x5,42x5x36x5,42x6x6x6,42x6x9x6,42x6x12x6,42x6x18x6,42x6x24x6,42x6x30x6,42x6x36x6,42x7x6x7,42x7x9x7,42x7x12x7,42x7x18x7,42x7x24x7,42x7x30x7,42x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Straight Reducer PExPE.rfa",
                description: "",
                angle: "90",
                connector: "200*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,15",
                dispPosition: "79",
                csvFileName: "cooper B-Line AL Straight Reducer PExPE",
                bendType: "",
                id: "24108886631763211",
                isClearence: "true"
              }
            ],
            ladderCableTrayUnion: [
              {
                name: "cooper B-Line AL Expansion Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "1",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Expansion Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24108853631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Universal Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Universal Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,16",
                dispPosition: "81",
                csvFileName: "",
                bendType: "",
                id: "24108857631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Wedge Lock Splice Plate FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayUnion",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Wedge Lock Splice Plate FExFE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,16",
                dispPosition: "82",
                csvFileName: "",
                bendType: "",
                id: "24108858631763611",
                isClearence: "true"
              }
            ],
            ladderCableTrayMultiPort: [
              {
                name: "cooper B-Line AL Blind End FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "1",
                sizeRange: "6x4,6x5,6x6,6x7,9x4,9x5,9x6,9x7,12x4,12x5,12x6,12x7,18x4,18x5,18x6,18x7,24x4,24x5,24x6,24x7,30x4,30x5,30x6,30x7,36x4,36x5,36x6,36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Blind End FE.rfa",
                description: "",
                angle: "90",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24108852631766111",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Frame Type Box Connector FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "2",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Frame Type Box Connector FE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24108855631763611",
                isClearence: "true"
              },
              {
                name: "cooper B-Line AL Tray To Box Splice Plate FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "ladderCableTrayMultiPort",
                position: "3",
                sizeRange: "6x4x6x4,6x5x6x5,6x6x6x6,6x7x6x7,9x4x9x4,9x5x9x5,9x6x9x6,9x7x9x7,12x4x12x4,12x5x12x5,12x6x12x6,12x7x12x7,18x4x18x4,18x5x18x5,18x6x18x6,18x7x18x7,24x4x24x4,24x5x24x5,24x6x24x6,24x7x24x7,30x4x30x4,30x5x30x5,30x6x30x6,30x7x30x7,36x4x36x4,36x5x36x5,36x6x36x6,36x7x36x7",
                manufacturer: "cooper B-Line",
                shape: "ladder Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\cooper b-line\\al cable ladder ftgs\\aluminum\\tray\\",
                icon: "cooper B-Line AL Tray To Box Splice Plate FE.rfa",
                description: "",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,15",
                dispPosition: "80",
                csvFileName: "",
                bendType: "",
                id: "24108856631763611",
                isClearence: "true"
              }
            ]
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                isConnCheck: "",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                id: "24122208708764011",
                IsHanger: "True",
                supportDiscipline: "cable Tray",
                specId: "25",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "rMC Galv Allied Threaded with bends - Wirefill",
        unit: "IMPERIAL",
        id: "11",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        IsHangerNeeded: "False",
        systemUniqueId: "a7690a94-e583-44ac-9d57-2a6b44463b22",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "Allied EG Galv Steel GRC Rigid Conduit MPTxMPT",
              id: "2474720480358611",
              Length: "10",
              JunctionType: "Tee",
              material: "Allied EG Galv Steel RMC",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,5,6",
              manufacturer: "Allied EG",
              path: "\\imperial\\conduit\\allied eg\\e_galv-stl rmc conduit thrd\\galvanized steel\\rmc\\",
              icon: "Allied EG Galv Steel GRC Rigid Conduit MPTxMPT.rfa",
              description: "",
              descriptionType: "",
              connector: "100",
              extraField: "False",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
              BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5,0,0",
              LeadLength: "2,2,2,2,2,2,2.5,2.5,2.5,2.5,0,0",
              TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0,0,0",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Allied EG GS Galvanized Rigid Steel Conduit Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5*,6x6*",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl rmc conduit ftgs thrd\\galvanized steel\\rmc\\",
                icon: "Allied EG GS Galvanized Rigid Steel Conduit Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*100",
                centerRadius: "0.708333333333333",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG GS Galvanized Rigid Steel Conduit Bend MPTxMPT",
                id: "24129618480970311",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "8,10,13",
                LeadOutLength: "103.45879,98.12085,90.75208",
                TakeUp: "6,8,11",
                id: "24235026928858411",
                isClearence: "false",
                OffsetType: "stub Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "9.5,11,13,16,16.25,18.125,24,26.75,30.75,35",
                LeadOutLength: "103.824116,100.458795,96.1026,90.255532,90.79093,87.737833,74.165931,67.363277,59.122126,51.227879",
                TakeUp: "7.5,9,11,14,14.25,16.125,21.5,24.25,28.25,32.5",
                id: "24235027928858411",
                isClearence: "false",
                OffsetType: "stub Machine Bend"
              }
            ],
            transition: {
              addDefaultItem: {
                name: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "Transition",
                position: "2",
                sizeRange: "0.5x0.375,0.75x0.5,1x0.5,1x0.75,1.25x0.5,1.25x0.75,1.25x1,1.5x0.5,1.5x0.75,1.5x1,1.5x1.25,2x0.5,2x0.75,2x1,2x1.25,2x1.5",
                manufacturer: "rACO",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\raco\\e_galv-stl grc conduit ftgs thrd\\galvanized steel\\grc\\",
                icon: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT",
                id: "24158161942659911",
                isClearence: "false"
              }
            },
            cap: [],
            union: [
              {
                name: "Allied EG Galv Steel RMC Coupling FPTxFPT",
                defaultFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl rmc conduit ftgs thrd\\galvanized steel\\rmc\\",
                icon: "Allied EG Galv Steel RMC Coupling FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG Galv Steel RMC Coupling FPTxFPT",
                id: "2474733480958711",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT",
                id: "24129825738659511",
                isClearence: "false"
              },
              {
                name: "Allied EG Galv Steel EMT Coupling CExCE",
                defaultFor: "",
                fittingType: "union",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                guid: "21618712-dfdc-4687-b1bd-732ea1295c38",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs cp\\galvanized steel\\emt\\",
                icon: "Allied EG Galv Steel EMT Coupling CExCE.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "Allied EG Galv Steel EMT Coupling CExCE",
                id: "2474729480758711",
                isClearence: "false"
              }
            ],
            multiPort: [
              {
                name: "crouse Hinds Galv CS UNF-5 Union FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "2",
                sizeRange: "0.5x0.5,0.5x0.75,0.75x0.75,1x1",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\galv-cs conduit ftgs thrd\\galvanized steel\\mc\\",
                icon: "crouse Hinds Galv CS UNF-5 Union FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "crouse Hinds Galv CS UNF-5 Union FPTxFPT",
                id: "24129960738571011",
                isClearence: "false"
              },
              {
                name: "crouse Hinds Galv CS UNY-5 Union MPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.5,0.75x0.75,1x1",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\galv-cs conduit ftgs thrd\\galvanized steel\\mc\\",
                icon: "crouse Hinds Galv CS UNY-5 Union MPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "crouse Hinds Galv CS UNY-5 Union MPTxFPT",
                id: "24129961738571111",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24225278928870311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24225279928870311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24225280928870311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "7",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24225281928870311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "8",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24231617928870311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "9",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24231618928870311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "10",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                guid: "d6006cca-e43c-4d1c-bb03-077c1bcd48cb",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252761038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              }
            ],
            junctionBoxTee: {
              addDefaultItem: {
                name: "crouse-Hinds MI Form 5 Type T Conduit Outlet Body FPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxTee",
                position: "1",
                sizeRange: "0.5x0.5x0.5,0.75x0.75x0.75,1x1x1,1.25x1.25x1.25,1.5x1.5x1.5,2x2x2,2.5x2.5x2.5,3x3x3,3.5x3.5x3.5,4x4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type T Conduit Outlet Body FPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101",
                centerRadius: "0.153335416666656",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "crouse-Hinds MI Form 5 Type T Conduit Outlet Body FPTxFPTxFPT",
                id: "24129819738659611",
                isClearence: "false"
              }
            },
            junctionBoxCross: {
              addDefaultItem: {
                name: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxCross",
                position: "1",
                sizeRange: "0.5x0.5x0.5x0.5,0.75x0.75x0.75x0.75,1x1x1x1,1.25x1.25x1.25x1.25,1.5x1.5x1.5x1.5,2x2x2x2",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101*101",
                centerRadius: "0.161958333333322",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT",
                id: "24129816738670611",
                isClearence: "false"
              }
            },
            junctionBoxElbow: [
              {
                name: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "1.05000000000001",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT",
                id: "24129826738659511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0.89479166666667",
                diameter: "0.208333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT",
                id: "24129827738659511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "1.02083333333334",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT",
                id: "24129828738659511",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: []
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "12x12",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "Trapeze Hanger",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "2",
                csvFileName: "",
                id: "24120904704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                specId: "131",
                isClearence: "false"
              },
              {
                name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "24x24",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "3",
                csvFileName: "",
                id: "24120907704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "6",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "7",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "8",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "9",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "10",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "10",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "11",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "11",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "12",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Floor Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "12",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Floor Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "13",
                csvFileName: "site Survey Work CS STD Pipe Floor Sleeve",
                id: "2413161446847611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Wall Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "13",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std wall sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Wall Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "14",
                csvFileName: "site Survey Work CS STD Pipe Wall Sleeve",
                id: "2413161657637611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "eMT Galv Allied Compression - Wirefill",
        unit: "IMPERIAL",
        id: "9",
        systemShape: "FieldFabConduit",
        IsHangerNeeded: "True",
        systemUniqueId: "794c3f7a-a208-4191-b8a6-a1b3b20f2ede",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE",
              id: "2474706480158611",
              Length: "10",
              JunctionType: "Tee",
              material: "Allied EG Galv Steel EMT",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4",
              manufacturer: "Allied EG",
              path: "\\imperial\\conduit\\allied eg\\e_galv-stl emt conduit pe\\galvanized steel\\emt\\",
              icon: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE.rfa",
              description: "",
              descriptionType: "Allied EMT",
              connector: "102",
              extraField: "False",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
              BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
              LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
              TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs pe\\galvanized steel\\emt\\",
                icon: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.666666666666725",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE",
                id: "24129608737770311",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "7,8,10",
                LeadOutLength: "105.83324,103.45879,98.12085",
                TakeUp: "5,6,8",
                id: "242350241038758411",
                isClearence: "false",
                OffsetType: "stub Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "9,10.875,12.75,15.125,15.875,17.375,24,27,31.25,36.25",
                LeadOutLength: "104.22594,100.48562,96.25443,91.03236,90.96958,88.09513,74.16593,67.11328,58.62213,49.97788",
                TakeUp: "7,8.875,10.75,13.125,13.875,15.375,21.5,24,27.75,32.25",
                id: "242350251038758411",
                isClearence: "false",
                OffsetType: "stub Machine Bend"
              }
            ],
            transition: [],
            union: {
              addDefaultItem: {
                name: "Allied EG Galv Steel EMT Coupling CExCE",
                defaultFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs cp\\galvanized steel\\emt\\",
                icon: "Allied EG Galv Steel EMT Coupling CExCE.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG Galv Steel EMT Coupling CExCE",
                id: "2474729480758711",
                isClearence: "false"
              }
            },
            multiPort: [
              {
                name: "Appleton Galv-CS 7000US EMT Connector Face Based CE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Appleton",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\appleton\\cs-galv connector ftgs compression\\galvanized steel\\emt\\",
                icon: "Appleton Galv-CS 7000US EMT Connector Face Based CE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "24194167768159911",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252741038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252751038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252761038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252771038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "7",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242316151038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "8",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242316161038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Machine Bend"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: {
              addDefaultItem: {
                name: "sysQue Concrete Pad",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "8061a9e0-7d22-4f4a-b1a9-2fa23be5e2c9",
                addedWireLength: "0",
                category: "Generic Models",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Concrete Pad.rfa",
                connector: "",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                userCustomFamilyID: "6852",
                isClearence: "false"
              }
            },
            junctionBox: {
              addDefaultItem: {
                name: "sysQue Hinged Cover Junction Box",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "Hoffman",
                model: "xx",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "8d410d45-8618-433f-939d-a088972a93b7",
                addedWireLength: "1",
                category: "electrical Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Hinged Cover Junction Box.rfa",
                connector: "",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                userCustomFamilyID: "6853",
                isClearence: "false"
              }
            },
            panelBoard: {
              addDefaultItem: {
                name: "sysQue Panelboard Face Based",
                defaultFor: "",
                disableFor: "",
                fittingType: "panelBoard",
                position: "1",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "4c24435a-03f1-472b-a5c2-16d3c9381401",
                addedWireLength: "5",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Panelboard Face Based.rfa",
                connector: "109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                userCustomFamilyID: "6854",
                isClearence: "false"
              }
            },
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: {
              addDefaultItem: {
                name: "rACO 779CUS 4 Inch Square Mud Ring Device Cover",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\galvstl square junction boxes\\galvanized steel\\rmc\\",
                icon: "rACO 779CUS 4 Inch Square Mud Ring Device Cover.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "24203860636178811",
                JBoxType: "Hosted",
                isClearence: "false"
              }
            }
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "6",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "7",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "8",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "9",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "10",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "10",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "11",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "11",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Floor Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "12",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Floor Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "12",
                csvFileName: "site Survey Work CS STD Pipe Floor Sleeve",
                id: "2413161446847611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Wall Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "13",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std wall sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Wall Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "13",
                csvFileName: "site Survey Work CS STD Pipe Wall Sleeve",
                id: "2413161657637611",
                isClearence: "false"
              },
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                disableFor: "",
                fittingType: "normal",
                position: "14",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                isConnCheck: "",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "14",
                id: "24120904704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                specId: "128",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "eMT Galv Allied Set Screw - Wirefill",
        unit: "IMPERIAL",
        id: "10",
        systemShape: "FieldFabConduit",
        systemUniqueId: "ed71707c-3c86-44d6-ab06-1e8042520660",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE",
              id: "2474706480158611",
              Length: "10",
              JunctionType: "Tee",
              material: "Allied EG Galv Steel EMT",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4",
              manufacturer: "Allied EG",
              path: "\\imperial\\conduit\\allied eg\\e_galv-stl emt conduit pe\\galvanized steel\\emt\\",
              icon: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE.rfa",
              description: "",
              descriptionType: "",
              connector: "102",
              extraField: "False",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
              BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
              LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
              TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs pe\\galvanized steel\\emt\\",
                icon: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.666666666666626",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE",
                id: "24129608737770311",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "7,8,10",
                LeadOutLength: "105.83324,103.45879,98.12085",
                TakeUp: "5,6,8",
                id: "242350241038758411",
                isClearence: "false",
                OffsetType: "stub Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "9,10.875,12.75,15.125,15.875,17.375,24,27,31.25,36.25",
                LeadOutLength: "104.22594,100.48562,96.25443,91.03236,90.96958,88.09513,74.16593,67.11328,58.62213,49.97788",
                TakeUp: "7,8.875,10.75,13.125,13.875,15.375,21.5,24,27.75,32.25",
                id: "242350251038758411",
                isClearence: "false",
                OffsetType: "stub Machine Bend"
              }
            ],
            union: {
              addDefaultItem: {
                name: "raco CS EMT Coupling SetScrewxSetScrew",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "rACO",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\raco\\e_cs emt electrical ftgs ss\\carbon steel\\emt\\",
                icon: "raco CS EMT Coupling SetScrewxSetScrew.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "raco CS EMT Coupling SetScrewxSetScrew",
                id: "24166747989758711",
                isClearence: "false"
              }
            },
            multiPort: [
              {
                name: "Appleton Galv-CS 4000US EMT Connector SS",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Appleton",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\appleton\\cs-galv connector ftgs set-screw\\galvanized steel\\emt\\",
                icon: "Appleton Galv-CS 4000US EMT Connector SS.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "24134725768258711",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252741038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252751038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252761038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252771038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242316151038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "7",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242316161038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Machine Bend"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: {
              addDefaultItem: {
                name: "sysQue Panelboard Face Based",
                disableFor: "",
                fittingType: "panelBoard",
                sizeRange: "",
                manufacturer: ".",
                model: ".",
                nominalSize: ".",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "dc0443f7-cd01-4aff-9876-c1fce700c1fa",
                addedWireLength: "5",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Panelboard Face Based.rfa",
                connector: "100*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                userCustomFamilyID: "6855",
                isClearence: "false"
              }
            },
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: [
              {
                name: "crouse-Hinds Steel TP395 Square Two Device Box E_KO-F_FB",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "crouse-Hinds",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\crouse-hinds\\fb_galvstl square junction boxes\\galvanized steel\\mc\\",
                icon: "crouse-Hinds Steel TP395 Square Two Device Box E_KO-F_FB.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "241950101127174511",
                JBoxType: "Hosted",
                isClearence: "false"
              },
              {
                name: "rACO Galv-Stl 189 Square Box FKO",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "2",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\galvstl square junction boxes\\galvanized steel\\rmc\\",
                icon: "rACO Galv-Stl 189 Square Box FKO.rfa",
                description: "",
                descriptionType: "189 SQ BX",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "24195478636174511",
                JBoxType: "Non-Hosted",
                isClearence: "false"
              }
            ]
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "12x12",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "2",
                csvFileName: "",
                id: "24120904704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "24x24",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "3",
                csvFileName: "",
                id: "24120907704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "6",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "7",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "8",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "9",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "10",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "10",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "11",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "11",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "12",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Floor Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "12",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Floor Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "13",
                csvFileName: "site Survey Work CS STD Pipe Floor Sleeve",
                id: "2413161446847611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Wall Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "13",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std wall sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Wall Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "14",
                csvFileName: "site Survey Work CS STD Pipe Wall Sleeve",
                id: "2413161657637611",
                isClearence: "false"
              },
              {
                name: "p3300T-GR UniStrut Conduit Hanger 7_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "14",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p3300T-GR UniStrut Conduit Hanger 7_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "15",
                csvFileName: "",
                id: "24120909704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "USTRT P3301T-PG Dbl UniStrut Conduit Hanger 7_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "15",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "USTRT P3301T-PG Dbl UniStrut Conduit Hanger 7_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "16",
                csvFileName: "",
                id: "24120912704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "rMC Galv Allied Threaded with bends - Panel/Circuit",
        unit: "IMPERIAL",
        id: "8",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        systemUniqueId: "06a433e1-6897-46cf-95a2-7c2d221ea23b",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "Allied EG Galv Steel GRC Rigid Conduit MPTxMPT",
              id: "2474720480358611",
              Length: "10",
              JunctionType: "Tee",
              material: "Allied EG Galv Steel RMC",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,5*,6*",
              manufacturer: "Allied EG",
              path: "\\imperial\\conduit\\allied eg\\e_galv-stl rmc conduit thrd\\galvanized steel\\rmc\\",
              icon: "Allied EG Galv Steel GRC Rigid Conduit MPTxMPT.rfa",
              description: "",
              descriptionType: "rMC",
              connector: "100",
              extraField: "True",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
              BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5,0*,0*",
              LeadLength: "2,2,2,2,2,2,2.5,2.5,2.5,2.5,0*,0*",
              TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0,0*,0*",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Allied EG GS Galvanized Rigid Steel Conduit Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "8",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl rmc conduit ftgs thrd\\galvanized steel\\rmc\\",
                icon: "Allied EG GS Galvanized Rigid Steel Conduit Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*100",
                centerRadius: "0.708333333333333",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG GS Galvanized Rigid Steel Conduit Bend MPTxMPT",
                id: "24129618480970311",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "8,10,13",
                LeadOutLength: "103.45879,98.12085,90.75208",
                TakeUp: "6,8,11",
                id: "24235026928858411",
                isClearence: "false",
                OffsetType: "stub Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "9.5,11,13,16,16.25,18.125,24,26.75,30.75,35",
                LeadOutLength: "103.824116,100.458795,96.1026,90.255532,90.79093,87.737833,74.165931,67.363277,59.122126,51.227879",
                TakeUp: "7.5,9,11,14,14.25,16.125,21.5,24.25,28.25,32.5",
                id: "24235027928858411",
                isClearence: "false",
                OffsetType: "stub Machine Bend"
              },
              {
                name: "Allied EG GS True Color Black EMT Conduit Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs pe\\galvanized steel\\emt",
                icon: "Allied EG GS True Color Black EMT Conduit Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.666666666666697",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,4",
                dispPosition: "24",
                csvFileName: "Allied EG GS True Color Black EMT Conduit Bend PExPE",
                id: "24129609737770311",
                isClearence: "false"
              }
            ],
            transition: {
              addDefaultItem: {
                name: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "Transition",
                position: "1",
                sizeRange: "0.5x0.375,0.75x0.5,1x0.5,1x0.75,1.25x0.5,1.25x0.75,1.25x1,1.5x0.5,1.5x0.75,1.5x1,1.5x1.25,2x0.5,2x0.75,2x1,2x1.25,2x1.5",
                manufacturer: "rACO",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\raco\\e_galv-stl grc conduit ftgs thrd\\galvanized steel\\grc\\",
                icon: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT",
                id: "24158161942659911",
                isClearence: "false"
              }
            },
            cap: [],
            union: [
              {
                name: "Allied EG Galv Steel RMC Coupling FPTxFPT",
                defaultFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl rmc conduit ftgs thrd\\galvanized steel\\rmc\\",
                icon: "Allied EG Galv Steel RMC Coupling FPTxFPT.rfa",
                description: "",
                descriptionType: "rMC Coupling",
                angle: "",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG Galv Steel RMC Coupling FPTxFPT",
                id: "2474733480958711",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT",
                id: "24129825738659511",
                isClearence: "false"
              },
              {
                name: "T&B CS UNF-W Conduit Union FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Thomas And Betts",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\thomas & betts\\ocal_cs conduit ftgs thrd\\carbon steel\\rmc\\",
                icon: "T&B CS UNF-W Conduit Union FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "T&B CS UNF-W Conduit Union FPTxFPT",
                id: "24160658954971011",
                isClearence: "false"
              }
            ],
            multiPort: [
              {
                name: "crouse Hinds Galv CS UNF-5 Union FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "2",
                sizeRange: "0.5x0.5,0.5x0.75,0.75x0.75,1x1",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\galv-cs conduit ftgs thrd\\galvanized steel\\mc\\",
                icon: "crouse Hinds Galv CS UNF-5 Union FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "crouse Hinds Galv CS UNF-5 Union FPTxFPT",
                id: "24129960738571011",
                isClearence: "false"
              },
              {
                name: "crouse Hinds Galv CS UNY-5 Union MPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.5,0.75x0.75,1x1",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\galv-cs conduit ftgs thrd\\galvanized steel\\mc\\",
                icon: "crouse Hinds Galv CS UNY-5 Union MPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "crouse Hinds Galv CS UNY-5 Union MPTxFPT",
                id: "24129961738571111",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24225278928870311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24225279928870311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24225280928870311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "7",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24225281928870311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "8",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24231617928870311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "9",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24231618928870311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Machine Bend"
              },
              {
                name: "Appleton Galv-CS 4000US EMT Connector SS",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "10",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Appleton",
                guid: "12863a3d-bddf-494f-b005-cd6c97a230b1",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\appleton\\cs-galv connector ftgs set-screw\\galvanized steel\\emt\\",
                icon: "Appleton Galv-CS 4000US EMT Connector SS.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                id: "24134725768258711",
                isClearence: "false"
              }
            ],
            junctionBoxTee: {
              addDefaultItem: {
                name: "crouse-Hinds MI Form 5 Type T Conduit Outlet Body FPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxTee",
                position: "1",
                sizeRange: "0.5x0.5x0.5,0.75x0.75x0.75,1x1x1,1.25x1.25x1.25,1.5x1.5x1.5,2x2x2,2.5x2.5x2.5,3x3x3,3.5x3.5x3.5,4x4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type T Conduit Outlet Body FPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101",
                centerRadius: "0.153335416666656",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "crouse-Hinds MI Form 5 Type T Conduit Outlet Body FPTxFPTxFPT",
                id: "24129819738659611",
                isClearence: "false"
              }
            },
            junctionBoxCross: {
              addDefaultItem: {
                name: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxCross",
                position: "1",
                sizeRange: "0.5x0.5x0.5x0.5,0.75x0.75x0.75x0.75,1x1x1x1,1.25x1.25x1.25x1.25,1.5x1.5x1.5x1.5,2x2x2x2",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101*101",
                centerRadius: "0.161958333333322",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT",
                id: "24129816738670611",
                isClearence: "false"
              }
            },
            junctionBoxElbow: [
              {
                name: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "1.05000000000001",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT",
                id: "24129826738659511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0.89479166666667",
                diameter: "0.208333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT",
                id: "24129827738659511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "1.02083333333334",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT",
                id: "24129828738659511",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: {
              addDefaultItem: {
                name: "sysQue Panelboard Face Based",
                disableFor: "",
                fittingType: "panelBoard",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "x",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "0737a65b-78ee-4617-b23c-13149601b3ac",
                addedWireLength: "5",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Panelboard Face Based.rfa",
                connector: "100*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                userCustomFamilyID: "6856",
                isClearence: "false"
              }
            },
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: []
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "6",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "7",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "8",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "9",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "10",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "10",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "11",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "11",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "12",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Floor Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "12",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Floor Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "13",
                csvFileName: "site Survey Work CS STD Pipe Floor Sleeve",
                id: "2413161446847611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Wall Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "13",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std wall sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Wall Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "14",
                csvFileName: "site Survey Work CS STD Pipe Wall Sleeve",
                id: "2413161657637611",
                isClearence: "false"
              },
              {
                name: "p3300T-GR UniStrut Conduit Hanger 7_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "14",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support",
                icon: "p3300T-GR UniStrut Conduit Hanger 7_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "15",
                csvFileName: "",
                id: "24120909704164011",
                isClearence: "false"
              },
              {
                name: "p3300T-GR UniStrut Conduit Hanger 7_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "15",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support",
                icon: "p3300T-GR UniStrut Conduit Hanger 7_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "16",
                csvFileName: "",
                id: "24120909704164011",
                isClearence: "false"
              },
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "16",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "17",
                csvFileName: "",
                id: "24120904704164011",
                isClearence: "false"
              },
              {
                name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "17",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support",
                icon: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "18",
                csvFileName: "",
                id: "24120907704164011",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "pVC Sch80 Allied with fittings - Panel/Circuit",
        unit: "IMPERIAL",
        id: "7",
        InVisibility: "",
        systemShape: "conduit",
        IsHangerNeeded: "True",
        systemUniqueId: "d149a8fb-9e7a-404e-bbe6-a04a5ece73e5",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "conduit",
            electricalTypeItems: {
              name: "Allied EG PVC Sch80 Rigid Conduit PExBELL",
              id: "2474727480658611",
              Length: "10",
              JunctionType: "Tee",
              material: "Allied EG PVC Sch80",
              OldMat: "",
              shape: "conduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5*,4,5,6",
              manufacturer: "Allied EG",
              path: "\\imperial\\conduit\\allied eg\\e_pvc sch80 rigid conduit solvent\\pvc\\sch80\\",
              icon: "Allied EG PVC Sch80 Rigid Conduit PExPE.RFA",
              description: "",
              descriptionType: "",
              connector: "104*105",
              extraField: "True",
              displayPosition: "0,0",
              dispPosition: "1",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "330",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Allied EG PVC Sch80 90 Deg Elbow Std Radius PExPE",
                defaultFor: "",
                fittingType: "elbow",
                position: "18",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 90 Deg Elbow Std Radius PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "104*104",
                centerRadius: "2.81166666666666",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG PVC Sch80 90 Deg Elbow Std Radius PExPE",
                id: "2474702479958411",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 45 Deg Elbow Std Radius PExPE",
                defaultFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 45 Deg Elbow Std Radius PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "45",
                connector: "104*104",
                centerRadius: "0.612436867076458",
                diameter: "0.208333333333333",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "Allied EG PVC Sch80 45 Deg Elbow Std Radius PExPE",
                id: "2474697479958511",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 30 Deg Elbow Std Radius PExPE",
                defaultFor: "",
                fittingType: "elbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 30 Deg Elbow Std Radius PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "30",
                connector: "104*104",
                centerRadius: "0.982372981077807",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "Allied EG PVC Sch80 30 Deg Elbow Std Radius PExPE",
                id: "2474692479958911",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC 5 Deg Coupling PExPE",
                defaultFor: "",
                fittingType: "elbow",
                position: "4",
                sizeRange: "2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC 5 Deg Coupling PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "5",
                connector: "104*104",
                centerRadius: "0.471259299139102",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "Allied EG PVC 5 Deg Coupling PExPE",
                id: "2474762481158711",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 22_5 Deg Elbow Spl Radius 18 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "5",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 22_5 Deg Elbow Spl Radius 18 PExPE.rfa",
                description: "",
                angle: "22.5",
                connector: "104*104",
                centerRadius: "0.558785217736154",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "",
                id: "2474684479958811",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 22_5 Deg Elbow Spl Radius 24 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "6",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 22_5 Deg Elbow Spl Radius 24 PExPE.rfa",
                description: "",
                angle: "22.5",
                connector: "104*104",
                centerRadius: "0.679074734759316",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "",
                id: "2474685479958811",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 22_5 Deg Elbow Spl Radius 30 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "7",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 22_5 Deg Elbow Spl Radius 30 PExPE.rfa",
                description: "",
                angle: "22.5",
                connector: "104*104",
                centerRadius: "0.809780918449145",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,4",
                dispPosition: "24",
                csvFileName: "",
                id: "2474686479958811",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 22_5 Deg Elbow Spl Radius 36 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "8",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 22_5 Deg Elbow Spl Radius 36 PExPE.rfa",
                description: "",
                angle: "22.5",
                connector: "104*104",
                centerRadius: "0.909237102138974",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,4",
                dispPosition: "25",
                csvFileName: "",
                id: "2474687479958811",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 30 Deg Elbow Spl Radius 18 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "9",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 30 Deg Elbow Spl Radius 18 PExPE.rfa",
                description: "",
                angle: "30",
                connector: "104*104",
                centerRadius: "0.662340455313351",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,5",
                dispPosition: "26",
                csvFileName: "",
                id: "2474688479958911",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 30 Deg Elbow Spl Radius 24 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "10",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 30 Deg Elbow Spl Radius 24 PExPE.rfa",
                description: "",
                angle: "30",
                connector: "104*104",
                centerRadius: "0.817148384862245",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,5",
                dispPosition: "27",
                csvFileName: "",
                id: "2474689479958911",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 30 Deg Elbow Spl Radius 30 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "11",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 30 Deg Elbow Spl Radius 30 PExPE.rfa",
                description: "",
                angle: "30",
                connector: "104*104",
                centerRadius: "0.982372981077806",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,5",
                dispPosition: "28",
                csvFileName: "",
                id: "2474690479958911",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 30 Deg Elbow Spl Radius 36 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "12",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 30 Deg Elbow Spl Radius 36 PExPE.rfa",
                description: "",
                angle: "30",
                connector: "104*104",
                centerRadius: "0.970514243960035",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,5",
                dispPosition: "29",
                csvFileName: "",
                id: "2474691479958911",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 45 Deg Elbow Spl Radius 18 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "13",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 45 Deg Elbow Spl Radius 18 PExPE.rfa",
                description: "",
                angle: "45",
                connector: "104*104",
                centerRadius: "0.881737010226309",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,5",
                dispPosition: "30",
                csvFileName: "",
                id: "2474693479958511",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 45 Deg Elbow Spl Radius 24 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "14",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 45 Deg Elbow Spl Radius 24 PExPE.rfa",
                description: "",
                angle: "45",
                connector: "104*104",
                centerRadius: "1.10967712474619",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,6",
                dispPosition: "31",
                csvFileName: "",
                id: "2474694479958511",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 45 Deg Elbow Spl Radius 30 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "15",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 45 Deg Elbow Spl Radius 30 PExPE.rfa",
                description: "",
                angle: "45",
                connector: "104*104",
                centerRadius: "1.34803390593274",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,6",
                dispPosition: "32",
                csvFileName: "",
                id: "2474695479958511",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 45 Deg Elbow Spl Radius 36 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "16",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 45 Deg Elbow Spl Radius 36 PExPE.rfa",
                description: "",
                angle: "45",
                connector: "104*104",
                centerRadius: "1.55514068711928",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,6",
                dispPosition: "33",
                csvFileName: "",
                id: "2474696479958511",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 18 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "17",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 18 PExPE.rfa",
                description: "",
                angle: "90",
                connector: "104*104",
                centerRadius: "1.76041666666666",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,6",
                dispPosition: "34",
                csvFileName: "",
                id: "2474698479958411",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 24 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 24 PExPE.rfa",
                description: "",
                angle: "90",
                connector: "104*104",
                centerRadius: "2.28124999999999",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,6",
                dispPosition: "35",
                csvFileName: "",
                id: "2474699479958411",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 30 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "19",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 30 PExPE.rfa",
                description: "",
                angle: "90",
                connector: "104*104",
                centerRadius: "2.81166666666666",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,7",
                dispPosition: "36",
                csvFileName: "",
                id: "2474700479958411",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 36 PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "20",
                sizeRange: "1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch80 ftgs solvent\\pvc\\sch80\\",
                icon: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 36 PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "104*104",
                centerRadius: "3.31166666666666",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,7",
                dispPosition: "37",
                csvFileName: "Allied EG PVC Sch80 90 Deg Elbow Spl Radius 36 PExPE",
                id: "2474701479958411",
                isClearence: "false"
              }
            ],
            cap: {
              addDefaultItem: {
                name: "Allied EG PVC Access Fitting Type E PE",
                defaultFor: "",
                disableFor: "",
                fittingType: "cap",
                position: "1",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Access Fitting Type E PE.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "105",
                centerRadius: "2.00692581296257E-14",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "Allied EG PVC Access Fitting Type E PE",
                id: "2474774481159511",
                isClearence: "false"
              }
            },
            union: [
              {
                name: "Allied EG PVC Coupling SWxSW",
                defaultFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5*,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Coupling SWxSW.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "105*105",
                centerRadius: "0.00520833333334403",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG PVC Coupling SWxSW",
                id: "2474763481158711",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Access Fitting Type C PExPE",
                defaultFor: "",
                fittingType: "union",
                position: "2",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Access Fitting Type C PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "105",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "Allied EG PVC Access Fitting Type C PExPE",
                id: "2474773481159511",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Expansion Coupling Two Piece MPTxSW",
                defaultFor: "",
                fittingType: "union",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Expansion Coupling Two Piece MPTxSW.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "100*105",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "Allied EG PVC Expansion Coupling Two Piece MPTxSW",
                id: "2474764481158711",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Female Adapter FPTxSW",
                defaultFor: "",
                fittingType: "union",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Female Adapter FPTxSW.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "101*105",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "Allied EG PVC Female Adapter FPTxSW",
                id: "2474765481159911",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Terminal Adapter SWxMPT",
                defaultFor: "",
                fittingType: "union",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Terminal Adapter SWxMPT.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "105*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "Allied EG PVC Terminal Adapter SWxMPT",
                id: "2474766481159911",
                isClearence: "false"
              }
            ],
            multiPort: [
              {
                name: "Allied EG PVC Double Gang Boxes F Series FS PE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "1",
                sizeRange: "0.5,0.75,1",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Double Gang Boxes F Series FS PE.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "105",
                centerRadius: "9.06683724125213E-15",
                diameter: "0.0625",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "Allied EG PVC Double Gang Boxes F Series FS PE",
                id: "2474767481159711",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Double Gang Boxes F Series FSC PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Double Gang Boxes F Series FSC PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "105*105",
                centerRadius: "0.533833333333351",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "Allied EG PVC Double Gang Boxes F Series FSC PExPE",
                id: "2474768481159711",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Double Gang Boxes F Series FSCC PExPExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "3",
                sizeRange: "0.5x0.5x0.5,0.75x0.75x0.75,1x1x1",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Double Gang Boxes F Series FSCC PExPExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "105*105*105",
                centerRadius: "0.54292796899213",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "Allied EG PVC Double Gang Boxes F Series FSCC PExPExPE",
                id: "2474771481159811",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Double Gang Boxes F Series FSS PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Double Gang Boxes F Series FSS PExPE.rfa",
                description: "",
                angle: "0",
                connector: "105*105",
                centerRadius: "9.06699384525542E-15",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "",
                id: "2474772481159811",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Triple Gang Boxes F Series FS PE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "5",
                sizeRange: "0.5,0.75,1",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Triple Gang Boxes F Series FS PE.rfa",
                description: "",
                angle: "0",
                connector: "105",
                centerRadius: "9.06699384525542E-15",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "",
                id: "2474769481159711",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Triple Gang Boxes F Series FSC PEXPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Triple Gang Boxes F Series FSC PEXPE.rfa",
                description: "",
                angle: "0",
                connector: "105*105",
                centerRadius: "9.06699384525542E-15",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "",
                id: "2474770481159711",
                isClearence: "false"
              }
            ],
            junctionBoxTee: {
              addDefaultItem: {
                name: "Allied EG PVC Access Fitting Type T PExPExPE",
                defaultFor: "",
                fittingType: "JunctionBoxTee",
                position: "1",
                sizeRange: "0.5x0.5x0.5,0.75x0.75x0.75,1x1x1,1.25x1.25x1.25,1.5x1.5x1.5,2x2x2,2.5x2.5x2.5,3x3x3,3.5x3.5x3.5,4x4x4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Access Fitting Type T PExPExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "105*105*105",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "Allied EG PVC Access Fitting Type T PExPExPE",
                id: "2474778481159611",
                isClearence: "false"
              }
            },
            junctionBoxElbow: [
              {
                name: "Allied EG PVC Access Fitting Type LB PExPE",
                defaultFor: "",
                fittingType: "JunctionBoxElbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Access Fitting Type LB PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "105*105",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "Allied EG PVC Access Fitting Type LB PExPE",
                id: "2474775481159511",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Access Fitting Type LL PExPE",
                defaultFor: "",
                fittingType: "JunctionBoxElbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Access Fitting Type LL PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "105*105",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "Allied EG PVC Access Fitting Type LL PExPE",
                id: "2474776481159511",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC Access Fitting Type LR PExPE",
                defaultFor: "",
                fittingType: "JunctionBoxElbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Access Fitting Type LR PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "105*105",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "Allied EG PVC Access Fitting Type LR PExPE",
                id: "2474777481159511",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: []
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "12x12",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "2",
                csvFileName: "",
                id: "24120904704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                specId: "137",
                isClearence: "false"
              },
              {
                name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "24x24",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "3",
                csvFileName: "",
                id: "24120907704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                specId: "138",
                isClearence: "false"
              },
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "6",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "7",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "8",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "9",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "10",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "southwire Armorlite 12/3 MC Cable - Panel/Circuit",
        unit: "IMPERIAL",
        id: "17",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        systemUniqueId: "c50dd2c1-9e3b-4a9f-ad14-2b4af073ee47",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "southwire 12-3 Solid Wire Armorlite MC Conduit",
              id: "24127982732070211",
              Length: "250",
              JunctionType: "Tee",
              material: "southwire AL Armorlite 12/3 Solid MC Cable",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5",
              manufacturer: "southwire",
              path: "\\imperial\\conduit\\southwire\\aluminum armorlite mc cable\\aluminum\\mc\\",
              icon: "southwire 12-3 Solid Wire Armorlite MC Conduit.RFA",
              description: "",
              descriptionType: "",
              connector: "102",
              extraField: "True",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "",
              BendRadius: "3.535",
              LeadLength: "0.06",
              TakeUp: "2.5",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: {
              addDefaultItem: {
                name: "southwire 12-3 Solid Wire Armorlite MC Bend",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5",
                manufacturer: "southwire",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\southwire\\aluminum armorlite mc cable ftgs\\aluminum\\mc\\",
                icon: "southwire 12-3 Solid Wire Armorlite MC Bend.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.440416666666666",
                diameter: "0.0416666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "southwire 12-3 Solid Wire Armorlite MC Bend",
                id: "24129627737870311",
                isClearence: "false"
              }
            },
            union: [],
            multiPort: []
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: []
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "southwire Armorlite 12/3 MC Cable - Wirefill",
        unit: "IMPERIAL",
        id: "18",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        systemUniqueId: "d20dac0a-2eb3-403a-969e-201fbf74626d",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "southwire 12-3 Solid Wire Armorlite MC Conduit",
              id: "24127982732070211",
              Length: "250",
              JunctionType: "Tee",
              material: "southwire AL Armorlite 12/3 Solid MC Cable",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5",
              manufacturer: "southwire",
              path: "\\imperial\\conduit\\southwire\\aluminum armorlite mc cable\\aluminum\\mc\\",
              icon: "southwire 12-3 Solid Wire Armorlite MC Conduit.RFA",
              description: "",
              descriptionType: "",
              connector: "102",
              extraField: "False",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "",
              BendRadius: "3.535",
              LeadLength: "0.001",
              TakeUp: "2.5",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: {
              addDefaultItem: {
                name: "southwire 12-3 Solid Wire Armorlite MC Bend",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5",
                manufacturer: "southwire",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\southwire\\aluminum armorlite mc cable ftgs\\aluminum\\mc\\",
                icon: "southwire 12-3 Solid Wire Armorlite MC Bend.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.440416666666666",
                diameter: "0.0416666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "southwire 12-3 Solid Wire Armorlite MC Bend",
                id: "24129627737870311",
                isClearence: "false"
              }
            },
            union: [],
            multiPort: []
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: {
              addDefaultItem: {
                name: "nVent A1BFVGS Need To Rip",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "nVent",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\nvent\\e_caddy_galv-stl junction boxes\\galvanized steel\\elec_np\\",
                icon: "nVent A1BFVGS Need To Rip .rfa",
                description: "",
                descriptionType: "nVent A1BFVGS",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "242004021159558611",
                JBoxType: "Hosted",
                isClearence: "false"
              }
            }
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "Wireway Hoffman NEMA Type 12 Flg x Flg",
        unit: "IMPERIAL",
        id: "26",
        InVisibility: "",
        systemShape: "WireWay",
        IsHangerNeeded: "True",
        systemUniqueId: "dfbedd4a-0c1d-48dc-8b3e-88f4b0c8d6e9",
        hangerDisabledFor: "",
        isClearence: "true",
        fittings: [
          {
            name: "WireWay",
            electricalTypeItems: {
              name: "Hoffman GS NEMA Type12 Straight Length 120 Inch FlgdxFlgd",
              id: "24128461733060111",
              Length: "10",
              JunctionType: "Tee",
              OldMat: "",
              shape: "Wire Mesh Cable Tray",
              sizeRange: "2.5x2.5,4x4,6x6,8x8,12x6",
              manufacturer: "Hoffman",
              path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
              icon: "Hoffman GS NEMA Type12 Straight Length 120 Inch FlgdxFlgd.rfa",
              description: "",
              descriptionType: "",
              connector: "202",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "2",
              duplicateFrom: "Wire Mesh Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              isClearence: "true"
            },
            channelCableTrayElbow: [
              {
                name: "Hoffman GS NEMA Type12 45 Deg Top Opening Elbow FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8,12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 45 Deg Top Opening Elbow FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "45",
                connector: "202*202",
                centerRadius: "0.39583333333332",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "1",
                displayPosition: "1,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24128451733060511",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 90 Deg Top Opening Elbow FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8,12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 90 Deg Top Opening Elbow FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0.749999999999966",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "1",
                displayPosition: "4,0",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24128456733060711",
                isClearence: "true"
              }
            ],
            channelCableTrayVerticalElbow: [
              {
                name: "Hoffman GS NEMA Type12 90 Deg Inside Opening Elbow FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "1",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8,12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 90 Deg Inside Opening Elbow FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0.499999999999966",
                isConnCheck: "True",
                extraField: "",
                Height: "1",
                width: "0.5",
                displayPosition: "2,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24128454733060711",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 90 Deg Outside Opening Elbow FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "2",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8,12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 90 Deg Outside Opening Elbow FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0.499999999999966",
                isConnCheck: "True",
                extraField: "",
                Height: "1",
                width: "0.5",
                displayPosition: "3,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24128455733060711",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 45 Inside Opening Elbow FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "3",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 45 Inside Opening Elbow FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "45",
                connector: "202*202",
                centerRadius: "0.249999999999968",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.5",
                displayPosition: "3,1",
                dispPosition: "12",
                csvFileName: "",
                bendType: "Vertical Inside Bend",
                id: "24128449733060511",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 45 Outside Opening Elbow FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "4",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 45 Outside Opening Elbow FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "45",
                connector: "202*202",
                centerRadius: "0.249999999999968",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.5",
                displayPosition: "4,1",
                dispPosition: "13",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24128450733060511",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 90 Clockwise Elbow FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "5",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 90 Clockwise Elbow FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0.49999999999998",
                isConnCheck: "True",
                extraField: "",
                Height: "0.5",
                width: "0.5",
                displayPosition: "0,2",
                dispPosition: "14",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24128452733060711",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 90 Counter Clockwise Elbow FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayVerticalElbow",
                position: "6",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 90 Counter Clockwise Elbow FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0.354166666666648",
                isConnCheck: "True",
                extraField: "",
                Height: "0.208333333333333",
                width: "0.208333333333333",
                displayPosition: "1,2",
                dispPosition: "15",
                csvFileName: "",
                bendType: "Vertical Outside Bend",
                id: "24128453733060711",
                isClearence: "true"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "Hoffman GS NEMA Type12 Cross Fitting FlgdxFlgdxFlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "2.5x2.5x2.5x2.5x2.5x2.5x2.5x2.5,4x4x4x4x4x4x4x4,6x6x6x6x6x6x6x6,8x8x8x8x8x8x8x8,12x6x12x6x12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Cross Fitting FlgdxFlgdxFlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202*202*202",
                centerRadius: "0.416666666666677",
                isConnCheck: "True",
                extraField: "",
                Height: "0.333333333333333",
                width: "0.333333333333333",
                displayPosition: "0,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24128469733061111",
                isClearence: "true"
              }
            },
            channelCableTrayTee: {
              addDefaultItem: {
                name: "Hoffman GS NEMA Type12 Top Opening Tee FlgdxFlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "2.5x2.5x2.5x2.5x2.5x2.5,4x4x4x4x4x4,6x6x6x6x6x6,8x8x8x8x8x8,12x6x12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Top Opening Tee FlgdxFlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202*202",
                centerRadius: "0.583333333333354",
                isConnCheck: "True",
                extraField: "",
                Height: "0.666666666666667",
                width: "0.666666666666667",
                displayPosition: "1,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24128473733061011",
                isClearence: "true"
              }
            },
            channelCableTrayTransition: {
              addDefaultItem: {
                name: "Hoffman GS NEMA Type12 Reducer FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "4x4x2.5x2.5,6x6x4x4,8x8x6x6,12x6x6x6,12x6x4x4",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Reducer FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,3",
                dispPosition: "22",
                csvFileName: "",
                bendType: "",
                id: "24128478733063211",
                isClearence: "true"
              }
            },
            channelCableTrayUnion: [
              {
                name: "Hoffman GS NEMA Type12 Flange Gasket FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "1",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8,12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Flange Gasket FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,1",
                dispPosition: "11",
                csvFileName: "",
                bendType: "",
                id: "24128757733063511",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 Cut Off Fitting Lay In FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "2",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8,12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Cut Off Fitting Lay In FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,3",
                dispPosition: "19",
                csvFileName: "",
                bendType: "",
                id: "24128476733060111",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 Cut Off Fitting Non Lay In FlgdxPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "3",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8,12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Cut Off Fitting Non Lay In FlgdxPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*200",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "1,3",
                dispPosition: "20",
                csvFileName: "",
                bendType: "",
                id: "24128477733060111",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 Junction Box FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayUnion",
                position: "4",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Junction Box FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,3",
                dispPosition: "21",
                csvFileName: "",
                bendType: "",
                id: "24128475733063511",
                isClearence: "true"
              }
            ],
            channelCableTrayMultiPort: [
              {
                name: "Hoffman GS NEMA Type12 Box Connector Flgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "1",
                sizeRange: "2.5x2.5,4x4,6x6,8x8,12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Box Connector Flgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "2,2",
                dispPosition: "16",
                csvFileName: "",
                bendType: "",
                id: "24128467733063511",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 Clockwise Transpos FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "2",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Clockwise Transpos FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,2",
                dispPosition: "17",
                csvFileName: "",
                bendType: "",
                id: "24128470733063511",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 Counter Clockwise Transpos FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "3",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Counter Clockwise Transpos FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,2",
                dispPosition: "18",
                csvFileName: "",
                bendType: "",
                id: "24128471733063511",
                isClearence: "true"
              },
              {
                name: "Hoffman GS NEMA Type12 Telescope Fitting Lay In FlgdxFlgd",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "4",
                sizeRange: "2.5x2.5x2.5x2.5,4x4x4x4,6x6x6x6,8x8x8x8,12x6x12x6",
                manufacturer: "Hoffman",
                shape: "Wire Mesh Cable Tray",
                path: "\\imperial\\cabletrays\\clearance\\hoffman\\cs-pnt lay-in nema-12 fc wireway\\carbon steel\\tray\\",
                icon: "Hoffman GS NEMA Type12 Telescope Fitting Lay In FlgdxFlgd.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*202",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,3",
                dispPosition: "23",
                csvFileName: "",
                bendType: "",
                id: "24128474733063511",
                isClearence: "true"
              }
            ]
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs cable tray trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Cable Tray Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                isConnCheck: "",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                id: "24122208708764011",
                IsHanger: "True",
                supportDiscipline: "Wireway",
                specId: "126",
                isClearence: "false"
              },
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            panelBoard: []
          },
          {
            name: "Assemblies"
          },
          {
            name: "cableTray2",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "custom Content_Accessories_Building Layout",
        unit: "IMPERIAL",
        id: "1",
        systemShape: "conduit",
        systemUniqueId: "cc469db7-0e75-408d-bdd7-a772dfda7e45",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "conduit"
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [
              {
                name: "sysQue 24x48 Troffer Fixture",
                defaultFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "d78fea63-6ed5-437e-9d54-8f593e9f9fdb",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue 24x48 Troffer Fixture.rfa",
                connector: "109*109*109",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                userCustomFamilyID: "6818",
                isClearence: "false"
              },
              {
                name: "sysQue 24x48 Troffer Parabolic Fixture",
                defaultFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "2cc62ab9-c589-447b-bc18-77fb7eb0d699",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue 24x48 Troffer Parabolic Fixture.rfa",
                connector: "109*109*109",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                userCustomFamilyID: "6819",
                isClearence: "false"
              },
              {
                name: "sysQue Can Light Generic Style1",
                defaultFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "e370dab4-0888-49c5-b4ad-0f1cbe66ffd2",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Can Light Generic Style1.rfa",
                connector: "109*109*109*109",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                userCustomFamilyID: "6820",
                isClearence: "false"
              },
              {
                name: "sysQue Can Light Generic Style2",
                defaultFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "e72a6ac4-a5e2-41f3-ac6f-31189caa0d1d",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Can Light Generic Style2.rfa",
                connector: "109*109*109*109",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                userCustomFamilyID: "6821",
                isClearence: "false"
              },
              {
                name: "sysQue Can Light Generic",
                defaultFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "f961f6d6-2eb7-43ff-ae83-18aa60ffac7d",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Can Light Generic.rfa",
                connector: "109*109*109*109",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                userCustomFamilyID: "6822",
                isClearence: "false"
              },
              {
                name: "sysQue Concrete Pad",
                defaultFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "c5b18388-0049-4756-9cb1-b3300c2861c7",
                addedWireLength: "1",
                category: "Generic Models",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Concrete Pad.rfa",
                connector: "",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                userCustomFamilyID: "6823",
                isClearence: "false"
              },
              {
                name: "sysQue Strut Floor Rack",
                defaultFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "dcb4304f-a07d-4fc5-9a2d-12617fc556db",
                addedWireLength: "1",
                category: "Generic Models",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Strut Floor Rack.rfa",
                connector: "",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                userCustomFamilyID: "6824",
                isClearence: "false"
              },
              {
                name: "sysQue Strut Floor Stand",
                defaultFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "d1ceae4f-7000-4897-beed-d900caa69a5e",
                addedWireLength: "1",
                category: "Generic Models",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Strut Floor Stand.rfa",
                connector: "",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                userCustomFamilyID: "6825",
                isClearence: "false"
              },
              {
                name: "sysQue 3 inch RGBW Adjustable Recessed Wall Wash",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "x",
                model: "x",
                nominalSize: "x",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "ab080f16-f2e3-4b72-bddd-6b961877b622",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue 3 inch RGBW Adjustable Recessed Wall Wash.rfa",
                connector: "109*109*109*109*109*109",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "17",
                userCustomFamilyID: "6857",
                isClearence: "false"
              },
              {
                name: "sysQue 4x9 inch RGBW Recessed Wall Wash",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "x",
                model: "x",
                nominalSize: "x",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "fdc734ae-70e6-4b94-bf59-90b92da3d29b",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue 4x9 inch RGBW Recessed Wall Wash.rfa",
                connector: "109*109*109*109*109*109",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "18",
                userCustomFamilyID: "6858",
                isClearence: "false"
              },
              {
                name: "sysQue 6 inch RGBW Recessed",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "x",
                model: "x",
                nominalSize: "x",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "0a9592e6-6221-4c5e-ae7a-8ca30b4a142d",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue 6 inch RGBW Recessed.rfa",
                connector: "109*109*109*109*109*109",
                extraField: "",
                displayPosition: "3,2",
                dispPosition: "19",
                userCustomFamilyID: "6859",
                isClearence: "false"
              },
              {
                name: "sysQue Light Fixture",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "x",
                model: "x",
                nominalSize: "x",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "28addced-3219-4726-b120-20c733035320",
                addedWireLength: "1",
                category: "Lighting Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Light Fixture.rfa",
                connector: "",
                extraField: "",
                displayPosition: "4,2",
                dispPosition: "20",
                userCustomFamilyID: "6860",
                isClearence: "false"
              },
              {
                name: "rod - Point Assembly",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: ".",
                model: ".",
                nominalSize: ".",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "28c19131-b9f0-4193-abfe-93b74ddecdf2",
                addedWireLength: "0",
                category: "pipe Accessories",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "rod - Point Assembly.rfa",
                description: "",
                descriptionType: "",
                connector: "",
                extraField: "",
                displayPosition: "1,3",
                dispPosition: "23",
                userCustomFamilyID: "88124",
                isClearence: "false"
              },
              {
                name: "sysQue Generic Strut Rack Assembly",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "unistrut",
                model: "p1000",
                nominalSize: "1 5/8\/",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "9a2e7023-a1e9-41d5-bb29-32da001f8cfc",
                addedWireLength: "0",
                category: "pipe Accessories",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Generic Strut Rack Assembly.rfa",
                description: "",
                descriptionType: "",
                connector: "",
                extraField: "",
                displayPosition: "2,3",
                dispPosition: "26",
                userCustomFamilyID: "89647",
                isClearence: "false"
              },
              {
                name: "sysQue Generic Double Strut Rack Assembly",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "unistrut",
                model: "p1001",
                nominalSize: "1 5/8\\",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "7f367449-d328-4c33-83fa-205580291c98",
                addedWireLength: "0",
                category: "pipe Accessories",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Generic Double Strut Rack Assembly.rfa",
                description: "",
                descriptionType: "",
                connector: "109*109",
                extraField: "",
                displayPosition: "3,3",
                dispPosition: "27",
                userCustomFamilyID: "89648",
                isClearence: "false"
              }
            ],
            junctionBox: {
              addDefaultItem: {
                name: "sysQue Hinged Cover Junction Box",
                disableFor: "",
                fittingType: "JunctionBox",
                sizeRange: "",
                manufacturer: "x",
                model: "x",
                nominalSize: "x",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "42c3ecd1-2c2b-42d8-98f1-7810acbf0b68",
                addedWireLength: "2",
                category: "electrical Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Hinged Cover Junction Box.rfa",
                connector: "",
                extraField: "",
                displayPosition: "0,3",
                dispPosition: "21",
                userCustomFamilyID: "6861",
                isClearence: "false"
              }
            },
            panelBoard: {
              addDefaultItem: {
                name: "sysQue Panelboard Face Based",
                defaultFor: "",
                fittingType: "panelBoard",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "x",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "bc680f3b-eead-4d31-bcc9-be95974d7083",
                addedWireLength: "3",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Panelboard Face Based.rfa",
                description: "",
                descriptionType: "",
                connector: "109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "12",
                userCustomFamilyID: "6862",
                isClearence: "false"
              }
            },
            Transformer: [
              {
                name: "sysQue Transformer Face Based",
                defaultFor: "",
                fittingType: "Transformer",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "x",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "24014272-c3b8-40ba-8ffc-f0bf66b4393e",
                addedWireLength: "3",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Transformer Face Based.rfa",
                connector: "109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "15",
                userCustomFamilyID: "6864",
                isClearence: "false"
              },
              {
                name: "sysQue Transformer Floor Mounted Equipment",
                defaultFor: "",
                fittingType: "Transformer",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "x",
                pDFLocation: "c:\\programdata\\buildingdata\\sysquecontent2015\\buildingdata\\imperial\\custom\\generic electric\\electricalusercustomcontent\\sysque systems.pdf",
                guid: "4b2cfe3c-d7a2-447a-99d1-fd6de2f2cc41",
                addedWireLength: "3",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Transformer Floor Mounted Equipment.rfa",
                connector: "109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "16",
                userCustomFamilyID: "6865",
                isClearence: "false"
              }
            ],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: {
              addDefaultItem: {
                name: "sysQue SwitchGear Assembly",
                disableFor: "",
                fittingType: "equipmentSwitch",
                sizeRange: "",
                manufacturer: "Generic",
                model: ".",
                nominalSize: ".",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "79da53fc-769d-412d-a993-fe71939dfb7c",
                addedWireLength: "5",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue SwitchGear Assembly.rfa",
                description: "",
                descriptionType: "",
                connector: "109*109*109*109*109*109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "1,4",
                dispPosition: "30",
                userCustomFamilyID: "89883",
                isClearence: "false"
              }
            }
          },
          {
            name: "Accessories",
            junctionBox: []
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "False",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "31",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "11",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "32",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "12",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Floor Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "33",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Floor Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "13",
                csvFileName: "site Survey Work CS STD Pipe Floor Sleeve",
                id: "2413161446847611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Wall Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "34",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std wall sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Wall Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "14",
                csvFileName: "site Survey Work CS STD Pipe Wall Sleeve",
                id: "2413161657637611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS Floor Base Rectangular Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "35",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\rectangular sleeves\\sm assign after\\rectangular\\",
                icon: "site Survey Work CS Floor Base Rectangular Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "15",
                csvFileName: "",
                id: "24133895761748211",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS Wall Base Rectangular Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "36",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\rectangular sleeves\\sm assign after\\rectangular\\",
                icon: "site Survey Work CS Wall Base Rectangular Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "16",
                csvFileName: "",
                id: "24133896761748211",
                isClearence: "false"
              },
              {
                name: "sSW User Defined Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "37",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW User Defined Point.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "17",
                csvFileName: "",
                id: "24160277468557611",
                IsHanger: "True",
                supportDiscipline: "",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "eMT Galv Allied Compression - Panel/Circuits",
        unit: "IMPERIAL",
        id: "6",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        IsHangerNeeded: "False",
        systemUniqueId: "4501ee38-c279-48cc-82c0-d03127f13842",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: [
              {
                name: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE",
                id: "2474706480158611",
                Length: "10",
                JunctionType: "Tee",
                material: "Allied EG Galv Steel EMT",
                OldMat: "",
                shape: "FieldFabConduit",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4",
                manufacturer: "Allied EG",
                path: "\\imperial\\conduit\\allied eg\\e_galv-stl emt conduit pe\\galvanized steel\\emt\\",
                icon: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102",
                extraField: "True",
                displayPosition: "0,0",
                dispPosition: "1",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0",
                serviceType: "",
                serviceTypeColor: "",
                LineWeight: "",
                LinePattern: "",
                TotalBendRun: "360",
                isClearence: "false"
              },
              {
                name: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE-3",
                id: "2474706480158611",
                Length: "10",
                JunctionType: "Tee",
                material: "Allied EG Galv Steel EMT",
                OldMat: "",
                shape: "FieldFabConduit",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4",
                manufacturer: "Allied EG",
                path: "\\imperial\\conduit\\allied eg\\e_galv-stl emt conduit pe\\galvanized steel\\emt\\",
                icon: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102",
                extraField: "True",
                displayPosition: "2,2",
                dispPosition: "13",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0",
                defaultFor: "",
                serviceType: "",
                serviceTypeColor: "",
                LineWeight: "",
                LinePattern: "",
                TotalBendRun: "360",
                isClearence: "false"
              }
            ],
            elbow: [
              {
                name: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs pe\\galvanized steel\\emt\\",
                icon: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.666666666666626",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE",
                id: "24129608737770311",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "7,8,10",
                LeadOutLength: "105.83324,103.45879,98.12085",
                TakeUp: "5,6,8",
                id: "242350241038758411",
                isClearence: "false",
                OffsetType: "stub Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "9,10.875,12.75,15.125,15.875,17.375,24,27,31.25,36.25",
                LeadOutLength: "104.22594,100.48562,96.25443,91.03236,90.96958,88.09513,74.16593,67.11328,58.62213,49.97788",
                TakeUp: "7,8.875,10.75,13.125,13.875,15.375,21.5,24,27.75,32.25",
                id: "242350251038758411",
                isClearence: "false",
                OffsetType: "stub Machine Bend"
              }
            ],
            union: {
              addDefaultItem: {
                name: "Allied EG Galv Steel EMT Coupling CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs cp\\galvanized steel\\emt\\",
                icon: "Allied EG Galv Steel EMT Coupling CExCE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG Galv Steel EMT Coupling CExCE",
                id: "2474729480758711",
                isClearence: "false"
              }
            },
            multiPort: [
              {
                name: "Appleton Galv-CS 7000US EMT Connector CE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "8",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Appleton",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\appleton\\cs-galv connector ftgs compression\\galvanized steel\\emt\\",
                icon: "Appleton Galv-CS 7000US EMT Connector CE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*108",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "24134723768158711",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252741038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252751038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252761038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252771038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242316151038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "7",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242316161038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Machine Bend"
              },
              {
                name: "Appleton Galv-CS 4000US EMT Connector SS",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Appleton",
                guid: "5c8fbb2c-80d0-4ec5-aa79-227c2c63077d",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\appleton\\cs-galv connector ftgs set-screw\\galvanized steel\\emt\\",
                icon: "Appleton Galv-CS 4000US EMT Connector SS.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,2",
                dispPosition: "15",
                csvFileName: "",
                id: "24134725768258711",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Accessories",
            junctionBox: []
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                descriptionType: "core Drill Floor",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                descriptionType: "core Drill Wall",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Floor Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Floor Sleeve.rfa",
                description: "",
                descriptionType: "Floor Sleeve",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "site Survey Work CS STD Pipe Floor Sleeve",
                id: "2413161446847611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Wall Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std wall sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Wall Sleeve.rfa",
                description: "",
                descriptionType: "Wall Sleeve",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "site Survey Work CS STD Pipe Wall Sleeve",
                id: "2413161657637611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                descriptionType: "centerline Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                descriptionType: "control Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                descriptionType: "Layout Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                descriptionType: "stub-Up Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "12x12",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                id: "24120904704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "USTRT CS P11-HG Rigid Conduit Clamp",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "10",
                sizeRange: "0.375,0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,5,6,8",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\e_cs conduit supports\\carbon steel\\support\\",
                icon: "USTRT CS P11-HG Rigid Conduit Clamp.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                id: "242240591298877811",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [],
            junctionBox: {
              addDefaultItem: {
                name: "sysQue Hinged Cover Junction Box",
                disableFor: "",
                fittingType: "JunctionBox",
                sizeRange: "",
                manufacturer: "Hoffman",
                model: "xx",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "a01ac093-3eaa-4705-926c-48737a84eb6c",
                addedWireLength: "1",
                category: "electrical Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Hinged Cover Junction Box.rfa",
                connector: "",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                userCustomFamilyID: "6828",
                isClearence: "false"
              }
            },
            panelBoard: {
              addDefaultItem: {
                name: "sysQue Panelboard Face Based",
                disableFor: "",
                fittingType: "panelBoard",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "4f5ff0c0-a31a-4de9-baac-7f0449feb03e",
                addedWireLength: "5",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Panelboard Face Based.rfa",
                description: "",
                descriptionType: "",
                connector: "109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                userCustomFamilyID: "6830",
                isClearence: "false"
              }
            }
          },
          {
            name: "Assemblies"
          },
          {
            name: "aaaaaaaaa",
            isCustomContent: "True",
            normal: {
              addDefaultItem: {
                name: "sysQue Concrete Pad",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "da",
                model: "a",
                nominalSize: "1",
                pDFLocation: "c:\\Users\\EFenech\\Desktop\\ceva.pdf",
                guid: "698c4f2a-2bbf-4bdd-b389-7d31ba916dd8",
                addedWireLength: "1",
                category: "Generic Models",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent\\various\\elec_np",
                icon: "sysQue Concrete Pad.rfa",
                description: "",
                descriptionType: "",
                connector: "",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                userCustomFamilyID: "0",
                isClearence: "false"
              }
            }
          },
          {
            name: "fewafree",
            isCustomContent: "True"
          },
          {
            name: "aaaaaferr3q",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "eMT Galv Allied Set Screw - Panel/Circuit",
        unit: "IMPERIAL",
        id: "3",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        IsHangerNeeded: "True",
        systemUniqueId: "4658804d-4746-4c93-b2a6-0c48275fc52d",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE",
              id: "2474706480158611",
              Length: "10",
              JunctionType: "Tee",
              material: "Allied EG Galv Steel EMT",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4",
              manufacturer: "Allied EG",
              path: "\\imperial\\conduit\\allied eg\\e_galv-stl emt conduit pe\\galvanized steel\\emt\\",
              icon: "Allied EG Galv Steel EMT Electrical Metallic Tubing PExPE.rfa",
              description: "",
              descriptionType: "",
              connector: "102",
              extraField: "True",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
              BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
              LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
              TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs pe\\galvanized steel\\emt\\",
                icon: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.666666666666626",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG GS E-Z Pull EMT Conduit Bend PExPE",
                id: "24129608737770311",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "7,8,10",
                LeadOutLength: "105.83324,103.45879,98.12085",
                TakeUp: "5,6,8",
                id: "242350241038758411",
                isClearence: "false",
                OffsetType: "stub Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "9,10.875,12.75,15.125,15.875,17.375,24,27,31.25,36.25",
                LeadOutLength: "104.22594,100.48562,96.25443,91.03236,90.96958,88.09513,74.16593,67.11328,58.62213,49.97788",
                TakeUp: "7,8.875,10.75,13.125,13.875,15.375,21.5,24,27.75,32.25",
                id: "242350251038758411",
                isClearence: "false",
                OffsetType: "stub Machine Bend"
              }
            ],
            union: {
              addDefaultItem: {
                name: "Allied EG Galv Steel EMT Set Screw Cplng SetScrewxSetScrew",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs ss\\galvanized steel\\emt\\",
                icon: "Allied EG Galv Steel EMT Set Screw Cplng SetScrewxSetScrew.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG Galv Steel EMT Set Screw Cplng SetScrewxSetScrew",
                id: "2474731480858711",
                isClearence: "false"
              }
            },
            multiPort: [
              {
                name: "Appleton Galv-CS 4000US EMT Connector SS",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Appleton",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\appleton\\cs-galv connector ftgs set-screw\\galvanized steel\\emt\\",
                icon: "Appleton Galv-CS 4000US EMT Connector SS.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "24134725768258711",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252741038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252751038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252761038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252771038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242316151038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "7",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242316161038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Machine Bend"
              }
            ]
          },
          {
            name: "Accessories",
            junctionBox: [
              {
                name: "crouse-Hinds Steel TP403MSB Square Outlet Box E_KO-F_FB",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "crouse-Hinds",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\crouse-hinds\\fb_galvstl square junction boxes\\galvanized steel\\mc\\",
                icon: "crouse-Hinds Steel TP403MSB Square Outlet Box E_KO-F_FB.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "241950121127174511",
                JBoxType: "Hosted",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds Steel TP395 Square Two Device Box E_KO-F_FB",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "2",
                sizeRange: "",
                manufacturer: "crouse-Hinds",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\crouse-hinds\\fb_galvstl square junction boxes\\galvanized steel\\mc\\",
                icon: "crouse-Hinds Steel TP395 Square Two Device Box E_KO-F_FB.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "241950101127174511",
                JBoxType: "Hosted",
                isClearence: "false"
              },
              {
                name: "nVent A1BFVGS Need To Rip",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "3",
                sizeRange: "",
                manufacturer: "nVent",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\nvent\\e_caddy_galv-stl junction boxes\\galvanized steel\\elec_np\\",
                icon: "nVent A1BFVGS Need To Rip .rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "242004021159558611",
                JBoxType: "Hosted",
                isClearence: "false"
              }
            ]
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                descriptionType: "core Floor",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                descriptionType: "core Wall",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Floor Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Floor Sleeve.rfa",
                description: "",
                descriptionType: "Floor Sleeve",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "site Survey Work CS STD Pipe Floor Sleeve",
                id: "2413161446847611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Wall Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std wall sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Wall Sleeve.rfa",
                description: "",
                descriptionType: "Wall Sleeve",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "site Survey Work CS STD Pipe Wall Sleeve",
                id: "2413161657637611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                descriptionType: "centerline Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                descriptionType: "control Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                descriptionType: "Layout Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                descriptionType: "stub-Up Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "Minerallac CS EMT Conduit Hanger Bolt Zinc Plated",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4",
                manufacturer: "Minerallac",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\minerallac\\cs conduit hanger\\carbon steel\\support\\",
                icon: "Minerallac CS EMT Conduit Hanger Bolt Zinc Plated.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                isConnCheck: "",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                id: "24150665921873911",
                IsHanger: "True",
                supportDiscipline: "conduit",
                specId: "133",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: [
              {
                name: "sysQue Concrete Pad",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "9f5b2eba-34c2-4f49-bec7-2968cc7449ad",
                addedWireLength: "0",
                category: "Generic Models",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Concrete Pad.rfa",
                connector: "",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                userCustomFamilyID: "6827",
                isClearence: "false"
              },
              {
                name: "sysQue Strut Floor Stand",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "unistrut",
                model: "rack",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "c3af5c29-aa87-4285-bf30-1a88a3848c7b",
                addedWireLength: "0",
                category: "Generic Models",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Strut Floor Stand.rfa",
                description: "",
                descriptionType: "unistrut Rack",
                connector: "",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                userCustomFamilyID: "42780",
                isClearence: "false"
              }
            ],
            junctionBox: {
              addDefaultItem: {
                name: "sysQue Hinged Cover Junction Box",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "Hoffman",
                model: "xx",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "65575bbe-c2c1-4ab5-8071-329034c36d89",
                addedWireLength: "1",
                category: "electrical Fixtures",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Hinged Cover Junction Box.rfa",
                connector: "",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                userCustomFamilyID: "6829",
                isClearence: "false"
              }
            },
            panelBoard: {
              addDefaultItem: {
                name: "sysQue Panelboard Face Based",
                defaultFor: "",
                disableFor: "",
                fittingType: "panelBoard",
                position: "1",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: "xx",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "e668ba6f-c9e3-4ac1-9a51-c456af247914",
                addedWireLength: "5",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Panelboard Face Based.rfa",
                connector: "109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                userCustomFamilyID: "6831",
                isClearence: "false"
              }
            },
            Transformer: {
              addDefaultItem: {
                name: "sysQue Transformer Face Based",
                disableFor: "",
                fittingType: "Transformer",
                sizeRange: "",
                manufacturer: "test",
                model: "model",
                nominalSize: "1",
                pDFLocation: "c:\\Users\\EFenech\\Desktop\\ceva.pdf",
                guid: "c9ce8db0-bd2c-402a-88ad-ccdc47f0b6fb",
                addedWireLength: "1",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent\\various\\elec_np",
                icon: "sysQue Transformer Face Based.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100*100*100*100*100*100",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "6",
                userCustomFamilyID: "0",
                isClearence: "false"
              }
            }
          },
          {
            name: "Assemblies"
          },
          {
            name: "uuu23",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "pVC Sch40 without fittings - Wirefill",
        unit: "IMPERIAL",
        id: "14",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        IsHangerNeeded: "False",
        systemUniqueId: "b6feb15b-ae5e-438f-932a-3b0d9e5d3f77",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "Allied EG PVC Sch40 Rigid Conduit PExPE",
              id: "2474726480558611",
              Length: "10",
              JunctionType: "Tee",
              material: "Allied EG PVC Sch40",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,5,6",
              manufacturer: "Allied EG",
              path: "\\imperial\\conduit\\allied eg\\e_pvc sch40 rigid conduit solvent\\pvc\\sch40\\",
              icon: "Allied EG PVC Sch40 Rigid Conduit PExPE.rfa",
              description: "",
              descriptionType: "pVC Sch40",
              connector: "104",
              extraField: "False",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
              BendRadius: "4.25,5.4735,6.9375,8.75,8.25,9,10.5,13,15,16,24,30",
              LeadLength: "2,2,2,2,2,2,3,3.125,3.25,3.375,3.622,3.74",
              TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0,0,0",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Allied EG PVC Sch40 Conduit Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_pvc sch40 ftgs solvent\\pvc\\sch40\\",
                icon: "Allied EG PVC Sch40 Conduit Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "104*104",
                centerRadius: "1.61458333333334",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG PVC Sch40 Conduit Bend PExPE",
                id: "24157350481070311",
                isClearence: "false"
              },
              {
                name: "Allied EG PVC 5 Deg Coupling PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC 5 Deg Coupling PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "5",
                connector: "105*105",
                centerRadius: "0.171304982945716",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "Allied EG PVC 5 Deg Coupling PExPE",
                id: "2474762481158711",
                isClearence: "false"
              }
            ],
            union: {
              addDefaultItem: {
                name: "Allied EG PVC Coupling SWxSW",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\pvc fittings solvent\\pvc\\elec_np\\",
                icon: "Allied EG PVC Coupling SWxSW.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "105*105",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG PVC Coupling SWxSW",
                id: "2474763481158711",
                isClearence: "false"
              }
            }
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                guid: "1e96a2ef-7d71-4e8f-96c1-337c2835a42b",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                guid: "9f22df51-27b0-41fd-b980-403cd1244448",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "6",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                guid: "a06726cf-471e-4db5-bfcd-462f2df69e80",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "7",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                guid: "316c96bb-4a67-46ce-9d07-b1cb80a8ec83",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "8",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "",
                manufacturer: "site Survey Work",
                guid: "0f171b02-0b9c-41d2-ae98-4987605cd7a9",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "9",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          },
          {
            name: "lala",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "Lik Hung Trunking",
        unit: "METRIC",
        id: "84",
        InVisibility: "",
        systemShape: "WireWay",
        IsHangerNeeded: "False",
        systemUniqueId: "c3ea231b-14bc-4514-bd76-efb30c5ba251",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "WireWay",
            electricalTypeItems: {
              name: "M_Lik Hung CT-T Cable Trunking PExPE",
              id: "24165361975360131",
              Length: "9.84251968503937",
              JunctionType: "Tee",
              OldMat: "",
              shape: "Wire Mesh Cable Tray",
              sizeRange: "50x50,75x50,75x75,100x75,100x100,150x100,150x150,200x150,200x200",
              manufacturer: "Lik Hung",
              path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
              icon: "M_Lik Hung CT-T Cable Trunking PExPE.rfa",
              description: "",
              descriptionType: "cT-T Cable Trunking",
              connector: "200",
              extraField: "",
              displayPosition: "0,0",
              dispPosition: "1",
              duplicateFrom: "Wire Mesh Cable Tray",
              defaultFor: "",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              isClearence: "false"
            },
            channelCableTrayElbow: [
              {
                name: "M_Lik Hung CT-11AT 135 Bend FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "1",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x75x100x75,100x100x100x100,150x100x150x100,150x150x150x150,200x150x200x150,200x200x200x200",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung CT-11AT 135 Bend FExFE.rfa",
                description: "",
                descriptionType: "135 Bend",
                angle: "45",
                connector: "201*201",
                centerRadius: "0.37919502546814",
                isConnCheck: "True",
                extraField: "",
                Height: "0.656167979002625",
                width: "0.656167979002625",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                bendType: "",
                id: "24165370975360531",
                isClearence: "false"
              },
              {
                name: "M_Lik Hung CT-1AT 90 Sharp Bend FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "2",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x75x100x75,100x100x100x100,150x100x150x100,150x150x150x150,200x150x200x150,200x200x200x200",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung CT-1AT 90 Sharp Bend FExFE.rfa",
                description: "",
                descriptionType: "90 Sharp Bend",
                angle: "90",
                connector: "201*201",
                centerRadius: "0.328083989501289",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "0.164041994750656",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                bendType: "",
                id: "24165365975360731",
                isClearence: "false"
              },
              {
                name: "M_Lik Hung CT-1T 90 Mitre Bend FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayElbow",
                position: "3",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x75x100x75,100x100x100x100,150x100x150x100,150x150x150x150,200x150x200x150,200x200x200x200",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung CT-1T 90 Mitre Bend FExFE.rfa",
                description: "",
                descriptionType: "90 Mitre Bend",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                bendType: "",
                id: "24165362975360731",
                isClearence: "false"
              }
            ],
            channelCableTrayCross: {
              addDefaultItem: {
                name: "M_Lik Hung CT-5T 90 Mitre Cross FExFExFExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayCross",
                position: "1",
                sizeRange: "50x50x50x50x50x50x50x50,75x50x75x50x75x50x75x50,75x75x75x75x75x75x75x75,100x75x100x75x100x75x100x75,100x100x100x100x100x100x100x100,150x100x150x100x150x100x150x100,150x150x150x150x150x150x150x150,200x150x200x150x200x150x200x150,200x200x200x200x200x200x200x200",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung CT-5T 90 Mitre Cross FExFExFExFE.rfa",
                description: "",
                descriptionType: "90 Mitre Cross",
                angle: "90",
                connector: "201*201*201*201",
                centerRadius: "0.287073490813649",
                isConnCheck: "True",
                extraField: "",
                Height: "0.164041994750656",
                width: "0.246062992125984",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                bendType: "",
                id: "24165373975361131",
                isClearence: "false"
              }
            },
            channelCableTrayTee: {
              addDefaultItem: {
                name: "M_Lik Hung CT-3AT Sharp Tee FExFExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTee",
                position: "1",
                sizeRange: "50x50x50x50x50x50,75x50x75x50x75x50,75x75x75x75x75x75,100x75x100x75x100x75,100x100x100x100x100x100,150x100x150x100x150x100,150x150x150x150x150x150,200x150x200x150x200x150,200x200x200x200x200x200",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung CT-3AT Sharp Tee FExFExFE.rfa",
                description: "",
                descriptionType: "sharp Tee",
                angle: "90",
                connector: "201*201*201",
                centerRadius: "0.574146981627292",
                isConnCheck: "True",
                extraField: "",
                Height: "0.656167979002625",
                width: "0.656167979002625",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                bendType: "",
                id: "24165369975361031",
                isClearence: "false"
              }
            },
            channelCableTrayTransition: [
              {
                name: "M_Lik Hung CT-6T Left Reducer FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "1",
                sizeRange: "50x50x75x75,50x50x100x50,75x75x50x50,75x75x100x100,100x50x50x50,100x100x75x75,100x100x150x100,100x100x150x150,150x100x100x100,150x150x100x100,150x150x200x200,200x200x150x150",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung CT-6T Left Reducer FExFE.rfa",
                description: "",
                descriptionType: "Left Reducer",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "M_Lik Hung CT-6T Left Reducer FExFE",
                bendType: "",
                id: "24165374975360831",
                isClearence: "false"
              },
              {
                name: "M_Lik Hung CT-6T Reducer FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "2",
                sizeRange: "50x50x75x75,50x50x100x50,75x75x50x50,75x75x100x100,100x50x50x50,100x100x75x75,100x100x150x100,100x100x150x150,150x100x100x100,150x150x100x100,150x150x200x200,200x200x150x150",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung CT-6T Reducer FExFE.rfa",
                description: "",
                descriptionType: "reducer",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "M_Lik Hung CT-6T Reducer FExFE",
                bendType: "",
                id: "24165376975363231",
                isClearence: "false"
              },
              {
                name: "M_Lik Hung CT-6T Right Reducer FExFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayTransition",
                position: "3",
                sizeRange: "50x50x75x75,50x50x100x50,75x75x50x50,75x75x100x100,100x50x50x50,100x100x75x75,100x100x150x100,100x100x150x150,150x100x100x100,150x150x100x100,150x150x200x200,200x200x150x150",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung CT-6T Right Reducer FExFE.rfa",
                description: "",
                descriptionType: "right Reducer",
                angle: "90",
                connector: "201*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "M_Lik Hung CT-6T Right Reducer FExFE",
                bendType: "",
                id: "24165375975360931",
                isClearence: "false"
              }
            ],
            channelCableTrayMultiPort: [
              {
                name: "M_Lik Hung ECS End Cap FE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "1",
                sizeRange: "50x50,75x50,75x75,100x75,100x100,150x100,150x150,200x150,200x200",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung ECS End Cap FE.rfa",
                description: "",
                descriptionType: "end Cap",
                angle: "90",
                connector: "201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                bendType: "",
                id: "24165341975366131",
                isClearence: "false"
              },
              {
                name: "M_Lik Hung FF Flange FLGxFE",
                defaultFor: "",
                disableFor: "",
                fittingType: "channelCableTrayMultiPort",
                position: "2",
                sizeRange: "50x50x50x50,75x50x75x50,75x75x75x75,100x75x100x75,100x100x100x100,150x100x150x100,150x150x150x150,200x150x200x150,200x200x200x200",
                manufacturer: "Lik Hung",
                shape: "Wire Mesh Cable Tray",
                path: "\\metric\\cabletrays\\lik hung\\m_galv cable trunking\\galvanized steel\\tray",
                icon: "M_Lik Hung FF Flange FLGxFE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "202*201",
                centerRadius: "0",
                isConnCheck: "True",
                extraField: "",
                Height: "0",
                width: "0",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                bendType: "",
                id: "24165344975374931",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "rymco EMT Panel/Circuit",
        unit: "METRIC",
        id: "86",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        IsHangerNeeded: "False",
        systemUniqueId: "206905c5-70cd-41df-b516-5c0c2eb33a0f",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit"
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "rymco IMC - Panel/Circuit",
        unit: "METRIC",
        id: "87",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        IsHangerNeeded: "False",
        systemUniqueId: "54097f32-15a9-4f88-91e2-64c8ed154ad3",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit"
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "Assemblies"
          }
        ]
      },
      {
        name: "eMT Wheatland Set Screw Wirefill",
        unit: "IMPERIAL",
        id: "4",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        IsHangerNeeded: "True",
        systemUniqueId: "363be8de-f15d-45e1-a429-5dff1c4baa70",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "Wheatland Galv-Stl EMT Conduit PExPE",
              id: "24141020790358611",
              Length: "10",
              JunctionType: "Tee",
              material: "Wheatland Galv Steel EMT",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,5*,6*",
              manufacturer: "Wheatland",
              path: "\\imperial\\conduit\\wheatland\\e_galv-stl emt conduit pe\\galvanized steel\\emt\\",
              icon: "Wheatland Galv-Stl EMT Conduit PExPE.rfa",
              description: "eMT",
              descriptionType: "",
              connector: "102",
              extraField: "False",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\555 and 881 Bender Data.pdf",
              BendRadius: "4.3125,5.25,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5,0*,0*",
              LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4,0*,0*",
              TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,0,0,0,0,0*,0*",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Wheatland Galv-Stl EMT Conduit Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Wheatland",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\wheatland\\e_galv-stl emt conduit bends pe\\galvanized steel\\emt\\",
                icon: "Wheatland Galv-Stl EMT Conduit Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.458333333333334",
                diameter: "0.25",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Wheatland Galv-Stl EMT Conduit Bend PExPE",
                id: "24149633919158411",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Hand Bend CExCE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "7,8,10",
                LeadOutLength: "105.83324,103.45879,98.12085",
                TakeUp: "5,6,8",
                id: "242350241038758411",
                isClearence: "false",
                OffsetType: "stub Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "GENEL Galv-Stl EMT Stub 90 Machine Bend CExCE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "9,10.875,12.75,15.125,15.875,17.375,24,27,31.25,36.25",
                LeadOutLength: "104.22594,100.48562,96.25443,91.03236,90.96958,88.09513,74.16593,67.11328,58.62213,49.97788",
                TakeUp: "7,8.875,10.75,13.125,13.875,15.375,21.5,24,27.75,32.25",
                id: "242350251038758411",
                isClearence: "false",
                OffsetType: "stub Machine Bend"
              }
            ],
            union: {
              addDefaultItem: {
                name: "Allied EG Galv Steel EMT Set Screw Cplng SetScrewxSetScrew",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Allied EG",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl emt conduit ftgs ss\\galvanized steel\\emt\\",
                icon: "Allied EG Galv Steel EMT Set Screw Cplng SetScrewxSetScrew.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*103",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG Galv Steel EMT Set Screw Cplng SetScrewxSetScrew",
                id: "2474731480858711",
                isClearence: "false",
                param: {
                  name: "UPC",
                  Value: "",
                  Type: "Text",
                  category: "conduit Runs,Conduits,Conduit Fittings",
                  Group: "pG_IDENTITY_DATA",
                  GroupParameterUnder: "pG_IDENTITY_DATA",
                  IsInstance: "True",
                  IsShared: "False",
                  size: [
                    {
                      id: "0.5x0.5",
                      Value: "98007013561"
                    },
                    {
                      id: "0.75x0.75",
                      Value: "98007013562"
                    },
                    {
                      id: "1x1",
                      Value: "98007013563"
                    },
                    {
                      id: "1.25x1.25",
                      Value: "98007013564"
                    },
                    {
                      id: "1.5x1.5",
                      Value: "98007013565"
                    },
                    {
                      id: "2x2",
                      Value: "98007013566"
                    },
                    {
                      id: "2.5x2.5",
                      Value: "98007013567"
                    },
                    {
                      id: "3x3",
                      Value: "98007013568"
                    },
                    {
                      id: "3.5x3.5",
                      Value: "98007013569"
                    },
                    {
                      id: "4x4",
                      Value: "98007013570"
                    }
                  ]
                }
              }
            },
            multiPort: [
              {
                name: "Appleton Galv-CS 4000S EMT Connector Face Based SS",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "10",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Appleton",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\appleton\\cs-galv connector ftgs set-screw\\galvanized steel\\emt\\",
                icon: "Appleton Galv-CS 4000S EMT Connector Face Based SS.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "103*108",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "24194168768259911",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "11",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252741038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "12",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "GENEL Galv-Stl EMT Four Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252751038770311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "13",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242252761038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "14",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "GENEL Galv-Stl EMT Three Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242252771038770311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "15",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Hand Bend PExPE",
                BendRadius: "4.5625,5.4375,7.5625",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "242316151038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "16",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel emt ftgs pe\\galvanized steel\\emt\\",
                icon: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE.rfa",
                description: "",
                descriptionType: "",
                connector: "102*102",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "GENEL Galv-Stl EMT Two Point Saddle Machine Bend PExPE",
                BendRadius: "4.3125,5.5,7,8.8125,8.375,9.25,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,2.875,3.25,4.1825,5.5,5.75,6.15,5.77,6.56,8.5",
                id: "242316161038770311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Machine Bend"
              }
            ]
          },
          {
            name: "Accessories",
            junctionBox: [
              {
                name: "rACO Galv-Stl 192 Square Box FB FKOxFKOxFKOxFKOxFKOxFKO",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\fb_galvstl square junction boxes\\galvanized steel\\mc\\",
                icon: "rACO Galv-Stl 192 Square Box FB FKOxFKOxFKOxFKOxFKOxFKO.rfa",
                description: "",
                descriptionType: "raco 192",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "242051321127468711",
                JBoxType: "Hosted",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds Steel TP395 Square Two Device Box E_KO-F_FB",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "2",
                sizeRange: "",
                manufacturer: "crouse-Hinds",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\crouse-hinds\\fb_galvstl square junction boxes\\galvanized steel\\mc\\",
                icon: "crouse-Hinds Steel TP395 Square Two Device Box E_KO-F_FB.rfa",
                description: "",
                descriptionType: "crouse Hinds TP395",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "241950101127174511",
                JBoxType: "Hosted",
                isClearence: "false"
              },
              {
                name: "raco Galv-Stl Square Box 248 FKO_FB",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "3",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "2",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\fb_galvstl square junction boxes\\galvanized steel\\mc\\",
                icon: "raco Galv-Stl Square Box 248 FKO_FB.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "241952641127474511",
                JBoxType: "Hosted",
                isClearence: "false"
              },
              {
                name: "rACO Galv-Stl 199 Square Box FB FKOxFKOxFKOxFKOxFKOxFKO",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "4",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\fb_galvstl square junction boxes\\galvanized steel\\mc\\",
                icon: "rACO Galv-Stl 199 Square Box FB FKOxFKOxFKOxFKOxFKOxFKO.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "242051371127468711",
                JBoxType: "Hosted",
                isClearence: "false"
              }
            ]
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                descriptionType: "core Floor",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                descriptionType: "core Wall",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                descriptionType: "control Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                descriptionType: "Layout Point",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                descriptionType: "stub Up",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "24120904704164011",
                supportDiscipline: "conduit",
                specId: "135",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "1",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                id: "24120907704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                specId: "139",
                isClearence: "false"
              },
              {
                name: "p3301T-GR Dbl UniStrut Conduit Hanger 7_8",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support",
                icon: "p3301t-gr dbl unistrut conduit hanger 7_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                isConnCheck: "",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                id: "24120911704164011",
                IsHanger: "True",
                supportDiscipline: "",
                specId: "140",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            isCustomContent: "True",
            normal: {
              addDefaultItem: {
                name: "sysQue Concrete Pad",
                disableFor: "",
                fittingType: "normal",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: ".",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "40ba91fc-e29b-44e2-9a6f-f2a706aee7a9",
                addedWireLength: "1",
                category: "Generic Models",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Concrete Pad.rfa",
                description: "",
                descriptionType: "Housekeeping Pad",
                connector: "",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                userCustomFamilyID: "53814",
                isClearence: "false"
              }
            },
            panelBoard: {
              addDefaultItem: {
                name: "sysQue Panelboard Face Based",
                disableFor: "",
                fittingType: "panelBoard",
                sizeRange: "",
                manufacturer: "Generic",
                model: "Generic",
                nominalSize: ".",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "5d697acf-ad16-4155-8124-768eaf679012",
                addedWireLength: "5",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Panelboard Face Based.rfa",
                description: "",
                descriptionType: "panel",
                connector: "109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                userCustomFamilyID: "53818",
                isClearence: "false"
              }
            },
            Transformer: {
              addDefaultItem: {
                name: "sysQue Transformer Floor Mounted Equipment",
                disableFor: "",
                fittingType: "Transformer",
                sizeRange: "",
                manufacturer: ".",
                model: ".",
                nominalSize: ".",
                pDFLocation: "c:\\ProgramData\\BuildingData\\Support\\Parametric Generic Content.pdf",
                guid: "e5264807-b65c-4f58-a57a-f5574a8ad10f",
                addedWireLength: "5",
                category: "electrical Equipment",
                shape: "customContent",
                path: "\\imperial\\custom\\generic electric\\electricalusercustomcontent",
                icon: "sysQue Transformer Floor Mounted Equipment.rfa",
                description: "",
                descriptionType: "",
                connector: "109*109*109*109*109*109*109",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                userCustomFamilyID: "53820",
                isClearence: "false"
              }
            }
          },
          {
            name: "Assemblies"
          },
          {
            name: "testTab",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "southwire Armorlite 12/2 MC Cable - Wirefill",
        unit: "IMPERIAL",
        id: "16",
        InVisibility: "",
        systemShape: "FieldFabConduit",
        systemUniqueId: "614a06bd-4ef0-49d6-b99f-13162a2bd792",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "FieldFabConduit",
            electricalTypeItems: {
              name: "southwire 12-2 Solid Wire Armorlite MC Conduit",
              id: "24127978732070211",
              Length: "250",
              JunctionType: "Tee",
              material: "southwire AL Armorlite 12/2 Solid MC Cable",
              OldMat: "",
              shape: "FieldFabConduit",
              sizeRange: "0.5",
              manufacturer: "southwire",
              path: "\\imperial\\conduit\\southwire\\aluminum armorlite mc cable\\aluminum\\mc\\",
              icon: "southwire 12-2 Solid Wire Armorlite MC Conduit.rfa",
              description: "",
              descriptionType: "",
              connector: "102",
              extraField: "True",
              displayPosition: "0,0",
              dispPosition: "1",
              pDFLocation: "",
              BendRadius: "3.689",
              LeadLength: "2.5",
              TakeUp: "0.1",
              serviceType: "2 hr Rated Cable Feeder",
              serviceTypeColor: "142,53,50",
              LineWeight: "2",
              LinePattern: "center 5/8\\",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: {
              addDefaultItem: {
                name: "southwire 12-2 Solid Wire Armorlite MC Bend",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5",
                manufacturer: "southwire",
                shape: "FieldFabConduit",
                path: "\\imperial\\conduitfittings\\southwire\\aluminum armorlite mc cable ftgs\\aluminum\\mc\\",
                icon: "southwire 12-2 Solid Wire Armorlite MC Bend.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "102*102",
                centerRadius: "0.45325",
                diameter: "0.0416666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "southwire 12-2 Solid Wire Armorlite MC Bend",
                id: "24129625737870311",
                isClearence: "false"
              }
            },
            union: [],
            multiPort: []
          },
          {
            name: "customContent",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: [
              {
                name: "rACO Galv-Stl 257 Square Box FKO_FB",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\fb_galvstl square junction boxes\\galvanized steel\\mc\\",
                icon: "rACO Galv-Stl 257 Square Box FKO_FB.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109*109*109*109*109*109*109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "241952671127474511",
                JBoxType: "Hosted",
                isClearence: "false"
              },
              {
                name: "rACO 773CUS 4 Inch Square Single Device Cover",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "2",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "0",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\galvstl square junction boxes\\galvanized steel\\rmc\\",
                icon: "rACO 773CUS 4 Inch Square Single Device Cover.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "24203859636178811",
                JBoxType: "Hosted",
                isClearence: "false"
              }
            ]
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "3",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "4",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                guid: "76be21dc-d4d6-483c-b3c1-7a61a4c481b7",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                id: "24120907704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                guid: "0669108c-2853-4fd3-a5ef-51b4b0739b0d",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                id: "24120904704164011",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                guid: "63505572-d9fa-4a7c-8bc3-b7193b78cb86",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                descriptionType: "core Floor",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "rMC Alum Allied Thd x Thd with fittings - Wirefill",
        unit: "IMPERIAL",
        id: "12",
        InVisibility: "",
        systemShape: "conduit",
        systemUniqueId: "c7597d0c-1a00-4f4a-8b55-03bad77d597a",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "conduit",
            electricalTypeItems: {
              name: "Allied EG Al Rigid Metal Conduit MPTxMPT",
              id: "2474680479858611",
              Length: "10",
              JunctionType: "Tee",
              material: "Allied EG AL RMC",
              OldMat: "",
              shape: "conduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,5,6",
              manufacturer: "Allied EG",
              path: "\\imperial\\conduit\\allied eg\\e_alum rmc conduit thrd\\aluminum\\rmc\\",
              icon: "Allied EG Al Rigid Metal Conduit MPTxMPT.rfa",
              description: "",
              descriptionType: "",
              connector: "100",
              extraField: "False",
              displayPosition: "0,0",
              dispPosition: "1",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Allied EG Al 90 Elbow MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "11",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_alum rmc conduit ftgs thrd\\aluminum\\rmc\\",
                icon: "Allied EG Al 90 Elbow MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*100",
                centerRadius: "2.81249999999999",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Allied EG Al 90 Elbow MPTxMPT",
                id: "2474678479758411",
                isClearence: "false"
              },
              {
                name: "Allied EG Al 45 Elbow MPTxMPT",
                defaultFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_alum rmc conduit ftgs thrd\\aluminum\\rmc\\",
                icon: "Allied EG Al 45 Elbow MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                angle: "45",
                connector: "100*100",
                centerRadius: "0.473752403545367",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "Allied EG Al 45 Elbow MPTxMPT",
                id: "2474677479758511",
                isClearence: "false"
              }
            ],
            transition: {
              addDefaultItem: {
                name: "Killark AL R Reducing Bushing MPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "Transition",
                position: "2",
                sizeRange: "0.375x0.5,0.375x0.75,0.375x1,0.5x0.375,0.5x0.75,0.5x1,0.5x1.25,0.5x1.5,0.5x2,0.75x0.375,0.75x0.5,0.75x1,0.75x1.25,0.75x1.5,0.75x2,1x0.375,1x0.5,1x0.75,1x1.25,1x1.5,1x2,1x2.5,1.25x0.5,1.25x0.75,1.25x1,1.25x1.5,1.25x2,1.5x0.5,1.5x0.75,1.5x1,1.5x1.25,1.5x2,1.5x2.5,1.5x3,2x0.5,2x0.75,2x1,2x1.25,2x1.5,2x2.5,2x3,2x3.5,2x4,2.5x1,2.5x1.5,2.5x2,2.5x3,2.5x3.5,2.5x4,3x1.5,3x2,3x2.5,3x3.5,3x4,3.5x2,3.5x2.5,3.5x3,3.5x4,4x2,4x2.5,4x3,4x3.5",
                manufacturer: "Killark",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\killark\\al conduit fittings thrd\\aluminum\\rmc",
                icon: "Killark AL R Reducing Bushing MPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "Killark AL R Reducing Bushing MPTxFPT",
                id: "24166853982875111",
                isClearence: "false"
              }
            },
            cap: [],
            union: [
              {
                name: "Allied EG Al Coupling FPTxFPT",
                defaultFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_alum rmc conduit ftgs thrd\\aluminum\\rmc\\",
                icon: "Allied EG Al Coupling FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "Allied EG Al Coupling FPTxFPT",
                id: "2474679479758711",
                isClearence: "false"
              },
              {
                name: "crouse Hinds AL UNF-6 Union FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "6",
                sizeRange: "1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\al conduit ftgs thrd\\aluminum\\mc\\",
                icon: "crouse Hinds AL UNF-6 Union FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "crouse Hinds AL UNF-6 Union FPTxFPT",
                id: "24129954738371011",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds AL Series 5 Type C Conduit Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "11",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\al conduit bodies & boxes thrd\\aluminum\\mc\\",
                icon: "crouse-Hinds AL Series 5 Type C Conduit Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "crouse-Hinds AL Series 5 Type C Conduit Body FPTxFPT",
                id: "24129981738259511",
                isClearence: "false"
              }
            ],
            multiPort: [],
            junctionBoxTee: [
              {
                name: "crouse-Hinds AL Series 5 Type T Conduit Body FPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxTee",
                position: "1",
                sizeRange: "0.5x0.5x0.5,0.75x0.75x0.75,1x1x1,1.25x1.25x1.25,1.5x1.5x1.5,2x2x2,2.5x2.5x2.5,3x3x3,3.5x3.5x3.5,4x4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\al conduit bodies & boxes thrd\\aluminum\\mc\\",
                icon: "crouse-Hinds AL Series 5 Type T Conduit Body FPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101",
                centerRadius: "0.104062499999989",
                diameter: "0.104166666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "crouse-Hinds AL Series 5 Type T Conduit Body FPTxFPTxFPT",
                id: "24129967738259611",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds AL Series 5 Type TB Conduit Body FPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxTee",
                position: "2",
                sizeRange: "0.5x0.5x0.5,0.75x0.75x0.75,1x1x1,1.25x1.25x1.25,1.5x1.5x1.5,2x2x2",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\al conduit bodies & boxes thrd\\aluminum\\mc\\",
                icon: "crouse-Hinds AL Series 5 Type TB Conduit Body FPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101",
                centerRadius: "0.09899833333332",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "crouse-Hinds AL Series 5 Type TB Conduit Body FPTxFPTxFPT",
                id: "24129972738259611",
                isClearence: "false"
              }
            ],
            junctionBoxCross: {
              addDefaultItem: {
                name: "crouse-Hinds AL Series 5 Type X Conduit Body FPTxFPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxCross",
                position: "1",
                sizeRange: "0.5x0.5x0.5x0.5,0.75x0.75x0.75x0.75,1x1x1x1,1.25x1.25x1.25x1.25,1.5x1.5x1.5x1.5,2x2x2x2",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\al conduit bodies & boxes thrd\\aluminum\\mc\\",
                icon: "crouse-Hinds AL Series 5 Type X Conduit Body FPTxFPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101*101",
                centerRadius: "0.0957695833333425",
                diameter: "0.0416666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "crouse-Hinds AL Series 5 Type X Conduit Body FPTxFPTxFPTxFPT",
                id: "24129974738259611",
                isClearence: "false"
              }
            },
            junctionBoxElbow: [
              {
                name: "crouse-Hinds AL Series 5 Type LB Conduit Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "7",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\al conduit bodies & boxes thrd\\aluminum\\mc\\",
                icon: "crouse-Hinds AL Series 5 Type LB Conduit Body FPTxFPT.rfa",
                description: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0.145145833333345",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                id: "24129986738259511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds AL Series 5 Type LL Conduit Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "8",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\al conduit bodies & boxes thrd\\aluminum\\mc\\",
                icon: "crouse-Hinds AL Series 5 Type LL Conduit Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0.170000000000015",
                diameter: "0.333333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "crouse-Hinds AL Series 5 Type LL Conduit Body FPTxFPT",
                id: "24129991738259511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds AL Series 5 Type LR Conduit Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "9",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\al conduit bodies & boxes thrd\\aluminum\\mc\\",
                icon: "crouse-Hinds AL Series 5 Type LR Conduit Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0.0797666666666832",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "crouse-Hinds AL Series 5 Type LR Conduit Body FPTxFPT",
                id: "24129996738259511",
                isClearence: "false"
              }
            ]
          },
          {
            name: "customContent",
            normal: [],
            panelBoard: [],
            Transformer: [],
            switchBoard: [],
            OtherPanel: [],
            equipmentSwitch: []
          },
          {
            name: "Accessories",
            junctionBox: []
          },
          {
            name: "BuildingLayout",
            normal: [
              {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "12x12",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "24120904704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "2",
                sizeRange: "24x24",
                manufacturer: "unistrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support\\",
                icon: "p1001T-GR Dbl UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,0",
                dispPosition: "3",
                csvFileName: "",
                id: "24120907704164011",
                IsHanger: "True",
                supportDiscipline: "conduit",
                isClearence: "false"
              },
              {
                name: "sSW Anchor Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "5",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Anchor Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "",
                id: "2472259468557611",
                isClearence: "false"
              },
              {
                name: "sSW CenterLine Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "6",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW CenterLine Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "",
                id: "2472260468557611",
                isClearence: "false"
              },
              {
                name: "sSW Control Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "7",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Control Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "",
                id: "2472261468557611",
                isClearence: "false"
              },
              {
                name: "sSW Layout Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "8",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Layout Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "",
                id: "2472263468557611",
                isClearence: "false"
              },
              {
                name: "sSW Stub-Up Point",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "9",
                sizeRange: "",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\misc layout points\\carbon steel\\std\\",
                icon: "sSW Stub-Up Point.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "",
                id: "2472264468557611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Floor",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "10",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Floor.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "site Survey Work Core Drill Hole - Floor",
                id: "2412984073907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work Core Drill Hole - Wall",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "11",
                sizeRange: "0.375,0.5,0.625,0.75,0.875,1,1.125,1.25,1.375,1.5,1.75,1.875,2,2.125,2.25,2.375,2.5,2.625,2.75,2.875,3,3.25,3.5,4,4.25,4.5,4.75,5,5.25,5.5,6,6.25,6.5,7,7.25,7.5,7.75,8,8.25,8.5,9,9.5,10,12,14,16,18,20,24,26,28,30,32,34,36,38,40,42,44,46,48",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\core drill holes\\concrete\\slv\\",
                icon: "site Survey Work Core Drill Hole - Wall.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "site Survey Work Core Drill Hole - Wall",
                id: "2412984173907611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Floor Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "12",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Floor Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "site Survey Work CS STD Pipe Floor Sleeve",
                id: "2413161446847611",
                isClearence: "false"
              },
              {
                name: "site Survey Work CS STD Pipe Wall Sleeve",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "13",
                sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,4.5,5,6,7,8,9,10,11,12,14,16,18,20,22,24,26,28,30,32,34,36,38,40,42,48,54,60,66,72,78,84,90,96,102,108,120,144",
                manufacturer: "site Survey Work",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\site survey work\\cs std wall sleeves\\carbon steel\\std\\",
                icon: "site Survey Work CS STD Pipe Wall Sleeve.rfa",
                description: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "site Survey Work CS STD Pipe Wall Sleeve",
                id: "2413161657637611",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "rMC Wheatland Galv Threaded - Wirefill",
        unit: "IMPERIAL",
        id: "5",
        InVisibility: "",
        systemShape: "conduit",
        IsHangerNeeded: "True",
        systemUniqueId: "9a911381-249c-4daf-b4c1-056725ebec52",
        hangerDisabledFor: "",
        isClearence: "false",
        fittings: [
          {
            name: "conduit",
            electricalTypeItems: {
              name: "Wheatland GS DuraGuard RMC 10 ft MPTxMPT",
              id: "24140438786358611",
              Length: "10",
              JunctionType: "Tee",
              material: "Wheatland Galv Steel RMC",
              OldMat: "",
              shape: "conduit",
              sizeRange: "0.5,0.75,1,1.25,1.5,2,2.5,3,3.5,4,5,6",
              manufacturer: "Wheatland",
              path: "\\imperial\\conduit\\wheatland\\e_galv-cs rmc conduit thrd\\galvanized steel\\rmc\\",
              icon: "Wheatland GS DuraGuard RMC 10 ft MPTxMPT.rfa",
              description: "",
              descriptionType: "",
              connector: "100",
              extraField: "False",
              displayPosition: "0,0",
              dispPosition: "1",
              serviceType: "",
              serviceTypeColor: "",
              LineWeight: "",
              LinePattern: "",
              TotalBendRun: "360",
              isClearence: "false"
            },
            elbow: [
              {
                name: "Wheatland Galv-Steel RMC Straight 90 Elbow MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Wheatland",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\wheatland\\e_galv-steel rmc conduit ftgs thrd\\galvanized steel\\rmc\\",
                icon: "Wheatland Galv-Steel RMC Straight 90 Elbow MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*100",
                centerRadius: "1.12499999999998",
                diameter: "0.208333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,2",
                dispPosition: "11",
                csvFileName: "Wheatland Galv-Steel RMC Straight 90 Elbow MPTxMPT",
                id: "241997361154058411",
                isClearence: "false"
              },
              {
                name: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT",
                defaultFor: "bianca_brinzoi@trimble.com",
                disableFor: "",
                fittingType: "elbow",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,3",
                dispPosition: "18",
                csvFileName: "GENEL Galv-Stl RMC 90 Stub Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "8,10,13",
                LeadOutLength: "103.45879,98.12085,90.75208",
                TakeUp: "6,8,11",
                id: "24235026928858411",
                isClearence: "false",
                OffsetType: "stub Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,3",
                dispPosition: "19",
                csvFileName: "GENEL Galv-Stl RMC 90 Stub Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "9.5,11,13,16,16.25,18.125,24,26.75,30.75,35",
                LeadOutLength: "103.824116,100.458795,96.1026,90.255532,90.79093,87.737833,74.165931,67.363277,59.122126,51.227879",
                TakeUp: "7.5,9,11,14,14.25,16.125,21.5,24.25,28.25,32.5",
                id: "24235027928858411",
                isClearence: "false",
                OffsetType: "stub Machine Bend"
              },
              {
                name: "Allied EG Galv Steel GRC 45 Elbow MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "elbow",
                position: "7",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Allied EG",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\allied eg\\e_galv-stl grc conduit ftgs thrd\\galvanized steel\\grc",
                icon: "Allied EG Galv Steel GRC 45 Elbow MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                angle: "45",
                connector: "100*100",
                centerRadius: "1.34803390593272",
                diameter: "0.5",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,3",
                dispPosition: "20",
                csvFileName: "Allied EG Galv Steel GRC 45 Elbow MPTxMPT",
                id: "24154448934758511",
                isClearence: "false"
              }
            ],
            transition: [
              {
                name: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "Transition",
                position: "1",
                sizeRange: "0.5x0.375,0.75x0.5,1x0.5,1x0.75,1.25x0.5,1.25x0.75,1.25x1,1.5x0.5,1.5x0.75,1.5x1,1.5x1.25,2x0.5,2x0.75,2x1,2x1.25,2x1.5",
                manufacturer: "rACO",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\raco\\e_galv-stl grc conduit ftgs thrd\\galvanized steel\\grc\\",
                icon: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,4",
                dispPosition: "21",
                csvFileName: "raco Galv Steel GRC Rigid Reducing Bushing MPTxFPT",
                id: "24158161942659911",
                isClearence: "false"
              },
              {
                name: "raco CS RMC Reducing Bushing MPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "Transition",
                position: "2",
                sizeRange: "0.5x0.375,0.75x0.5,1x0.5,1x0.75,1.25x0.5,1.25x0.75,1.25x1,1.5x0.5,1.5x0.75,1.5x1,1.5x1.25,2x0.5,2x0.75,2x1,2x1.25,2x1.5",
                manufacturer: "rACO",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\raco\\e_cs rmc-imc electrical ftgs thrd\\carbon steel\\rmc",
                icon: "raco CS RMC Reducing Bushing MPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "100*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,4",
                dispPosition: "22",
                csvFileName: "raco CS RMC Reducing Bushing MPTxFPT",
                id: "24166773990175111",
                isClearence: "false"
              }
            ],
            union: [
              {
                name: "Wheatland Galv-Steel RMC Coupling FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4,5x5,6x6",
                manufacturer: "Wheatland",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\wheatland\\e_galv-steel rmc conduit ftgs thrd\\galvanized steel\\rmc\\",
                icon: "Wheatland Galv-Steel RMC Coupling FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "Wheatland Galv-Steel RMC Coupling FPTxFPT",
                id: "241997251154058711",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,1",
                dispPosition: "9",
                csvFileName: "crouse-Hinds MI Form 5 Type C Conduit Outlet Body FPTxFPT",
                id: "24129825738659511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI FSC Cast Device Box FPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "union",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI FSC Cast Device Box FPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,1",
                dispPosition: "10",
                csvFileName: "crouse-Hinds MI FSC Cast Device Box FPT",
                id: "24129830738659511",
                isClearence: "false"
              }
            ],
            multiPort: [
              {
                name: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "1",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,2",
                dispPosition: "12",
                csvFileName: "GENEL Galv-Stl RMC Four Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24225278928870311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "2",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,2",
                dispPosition: "13",
                csvFileName: "GENEL Galv-Stl RMC Four Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24225279928870311",
                isClearence: "false",
                OffsetType: "Four Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,2",
                dispPosition: "14",
                csvFileName: "GENEL Galv-Stl RMC Three Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24225280928870311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,2",
                dispPosition: "15",
                csvFileName: "GENEL Galv-Stl RMC Three Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24225281928870311",
                isClearence: "false",
                OffsetType: "Three Point Saddle Machine Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1",
                manufacturer: "Generic Electric",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,3",
                dispPosition: "16",
                csvFileName: "GENEL Galv-Stl RMC Two Point Saddle Hand Bend MPTxMPT",
                BendRadius: "5.4375,7.5625,10.34375",
                LeadLength: "2,2,2",
                LeadOutLength: "12,12,12",
                TakeUp: "0,0,0",
                id: "24231617928870311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Hand Bend"
              },
              {
                name: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "MultiPort",
                position: "6",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "Generic Electric",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\generic electric\\e_galv steel ftgs thrd\\galvanized steel\\rmc\\",
                icon: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT.rfa",
                description: "",
                descriptionType: "",
                connector: "100*100",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,3",
                dispPosition: "17",
                csvFileName: "GENEL Galv-Stl RMC Two Point Saddle Machine Bend MPTxMPT",
                BendRadius: "4.25,5.4375,6.9375,8.75,8.25,9,13.9,16.48,19.18,21.5",
                LeadLength: "2,2,2,2,2,2,2.5,3,3.5,4",
                LeadOutLength: "12,12,12,12,12,12,12,12,12,12",
                TakeUp: "2.5,3,3.4375,4.5,5.8125,6.25,6.15,6,7,8.75",
                id: "24231618928870311",
                isClearence: "false",
                OffsetType: "Two Point Saddle Machine Bend"
              }
            ],
            junctionBoxTee: {
              addDefaultItem: {
                name: "crouse-Hinds MI Form 5 Type TB Conduit Outlet Body FPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxTee",
                position: "2",
                sizeRange: "0.5x0.5x0.5,0.75x0.75x0.75,1x1x1,1.25x1.25x1.25,1.5x1.5x1.5,2x2x2",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type TB Conduit Outlet Body FPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101",
                centerRadius: "0.18335833333329",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "4,0",
                dispPosition: "5",
                csvFileName: "crouse-Hinds MI Form 5 Type TB Conduit Outlet Body FPTxFPTxFPT",
                id: "24129820738659611",
                isClearence: "false"
              }
            },
            junctionBoxCross: {
              addDefaultItem: {
                name: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxCross",
                position: "1",
                sizeRange: "0.5x0.5x0.5x0.5,0.75x0.75x0.75x0.75,1x1x1x1,1.25x1.25x1.25x1.25,1.5x1.5x1.5x1.5,2x2x2x2",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101*101*101",
                centerRadius: "0.0914333333333223",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "3,0",
                dispPosition: "4",
                csvFileName: "crouse-Hinds MI Form 5 Type X Conduit Outlet Body FPTxFPTxFPTxFPT",
                id: "24129816738670611",
                isClearence: "false"
              }
            },
            junctionBoxElbow: [
              {
                name: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "3",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0.0819666666666684",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,1",
                dispPosition: "6",
                csvFileName: "crouse-Hinds MI Form 5 Type LB Conduit Outlet Body FPTxFPT",
                id: "24129826738659511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "4",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "1.07228333333334",
                diameter: "0.291666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,1",
                dispPosition: "7",
                csvFileName: "crouse-Hinds MI Form 5 Type LL Conduit Outlet Body FPTxFPT",
                id: "24129827738659511",
                isClearence: "false"
              },
              {
                name: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "5",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5,3x3,3.5x3.5,4x4",
                manufacturer: "crouse-Hinds",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\crouse-hinds\\mi conduit bodies & boxes thrd\\malleable iron\\mc\\",
                icon: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT.rfa",
                description: "",
                descriptionType: "LR Conduit Body",
                angle: "90",
                connector: "101*101",
                centerRadius: "0.0819666666666684",
                diameter: "0.0833333333333333",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,1",
                dispPosition: "8",
                csvFileName: "crouse-Hinds MI Form 5 Type LR Conduit Outlet Body FPTxFPT",
                id: "24129828738659511",
                isClearence: "false"
              },
              {
                name: "robRoy CS PREL-9 Malleable Elbow FPTxFPT",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBoxElbow",
                position: "8",
                sizeRange: "0.5x0.5,0.75x0.75,1x1,1.25x1.25,1.5x1.5,2x2,2.5x2.5",
                manufacturer: "robRoy",
                shape: "conduit",
                path: "\\imperial\\conduitfittings\\robroy\\plasti-bond_cs conduit ftgs thrd\\carbon steel\\rmc",
                icon: "robRoy CS PREL-9 Malleable Elbow FPTxFPT.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "101*101",
                centerRadius: "0.416666666666639",
                diameter: "0.166666666666667",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "2,4",
                dispPosition: "23",
                csvFileName: "robRoy CS PREL-9 Malleable Elbow FPTxFPT",
                id: "24215303954358411",
                isClearence: "false"
              }
            ]
          },
          {
            name: "Accessories",
            junctionBox: [
              {
                name: "raco Galv-Stl Square Box 242 FKO",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "1",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "2",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\galvstl square junction boxes\\galvanized steel\\rmc\\",
                icon: "raco Galv-Stl Square Box 242 FKO.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "24109753636168711",
                JBoxType: "Non-Hosted",
                isClearence: "false"
              },
              {
                name: "raco Galv-Stl Square Box 243 FKO",
                defaultFor: "",
                disableFor: "",
                fittingType: "JunctionBox",
                position: "2",
                sizeRange: "",
                manufacturer: "rACO",
                addedWireLength: "1",
                shape: "Accessories",
                path: "\\imperial\\accessories\\raco\\galvstl square junction boxes\\galvanized steel\\rmc\\",
                icon: "raco Galv-Stl Square Box 243 FKO.rfa",
                description: "",
                descriptionType: "",
                angle: "0",
                connector: "109*109*109*109",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "1,0",
                dispPosition: "2",
                csvFileName: "",
                id: "24109754636168711",
                JBoxType: "Non-Hosted",
                isClearence: "false"
              }
            ]
          },
          {
            name: "BuildingLayout",
            normal: {
              addDefaultItem: {
                name: "p1000T-GR UniStrut Conduit Hanger 1 5_8",
                defaultFor: "",
                disableFor: "",
                fittingType: "normal",
                position: "1",
                sizeRange: "12x12",
                manufacturer: "uniStrut",
                shape: "BuildingLayout",
                path: "\\imperial\\hangers\\unistrut\\cs conduit trapeze hangers\\carbon steel\\support",
                icon: "p1000T-GR UniStrut Conduit Hanger 1 5_8.rfa",
                description: "",
                descriptionType: "",
                angle: "90",
                connector: "",
                centerRadius: "0",
                diameter: "0",
                isConnCheck: "True",
                extraField: "",
                displayPosition: "0,0",
                dispPosition: "1",
                csvFileName: "",
                id: "24120904704164011",
                supportDiscipline: "",
                specId: "136",
                isClearence: "false"
              }
            }
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          },
          {
            name: "aaaaab",
            isCustomContent: "True"
          }
        ]
      },
      {
        name: "bla",
        unit: "IMPERIAL",
        id: "88",
        InVisibility: "",
        systemShape: "BusWay",
        IsHangerNeeded: "False",
        systemUniqueId: "b7514687-d935-4c45-86b2-f45888ddb0f5",
        hangerDisabledFor: "emanuela_fenechiu@trimble.com",
        isClearence: "true",
        fittings: [
          {
            name: "BusWay"
          },
          {
            name: "Accessories"
          },
          {
            name: "BuildingLayout"
          },
          {
            name: "Assemblies"
          },
          {
            name: "customContent",
            isCustomContent: "True"
          }
        ]
      }
    ]
  }